/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(<any>response_);
                } catch (e) {
                    return <Observable<IsTenantAvailableOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<IsTenantAvailableOutput>><any>_observableThrow(response_);
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param email (optional) 
     * @param userId (optional) 
     * @return Success
     */
    userNameOrEmailExist(email: string | undefined, userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/UserNameOrEmailExist?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserNameOrEmailExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserNameOrEmailExist(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUserNameOrEmailExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    checkIsActive(userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/CheckIsActive?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIsActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsActive(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIsActive(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param password (optional) 
     * @param token (optional) 
     * @return Success
     */
    activateAccount(userId: number | undefined, password: string | undefined, token: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateAccount?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (password === null)
            throw new Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateAccount(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processActivateAccount(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    sendConfirmationEmail(userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendConfirmationEmail?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConfirmationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConfirmationEmail(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSendConfirmationEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param token (optional) 
     * @return Success
     */
    confirmEmail(userId: number | undefined, token: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/ConfirmEmail?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forgotPassword(body: ForgotPasswordDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Account/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param token (optional) 
     * @return Success
     */
    sendNewPasswordAfterReset(userId: number | undefined, token: string | undefined): Observable<ResetPasswordResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendNewPasswordAfterReset?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNewPasswordAfterReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNewPasswordAfterReset(<any>response_);
                } catch (e) {
                    return <Observable<ResetPasswordResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResetPasswordResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processSendNewPasswordAfterReset(response: HttpResponseBase): Observable<ResetPasswordResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(<any>response_);
                } catch (e) {
                    return <Observable<RegisterOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterOutput>><any>_observableThrow(response_);
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteUserData(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/DeleteUserData?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserData(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteUserData(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    insertMunicipality(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Address/InsertMunicipality";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertMunicipality(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertMunicipality(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processInsertMunicipality(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @return Success
     */
    getAllRegion(): Observable<RegionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Address/GetAllRegion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRegion(<any>response_);
                } catch (e) {
                    return <Observable<RegionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRegion(response: HttpResponseBase): Observable<RegionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @return Success
     */
    getAllProvinces(): Observable<ProvinceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Address/GetAllProvinces";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProvinces(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProvinces(<any>response_);
                } catch (e) {
                    return <Observable<ProvinceDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProvinceDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllProvinces(response: HttpResponseBase): Observable<ProvinceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProvinceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @return Success
     */
    getAllMunicipality(): Observable<MunicipalityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Address/GetAllMunicipality";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMunicipality(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMunicipality(<any>response_);
                } catch (e) {
                    return <Observable<MunicipalityDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MunicipalityDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllMunicipality(response: HttpResponseBase): Observable<MunicipalityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MunicipalityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AllergyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAllergyDto | undefined): Observable<AllergyDto> {
        let url_ = this.baseUrl + "/api/services/app/Allergy/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<AllergyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AllergyDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AllergyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllergyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAllergyDto | undefined): Observable<AllergyDto> {
        let url_ = this.baseUrl + "/api/services/app/Allergy/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<AllergyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AllergyDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AllergyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllergyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Allergy/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Allergy/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    getLifeSavingMedications(patientId: number | undefined): Observable<SimpleMedicationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Allergy/GetLifeSavingMedications?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLifeSavingMedications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLifeSavingMedications(<any>response_);
                } catch (e) {
                    return <Observable<SimpleMedicationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SimpleMedicationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLifeSavingMedications(response: HttpResponseBase): Observable<SimpleMedicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SimpleMedicationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AllergyDto> {
        let url_ = this.baseUrl + "/api/services/app/Allergy/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<AllergyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AllergyDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AllergyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllergyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicalHistoryId (optional) 
     * @param isOther (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(medicalHistoryId: number | undefined, isOther: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<AllergyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Allergy/GetAll?";
        if (medicalHistoryId === null)
            throw new Error("The parameter 'medicalHistoryId' cannot be null.");
        else if (medicalHistoryId !== undefined)
            url_ += "MedicalHistoryId=" + encodeURIComponent("" + medicalHistoryId) + "&";
        if (isOther === null)
            throw new Error("The parameter 'isOther' cannot be null.");
        else if (isOther !== undefined)
            url_ += "IsOther=" + encodeURIComponent("" + isOther) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<AllergyDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AllergyDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AllergyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllergyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AslContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AslContact/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAslContactDto | undefined): Observable<AslContactDto> {
        let url_ = this.baseUrl + "/api/services/app/AslContact/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<AslContactDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AslContactDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AslContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AslContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAslContactDto | undefined): Observable<AslContactDto> {
        let url_ = this.baseUrl + "/api/services/app/AslContact/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<AslContactDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AslContactDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AslContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AslContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AslContact/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicalHistoryId (optional) 
     * @param id (optional) 
     * @return Success
     */
    get(medicalHistoryId: number | undefined, id: number | undefined): Observable<AslContactDto> {
        let url_ = this.baseUrl + "/api/services/app/AslContact/Get?";
        if (medicalHistoryId === null)
            throw new Error("The parameter 'medicalHistoryId' cannot be null.");
        else if (medicalHistoryId !== undefined)
            url_ += "MedicalHistoryId=" + encodeURIComponent("" + medicalHistoryId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<AslContactDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AslContactDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AslContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AslContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicalHistoryId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(medicalHistoryId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<AslContactDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AslContact/GetAll?";
        if (medicalHistoryId === null)
            throw new Error("The parameter 'medicalHistoryId' cannot be null.");
        else if (medicalHistoryId !== undefined)
            url_ += "MedicalHistoryId=" + encodeURIComponent("" + medicalHistoryId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<AslContactDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AslContactDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AslContactDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AslContactDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssignmentTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AssignmentType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AttendanceMarkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceMark/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BloodGroupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BloodGroup/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CalendarEventServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCalendarEventDto | undefined): Observable<CalendarEventDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarEvent/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CalendarEventDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarEventDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CalendarEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCalendarEventDto | undefined): Observable<CalendarEventDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarEvent/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CalendarEventDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarEventDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CalendarEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CalendarEvent/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CalendarEvent/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param patientId (optional) 
     * @param userId (optional) 
     * @param taskId (optional) 
     * @param recurrentTypeId (optional) 
     * @param recurrentEndTypeId (optional) 
     * @param date (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @param statusTypeId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(operationalUnitId: number | undefined, patientId: number | undefined, userId: number | undefined, taskId: number | undefined, recurrentTypeId: number | undefined, recurrentEndTypeId: number | undefined, date: Date | undefined, dateStart: Date | undefined, dateEnd: Date | undefined, statusTypeId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<CalendarEventDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarEvent/GetAll?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (recurrentTypeId === null)
            throw new Error("The parameter 'recurrentTypeId' cannot be null.");
        else if (recurrentTypeId !== undefined)
            url_ += "RecurrentTypeId=" + encodeURIComponent("" + recurrentTypeId) + "&";
        if (recurrentEndTypeId === null)
            throw new Error("The parameter 'recurrentEndTypeId' cannot be null.");
        else if (recurrentEndTypeId !== undefined)
            url_ += "RecurrentEndTypeId=" + encodeURIComponent("" + recurrentEndTypeId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        if (dateStart === null)
            throw new Error("The parameter 'dateStart' cannot be null.");
        else if (dateStart !== undefined)
            url_ += "DateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toJSON() : "") + "&";
        if (dateEnd === null)
            throw new Error("The parameter 'dateEnd' cannot be null.");
        else if (dateEnd !== undefined)
            url_ += "DateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toJSON() : "") + "&";
        if (statusTypeId === null)
            throw new Error("The parameter 'statusTypeId' cannot be null.");
        else if (statusTypeId !== undefined)
            url_ += "StatusTypeId=" + encodeURIComponent("" + statusTypeId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CalendarEventDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarEventDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CalendarEventDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarEventDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param patientId (optional) 
     * @param userId (optional) 
     * @param taskId (optional) 
     * @param recurrentTypeId (optional) 
     * @param recurrentEndTypeId (optional) 
     * @param date (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @param statusTypeId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getExport(operationalUnitId: number | undefined, patientId: number | undefined, userId: number | undefined, taskId: number | undefined, recurrentTypeId: number | undefined, recurrentEndTypeId: number | undefined, date: Date | undefined, dateStart: Date | undefined, dateEnd: Date | undefined, statusTypeId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarEvent/GetExport?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (recurrentTypeId === null)
            throw new Error("The parameter 'recurrentTypeId' cannot be null.");
        else if (recurrentTypeId !== undefined)
            url_ += "RecurrentTypeId=" + encodeURIComponent("" + recurrentTypeId) + "&";
        if (recurrentEndTypeId === null)
            throw new Error("The parameter 'recurrentEndTypeId' cannot be null.");
        else if (recurrentEndTypeId !== undefined)
            url_ += "RecurrentEndTypeId=" + encodeURIComponent("" + recurrentEndTypeId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        if (dateStart === null)
            throw new Error("The parameter 'dateStart' cannot be null.");
        else if (dateStart !== undefined)
            url_ += "DateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toJSON() : "") + "&";
        if (dateEnd === null)
            throw new Error("The parameter 'dateEnd' cannot be null.");
        else if (dateEnd !== undefined)
            url_ += "DateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toJSON() : "") + "&";
        if (statusTypeId === null)
            throw new Error("The parameter 'statusTypeId' cannot be null.");
        else if (statusTypeId !== undefined)
            url_ += "StatusTypeId=" + encodeURIComponent("" + statusTypeId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExport(<any>response_);
                } catch (e) {
                    return <Observable<FileExportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetExport(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CalendarEventDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarEvent/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CalendarEventDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarEventDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CalendarEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CalendarShiftServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCalendarShiftDto | undefined): Observable<CalendarShiftDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarShift/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CalendarShiftDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarShiftDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CalendarShiftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarShiftDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCalendarShiftDto | undefined): Observable<CalendarShiftDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarShift/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CalendarShiftDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarShiftDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CalendarShiftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarShiftDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CalendarShift/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CalendarShiftDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarShift/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CalendarShiftDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarShiftDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CalendarShiftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarShiftDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param isAscending (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, isAscending: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, sorting: string | undefined, maxResultCount: number | undefined): Observable<CalendarShiftDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarShift/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isAscending === null)
            throw new Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "IsAscending=" + encodeURIComponent("" + isAscending) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CalendarShiftDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarShiftDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CalendarShiftDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarShiftDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CalendarStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCalendarStatusDto | undefined): Observable<CalendarStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarStatus/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CalendarStatusDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarStatusDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CalendarStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCalendarStatusDto | undefined): Observable<CalendarStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarStatus/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CalendarStatusDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarStatusDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CalendarStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CalendarStatus/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CalendarStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarStatus/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CalendarStatusDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarStatusDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CalendarStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<CalendarStatusDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarStatus/GetAll?";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CalendarStatusDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarStatusDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CalendarStatusDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarStatusDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CalendarStatusTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CalendarStatusType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CalendarTaskServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCalendarTaskDto | undefined): Observable<CalendarTaskDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarTask/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CalendarTaskDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarTaskDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CalendarTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCalendarTaskDto | undefined): Observable<CalendarTaskDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarTask/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CalendarTaskDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarTaskDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CalendarTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CalendarTask/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CalendarTaskDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarTask/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CalendarTaskDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarTaskDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CalendarTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param isAscending (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, isAscending: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, sorting: string | undefined, maxResultCount: number | undefined): Observable<CalendarTaskDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarTask/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isAscending === null)
            throw new Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "IsAscending=" + encodeURIComponent("" + isAscending) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CalendarTaskDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarTaskDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CalendarTaskDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarTaskDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CashBoxAppServeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCashBoxByOperationaUnitId(id: number | undefined): Observable<CashBoxDto> {
        let url_ = this.baseUrl + "/api/services/app/CashBoxAppServe/GetCashBoxByOperationaUnitId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCashBoxByOperationaUnitId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCashBoxByOperationaUnitId(<any>response_);
                } catch (e) {
                    return <Observable<CashBoxDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CashBoxDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCashBoxByOperationaUnitId(response: HttpResponseBase): Observable<CashBoxDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashBoxDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CashBoxDto> {
        let url_ = this.baseUrl + "/api/services/app/CashBoxAppServe/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CashBoxDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CashBoxDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CashBoxDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashBoxDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(operationalUnitId: number | undefined, startDate: Date | undefined, endDate: Date | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<CashBoxDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CashBoxAppServe/GetAll?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CashBoxDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CashBoxDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CashBoxDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashBoxDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CashBoxUserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCashBoxUserDto | undefined): Observable<CashBoxUserDto> {
        let url_ = this.baseUrl + "/api/services/app/CashBoxUser/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CashBoxUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CashBoxUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CashBoxUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashBoxUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCashBoxUserDto | undefined): Observable<CashBoxUserDto> {
        let url_ = this.baseUrl + "/api/services/app/CashBoxUser/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CashBoxUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CashBoxUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CashBoxUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashBoxUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CashBoxUser/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CashBoxUserDto> {
        let url_ = this.baseUrl + "/api/services/app/CashBoxUser/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CashBoxUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CashBoxUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CashBoxUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashBoxUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param cashBoxId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(cashBoxId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<CashBoxUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CashBoxUser/GetAll?";
        if (cashBoxId === null)
            throw new Error("The parameter 'cashBoxId' cannot be null.");
        else if (cashBoxId !== undefined)
            url_ += "CashBoxId=" + encodeURIComponent("" + cashBoxId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CashBoxUserDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CashBoxUserDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CashBoxUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashBoxUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CashMovementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CashMovement/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param cashBoxId (optional) 
     * @param cashMovementReasonId (optional) 
     * @param cashMovementTypeId (optional) 
     * @param patientId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param note (optional) 
     * @param createOrModifiedById (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAllWithAmounts(cashBoxId: number | undefined, cashMovementReasonId: number | undefined, cashMovementTypeId: number | undefined, patientId: number | undefined, startDate: Date | undefined, endDate: Date | undefined, note: string | undefined, createOrModifiedById: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<CashMovementPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CashMovement/GetAllWithAmounts?";
        if (cashBoxId === null)
            throw new Error("The parameter 'cashBoxId' cannot be null.");
        else if (cashBoxId !== undefined)
            url_ += "CashBoxId=" + encodeURIComponent("" + cashBoxId) + "&";
        if (cashMovementReasonId === null)
            throw new Error("The parameter 'cashMovementReasonId' cannot be null.");
        else if (cashMovementReasonId !== undefined)
            url_ += "CashMovementReasonId=" + encodeURIComponent("" + cashMovementReasonId) + "&";
        if (cashMovementTypeId === null)
            throw new Error("The parameter 'cashMovementTypeId' cannot be null.");
        else if (cashMovementTypeId !== undefined)
            url_ += "CashMovementTypeId=" + encodeURIComponent("" + cashMovementTypeId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (createOrModifiedById === null)
            throw new Error("The parameter 'createOrModifiedById' cannot be null.");
        else if (createOrModifiedById !== undefined)
            url_ += "CreateOrModifiedById=" + encodeURIComponent("" + createOrModifiedById) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithAmounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithAmounts(<any>response_);
                } catch (e) {
                    return <Observable<CashMovementPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CashMovementPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllWithAmounts(response: HttpResponseBase): Observable<CashMovementPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashMovementPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param cashBoxId (optional) 
     * @param cashMovementReasonId (optional) 
     * @param cashMovementTypeId (optional) 
     * @param patientId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param note (optional) 
     * @param createOrModifiedById (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getCashMovementAmounts(cashBoxId: number | undefined, cashMovementReasonId: number | undefined, cashMovementTypeId: number | undefined, patientId: number | undefined, startDate: Date | undefined, endDate: Date | undefined, note: string | undefined, createOrModifiedById: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<CashMovementAmountsDto> {
        let url_ = this.baseUrl + "/api/services/app/CashMovement/GetCashMovementAmounts?";
        if (cashBoxId === null)
            throw new Error("The parameter 'cashBoxId' cannot be null.");
        else if (cashBoxId !== undefined)
            url_ += "CashBoxId=" + encodeURIComponent("" + cashBoxId) + "&";
        if (cashMovementReasonId === null)
            throw new Error("The parameter 'cashMovementReasonId' cannot be null.");
        else if (cashMovementReasonId !== undefined)
            url_ += "CashMovementReasonId=" + encodeURIComponent("" + cashMovementReasonId) + "&";
        if (cashMovementTypeId === null)
            throw new Error("The parameter 'cashMovementTypeId' cannot be null.");
        else if (cashMovementTypeId !== undefined)
            url_ += "CashMovementTypeId=" + encodeURIComponent("" + cashMovementTypeId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (createOrModifiedById === null)
            throw new Error("The parameter 'createOrModifiedById' cannot be null.");
        else if (createOrModifiedById !== undefined)
            url_ += "CreateOrModifiedById=" + encodeURIComponent("" + createOrModifiedById) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCashMovementAmounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCashMovementAmounts(<any>response_);
                } catch (e) {
                    return <Observable<CashMovementAmountsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CashMovementAmountsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCashMovementAmounts(response: HttpResponseBase): Observable<CashMovementAmountsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashMovementAmountsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param cashBoxId (optional) 
     * @param cashMovementReasonId (optional) 
     * @param cashMovementTypeId (optional) 
     * @param patientId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param note (optional) 
     * @param createOrModifiedById (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getFileExport(cashBoxId: number | undefined, cashMovementReasonId: number | undefined, cashMovementTypeId: number | undefined, patientId: number | undefined, startDate: Date | undefined, endDate: Date | undefined, note: string | undefined, createOrModifiedById: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/api/services/app/CashMovement/GetFileExport?";
        if (cashBoxId === null)
            throw new Error("The parameter 'cashBoxId' cannot be null.");
        else if (cashBoxId !== undefined)
            url_ += "CashBoxId=" + encodeURIComponent("" + cashBoxId) + "&";
        if (cashMovementReasonId === null)
            throw new Error("The parameter 'cashMovementReasonId' cannot be null.");
        else if (cashMovementReasonId !== undefined)
            url_ += "CashMovementReasonId=" + encodeURIComponent("" + cashMovementReasonId) + "&";
        if (cashMovementTypeId === null)
            throw new Error("The parameter 'cashMovementTypeId' cannot be null.");
        else if (cashMovementTypeId !== undefined)
            url_ += "CashMovementTypeId=" + encodeURIComponent("" + cashMovementTypeId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (createOrModifiedById === null)
            throw new Error("The parameter 'createOrModifiedById' cannot be null.");
        else if (createOrModifiedById !== undefined)
            url_ += "CreateOrModifiedById=" + encodeURIComponent("" + createOrModifiedById) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileExport(<any>response_);
                } catch (e) {
                    return <Observable<FileExportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileExport(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCashMovementDto | undefined): Observable<CashMovementDto> {
        let url_ = this.baseUrl + "/api/services/app/CashMovement/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CashMovementDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CashMovementDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CashMovementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashMovementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCashMovementDto | undefined): Observable<CashMovementDto> {
        let url_ = this.baseUrl + "/api/services/app/CashMovement/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CashMovementDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CashMovementDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CashMovementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashMovementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CashMovementDto> {
        let url_ = this.baseUrl + "/api/services/app/CashMovement/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CashMovementDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CashMovementDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CashMovementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashMovementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param cashBoxId (optional) 
     * @param cashMovementReasonId (optional) 
     * @param cashMovementTypeId (optional) 
     * @param patientId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param note (optional) 
     * @param createOrModifiedById (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(cashBoxId: number | undefined, cashMovementReasonId: number | undefined, cashMovementTypeId: number | undefined, patientId: number | undefined, startDate: Date | undefined, endDate: Date | undefined, note: string | undefined, createOrModifiedById: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<CashMovementDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CashMovement/GetAll?";
        if (cashBoxId === null)
            throw new Error("The parameter 'cashBoxId' cannot be null.");
        else if (cashBoxId !== undefined)
            url_ += "CashBoxId=" + encodeURIComponent("" + cashBoxId) + "&";
        if (cashMovementReasonId === null)
            throw new Error("The parameter 'cashMovementReasonId' cannot be null.");
        else if (cashMovementReasonId !== undefined)
            url_ += "CashMovementReasonId=" + encodeURIComponent("" + cashMovementReasonId) + "&";
        if (cashMovementTypeId === null)
            throw new Error("The parameter 'cashMovementTypeId' cannot be null.");
        else if (cashMovementTypeId !== undefined)
            url_ += "CashMovementTypeId=" + encodeURIComponent("" + cashMovementTypeId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (createOrModifiedById === null)
            throw new Error("The parameter 'createOrModifiedById' cannot be null.");
        else if (createOrModifiedById !== undefined)
            url_ += "CreateOrModifiedById=" + encodeURIComponent("" + createOrModifiedById) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CashMovementDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CashMovementDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CashMovementDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashMovementDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CashMovementReasonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCashMovementReasonDto | undefined): Observable<CashMovementReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/CashMovementReason/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CashMovementReasonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CashMovementReasonDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CashMovementReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashMovementReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCashMovementReasonDto | undefined): Observable<CashMovementReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/CashMovementReason/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CashMovementReasonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CashMovementReasonDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CashMovementReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashMovementReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CashMovementReason/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CashMovementReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/CashMovementReason/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CashMovementReasonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CashMovementReasonDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CashMovementReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashMovementReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param cashMovementTypeId (optional) 
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param isAscending (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(cashMovementTypeId: number | undefined, keyword: string | undefined, isActive: boolean | undefined, isAscending: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, sorting: string | undefined, maxResultCount: number | undefined): Observable<CashMovementReasonDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CashMovementReason/GetAll?";
        if (cashMovementTypeId === null)
            throw new Error("The parameter 'cashMovementTypeId' cannot be null.");
        else if (cashMovementTypeId !== undefined)
            url_ += "CashMovementTypeId=" + encodeURIComponent("" + cashMovementTypeId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isAscending === null)
            throw new Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "IsAscending=" + encodeURIComponent("" + isAscending) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CashMovementReasonDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CashMovementReasonDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CashMovementReasonDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashMovementReasonDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CashMovementTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CashMovementType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ChronologyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param medicationId (optional) 
     * @param keyword (optional) 
     * @param userId (optional) 
     * @param chronologyEventId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param operationalUnitId (optional) 
     * @param patientId (optional) 
     * @param forOperationalUnit (optional) 
     * @param forPatientAssignment (optional) 
     * @param forPatientTherapy (optional) 
     * @param forImportMedication (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getExport(medicationId: number | undefined, keyword: string | undefined, userId: number | undefined, chronologyEventId: number | undefined, startDate: Date | undefined, endDate: Date | undefined, operationalUnitId: number | undefined, patientId: number | undefined, forOperationalUnit: boolean | undefined, forPatientAssignment: boolean | undefined, forPatientTherapy: boolean | undefined, forImportMedication: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/api/services/app/Chronology/GetExport?";
        if (medicationId === null)
            throw new Error("The parameter 'medicationId' cannot be null.");
        else if (medicationId !== undefined)
            url_ += "MedicationId=" + encodeURIComponent("" + medicationId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (chronologyEventId === null)
            throw new Error("The parameter 'chronologyEventId' cannot be null.");
        else if (chronologyEventId !== undefined)
            url_ += "ChronologyEventId=" + encodeURIComponent("" + chronologyEventId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (forOperationalUnit === null)
            throw new Error("The parameter 'forOperationalUnit' cannot be null.");
        else if (forOperationalUnit !== undefined)
            url_ += "ForOperationalUnit=" + encodeURIComponent("" + forOperationalUnit) + "&";
        if (forPatientAssignment === null)
            throw new Error("The parameter 'forPatientAssignment' cannot be null.");
        else if (forPatientAssignment !== undefined)
            url_ += "ForPatientAssignment=" + encodeURIComponent("" + forPatientAssignment) + "&";
        if (forPatientTherapy === null)
            throw new Error("The parameter 'forPatientTherapy' cannot be null.");
        else if (forPatientTherapy !== undefined)
            url_ += "ForPatientTherapy=" + encodeURIComponent("" + forPatientTherapy) + "&";
        if (forImportMedication === null)
            throw new Error("The parameter 'forImportMedication' cannot be null.");
        else if (forImportMedication !== undefined)
            url_ += "ForImportMedication=" + encodeURIComponent("" + forImportMedication) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExport(<any>response_);
                } catch (e) {
                    return <Observable<FileExportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetExport(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicationId (optional) 
     * @param id (optional) 
     * @return Success
     */
    get(medicationId: number | undefined, id: number | undefined): Observable<ChronologyDto> {
        let url_ = this.baseUrl + "/api/services/app/Chronology/Get?";
        if (medicationId === null)
            throw new Error("The parameter 'medicationId' cannot be null.");
        else if (medicationId !== undefined)
            url_ += "MedicationId=" + encodeURIComponent("" + medicationId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ChronologyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChronologyDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ChronologyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChronologyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicationId (optional) 
     * @param keyword (optional) 
     * @param userId (optional) 
     * @param chronologyEventId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param operationalUnitId (optional) 
     * @param patientId (optional) 
     * @param forOperationalUnit (optional) 
     * @param forPatientAssignment (optional) 
     * @param forPatientTherapy (optional) 
     * @param forImportMedication (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(medicationId: number | undefined, keyword: string | undefined, userId: number | undefined, chronologyEventId: number | undefined, startDate: Date | undefined, endDate: Date | undefined, operationalUnitId: number | undefined, patientId: number | undefined, forOperationalUnit: boolean | undefined, forPatientAssignment: boolean | undefined, forPatientTherapy: boolean | undefined, forImportMedication: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<ChronologyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Chronology/GetAll?";
        if (medicationId === null)
            throw new Error("The parameter 'medicationId' cannot be null.");
        else if (medicationId !== undefined)
            url_ += "MedicationId=" + encodeURIComponent("" + medicationId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (chronologyEventId === null)
            throw new Error("The parameter 'chronologyEventId' cannot be null.");
        else if (chronologyEventId !== undefined)
            url_ += "ChronologyEventId=" + encodeURIComponent("" + chronologyEventId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (forOperationalUnit === null)
            throw new Error("The parameter 'forOperationalUnit' cannot be null.");
        else if (forOperationalUnit !== undefined)
            url_ += "ForOperationalUnit=" + encodeURIComponent("" + forOperationalUnit) + "&";
        if (forPatientAssignment === null)
            throw new Error("The parameter 'forPatientAssignment' cannot be null.");
        else if (forPatientAssignment !== undefined)
            url_ += "ForPatientAssignment=" + encodeURIComponent("" + forPatientAssignment) + "&";
        if (forPatientTherapy === null)
            throw new Error("The parameter 'forPatientTherapy' cannot be null.");
        else if (forPatientTherapy !== undefined)
            url_ += "ForPatientTherapy=" + encodeURIComponent("" + forPatientTherapy) + "&";
        if (forImportMedication === null)
            throw new Error("The parameter 'forImportMedication' cannot be null.");
        else if (forImportMedication !== undefined)
            url_ += "ForImportMedication=" + encodeURIComponent("" + forImportMedication) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ChronologyDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChronologyDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ChronologyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChronologyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ChronologyEventServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param forOperationalUnit (optional) 
     * @param forPatientAssignment (optional) 
     * @param forPatientTherapy (optional) 
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(forOperationalUnit: boolean | undefined, forPatientAssignment: boolean | undefined, forPatientTherapy: boolean | undefined, keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ChronologyEvent/GetAll?";
        if (forOperationalUnit === null)
            throw new Error("The parameter 'forOperationalUnit' cannot be null.");
        else if (forOperationalUnit !== undefined)
            url_ += "ForOperationalUnit=" + encodeURIComponent("" + forOperationalUnit) + "&";
        if (forPatientAssignment === null)
            throw new Error("The parameter 'forPatientAssignment' cannot be null.");
        else if (forPatientAssignment !== undefined)
            url_ += "ForPatientAssignment=" + encodeURIComponent("" + forPatientAssignment) + "&";
        if (forPatientTherapy === null)
            throw new Error("The parameter 'forPatientTherapy' cannot be null.");
        else if (forPatientTherapy !== undefined)
            url_ += "ForPatientTherapy=" + encodeURIComponent("" + forPatientTherapy) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CleaningEventServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CleaningEvent/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param environmentTypeId (optional) 
     * @param shiftId (optional) 
     * @param recurrentTypeId (optional) 
     * @param recurrentEndTypeId (optional) 
     * @param date (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @param statusTypeId (optional) 
     * @param note (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(operationalUnitId: number | undefined, environmentTypeId: number | undefined, shiftId: number | undefined, recurrentTypeId: number | undefined, recurrentEndTypeId: number | undefined, date: Date | undefined, dateStart: Date | undefined, dateEnd: Date | undefined, statusTypeId: number | undefined, note: string | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<CleaningEventDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CleaningEvent/GetAll?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (environmentTypeId === null)
            throw new Error("The parameter 'environmentTypeId' cannot be null.");
        else if (environmentTypeId !== undefined)
            url_ += "EnvironmentTypeId=" + encodeURIComponent("" + environmentTypeId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (recurrentTypeId === null)
            throw new Error("The parameter 'recurrentTypeId' cannot be null.");
        else if (recurrentTypeId !== undefined)
            url_ += "RecurrentTypeId=" + encodeURIComponent("" + recurrentTypeId) + "&";
        if (recurrentEndTypeId === null)
            throw new Error("The parameter 'recurrentEndTypeId' cannot be null.");
        else if (recurrentEndTypeId !== undefined)
            url_ += "RecurrentEndTypeId=" + encodeURIComponent("" + recurrentEndTypeId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        if (dateStart === null)
            throw new Error("The parameter 'dateStart' cannot be null.");
        else if (dateStart !== undefined)
            url_ += "DateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toJSON() : "") + "&";
        if (dateEnd === null)
            throw new Error("The parameter 'dateEnd' cannot be null.");
        else if (dateEnd !== undefined)
            url_ += "DateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toJSON() : "") + "&";
        if (statusTypeId === null)
            throw new Error("The parameter 'statusTypeId' cannot be null.");
        else if (statusTypeId !== undefined)
            url_ += "StatusTypeId=" + encodeURIComponent("" + statusTypeId) + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CleaningEventDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CleaningEventDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CleaningEventDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CleaningEventDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param environmentTypeId (optional) 
     * @param shiftId (optional) 
     * @param recurrentTypeId (optional) 
     * @param recurrentEndTypeId (optional) 
     * @param date (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @param statusTypeId (optional) 
     * @param note (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getFileExport(operationalUnitId: number | undefined, environmentTypeId: number | undefined, shiftId: number | undefined, recurrentTypeId: number | undefined, recurrentEndTypeId: number | undefined, date: Date | undefined, dateStart: Date | undefined, dateEnd: Date | undefined, statusTypeId: number | undefined, note: string | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/api/services/app/CleaningEvent/GetFileExport?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (environmentTypeId === null)
            throw new Error("The parameter 'environmentTypeId' cannot be null.");
        else if (environmentTypeId !== undefined)
            url_ += "EnvironmentTypeId=" + encodeURIComponent("" + environmentTypeId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (recurrentTypeId === null)
            throw new Error("The parameter 'recurrentTypeId' cannot be null.");
        else if (recurrentTypeId !== undefined)
            url_ += "RecurrentTypeId=" + encodeURIComponent("" + recurrentTypeId) + "&";
        if (recurrentEndTypeId === null)
            throw new Error("The parameter 'recurrentEndTypeId' cannot be null.");
        else if (recurrentEndTypeId !== undefined)
            url_ += "RecurrentEndTypeId=" + encodeURIComponent("" + recurrentEndTypeId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        if (dateStart === null)
            throw new Error("The parameter 'dateStart' cannot be null.");
        else if (dateStart !== undefined)
            url_ += "DateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toJSON() : "") + "&";
        if (dateEnd === null)
            throw new Error("The parameter 'dateEnd' cannot be null.");
        else if (dateEnd !== undefined)
            url_ += "DateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toJSON() : "") + "&";
        if (statusTypeId === null)
            throw new Error("The parameter 'statusTypeId' cannot be null.");
        else if (statusTypeId !== undefined)
            url_ += "StatusTypeId=" + encodeURIComponent("" + statusTypeId) + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileExport(<any>response_);
                } catch (e) {
                    return <Observable<FileExportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileExport(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param environmentTypeId (optional) 
     * @param shiftId (optional) 
     * @param recurrentTypeId (optional) 
     * @param recurrentEndTypeId (optional) 
     * @param date (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @param statusTypeId (optional) 
     * @param note (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getFileRecurrenceExport(operationalUnitId: number | undefined, environmentTypeId: number | undefined, shiftId: number | undefined, recurrentTypeId: number | undefined, recurrentEndTypeId: number | undefined, date: Date | undefined, dateStart: Date | undefined, dateEnd: Date | undefined, statusTypeId: number | undefined, note: string | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/api/services/app/CleaningEvent/GetFileRecurrenceExport?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (environmentTypeId === null)
            throw new Error("The parameter 'environmentTypeId' cannot be null.");
        else if (environmentTypeId !== undefined)
            url_ += "EnvironmentTypeId=" + encodeURIComponent("" + environmentTypeId) + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (recurrentTypeId === null)
            throw new Error("The parameter 'recurrentTypeId' cannot be null.");
        else if (recurrentTypeId !== undefined)
            url_ += "RecurrentTypeId=" + encodeURIComponent("" + recurrentTypeId) + "&";
        if (recurrentEndTypeId === null)
            throw new Error("The parameter 'recurrentEndTypeId' cannot be null.");
        else if (recurrentEndTypeId !== undefined)
            url_ += "RecurrentEndTypeId=" + encodeURIComponent("" + recurrentEndTypeId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        if (dateStart === null)
            throw new Error("The parameter 'dateStart' cannot be null.");
        else if (dateStart !== undefined)
            url_ += "DateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toJSON() : "") + "&";
        if (dateEnd === null)
            throw new Error("The parameter 'dateEnd' cannot be null.");
        else if (dateEnd !== undefined)
            url_ += "DateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toJSON() : "") + "&";
        if (statusTypeId === null)
            throw new Error("The parameter 'statusTypeId' cannot be null.");
        else if (statusTypeId !== undefined)
            url_ += "StatusTypeId=" + encodeURIComponent("" + statusTypeId) + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileRecurrenceExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileRecurrenceExport(<any>response_);
                } catch (e) {
                    return <Observable<FileExportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileRecurrenceExport(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCleaningEventDto | undefined): Observable<CleaningEventDto> {
        let url_ = this.baseUrl + "/api/services/app/CleaningEvent/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CleaningEventDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CleaningEventDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CleaningEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CleaningEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCleaningEventDto | undefined): Observable<CleaningEventDto> {
        let url_ = this.baseUrl + "/api/services/app/CleaningEvent/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CleaningEventDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CleaningEventDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CleaningEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CleaningEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CleaningEventDto> {
        let url_ = this.baseUrl + "/api/services/app/CleaningEvent/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CleaningEventDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CleaningEventDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CleaningEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CleaningEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CleaningStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCleaningStatusDto | undefined): Observable<CleaningStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/CleaningStatus/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CleaningStatusDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CleaningStatusDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CleaningStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CleaningStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CleaningStatus/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCleaningStatusDto | undefined): Observable<CleaningStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/CleaningStatus/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CleaningStatusDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CleaningStatusDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CleaningStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CleaningStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CleaningStatus/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CleaningStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/CleaningStatus/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CleaningStatusDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CleaningStatusDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CleaningStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CleaningStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<CleaningStatusDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CleaningStatus/GetAll?";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CleaningStatusDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CleaningStatusDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CleaningStatusDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CleaningStatusDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CleaningStatusTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CleaningStatusType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ClinicalSummaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateList(body: UpdateClinicalSummaryDto[] | undefined): Observable<ClinicalSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClinicalSummary/UpdateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateList(<any>response_);
                } catch (e) {
                    return <Observable<ClinicalSummaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClinicalSummaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateList(response: HttpResponseBase): Observable<ClinicalSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClinicalSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClinicalSummary/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateClinicalSummaryDto | undefined): Observable<ClinicalSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/ClinicalSummary/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ClinicalSummaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClinicalSummaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ClinicalSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicalSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateClinicalSummaryDto | undefined): Observable<ClinicalSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/ClinicalSummary/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ClinicalSummaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClinicalSummaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ClinicalSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicalSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClinicalSummary/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ClinicalSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/ClinicalSummary/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ClinicalSummaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClinicalSummaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ClinicalSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicalSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicalHistoryId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(medicalHistoryId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<ClinicalSummaryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ClinicalSummary/GetAll?";
        if (medicalHistoryId === null)
            throw new Error("The parameter 'medicalHistoryId' cannot be null.");
        else if (medicalHistoryId !== undefined)
            url_ += "MedicalHistoryId=" + encodeURIComponent("" + medicalHistoryId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ClinicalSummaryDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClinicalSummaryDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ClinicalSummaryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicalSummaryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ClinicalSummaryTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClinicalSummaryType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    changeGitToken(token: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeGitToken?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeGitToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeGitToken(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeGitToken(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DependencyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createList(body: CreateDependencyDto[] | undefined): Observable<DependencyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dependency/CreateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateList(<any>response_);
                } catch (e) {
                    return <Observable<DependencyDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DependencyDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCreateList(response: HttpResponseBase): Observable<DependencyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DependencyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateList(body: UpdateDependencyDto[] | undefined): Observable<DependencyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dependency/UpdateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateList(<any>response_);
                } catch (e) {
                    return <Observable<DependencyDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DependencyDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateList(response: HttpResponseBase): Observable<DependencyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DependencyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dependency/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateDependencyDto | undefined): Observable<DependencyDto> {
        let url_ = this.baseUrl + "/api/services/app/Dependency/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<DependencyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DependencyDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DependencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DependencyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDependencyDto | undefined): Observable<DependencyDto> {
        let url_ = this.baseUrl + "/api/services/app/Dependency/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<DependencyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DependencyDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DependencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DependencyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Dependency/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DependencyDto> {
        let url_ = this.baseUrl + "/api/services/app/Dependency/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DependencyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DependencyDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DependencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DependencyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param dependencyHistoryId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(dependencyHistoryId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<DependencyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Dependency/GetAll?";
        if (dependencyHistoryId === null)
            throw new Error("The parameter 'dependencyHistoryId' cannot be null.");
        else if (dependencyHistoryId !== undefined)
            url_ += "DependencyHistoryId=" + encodeURIComponent("" + dependencyHistoryId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DependencyDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DependencyDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DependencyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DependencyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DependencyHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param medicalHistoryId (optional) 
     * @param id (optional) 
     * @return Success
     */
    get(medicalHistoryId: number | undefined, id: number | undefined): Observable<DependencyHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/DependencyHistory/Get?";
        if (medicalHistoryId === null)
            throw new Error("The parameter 'medicalHistoryId' cannot be null.");
        else if (medicalHistoryId !== undefined)
            url_ += "MedicalHistoryId=" + encodeURIComponent("" + medicalHistoryId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DependencyHistoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DependencyHistoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DependencyHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DependencyHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicalHistoryId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(medicalHistoryId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<DependencyHistoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DependencyHistory/GetAll?";
        if (medicalHistoryId === null)
            throw new Error("The parameter 'medicalHistoryId' cannot be null.");
        else if (medicalHistoryId !== undefined)
            url_ += "MedicalHistoryId=" + encodeURIComponent("" + medicalHistoryId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DependencyHistoryDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DependencyHistoryDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DependencyHistoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DependencyHistoryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DiaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diary/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param patientId (optional) 
     * @param diaryTypeId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getFileExport(operationalUnitId: number | undefined, patientId: number | undefined, diaryTypeId: number | undefined, startDate: Date | undefined, endDate: Date | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/api/services/app/Diary/GetFileExport?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (diaryTypeId === null)
            throw new Error("The parameter 'diaryTypeId' cannot be null.");
        else if (diaryTypeId !== undefined)
            url_ += "DiaryTypeId=" + encodeURIComponent("" + diaryTypeId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileExport(<any>response_);
                } catch (e) {
                    return <Observable<FileExportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileExport(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateDiaryDto | undefined): Observable<DiaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Diary/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<DiaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DiaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DiaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDiaryDto | undefined): Observable<DiaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Diary/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<DiaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DiaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DiaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Diary/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DiaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Diary/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DiaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DiaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DiaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param patientId (optional) 
     * @param diaryTypeId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(operationalUnitId: number | undefined, patientId: number | undefined, diaryTypeId: number | undefined, startDate: Date | undefined, endDate: Date | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<DiaryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Diary/GetAll?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (diaryTypeId === null)
            throw new Error("The parameter 'diaryTypeId' cannot be null.");
        else if (diaryTypeId !== undefined)
            url_ += "DiaryTypeId=" + encodeURIComponent("" + diaryTypeId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DiaryDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DiaryDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DiaryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiaryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DiaryTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DiaryType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param patientId (optional) 
     * @param operationalUnitId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param startDocumentDate (optional) 
     * @param endDocumentDate (optional) 
     * @param startExpirationDate (optional) 
     * @param endExpirationDate (optional) 
     * @param sender (optional) 
     * @param recipient (optional) 
     * @param description (optional) 
     * @param documentTypeId (optional) 
     * @param isIncoming (optional) 
     * @param protocolNumber (optional) 
     * @param protocolTypeId (optional) 
     * @param isArchived (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(patientId: number | undefined, operationalUnitId: number | undefined, startDate: Date | undefined, endDate: Date | undefined, startDocumentDate: Date | undefined, endDocumentDate: Date | undefined, startExpirationDate: Date | undefined, endExpirationDate: Date | undefined, sender: string | undefined, recipient: string | undefined, description: string | undefined, documentTypeId: number | undefined, isIncoming: boolean | undefined, protocolNumber: string | undefined, protocolTypeId: number | undefined, isArchived: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<DocumentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetAll?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (startDocumentDate === null)
            throw new Error("The parameter 'startDocumentDate' cannot be null.");
        else if (startDocumentDate !== undefined)
            url_ += "StartDocumentDate=" + encodeURIComponent(startDocumentDate ? "" + startDocumentDate.toJSON() : "") + "&";
        if (endDocumentDate === null)
            throw new Error("The parameter 'endDocumentDate' cannot be null.");
        else if (endDocumentDate !== undefined)
            url_ += "EndDocumentDate=" + encodeURIComponent(endDocumentDate ? "" + endDocumentDate.toJSON() : "") + "&";
        if (startExpirationDate === null)
            throw new Error("The parameter 'startExpirationDate' cannot be null.");
        else if (startExpirationDate !== undefined)
            url_ += "StartExpirationDate=" + encodeURIComponent(startExpirationDate ? "" + startExpirationDate.toJSON() : "") + "&";
        if (endExpirationDate === null)
            throw new Error("The parameter 'endExpirationDate' cannot be null.");
        else if (endExpirationDate !== undefined)
            url_ += "EndExpirationDate=" + encodeURIComponent(endExpirationDate ? "" + endExpirationDate.toJSON() : "") + "&";
        if (sender === null)
            throw new Error("The parameter 'sender' cannot be null.");
        else if (sender !== undefined)
            url_ += "Sender=" + encodeURIComponent("" + sender) + "&";
        if (recipient === null)
            throw new Error("The parameter 'recipient' cannot be null.");
        else if (recipient !== undefined)
            url_ += "Recipient=" + encodeURIComponent("" + recipient) + "&";
        if (description === null)
            throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "Description=" + encodeURIComponent("" + description) + "&";
        if (documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else if (documentTypeId !== undefined)
            url_ += "DocumentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (isIncoming === null)
            throw new Error("The parameter 'isIncoming' cannot be null.");
        else if (isIncoming !== undefined)
            url_ += "IsIncoming=" + encodeURIComponent("" + isIncoming) + "&";
        if (protocolNumber === null)
            throw new Error("The parameter 'protocolNumber' cannot be null.");
        else if (protocolNumber !== undefined)
            url_ += "ProtocolNumber=" + encodeURIComponent("" + protocolNumber) + "&";
        if (protocolTypeId === null)
            throw new Error("The parameter 'protocolTypeId' cannot be null.");
        else if (protocolTypeId !== undefined)
            url_ += "ProtocolTypeId=" + encodeURIComponent("" + protocolTypeId) + "&";
        if (isArchived === null)
            throw new Error("The parameter 'isArchived' cannot be null.");
        else if (isArchived !== undefined)
            url_ += "IsArchived=" + encodeURIComponent("" + isArchived) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DocumentDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DocumentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param expiredWithinDays (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getExpiring(expiredWithinDays: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<ExpiringDocumentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetExpiring?";
        if (expiredWithinDays === null)
            throw new Error("The parameter 'expiredWithinDays' cannot be null.");
        else if (expiredWithinDays !== undefined)
            url_ += "ExpiredWithinDays=" + encodeURIComponent("" + expiredWithinDays) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpiring(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpiring(<any>response_);
                } catch (e) {
                    return <Observable<ExpiringDocumentDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExpiringDocumentDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetExpiring(response: HttpResponseBase): Observable<ExpiringDocumentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpiringDocumentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addMedications(body: AddMedicationsToDocumentDto | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/AddMedications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMedications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMedications(<any>response_);
                } catch (e) {
                    return <Observable<DocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processAddMedications(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLinkCandidates(id: number | undefined): Observable<PrescriptionLinkCandidatesDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetLinkCandidates?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLinkCandidates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkCandidates(<any>response_);
                } catch (e) {
                    return <Observable<PrescriptionLinkCandidatesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PrescriptionLinkCandidatesDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLinkCandidates(response: HttpResponseBase): Observable<PrescriptionLinkCandidatesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionLinkCandidatesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    linkPrescription(body: LinkPrescriptionDto | undefined): Observable<PrescriptionLinkCandidatesDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/LinkPrescription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkPrescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkPrescription(<any>response_);
                } catch (e) {
                    return <Observable<PrescriptionLinkCandidatesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PrescriptionLinkCandidatesDto>><any>_observableThrow(response_);
        }));
    }

    protected processLinkPrescription(response: HttpResponseBase): Observable<PrescriptionLinkCandidatesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionLinkCandidatesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @param medicationId (optional) 
     * @param patientMedicationTherapyId (optional) 
     * @return Success
     */
    getPrescriptionRowsForMedication(patientId: number | undefined, medicationId: number | undefined, patientMedicationTherapyId: number | undefined): Observable<PrescriptionRowDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetPrescriptionRowsForMedication?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (medicationId === null)
            throw new Error("The parameter 'medicationId' cannot be null.");
        else if (medicationId !== undefined)
            url_ += "MedicationId=" + encodeURIComponent("" + medicationId) + "&";
        if (patientMedicationTherapyId === null)
            throw new Error("The parameter 'patientMedicationTherapyId' cannot be null.");
        else if (patientMedicationTherapyId !== undefined)
            url_ += "PatientMedicationTherapyId=" + encodeURIComponent("" + patientMedicationTherapyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrescriptionRowsForMedication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrescriptionRowsForMedication(<any>response_);
                } catch (e) {
                    return <Observable<PrescriptionRowDtoListResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PrescriptionRowDtoListResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPrescriptionRowsForMedication(response: HttpResponseBase): Observable<PrescriptionRowDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionRowDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDocumentDto | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<DocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateDocumentDto | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<DocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Document/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    restore(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Document/Restore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestore(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRestore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DocumentTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateDocumentTypeDto | undefined): Observable<DocumentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DocumentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDocumentTypeDto | undefined): Observable<DocumentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DocumentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DocumentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param isAscending (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, isAscending: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, sorting: string | undefined, maxResultCount: number | undefined): Observable<DocumentTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isAscending === null)
            throw new Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "IsAscending=" + encodeURIComponent("" + isAscending) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTypeDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTypeDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DocumentTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EnvironmentTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateEnvironmentTypeDto | undefined): Observable<EnvironmentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/EnvironmentType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<EnvironmentTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EnvironmentTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<EnvironmentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnvironmentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateEnvironmentTypeDto | undefined): Observable<EnvironmentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/EnvironmentType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<EnvironmentTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EnvironmentTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<EnvironmentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnvironmentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EnvironmentType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<EnvironmentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/EnvironmentType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<EnvironmentTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EnvironmentTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EnvironmentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnvironmentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param isAscending (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, isAscending: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, sorting: string | undefined, maxResultCount: number | undefined): Observable<EnvironmentTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EnvironmentType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isAscending === null)
            throw new Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "IsAscending=" + encodeURIComponent("" + isAscending) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<EnvironmentTypeDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EnvironmentTypeDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EnvironmentTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnvironmentTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FamilyHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FamilyHistory/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateFamilyHistoryDto | undefined): Observable<FamilyHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyHistory/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FamilyHistoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FamilyHistoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FamilyHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FamilyHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateFamilyHistoryDto | undefined): Observable<FamilyHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyHistory/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<FamilyHistoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FamilyHistoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FamilyHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FamilyHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FamilyHistory/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicalHistoryId (optional) 
     * @param id (optional) 
     * @return Success
     */
    get(medicalHistoryId: number | undefined, id: number | undefined): Observable<FamilyHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyHistory/Get?";
        if (medicalHistoryId === null)
            throw new Error("The parameter 'medicalHistoryId' cannot be null.");
        else if (medicalHistoryId !== undefined)
            url_ += "MedicalHistoryId=" + encodeURIComponent("" + medicalHistoryId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<FamilyHistoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FamilyHistoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FamilyHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FamilyHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicalHistoryId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(medicalHistoryId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<FamilyHistoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyHistory/GetAll?";
        if (medicalHistoryId === null)
            throw new Error("The parameter 'medicalHistoryId' cannot be null.");
        else if (medicalHistoryId !== undefined)
            url_ += "MedicalHistoryId=" + encodeURIComponent("" + medicalHistoryId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<FamilyHistoryDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FamilyHistoryDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FamilyHistoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FamilyHistoryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FamilyMemberServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createList(body: CreateFamilyMemberDto[] | undefined): Observable<FamilyMemberDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMember/CreateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateList(<any>response_);
                } catch (e) {
                    return <Observable<FamilyMemberDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FamilyMemberDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCreateList(response: HttpResponseBase): Observable<FamilyMemberDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FamilyMemberDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateList(body: UpdateFamilyMemberDto[] | undefined): Observable<FamilyMemberDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMember/UpdateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateList(<any>response_);
                } catch (e) {
                    return <Observable<FamilyMemberDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FamilyMemberDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateList(response: HttpResponseBase): Observable<FamilyMemberDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FamilyMemberDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMember/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateFamilyMemberDto | undefined): Observable<FamilyMemberDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMember/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FamilyMemberDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FamilyMemberDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FamilyMemberDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FamilyMemberDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateFamilyMemberDto | undefined): Observable<FamilyMemberDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMember/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<FamilyMemberDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FamilyMemberDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FamilyMemberDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FamilyMemberDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMember/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<FamilyMemberDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMember/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<FamilyMemberDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FamilyMemberDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FamilyMemberDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FamilyMemberDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param familyHistoryId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(familyHistoryId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<FamilyMemberDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMember/GetAll?";
        if (familyHistoryId === null)
            throw new Error("The parameter 'familyHistoryId' cannot be null.");
        else if (familyHistoryId !== undefined)
            url_ += "FamilyHistoryId=" + encodeURIComponent("" + familyHistoryId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<FamilyMemberDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FamilyMemberDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FamilyMemberDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FamilyMemberDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FamilyMemberTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMemberType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    create(file: FileParameter | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/File/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    downloadFile(fileId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/File/DownloadFile?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(<any>response_);
                } catch (e) {
                    return <Observable<FileDownloadDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDownloadDto>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    getFile(fileId: number | undefined): Observable<FileExtendedDto> {
        let url_ = this.baseUrl + "/api/services/app/File/GetFile?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(<any>response_);
                } catch (e) {
                    return <Observable<FileExtendedDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExtendedDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileExtendedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExtendedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/File/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/File/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param name (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/File/GetAll?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<FileDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FileDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ForensicProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ForensicProfile/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateForensicProfileDto | undefined): Observable<ForensicProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/ForensicProfile/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ForensicProfileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ForensicProfileDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ForensicProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForensicProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateForensicProfileDto | undefined): Observable<ForensicProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/ForensicProfile/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ForensicProfileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ForensicProfileDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ForensicProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForensicProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ForensicProfile/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicalHistoryId (optional) 
     * @param id (optional) 
     * @return Success
     */
    get(medicalHistoryId: number | undefined, id: number | undefined): Observable<ForensicProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/ForensicProfile/Get?";
        if (medicalHistoryId === null)
            throw new Error("The parameter 'medicalHistoryId' cannot be null.");
        else if (medicalHistoryId !== undefined)
            url_ += "MedicalHistoryId=" + encodeURIComponent("" + medicalHistoryId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ForensicProfileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ForensicProfileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ForensicProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForensicProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<ForensicProfileDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ForensicProfile/GetAll?";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ForensicProfileDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ForensicProfileDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ForensicProfileDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForensicProfileDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GenderDictionaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GenderDictionary/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HandoverNoteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HandoverNote/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateHandoverNoteDto | undefined): Observable<HandoverNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/HandoverNote/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<HandoverNoteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HandoverNoteDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<HandoverNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HandoverNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateHandoverNoteDto | undefined): Observable<HandoverNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/HandoverNote/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<HandoverNoteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HandoverNoteDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<HandoverNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HandoverNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HandoverNote/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<HandoverNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/HandoverNote/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<HandoverNoteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HandoverNoteDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HandoverNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HandoverNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param handoverNoteTypeId (optional) 
     * @param shiftTypeId (optional) 
     * @param date (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(operationalUnitId: number | undefined, handoverNoteTypeId: number | undefined, shiftTypeId: number | undefined, date: Date | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<HandoverNoteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HandoverNote/GetAll?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (handoverNoteTypeId === null)
            throw new Error("The parameter 'handoverNoteTypeId' cannot be null.");
        else if (handoverNoteTypeId !== undefined)
            url_ += "HandoverNoteTypeId=" + encodeURIComponent("" + handoverNoteTypeId) + "&";
        if (shiftTypeId === null)
            throw new Error("The parameter 'shiftTypeId' cannot be null.");
        else if (shiftTypeId !== undefined)
            url_ += "ShiftTypeId=" + encodeURIComponent("" + shiftTypeId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<HandoverNoteDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HandoverNoteDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HandoverNoteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HandoverNoteDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HandoverNoteTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HandoverNoteType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HistoryNoteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateHistoryNoteDto | undefined): Observable<HistoryNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/HistoryNote/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<HistoryNoteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HistoryNoteDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<HistoryNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HistoryNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateHistoryNoteDto | undefined): Observable<HistoryNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/HistoryNote/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<HistoryNoteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HistoryNoteDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<HistoryNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HistoryNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HistoryNote/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<HistoryNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/HistoryNote/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<HistoryNoteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HistoryNoteDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HistoryNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HistoryNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicalHistoryId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(medicalHistoryId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<HistoryNoteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HistoryNote/GetAll?";
        if (medicalHistoryId === null)
            throw new Error("The parameter 'medicalHistoryId' cannot be null.");
        else if (medicalHistoryId !== undefined)
            url_ += "MedicalHistoryId=" + encodeURIComponent("" + medicalHistoryId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<HistoryNoteDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HistoryNoteDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HistoryNoteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HistoryNoteDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HistoryNoteTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HistoryNoteType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class IntoleranceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateIntoleranceDto | undefined): Observable<IntoleranceDto> {
        let url_ = this.baseUrl + "/api/services/app/Intolerance/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<IntoleranceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IntoleranceDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<IntoleranceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntoleranceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateIntoleranceDto | undefined): Observable<IntoleranceDto> {
        let url_ = this.baseUrl + "/api/services/app/Intolerance/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<IntoleranceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IntoleranceDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<IntoleranceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntoleranceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Intolerance/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Intolerance/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<IntoleranceDto> {
        let url_ = this.baseUrl + "/api/services/app/Intolerance/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<IntoleranceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IntoleranceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<IntoleranceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntoleranceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicalHistoryId (optional) 
     * @param isOther (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(medicalHistoryId: number | undefined, isOther: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<IntoleranceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Intolerance/GetAll?";
        if (medicalHistoryId === null)
            throw new Error("The parameter 'medicalHistoryId' cannot be null.");
        else if (medicalHistoryId !== undefined)
            url_ += "MedicalHistoryId=" + encodeURIComponent("" + medicalHistoryId) + "&";
        if (isOther === null)
            throw new Error("The parameter 'isOther' cannot be null.");
        else if (isOther !== undefined)
            url_ += "IsOther=" + encodeURIComponent("" + isOther) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<IntoleranceDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IntoleranceDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<IntoleranceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntoleranceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MealMarkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MealMark/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MealSlotServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MealSlot/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicalHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMedicalHistoryDto | undefined): Observable<MedicalHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalHistory/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MedicalHistoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalHistoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MedicalHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMedicalHistoryDto | undefined): Observable<MedicalHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalHistory/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MedicalHistoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalHistoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MedicalHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicalHistory/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MedicalHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalHistory/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MedicalHistoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalHistoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MedicalHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @param operationalUnitId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(patientId: number | undefined, operationalUnitId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<MedicalHistoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalHistory/GetAll?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MedicalHistoryDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalHistoryDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MedicalHistoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalHistoryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicalHistoryFileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicalHistoryFile/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMedicalHistoryFileDto | undefined): Observable<MedicalHistoryFileDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalHistoryFile/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MedicalHistoryFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalHistoryFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MedicalHistoryFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalHistoryFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MedicalHistoryFileDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalHistoryFile/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MedicalHistoryFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalHistoryFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MedicalHistoryFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalHistoryFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param allergyId (optional) 
     * @param intoleranceId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(allergyId: number | undefined, intoleranceId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<MedicalHistoryFileDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicalHistoryFile/GetAll?";
        if (allergyId === null)
            throw new Error("The parameter 'allergyId' cannot be null.");
        else if (allergyId !== undefined)
            url_ += "AllergyId=" + encodeURIComponent("" + allergyId) + "&";
        if (intoleranceId === null)
            throw new Error("The parameter 'intoleranceId' cannot be null.");
        else if (intoleranceId !== undefined)
            url_ += "IntoleranceId=" + encodeURIComponent("" + intoleranceId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MedicalHistoryFileDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicalHistoryFileDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MedicalHistoryFileDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalHistoryFileDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMedicationDto | undefined): Observable<MedicationDto> {
        let url_ = this.baseUrl + "/api/services/app/Medication/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MedicationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MedicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMedicationDto | undefined): Observable<MedicationDto> {
        let url_ = this.baseUrl + "/api/services/app/Medication/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MedicationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MedicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Medication/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateMedicationEquivalence(body: CreateMedicationEquivalenceListDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Medication/CreateUpdateMedicationEquivalence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateMedicationEquivalence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateMedicationEquivalence(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateUpdateMedicationEquivalence(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    checkIfMedicationInUseForTherapy(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Medication/CheckIfMedicationInUseForTherapy?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfMedicationInUseForTherapy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfMedicationInUseForTherapy(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIfMedicationInUseForTherapy(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    medicationToggle(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Medication/MedicationToggle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMedicationToggle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMedicationToggle(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMedicationToggle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param patientId (optional) 
     * @param predictionDay (optional) 
     * @param keyword (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getMedicationsUnderStock(operationalUnitId: number | undefined, patientId: number | undefined, predictionDay: Date | undefined, keyword: string | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<MedicationUnderStockDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Medication/GetMedicationsUnderStock?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (predictionDay === null)
            throw new Error("The parameter 'predictionDay' cannot be null.");
        else if (predictionDay !== undefined)
            url_ += "PredictionDay=" + encodeURIComponent(predictionDay ? "" + predictionDay.toJSON() : "") + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicationsUnderStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicationsUnderStock(<any>response_);
                } catch (e) {
                    return <Observable<MedicationUnderStockDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationUnderStockDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMedicationsUnderStock(response: HttpResponseBase): Observable<MedicationUnderStockDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationUnderStockDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param dryRun (optional) 
     * @param file (optional) 
     * @return Success
     */
    importMedicationsFromCsv(dryRun: boolean | undefined, file: FileParameter | undefined): Observable<MedicationImportLog> {
        let url_ = this.baseUrl + "/api/services/app/Medication/ImportMedicationsFromCsv?";
        if (dryRun === null)
            throw new Error("The parameter 'dryRun' cannot be null.");
        else if (dryRun !== undefined)
            url_ += "dryRun=" + encodeURIComponent("" + dryRun) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportMedicationsFromCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportMedicationsFromCsv(<any>response_);
                } catch (e) {
                    return <Observable<MedicationImportLog>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationImportLog>><any>_observableThrow(response_);
        }));
    }

    protected processImportMedicationsFromCsv(response: HttpResponseBase): Observable<MedicationImportLog> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationImportLog.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicationPharmaceuticalFormTypeId (optional) 
     * @param medicationPackagingTypeId (optional) 
     * @param medicationStrengthUnitTypeId (optional) 
     * @param isActive (optional) 
     * @param activeIngredients (optional) 
     * @param keyword (optional) 
     * @param isDeleted (optional) 
     * @param hasEanCode (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAllSimpleMedication(medicationPharmaceuticalFormTypeId: number | undefined, medicationPackagingTypeId: number | undefined, medicationStrengthUnitTypeId: number | undefined, isActive: boolean | undefined, activeIngredients: string | undefined, keyword: string | undefined, isDeleted: boolean | undefined, hasEanCode: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<BaseMedicationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Medication/GetAllSimpleMedication?";
        if (medicationPharmaceuticalFormTypeId === null)
            throw new Error("The parameter 'medicationPharmaceuticalFormTypeId' cannot be null.");
        else if (medicationPharmaceuticalFormTypeId !== undefined)
            url_ += "MedicationPharmaceuticalFormTypeId=" + encodeURIComponent("" + medicationPharmaceuticalFormTypeId) + "&";
        if (medicationPackagingTypeId === null)
            throw new Error("The parameter 'medicationPackagingTypeId' cannot be null.");
        else if (medicationPackagingTypeId !== undefined)
            url_ += "MedicationPackagingTypeId=" + encodeURIComponent("" + medicationPackagingTypeId) + "&";
        if (medicationStrengthUnitTypeId === null)
            throw new Error("The parameter 'medicationStrengthUnitTypeId' cannot be null.");
        else if (medicationStrengthUnitTypeId !== undefined)
            url_ += "MedicationStrengthUnitTypeId=" + encodeURIComponent("" + medicationStrengthUnitTypeId) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (activeIngredients === null)
            throw new Error("The parameter 'activeIngredients' cannot be null.");
        else if (activeIngredients !== undefined)
            url_ += "ActiveIngredients=" + encodeURIComponent("" + activeIngredients) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (hasEanCode === null)
            throw new Error("The parameter 'hasEanCode' cannot be null.");
        else if (hasEanCode !== undefined)
            url_ += "HasEanCode=" + encodeURIComponent("" + hasEanCode) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSimpleMedication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSimpleMedication(<any>response_);
                } catch (e) {
                    return <Observable<BaseMedicationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseMedicationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSimpleMedication(response: HttpResponseBase): Observable<BaseMedicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BaseMedicationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MedicationDto> {
        let url_ = this.baseUrl + "/api/services/app/Medication/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MedicationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MedicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicationPharmaceuticalFormTypeId (optional) 
     * @param medicationPackagingTypeId (optional) 
     * @param medicationStrengthUnitTypeId (optional) 
     * @param isActive (optional) 
     * @param activeIngredients (optional) 
     * @param keyword (optional) 
     * @param isDeleted (optional) 
     * @param hasEanCode (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(medicationPharmaceuticalFormTypeId: number | undefined, medicationPackagingTypeId: number | undefined, medicationStrengthUnitTypeId: number | undefined, isActive: boolean | undefined, activeIngredients: string | undefined, keyword: string | undefined, isDeleted: boolean | undefined, hasEanCode: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<MedicationItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Medication/GetAll?";
        if (medicationPharmaceuticalFormTypeId === null)
            throw new Error("The parameter 'medicationPharmaceuticalFormTypeId' cannot be null.");
        else if (medicationPharmaceuticalFormTypeId !== undefined)
            url_ += "MedicationPharmaceuticalFormTypeId=" + encodeURIComponent("" + medicationPharmaceuticalFormTypeId) + "&";
        if (medicationPackagingTypeId === null)
            throw new Error("The parameter 'medicationPackagingTypeId' cannot be null.");
        else if (medicationPackagingTypeId !== undefined)
            url_ += "MedicationPackagingTypeId=" + encodeURIComponent("" + medicationPackagingTypeId) + "&";
        if (medicationStrengthUnitTypeId === null)
            throw new Error("The parameter 'medicationStrengthUnitTypeId' cannot be null.");
        else if (medicationStrengthUnitTypeId !== undefined)
            url_ += "MedicationStrengthUnitTypeId=" + encodeURIComponent("" + medicationStrengthUnitTypeId) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (activeIngredients === null)
            throw new Error("The parameter 'activeIngredients' cannot be null.");
        else if (activeIngredients !== undefined)
            url_ += "ActiveIngredients=" + encodeURIComponent("" + activeIngredients) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (hasEanCode === null)
            throw new Error("The parameter 'hasEanCode' cannot be null.");
        else if (hasEanCode !== undefined)
            url_ += "HasEanCode=" + encodeURIComponent("" + hasEanCode) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MedicationItemDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationItemDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MedicationItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicationAdministrationRouteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicationAdministrationRoute/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicationBarcodeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMedicationBarcodeDto | undefined): Observable<MedicationBarcodeDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationBarcode/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MedicationBarcodeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationBarcodeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MedicationBarcodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationBarcodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicationBarcode/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MedicationBarcodeDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationBarcode/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MedicationBarcodeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationBarcodeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MedicationBarcodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationBarcodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicationId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(medicationId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<MedicationBarcodeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationBarcode/GetAll?";
        if (medicationId === null)
            throw new Error("The parameter 'medicationId' cannot be null.");
        else if (medicationId !== undefined)
            url_ += "MedicationId=" + encodeURIComponent("" + medicationId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MedicationBarcodeDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationBarcodeDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MedicationBarcodeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationBarcodeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicationOrderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMedicationOrderDto | undefined): Observable<MedicationOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationOrder/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MedicationOrderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationOrderDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MedicationOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMedicationOrderDto | undefined): Observable<MedicationOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationOrder/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MedicationOrderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationOrderDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MedicationOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicationOrder/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    sendOrder(id: number | undefined): Observable<MedicationOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationOrder/SendOrder?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendOrder(<any>response_);
                } catch (e) {
                    return <Observable<MedicationOrderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationOrderDto>><any>_observableThrow(response_);
        }));
    }

    protected processSendOrder(response: HttpResponseBase): Observable<MedicationOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @return Success
     */
    getOrCreateActiveOrder(operationalUnitId: number | undefined): Observable<SimpleMedicationOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationOrder/GetOrCreateActiveOrder?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "operationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrCreateActiveOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrCreateActiveOrder(<any>response_);
                } catch (e) {
                    return <Observable<SimpleMedicationOrderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SimpleMedicationOrderDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrCreateActiveOrder(response: HttpResponseBase): Observable<SimpleMedicationOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleMedicationOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getExport(id: number | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationOrder/GetExport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExport(<any>response_);
                } catch (e) {
                    return <Observable<FileExportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetExport(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MedicationOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationOrder/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MedicationOrderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationOrderDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MedicationOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param orderNumber (optional) 
     * @param patientId (optional) 
     * @param operationalUnitId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param medicationOrderStatusId (optional) 
     * @param isActive (optional) 
     * @param creatorUserId (optional) 
     * @param note (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(orderNumber: string | undefined, patientId: number | undefined, operationalUnitId: number | undefined, startDate: Date | undefined, endDate: Date | undefined, medicationOrderStatusId: number | undefined, isActive: boolean | undefined, creatorUserId: number | undefined, note: string | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<MedicationOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationOrder/GetAll?";
        if (orderNumber === null)
            throw new Error("The parameter 'orderNumber' cannot be null.");
        else if (orderNumber !== undefined)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (medicationOrderStatusId === null)
            throw new Error("The parameter 'medicationOrderStatusId' cannot be null.");
        else if (medicationOrderStatusId !== undefined)
            url_ += "MedicationOrderStatusId=" + encodeURIComponent("" + medicationOrderStatusId) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (creatorUserId === null)
            throw new Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MedicationOrderDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationOrderDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MedicationOrderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationOrderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicationOrderDetailServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMedicationOrderDetailDto | undefined): Observable<MedicationOrderDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationOrderDetail/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MedicationOrderDetailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationOrderDetailDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MedicationOrderDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationOrderDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMedicationOrderDetailDto | undefined): Observable<MedicationOrderDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationOrderDetail/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MedicationOrderDetailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationOrderDetailDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MedicationOrderDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationOrderDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicationOrderDetail/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MedicationOrderDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationOrderDetail/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MedicationOrderDetailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationOrderDetailDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MedicationOrderDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationOrderDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicationOrderId (optional) 
     * @param medicationId (optional) 
     * @param note (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(medicationOrderId: number | undefined, medicationId: number | undefined, note: string | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<MedicationOrderDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationOrderDetail/GetAll?";
        if (medicationOrderId === null)
            throw new Error("The parameter 'medicationOrderId' cannot be null.");
        else if (medicationOrderId !== undefined)
            url_ += "MedicationOrderId=" + encodeURIComponent("" + medicationOrderId) + "&";
        if (medicationId === null)
            throw new Error("The parameter 'medicationId' cannot be null.");
        else if (medicationId !== undefined)
            url_ += "MedicationId=" + encodeURIComponent("" + medicationId) + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MedicationOrderDetailDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationOrderDetailDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MedicationOrderDetailDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationOrderDetailDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicationPackagingTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicationPackagingType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicationPharmaceuticalFormTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicationPharmaceuticalFormType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicationStockServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    loadStructureStock(body: LoadStructureMedicationStockDto | undefined): Observable<MedicationStockDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStock/LoadStructureStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadStructureStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadStructureStock(<any>response_);
                } catch (e) {
                    return <Observable<MedicationStockDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationStockDto>><any>_observableThrow(response_);
        }));
    }

    protected processLoadStructureStock(response: HttpResponseBase): Observable<MedicationStockDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationStockDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param expiredWithinDays (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getExpiring(expiredWithinDays: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<ExpiringMedicationStockDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStock/GetExpiring?";
        if (expiredWithinDays === null)
            throw new Error("The parameter 'expiredWithinDays' cannot be null.");
        else if (expiredWithinDays !== undefined)
            url_ += "ExpiredWithinDays=" + encodeURIComponent("" + expiredWithinDays) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpiring(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpiring(<any>response_);
                } catch (e) {
                    return <Observable<ExpiringMedicationStockDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExpiringMedicationStockDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetExpiring(response: HttpResponseBase): Observable<ExpiringMedicationStockDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpiringMedicationStockDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param medicationId (optional) 
     * @param patientId (optional) 
     * @param expirationStatusStaticCode (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getExpirationOverview(operationalUnitId: number | undefined, medicationId: number | undefined, patientId: number | undefined, expirationStatusStaticCode: string | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<MedicationStockExpirationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStock/GetExpirationOverview?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (medicationId === null)
            throw new Error("The parameter 'medicationId' cannot be null.");
        else if (medicationId !== undefined)
            url_ += "MedicationId=" + encodeURIComponent("" + medicationId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (expirationStatusStaticCode === null)
            throw new Error("The parameter 'expirationStatusStaticCode' cannot be null.");
        else if (expirationStatusStaticCode !== undefined)
            url_ += "ExpirationStatusStaticCode=" + encodeURIComponent("" + expirationStatusStaticCode) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpirationOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpirationOverview(<any>response_);
                } catch (e) {
                    return <Observable<MedicationStockExpirationDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationStockExpirationDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetExpirationOverview(response: HttpResponseBase): Observable<MedicationStockExpirationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationStockExpirationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMedicationStockDto | undefined): Observable<MedicationStockDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStock/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MedicationStockDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationStockDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MedicationStockDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationStockDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMedicationStockDto | undefined): Observable<MedicationStockDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStock/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MedicationStockDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationStockDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MedicationStockDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationStockDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStock/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MedicationStockDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStock/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MedicationStockDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationStockDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MedicationStockDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationStockDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicationId (optional) 
     * @param operationalUnitId (optional) 
     * @param patientId (optional) 
     * @param onlyWithoutCode (optional) 
     * @param medicationKeyword (optional) 
     * @param packageCode (optional) 
     * @param medicationStockLocationStaticCode (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(medicationId: number | undefined, operationalUnitId: number | undefined, patientId: number | undefined, onlyWithoutCode: boolean | undefined, medicationKeyword: string | undefined, packageCode: string | undefined, medicationStockLocationStaticCode: string | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<MedicationStockDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStock/GetAll?";
        if (medicationId === null)
            throw new Error("The parameter 'medicationId' cannot be null.");
        else if (medicationId !== undefined)
            url_ += "MedicationId=" + encodeURIComponent("" + medicationId) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (onlyWithoutCode === null)
            throw new Error("The parameter 'onlyWithoutCode' cannot be null.");
        else if (onlyWithoutCode !== undefined)
            url_ += "OnlyWithoutCode=" + encodeURIComponent("" + onlyWithoutCode) + "&";
        if (medicationKeyword === null)
            throw new Error("The parameter 'medicationKeyword' cannot be null.");
        else if (medicationKeyword !== undefined)
            url_ += "MedicationKeyword=" + encodeURIComponent("" + medicationKeyword) + "&";
        if (packageCode === null)
            throw new Error("The parameter 'packageCode' cannot be null.");
        else if (packageCode !== undefined)
            url_ += "PackageCode=" + encodeURIComponent("" + packageCode) + "&";
        if (medicationStockLocationStaticCode === null)
            throw new Error("The parameter 'medicationStockLocationStaticCode' cannot be null.");
        else if (medicationStockLocationStaticCode !== undefined)
            url_ += "MedicationStockLocationStaticCode=" + encodeURIComponent("" + medicationStockLocationStaticCode) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MedicationStockDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationStockDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MedicationStockDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationStockDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicationStockAdjustmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dischargeUnits(body: DischargeUnitsInput | undefined): Observable<StockAdjustmentResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockAdjustment/DischargeUnits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDischargeUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDischargeUnits(<any>response_);
                } catch (e) {
                    return <Observable<StockAdjustmentResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockAdjustmentResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processDischargeUnits(response: HttpResponseBase): Observable<StockAdjustmentResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockAdjustmentResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    restoreUnits(body: RestoreUnitsInput | undefined): Observable<StockAdjustmentResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockAdjustment/RestoreUnits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreUnits(<any>response_);
                } catch (e) {
                    return <Observable<StockAdjustmentResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockAdjustmentResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processRestoreUnits(response: HttpResponseBase): Observable<StockAdjustmentResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockAdjustmentResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dischargePackage(body: DischargePackageInput | undefined): Observable<StockAdjustmentResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockAdjustment/DischargePackage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDischargePackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDischargePackage(<any>response_);
                } catch (e) {
                    return <Observable<StockAdjustmentResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockAdjustmentResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processDischargePackage(response: HttpResponseBase): Observable<StockAdjustmentResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockAdjustmentResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @param units (optional) 
     * @return Success
     */
    getImpact(medicationStockCode: string, patientId: number | undefined, units: number | undefined): Observable<StockImpactDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockAdjustment/GetImpact?";
        if (medicationStockCode === undefined || medicationStockCode === null)
            throw new Error("The parameter 'medicationStockCode' must be defined and cannot be null.");
        else
            url_ += "MedicationStockCode=" + encodeURIComponent("" + medicationStockCode) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (units === null)
            throw new Error("The parameter 'units' cannot be null.");
        else if (units !== undefined)
            url_ += "Units=" + encodeURIComponent("" + units) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImpact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImpact(<any>response_);
                } catch (e) {
                    return <Observable<StockImpactDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockImpactDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetImpact(response: HttpResponseBase): Observable<StockImpactDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockImpactDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    getOutOfStockMedications(patientId: number | undefined): Observable<StockImpactDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockAdjustment/GetOutOfStockMedications?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutOfStockMedications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutOfStockMedications(<any>response_);
                } catch (e) {
                    return <Observable<StockImpactDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockImpactDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOutOfStockMedications(response: HttpResponseBase): Observable<StockImpactDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockImpactDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicationStockCodeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMedicationStockCodeDto | undefined): Observable<MedicationStockCodeDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockCode/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MedicationStockCodeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationStockCodeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MedicationStockCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationStockCodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    printCodes(body: PrintMedicationStockCodesDto | undefined): Observable<PrintMedicationStockCodesResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockCode/PrintCodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrintCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintCodes(<any>response_);
                } catch (e) {
                    return <Observable<PrintMedicationStockCodesResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PrintMedicationStockCodesResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processPrintCodes(response: HttpResponseBase): Observable<PrintMedicationStockCodesResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintMedicationStockCodesResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockCode/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getByCode(code: string | undefined): Observable<MedicationStockCodeLookupDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockCode/GetByCode?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCode(<any>response_);
                } catch (e) {
                    return <Observable<MedicationStockCodeLookupDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationStockCodeLookupDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByCode(response: HttpResponseBase): Observable<MedicationStockCodeLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationStockCodeLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MedicationStockCodeDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockCode/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MedicationStockCodeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationStockCodeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MedicationStockCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationStockCodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicationStockId (optional) 
     * @param operationalUnitId (optional) 
     * @param code (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(medicationStockId: number | undefined, operationalUnitId: number | undefined, code: string | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<MedicationStockCodeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockCode/GetAll?";
        if (medicationStockId === null)
            throw new Error("The parameter 'medicationStockId' cannot be null.");
        else if (medicationStockId !== undefined)
            url_ += "MedicationStockId=" + encodeURIComponent("" + medicationStockId) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MedicationStockCodeDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationStockCodeDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MedicationStockCodeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationStockCodeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicationStockCodeStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockCodeStatus/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicationStockHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    get(medicationStockCode: string, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StockHistoryEntryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockHistory/Get?";
        if (medicationStockCode === undefined || medicationStockCode === null)
            throw new Error("The parameter 'medicationStockCode' must be defined and cannot be null.");
        else
            url_ += "MedicationStockCode=" + encodeURIComponent("" + medicationStockCode) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<StockHistoryEntryDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockHistoryEntryDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StockHistoryEntryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockHistoryEntryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicationStockLoanServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    lend(body: LendMedicationStockInput | undefined): Observable<LendMedicationStockResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockLoan/Lend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLend(<any>response_);
                } catch (e) {
                    return <Observable<LendMedicationStockResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LendMedicationStockResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processLend(response: HttpResponseBase): Observable<LendMedicationStockResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LendMedicationStockResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancel(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockLoan/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param receiverPatientId (optional) 
     * @return Success
     */
    getCandidateRows(receiverPatientId: number | undefined, medicationStockCode: string): Observable<LoanCandidateRowDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockLoan/GetCandidateRows?";
        if (receiverPatientId === null)
            throw new Error("The parameter 'receiverPatientId' cannot be null.");
        else if (receiverPatientId !== undefined)
            url_ += "ReceiverPatientId=" + encodeURIComponent("" + receiverPatientId) + "&";
        if (medicationStockCode === undefined || medicationStockCode === null)
            throw new Error("The parameter 'medicationStockCode' must be defined and cannot be null.");
        else
            url_ += "MedicationStockCode=" + encodeURIComponent("" + medicationStockCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateRows(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateRows(<any>response_);
                } catch (e) {
                    return <Observable<LoanCandidateRowDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoanCandidateRowDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCandidateRows(response: HttpResponseBase): Observable<LoanCandidateRowDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LoanCandidateRowDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicationStockReasonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMedicationStockReasonDto | undefined): Observable<MedicationStockReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockReason/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MedicationStockReasonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationStockReasonDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MedicationStockReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationStockReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMedicationStockReasonDto | undefined): Observable<MedicationStockReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockReason/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MedicationStockReasonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationStockReasonDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MedicationStockReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationStockReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockReason/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MedicationStockReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockReason/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MedicationStockReasonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationStockReasonDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MedicationStockReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationStockReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param applicableToUnitIncrease (optional) 
     * @param applicableToUnitDecrease (optional) 
     * @param applicableToPackageDischarge (optional) 
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param isAscending (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(applicableToUnitIncrease: boolean | undefined, applicableToUnitDecrease: boolean | undefined, applicableToPackageDischarge: boolean | undefined, keyword: string | undefined, isActive: boolean | undefined, isAscending: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, sorting: string | undefined, maxResultCount: number | undefined): Observable<MedicationStockReasonDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockReason/GetAll?";
        if (applicableToUnitIncrease === null)
            throw new Error("The parameter 'applicableToUnitIncrease' cannot be null.");
        else if (applicableToUnitIncrease !== undefined)
            url_ += "ApplicableToUnitIncrease=" + encodeURIComponent("" + applicableToUnitIncrease) + "&";
        if (applicableToUnitDecrease === null)
            throw new Error("The parameter 'applicableToUnitDecrease' cannot be null.");
        else if (applicableToUnitDecrease !== undefined)
            url_ += "ApplicableToUnitDecrease=" + encodeURIComponent("" + applicableToUnitDecrease) + "&";
        if (applicableToPackageDischarge === null)
            throw new Error("The parameter 'applicableToPackageDischarge' cannot be null.");
        else if (applicableToPackageDischarge !== undefined)
            url_ += "ApplicableToPackageDischarge=" + encodeURIComponent("" + applicableToPackageDischarge) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isAscending === null)
            throw new Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "IsAscending=" + encodeURIComponent("" + isAscending) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MedicationStockReasonDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MedicationStockReasonDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MedicationStockReasonDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationStockReasonDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicationStockTransferServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    preview(body: TransferStockInput | undefined): Observable<TransferWarningDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockTransfer/Preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreview(<any>response_);
                } catch (e) {
                    return <Observable<TransferWarningDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransferWarningDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processPreview(response: HttpResponseBase): Observable<TransferWarningDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransferWarningDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    transfer(body: TransferStockInput | undefined): Observable<TransferStockResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStockTransfer/Transfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransfer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransfer(<any>response_);
                } catch (e) {
                    return <Observable<TransferStockResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransferStockResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processTransfer(response: HttpResponseBase): Observable<TransferStockResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferStockResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicationStrengthUnitTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicationStrengthUnitType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicationTherapyTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MedicationTherapyType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MeetingMinuteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeetingMinute/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MeetingMinute/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param meetingTypeId (optional) 
     * @param topic (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @param meetingDateStart (optional) 
     * @param meetingDateEnd (optional) 
     * @param creationDateStart (optional) 
     * @param creationDateEnd (optional) 
     * @param userId (optional) 
     * @param patientId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getReportMeetingMinutePatients(operationalUnitId: number | undefined, meetingTypeId: number | undefined, topic: string | undefined, dateStart: Date | undefined, dateEnd: Date | undefined, meetingDateStart: Date | undefined, meetingDateEnd: Date | undefined, creationDateStart: Date | undefined, creationDateEnd: Date | undefined, userId: number | undefined, patientId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<MeetingMinutePatientReportDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MeetingMinute/GetReportMeetingMinutePatients?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (meetingTypeId === null)
            throw new Error("The parameter 'meetingTypeId' cannot be null.");
        else if (meetingTypeId !== undefined)
            url_ += "MeetingTypeId=" + encodeURIComponent("" + meetingTypeId) + "&";
        if (topic === null)
            throw new Error("The parameter 'topic' cannot be null.");
        else if (topic !== undefined)
            url_ += "Topic=" + encodeURIComponent("" + topic) + "&";
        if (dateStart === null)
            throw new Error("The parameter 'dateStart' cannot be null.");
        else if (dateStart !== undefined)
            url_ += "DateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toJSON() : "") + "&";
        if (dateEnd === null)
            throw new Error("The parameter 'dateEnd' cannot be null.");
        else if (dateEnd !== undefined)
            url_ += "DateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toJSON() : "") + "&";
        if (meetingDateStart === null)
            throw new Error("The parameter 'meetingDateStart' cannot be null.");
        else if (meetingDateStart !== undefined)
            url_ += "MeetingDateStart=" + encodeURIComponent(meetingDateStart ? "" + meetingDateStart.toJSON() : "") + "&";
        if (meetingDateEnd === null)
            throw new Error("The parameter 'meetingDateEnd' cannot be null.");
        else if (meetingDateEnd !== undefined)
            url_ += "MeetingDateEnd=" + encodeURIComponent(meetingDateEnd ? "" + meetingDateEnd.toJSON() : "") + "&";
        if (creationDateStart === null)
            throw new Error("The parameter 'creationDateStart' cannot be null.");
        else if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toJSON() : "") + "&";
        if (creationDateEnd === null)
            throw new Error("The parameter 'creationDateEnd' cannot be null.");
        else if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toJSON() : "") + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportMeetingMinutePatients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportMeetingMinutePatients(<any>response_);
                } catch (e) {
                    return <Observable<MeetingMinutePatientReportDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MeetingMinutePatientReportDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetReportMeetingMinutePatients(response: HttpResponseBase): Observable<MeetingMinutePatientReportDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingMinutePatientReportDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param meetingTypeId (optional) 
     * @param topic (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @param meetingDateStart (optional) 
     * @param meetingDateEnd (optional) 
     * @param creationDateStart (optional) 
     * @param creationDateEnd (optional) 
     * @param userId (optional) 
     * @param patientId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getExportReportMeetingMinutePatients(operationalUnitId: number | undefined, meetingTypeId: number | undefined, topic: string | undefined, dateStart: Date | undefined, dateEnd: Date | undefined, meetingDateStart: Date | undefined, meetingDateEnd: Date | undefined, creationDateStart: Date | undefined, creationDateEnd: Date | undefined, userId: number | undefined, patientId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/api/services/app/MeetingMinute/GetExportReportMeetingMinutePatients?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (meetingTypeId === null)
            throw new Error("The parameter 'meetingTypeId' cannot be null.");
        else if (meetingTypeId !== undefined)
            url_ += "MeetingTypeId=" + encodeURIComponent("" + meetingTypeId) + "&";
        if (topic === null)
            throw new Error("The parameter 'topic' cannot be null.");
        else if (topic !== undefined)
            url_ += "Topic=" + encodeURIComponent("" + topic) + "&";
        if (dateStart === null)
            throw new Error("The parameter 'dateStart' cannot be null.");
        else if (dateStart !== undefined)
            url_ += "DateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toJSON() : "") + "&";
        if (dateEnd === null)
            throw new Error("The parameter 'dateEnd' cannot be null.");
        else if (dateEnd !== undefined)
            url_ += "DateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toJSON() : "") + "&";
        if (meetingDateStart === null)
            throw new Error("The parameter 'meetingDateStart' cannot be null.");
        else if (meetingDateStart !== undefined)
            url_ += "MeetingDateStart=" + encodeURIComponent(meetingDateStart ? "" + meetingDateStart.toJSON() : "") + "&";
        if (meetingDateEnd === null)
            throw new Error("The parameter 'meetingDateEnd' cannot be null.");
        else if (meetingDateEnd !== undefined)
            url_ += "MeetingDateEnd=" + encodeURIComponent(meetingDateEnd ? "" + meetingDateEnd.toJSON() : "") + "&";
        if (creationDateStart === null)
            throw new Error("The parameter 'creationDateStart' cannot be null.");
        else if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toJSON() : "") + "&";
        if (creationDateEnd === null)
            throw new Error("The parameter 'creationDateEnd' cannot be null.");
        else if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toJSON() : "") + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportReportMeetingMinutePatients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportReportMeetingMinutePatients(<any>response_);
                } catch (e) {
                    return <Observable<FileExportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetExportReportMeetingMinutePatients(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param meetingTypeId (optional) 
     * @param topic (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @param meetingDateStart (optional) 
     * @param meetingDateEnd (optional) 
     * @param creationDateStart (optional) 
     * @param creationDateEnd (optional) 
     * @param userId (optional) 
     * @param patientId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getReportMeetingMinuteUsers(operationalUnitId: number | undefined, meetingTypeId: number | undefined, topic: string | undefined, dateStart: Date | undefined, dateEnd: Date | undefined, meetingDateStart: Date | undefined, meetingDateEnd: Date | undefined, creationDateStart: Date | undefined, creationDateEnd: Date | undefined, userId: number | undefined, patientId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<MeetingMinuteUserReportDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MeetingMinute/GetReportMeetingMinuteUsers?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (meetingTypeId === null)
            throw new Error("The parameter 'meetingTypeId' cannot be null.");
        else if (meetingTypeId !== undefined)
            url_ += "MeetingTypeId=" + encodeURIComponent("" + meetingTypeId) + "&";
        if (topic === null)
            throw new Error("The parameter 'topic' cannot be null.");
        else if (topic !== undefined)
            url_ += "Topic=" + encodeURIComponent("" + topic) + "&";
        if (dateStart === null)
            throw new Error("The parameter 'dateStart' cannot be null.");
        else if (dateStart !== undefined)
            url_ += "DateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toJSON() : "") + "&";
        if (dateEnd === null)
            throw new Error("The parameter 'dateEnd' cannot be null.");
        else if (dateEnd !== undefined)
            url_ += "DateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toJSON() : "") + "&";
        if (meetingDateStart === null)
            throw new Error("The parameter 'meetingDateStart' cannot be null.");
        else if (meetingDateStart !== undefined)
            url_ += "MeetingDateStart=" + encodeURIComponent(meetingDateStart ? "" + meetingDateStart.toJSON() : "") + "&";
        if (meetingDateEnd === null)
            throw new Error("The parameter 'meetingDateEnd' cannot be null.");
        else if (meetingDateEnd !== undefined)
            url_ += "MeetingDateEnd=" + encodeURIComponent(meetingDateEnd ? "" + meetingDateEnd.toJSON() : "") + "&";
        if (creationDateStart === null)
            throw new Error("The parameter 'creationDateStart' cannot be null.");
        else if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toJSON() : "") + "&";
        if (creationDateEnd === null)
            throw new Error("The parameter 'creationDateEnd' cannot be null.");
        else if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toJSON() : "") + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportMeetingMinuteUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportMeetingMinuteUsers(<any>response_);
                } catch (e) {
                    return <Observable<MeetingMinuteUserReportDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MeetingMinuteUserReportDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetReportMeetingMinuteUsers(response: HttpResponseBase): Observable<MeetingMinuteUserReportDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingMinuteUserReportDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param meetingTypeId (optional) 
     * @param topic (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @param meetingDateStart (optional) 
     * @param meetingDateEnd (optional) 
     * @param creationDateStart (optional) 
     * @param creationDateEnd (optional) 
     * @param userId (optional) 
     * @param patientId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getExportReportMeetingMinuteUsers(operationalUnitId: number | undefined, meetingTypeId: number | undefined, topic: string | undefined, dateStart: Date | undefined, dateEnd: Date | undefined, meetingDateStart: Date | undefined, meetingDateEnd: Date | undefined, creationDateStart: Date | undefined, creationDateEnd: Date | undefined, userId: number | undefined, patientId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/api/services/app/MeetingMinute/GetExportReportMeetingMinuteUsers?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (meetingTypeId === null)
            throw new Error("The parameter 'meetingTypeId' cannot be null.");
        else if (meetingTypeId !== undefined)
            url_ += "MeetingTypeId=" + encodeURIComponent("" + meetingTypeId) + "&";
        if (topic === null)
            throw new Error("The parameter 'topic' cannot be null.");
        else if (topic !== undefined)
            url_ += "Topic=" + encodeURIComponent("" + topic) + "&";
        if (dateStart === null)
            throw new Error("The parameter 'dateStart' cannot be null.");
        else if (dateStart !== undefined)
            url_ += "DateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toJSON() : "") + "&";
        if (dateEnd === null)
            throw new Error("The parameter 'dateEnd' cannot be null.");
        else if (dateEnd !== undefined)
            url_ += "DateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toJSON() : "") + "&";
        if (meetingDateStart === null)
            throw new Error("The parameter 'meetingDateStart' cannot be null.");
        else if (meetingDateStart !== undefined)
            url_ += "MeetingDateStart=" + encodeURIComponent(meetingDateStart ? "" + meetingDateStart.toJSON() : "") + "&";
        if (meetingDateEnd === null)
            throw new Error("The parameter 'meetingDateEnd' cannot be null.");
        else if (meetingDateEnd !== undefined)
            url_ += "MeetingDateEnd=" + encodeURIComponent(meetingDateEnd ? "" + meetingDateEnd.toJSON() : "") + "&";
        if (creationDateStart === null)
            throw new Error("The parameter 'creationDateStart' cannot be null.");
        else if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toJSON() : "") + "&";
        if (creationDateEnd === null)
            throw new Error("The parameter 'creationDateEnd' cannot be null.");
        else if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toJSON() : "") + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportReportMeetingMinuteUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportReportMeetingMinuteUsers(<any>response_);
                } catch (e) {
                    return <Observable<FileExportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetExportReportMeetingMinuteUsers(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMeetingMinuteDto | undefined): Observable<MeetingMinuteDto> {
        let url_ = this.baseUrl + "/api/services/app/MeetingMinute/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MeetingMinuteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MeetingMinuteDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MeetingMinuteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingMinuteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMeetingMinuteDto | undefined): Observable<MeetingMinuteDto> {
        let url_ = this.baseUrl + "/api/services/app/MeetingMinute/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MeetingMinuteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MeetingMinuteDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MeetingMinuteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingMinuteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MeetingMinuteDto> {
        let url_ = this.baseUrl + "/api/services/app/MeetingMinute/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MeetingMinuteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MeetingMinuteDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MeetingMinuteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingMinuteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param meetingTypeId (optional) 
     * @param topic (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @param meetingDateStart (optional) 
     * @param meetingDateEnd (optional) 
     * @param creationDateStart (optional) 
     * @param creationDateEnd (optional) 
     * @param userId (optional) 
     * @param patientId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(operationalUnitId: number | undefined, meetingTypeId: number | undefined, topic: string | undefined, dateStart: Date | undefined, dateEnd: Date | undefined, meetingDateStart: Date | undefined, meetingDateEnd: Date | undefined, creationDateStart: Date | undefined, creationDateEnd: Date | undefined, userId: number | undefined, patientId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<MeetingMinuteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MeetingMinute/GetAll?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (meetingTypeId === null)
            throw new Error("The parameter 'meetingTypeId' cannot be null.");
        else if (meetingTypeId !== undefined)
            url_ += "MeetingTypeId=" + encodeURIComponent("" + meetingTypeId) + "&";
        if (topic === null)
            throw new Error("The parameter 'topic' cannot be null.");
        else if (topic !== undefined)
            url_ += "Topic=" + encodeURIComponent("" + topic) + "&";
        if (dateStart === null)
            throw new Error("The parameter 'dateStart' cannot be null.");
        else if (dateStart !== undefined)
            url_ += "DateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toJSON() : "") + "&";
        if (dateEnd === null)
            throw new Error("The parameter 'dateEnd' cannot be null.");
        else if (dateEnd !== undefined)
            url_ += "DateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toJSON() : "") + "&";
        if (meetingDateStart === null)
            throw new Error("The parameter 'meetingDateStart' cannot be null.");
        else if (meetingDateStart !== undefined)
            url_ += "MeetingDateStart=" + encodeURIComponent(meetingDateStart ? "" + meetingDateStart.toJSON() : "") + "&";
        if (meetingDateEnd === null)
            throw new Error("The parameter 'meetingDateEnd' cannot be null.");
        else if (meetingDateEnd !== undefined)
            url_ += "MeetingDateEnd=" + encodeURIComponent(meetingDateEnd ? "" + meetingDateEnd.toJSON() : "") + "&";
        if (creationDateStart === null)
            throw new Error("The parameter 'creationDateStart' cannot be null.");
        else if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toJSON() : "") + "&";
        if (creationDateEnd === null)
            throw new Error("The parameter 'creationDateEnd' cannot be null.");
        else if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toJSON() : "") + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MeetingMinuteDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MeetingMinuteDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MeetingMinuteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingMinuteDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MeetingTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMeetingTypeDto | undefined): Observable<MeetingTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/MeetingType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MeetingTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MeetingTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MeetingTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMeetingTypeDto | undefined): Observable<MeetingTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/MeetingType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MeetingTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MeetingTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MeetingTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeetingType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MeetingTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/MeetingType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MeetingTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MeetingTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MeetingTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param isAscending (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, isAscending: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, sorting: string | undefined, maxResultCount: number | undefined): Observable<MeetingTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MeetingType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isAscending === null)
            throw new Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "IsAscending=" + encodeURIComponent("" + isAscending) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<MeetingTypeDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MeetingTypeDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MeetingTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NationalityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Nationality/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param isRead (optional) 
     * @param userId (optional) 
     * @param operationalUnitId (optional) 
     * @param taskId (optional) 
     * @param environmentTypeId (optional) 
     * @param recurrenceTypeId (optional) 
     * @param onlyReport (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(isRead: boolean | undefined, userId: number | undefined, operationalUnitId: number | undefined, taskId: number | undefined, environmentTypeId: number | undefined, recurrenceTypeId: number | undefined, onlyReport: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<UserNotificationPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetAll?";
        if (isRead === null)
            throw new Error("The parameter 'isRead' cannot be null.");
        else if (isRead !== undefined)
            url_ += "IsRead=" + encodeURIComponent("" + isRead) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (environmentTypeId === null)
            throw new Error("The parameter 'environmentTypeId' cannot be null.");
        else if (environmentTypeId !== undefined)
            url_ += "EnvironmentTypeId=" + encodeURIComponent("" + environmentTypeId) + "&";
        if (recurrenceTypeId === null)
            throw new Error("The parameter 'recurrenceTypeId' cannot be null.");
        else if (recurrenceTypeId !== undefined)
            url_ += "RecurrenceTypeId=" + encodeURIComponent("" + recurrenceTypeId) + "&";
        if (onlyReport === null)
            throw new Error("The parameter 'onlyReport' cannot be null.");
        else if (onlyReport !== undefined)
            url_ += "OnlyReport=" + encodeURIComponent("" + onlyReport) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<UserNotificationPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserNotificationPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserNotificationPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNotificationPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @return Success
     */
    getUnreadNotificationsCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUnreadNotificationsCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnreadNotificationsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnreadNotificationsCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetUnreadNotificationsCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param userNotificationId (optional) 
     * @return Success
     */
    setRead(userNotificationId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetRead?";
        if (userNotificationId === null)
            throw new Error("The parameter 'userNotificationId' cannot be null.");
        else if (userNotificationId !== undefined)
            url_ += "userNotificationId=" + encodeURIComponent("" + userNotificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetRead(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OnCallActivationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateOnCallActivationDto | undefined): Observable<OnCallActivationDto> {
        let url_ = this.baseUrl + "/api/services/app/OnCallActivation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<OnCallActivationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OnCallActivationDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OnCallActivationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnCallActivationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOnCallActivationDto | undefined): Observable<OnCallActivationDto> {
        let url_ = this.baseUrl + "/api/services/app/OnCallActivation/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<OnCallActivationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OnCallActivationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OnCallActivationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnCallActivationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OnCallActivation/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OnCallActivationDto> {
        let url_ = this.baseUrl + "/api/services/app/OnCallActivation/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<OnCallActivationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OnCallActivationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OnCallActivationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnCallActivationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param plannedAssignmentId (optional) 
     * @param plannedSlotId (optional) 
     * @param startDateTime (optional) 
     * @param endDateTime (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(plannedAssignmentId: number | undefined, plannedSlotId: number | undefined, startDateTime: Date | undefined, endDateTime: Date | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<OnCallActivationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OnCallActivation/GetAll?";
        if (plannedAssignmentId === null)
            throw new Error("The parameter 'plannedAssignmentId' cannot be null.");
        else if (plannedAssignmentId !== undefined)
            url_ += "PlannedAssignmentId=" + encodeURIComponent("" + plannedAssignmentId) + "&";
        if (plannedSlotId === null)
            throw new Error("The parameter 'plannedSlotId' cannot be null.");
        else if (plannedSlotId !== undefined)
            url_ += "PlannedSlotId=" + encodeURIComponent("" + plannedSlotId) + "&";
        if (startDateTime === null)
            throw new Error("The parameter 'startDateTime' cannot be null.");
        else if (startDateTime !== undefined)
            url_ += "StartDateTime=" + encodeURIComponent(startDateTime ? "" + startDateTime.toJSON() : "") + "&";
        if (endDateTime === null)
            throw new Error("The parameter 'endDateTime' cannot be null.");
        else if (endDateTime !== undefined)
            url_ += "EndDateTime=" + encodeURIComponent(endDateTime ? "" + endDateTime.toJSON() : "") + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<OnCallActivationDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OnCallActivationDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OnCallActivationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnCallActivationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OnCallTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OnCallType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OperationalUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    canDelete(body: Int64EntityDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnit/CanDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanDelete(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCanDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnit/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    restore(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnit/Restore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestore(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRestore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnit/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assgnManagerToOperationalUnit(body: OperationalUnitUserIdDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnit/AssgnManagerToOperationalUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssgnManagerToOperationalUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssgnManagerToOperationalUnit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAssgnManagerToOperationalUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignUsersToOperationalCenters(body: OperationalUnitUserIdsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnit/AssignUsersToOperationalCenters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignUsersToOperationalCenters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignUsersToOperationalCenters(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAssignUsersToOperationalCenters(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param userIds (optional) 
     * @param operationalUnitIds (optional) 
     * @return Success
     */
    removeUsersFromOperationalCenters(userIds: number[] | undefined, operationalUnitIds: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnit/RemoveUsersFromOperationalCenters?";
        if (userIds === null)
            throw new Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (operationalUnitIds === null)
            throw new Error("The parameter 'operationalUnitIds' cannot be null.");
        else if (operationalUnitIds !== undefined)
            operationalUnitIds && operationalUnitIds.forEach(item => { url_ += "OperationalUnitIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUsersFromOperationalCenters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUsersFromOperationalCenters(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveUsersFromOperationalCenters(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param unitManagerId (optional) 
     * @param isArchived (optional) 
     * @param userId (optional) 
     * @param patientId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    exportOperationalUnity(keyword: string | undefined, unitManagerId: number | undefined, isArchived: boolean | undefined, userId: number | undefined, patientId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnit/ExportOperationalUnity?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (unitManagerId === null)
            throw new Error("The parameter 'unitManagerId' cannot be null.");
        else if (unitManagerId !== undefined)
            url_ += "UnitManagerId=" + encodeURIComponent("" + unitManagerId) + "&";
        if (isArchived === null)
            throw new Error("The parameter 'isArchived' cannot be null.");
        else if (isArchived !== undefined)
            url_ += "IsArchived=" + encodeURIComponent("" + isArchived) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportOperationalUnity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportOperationalUnity(<any>response_);
                } catch (e) {
                    return <Observable<FileExportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExportDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportOperationalUnity(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateOperationalUnitDto | undefined): Observable<OperationalUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnit/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<OperationalUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OperationalUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OperationalUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationalUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOperationalUnitDto | undefined): Observable<OperationalUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnit/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<OperationalUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OperationalUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OperationalUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationalUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OperationalUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnit/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<OperationalUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OperationalUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OperationalUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationalUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param unitManagerId (optional) 
     * @param isArchived (optional) 
     * @param userId (optional) 
     * @param patientId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, unitManagerId: number | undefined, isArchived: boolean | undefined, userId: number | undefined, patientId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<OperationalUnitDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnit/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (unitManagerId === null)
            throw new Error("The parameter 'unitManagerId' cannot be null.");
        else if (unitManagerId !== undefined)
            url_ += "UnitManagerId=" + encodeURIComponent("" + unitManagerId) + "&";
        if (isArchived === null)
            throw new Error("The parameter 'isArchived' cannot be null.");
        else if (isArchived !== undefined)
            url_ += "IsArchived=" + encodeURIComponent("" + isArchived) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<OperationalUnitDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OperationalUnitDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OperationalUnitDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationalUnitDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OperationalUnitExpirationAlertServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateOperationalUnitExpirationAlertDto | undefined): Observable<OperationalUnitExpirationAlertDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnitExpirationAlert/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<OperationalUnitExpirationAlertDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OperationalUnitExpirationAlertDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OperationalUnitExpirationAlertDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationalUnitExpirationAlertDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOperationalUnitExpirationAlertDto | undefined): Observable<OperationalUnitExpirationAlertDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnitExpirationAlert/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<OperationalUnitExpirationAlertDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OperationalUnitExpirationAlertDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OperationalUnitExpirationAlertDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationalUnitExpirationAlertDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnitExpirationAlert/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OperationalUnitExpirationAlertDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnitExpirationAlert/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<OperationalUnitExpirationAlertDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OperationalUnitExpirationAlertDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OperationalUnitExpirationAlertDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationalUnitExpirationAlertDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(operationalUnitId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<OperationalUnitExpirationAlertDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnitExpirationAlert/GetAll?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<OperationalUnitExpirationAlertDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OperationalUnitExpirationAlertDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OperationalUnitExpirationAlertDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationalUnitExpirationAlertDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OperationalUnitFileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param operationalUnitId (optional) 
     * @param fileName (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(operationalUnitId: number | undefined, fileName: string | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<OperationalUnitFileDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnitFile/GetAll?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<OperationalUnitFileDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OperationalUnitFileDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OperationalUnitFileDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationalUnitFileDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    exportFile(id: number | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnitFile/ExportFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFile(<any>response_);
                } catch (e) {
                    return <Observable<FileExportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExportDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportFile(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateOperationalUnitFileDto | undefined): Observable<OperationalUnitFileDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnitFile/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<OperationalUnitFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OperationalUnitFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OperationalUnitFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationalUnitFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOperationalUnitFileDto | undefined): Observable<OperationalUnitFileDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnitFile/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<OperationalUnitFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OperationalUnitFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OperationalUnitFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationalUnitFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnitFile/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OperationalUnitFileDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnitFile/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<OperationalUnitFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OperationalUnitFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OperationalUnitFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationalUnitFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OperationalUnitShiftSlotServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateOperationalUnitShiftSlotDto | undefined): Observable<OperationalUnitShiftSlotDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnitShiftSlot/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<OperationalUnitShiftSlotDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OperationalUnitShiftSlotDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OperationalUnitShiftSlotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationalUnitShiftSlotDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOperationalUnitShiftSlotDto | undefined): Observable<OperationalUnitShiftSlotDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnitShiftSlot/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<OperationalUnitShiftSlotDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OperationalUnitShiftSlotDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OperationalUnitShiftSlotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationalUnitShiftSlotDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnitShiftSlot/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OperationalUnitShiftSlotDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnitShiftSlot/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<OperationalUnitShiftSlotDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OperationalUnitShiftSlotDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OperationalUnitShiftSlotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationalUnitShiftSlotDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param shiftTypeId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(operationalUnitId: number | undefined, shiftTypeId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<OperationalUnitShiftSlotDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationalUnitShiftSlot/GetAll?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (shiftTypeId === null)
            throw new Error("The parameter 'shiftTypeId' cannot be null.");
        else if (shiftTypeId !== undefined)
            url_ += "ShiftTypeId=" + encodeURIComponent("" + shiftTypeId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<OperationalUnitShiftSlotDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OperationalUnitShiftSlotDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OperationalUnitShiftSlotDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationalUnitShiftSlotDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrderStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderStatus/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PatientServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePatientDto | undefined): Observable<PatientDto> {
        let url_ = this.baseUrl + "/api/services/app/Patient/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PatientDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PatientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Patient/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reHospitalizePatient(body: ReHospitalizePatientDto | undefined): Observable<PatientDto> {
        let url_ = this.baseUrl + "/api/services/app/Patient/ReHospitalizePatient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReHospitalizePatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReHospitalizePatient(<any>response_);
                } catch (e) {
                    return <Observable<PatientDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientDto>><any>_observableThrow(response_);
        }));
    }

    protected processReHospitalizePatient(response: HttpResponseBase): Observable<PatientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param doctorId (optional) 
     * @param statusId (optional) 
     * @param nationalityId (optional) 
     * @param isMale (optional) 
     * @param operationalUnitId (optional) 
     * @param mealSlotId (optional) 
     * @param month (optional) 
     * @param patientIds (optional) 
     * @param monthPresent (optional) 
     * @param startDateCashMovement (optional) 
     * @param endDateCashMovement (optional) 
     * @param cashBoxId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAllPatientAttendances(keyword: string | undefined, doctorId: number | undefined, statusId: number | undefined, nationalityId: number | undefined, isMale: boolean | undefined, operationalUnitId: number | undefined, mealSlotId: number | undefined, month: Date | undefined, patientIds: number[] | undefined, monthPresent: Date | undefined, startDateCashMovement: Date | undefined, endDateCashMovement: Date | undefined, cashBoxId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PatientAttendanceItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Patient/GetAllPatientAttendances?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (doctorId === null)
            throw new Error("The parameter 'doctorId' cannot be null.");
        else if (doctorId !== undefined)
            url_ += "DoctorId=" + encodeURIComponent("" + doctorId) + "&";
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (nationalityId === null)
            throw new Error("The parameter 'nationalityId' cannot be null.");
        else if (nationalityId !== undefined)
            url_ += "NationalityId=" + encodeURIComponent("" + nationalityId) + "&";
        if (isMale === null)
            throw new Error("The parameter 'isMale' cannot be null.");
        else if (isMale !== undefined)
            url_ += "IsMale=" + encodeURIComponent("" + isMale) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (mealSlotId === null)
            throw new Error("The parameter 'mealSlotId' cannot be null.");
        else if (mealSlotId !== undefined)
            url_ += "MealSlotId=" + encodeURIComponent("" + mealSlotId) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent(month ? "" + month.toJSON() : "") + "&";
        if (patientIds === null)
            throw new Error("The parameter 'patientIds' cannot be null.");
        else if (patientIds !== undefined)
            patientIds && patientIds.forEach(item => { url_ += "PatientIds=" + encodeURIComponent("" + item) + "&"; });
        if (monthPresent === null)
            throw new Error("The parameter 'monthPresent' cannot be null.");
        else if (monthPresent !== undefined)
            url_ += "MonthPresent=" + encodeURIComponent(monthPresent ? "" + monthPresent.toJSON() : "") + "&";
        if (startDateCashMovement === null)
            throw new Error("The parameter 'startDateCashMovement' cannot be null.");
        else if (startDateCashMovement !== undefined)
            url_ += "StartDateCashMovement=" + encodeURIComponent(startDateCashMovement ? "" + startDateCashMovement.toJSON() : "") + "&";
        if (endDateCashMovement === null)
            throw new Error("The parameter 'endDateCashMovement' cannot be null.");
        else if (endDateCashMovement !== undefined)
            url_ += "EndDateCashMovement=" + encodeURIComponent(endDateCashMovement ? "" + endDateCashMovement.toJSON() : "") + "&";
        if (cashBoxId === null)
            throw new Error("The parameter 'cashBoxId' cannot be null.");
        else if (cashBoxId !== undefined)
            url_ += "CashBoxId=" + encodeURIComponent("" + cashBoxId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPatientAttendances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPatientAttendances(<any>response_);
                } catch (e) {
                    return <Observable<PatientAttendanceItemDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientAttendanceItemDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPatientAttendances(response: HttpResponseBase): Observable<PatientAttendanceItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientAttendanceItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param doctorId (optional) 
     * @param statusId (optional) 
     * @param nationalityId (optional) 
     * @param isMale (optional) 
     * @param operationalUnitId (optional) 
     * @param mealSlotId (optional) 
     * @param month (optional) 
     * @param patientIds (optional) 
     * @param monthPresent (optional) 
     * @param startDateCashMovement (optional) 
     * @param endDateCashMovement (optional) 
     * @param cashBoxId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAllPatientMeals(keyword: string | undefined, doctorId: number | undefined, statusId: number | undefined, nationalityId: number | undefined, isMale: boolean | undefined, operationalUnitId: number | undefined, mealSlotId: number | undefined, month: Date | undefined, patientIds: number[] | undefined, monthPresent: Date | undefined, startDateCashMovement: Date | undefined, endDateCashMovement: Date | undefined, cashBoxId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PatientMealItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Patient/GetAllPatientMeals?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (doctorId === null)
            throw new Error("The parameter 'doctorId' cannot be null.");
        else if (doctorId !== undefined)
            url_ += "DoctorId=" + encodeURIComponent("" + doctorId) + "&";
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (nationalityId === null)
            throw new Error("The parameter 'nationalityId' cannot be null.");
        else if (nationalityId !== undefined)
            url_ += "NationalityId=" + encodeURIComponent("" + nationalityId) + "&";
        if (isMale === null)
            throw new Error("The parameter 'isMale' cannot be null.");
        else if (isMale !== undefined)
            url_ += "IsMale=" + encodeURIComponent("" + isMale) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (mealSlotId === null)
            throw new Error("The parameter 'mealSlotId' cannot be null.");
        else if (mealSlotId !== undefined)
            url_ += "MealSlotId=" + encodeURIComponent("" + mealSlotId) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent(month ? "" + month.toJSON() : "") + "&";
        if (patientIds === null)
            throw new Error("The parameter 'patientIds' cannot be null.");
        else if (patientIds !== undefined)
            patientIds && patientIds.forEach(item => { url_ += "PatientIds=" + encodeURIComponent("" + item) + "&"; });
        if (monthPresent === null)
            throw new Error("The parameter 'monthPresent' cannot be null.");
        else if (monthPresent !== undefined)
            url_ += "MonthPresent=" + encodeURIComponent(monthPresent ? "" + monthPresent.toJSON() : "") + "&";
        if (startDateCashMovement === null)
            throw new Error("The parameter 'startDateCashMovement' cannot be null.");
        else if (startDateCashMovement !== undefined)
            url_ += "StartDateCashMovement=" + encodeURIComponent(startDateCashMovement ? "" + startDateCashMovement.toJSON() : "") + "&";
        if (endDateCashMovement === null)
            throw new Error("The parameter 'endDateCashMovement' cannot be null.");
        else if (endDateCashMovement !== undefined)
            url_ += "EndDateCashMovement=" + encodeURIComponent(endDateCashMovement ? "" + endDateCashMovement.toJSON() : "") + "&";
        if (cashBoxId === null)
            throw new Error("The parameter 'cashBoxId' cannot be null.");
        else if (cashBoxId !== undefined)
            url_ += "CashBoxId=" + encodeURIComponent("" + cashBoxId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPatientMeals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPatientMeals(<any>response_);
                } catch (e) {
                    return <Observable<PatientMealItemDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMealItemDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPatientMeals(response: HttpResponseBase): Observable<PatientMealItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMealItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param doctorId (optional) 
     * @param statusId (optional) 
     * @param nationalityId (optional) 
     * @param isMale (optional) 
     * @param operationalUnitId (optional) 
     * @param mealSlotId (optional) 
     * @param month (optional) 
     * @param patientIds (optional) 
     * @param monthPresent (optional) 
     * @param startDateCashMovement (optional) 
     * @param endDateCashMovement (optional) 
     * @param cashBoxId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAllPatientCashMovements(keyword: string | undefined, doctorId: number | undefined, statusId: number | undefined, nationalityId: number | undefined, isMale: boolean | undefined, operationalUnitId: number | undefined, mealSlotId: number | undefined, month: Date | undefined, patientIds: number[] | undefined, monthPresent: Date | undefined, startDateCashMovement: Date | undefined, endDateCashMovement: Date | undefined, cashBoxId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PatientCashMovimentPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Patient/GetAllPatientCashMovements?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (doctorId === null)
            throw new Error("The parameter 'doctorId' cannot be null.");
        else if (doctorId !== undefined)
            url_ += "DoctorId=" + encodeURIComponent("" + doctorId) + "&";
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (nationalityId === null)
            throw new Error("The parameter 'nationalityId' cannot be null.");
        else if (nationalityId !== undefined)
            url_ += "NationalityId=" + encodeURIComponent("" + nationalityId) + "&";
        if (isMale === null)
            throw new Error("The parameter 'isMale' cannot be null.");
        else if (isMale !== undefined)
            url_ += "IsMale=" + encodeURIComponent("" + isMale) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (mealSlotId === null)
            throw new Error("The parameter 'mealSlotId' cannot be null.");
        else if (mealSlotId !== undefined)
            url_ += "MealSlotId=" + encodeURIComponent("" + mealSlotId) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent(month ? "" + month.toJSON() : "") + "&";
        if (patientIds === null)
            throw new Error("The parameter 'patientIds' cannot be null.");
        else if (patientIds !== undefined)
            patientIds && patientIds.forEach(item => { url_ += "PatientIds=" + encodeURIComponent("" + item) + "&"; });
        if (monthPresent === null)
            throw new Error("The parameter 'monthPresent' cannot be null.");
        else if (monthPresent !== undefined)
            url_ += "MonthPresent=" + encodeURIComponent(monthPresent ? "" + monthPresent.toJSON() : "") + "&";
        if (startDateCashMovement === null)
            throw new Error("The parameter 'startDateCashMovement' cannot be null.");
        else if (startDateCashMovement !== undefined)
            url_ += "StartDateCashMovement=" + encodeURIComponent(startDateCashMovement ? "" + startDateCashMovement.toJSON() : "") + "&";
        if (endDateCashMovement === null)
            throw new Error("The parameter 'endDateCashMovement' cannot be null.");
        else if (endDateCashMovement !== undefined)
            url_ += "EndDateCashMovement=" + encodeURIComponent(endDateCashMovement ? "" + endDateCashMovement.toJSON() : "") + "&";
        if (cashBoxId === null)
            throw new Error("The parameter 'cashBoxId' cannot be null.");
        else if (cashBoxId !== undefined)
            url_ += "CashBoxId=" + encodeURIComponent("" + cashBoxId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPatientCashMovements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPatientCashMovements(<any>response_);
                } catch (e) {
                    return <Observable<PatientCashMovimentPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientCashMovimentPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPatientCashMovements(response: HttpResponseBase): Observable<PatientCashMovimentPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientCashMovimentPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param doctorId (optional) 
     * @param statusId (optional) 
     * @param nationalityId (optional) 
     * @param isMale (optional) 
     * @param operationalUnitId (optional) 
     * @param mealSlotId (optional) 
     * @param month (optional) 
     * @param patientIds (optional) 
     * @param monthPresent (optional) 
     * @param startDateCashMovement (optional) 
     * @param endDateCashMovement (optional) 
     * @param cashBoxId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAllSimple(keyword: string | undefined, doctorId: number | undefined, statusId: number | undefined, nationalityId: number | undefined, isMale: boolean | undefined, operationalUnitId: number | undefined, mealSlotId: number | undefined, month: Date | undefined, patientIds: number[] | undefined, monthPresent: Date | undefined, startDateCashMovement: Date | undefined, endDateCashMovement: Date | undefined, cashBoxId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<SimplePatientDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Patient/GetAllSimple?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (doctorId === null)
            throw new Error("The parameter 'doctorId' cannot be null.");
        else if (doctorId !== undefined)
            url_ += "DoctorId=" + encodeURIComponent("" + doctorId) + "&";
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (nationalityId === null)
            throw new Error("The parameter 'nationalityId' cannot be null.");
        else if (nationalityId !== undefined)
            url_ += "NationalityId=" + encodeURIComponent("" + nationalityId) + "&";
        if (isMale === null)
            throw new Error("The parameter 'isMale' cannot be null.");
        else if (isMale !== undefined)
            url_ += "IsMale=" + encodeURIComponent("" + isMale) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (mealSlotId === null)
            throw new Error("The parameter 'mealSlotId' cannot be null.");
        else if (mealSlotId !== undefined)
            url_ += "MealSlotId=" + encodeURIComponent("" + mealSlotId) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent(month ? "" + month.toJSON() : "") + "&";
        if (patientIds === null)
            throw new Error("The parameter 'patientIds' cannot be null.");
        else if (patientIds !== undefined)
            patientIds && patientIds.forEach(item => { url_ += "PatientIds=" + encodeURIComponent("" + item) + "&"; });
        if (monthPresent === null)
            throw new Error("The parameter 'monthPresent' cannot be null.");
        else if (monthPresent !== undefined)
            url_ += "MonthPresent=" + encodeURIComponent(monthPresent ? "" + monthPresent.toJSON() : "") + "&";
        if (startDateCashMovement === null)
            throw new Error("The parameter 'startDateCashMovement' cannot be null.");
        else if (startDateCashMovement !== undefined)
            url_ += "StartDateCashMovement=" + encodeURIComponent(startDateCashMovement ? "" + startDateCashMovement.toJSON() : "") + "&";
        if (endDateCashMovement === null)
            throw new Error("The parameter 'endDateCashMovement' cannot be null.");
        else if (endDateCashMovement !== undefined)
            url_ += "EndDateCashMovement=" + encodeURIComponent(endDateCashMovement ? "" + endDateCashMovement.toJSON() : "") + "&";
        if (cashBoxId === null)
            throw new Error("The parameter 'cashBoxId' cannot be null.");
        else if (cashBoxId !== undefined)
            url_ += "CashBoxId=" + encodeURIComponent("" + cashBoxId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSimple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSimple(<any>response_);
                } catch (e) {
                    return <Observable<SimplePatientDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SimplePatientDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSimple(response: HttpResponseBase): Observable<SimplePatientDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimplePatientDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePatientDto | undefined): Observable<PatientDto> {
        let url_ = this.baseUrl + "/api/services/app/Patient/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PatientDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PatientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PatientDto> {
        let url_ = this.baseUrl + "/api/services/app/Patient/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PatientDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PatientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param doctorId (optional) 
     * @param statusId (optional) 
     * @param nationalityId (optional) 
     * @param isMale (optional) 
     * @param operationalUnitId (optional) 
     * @param mealSlotId (optional) 
     * @param month (optional) 
     * @param patientIds (optional) 
     * @param monthPresent (optional) 
     * @param startDateCashMovement (optional) 
     * @param endDateCashMovement (optional) 
     * @param cashBoxId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, doctorId: number | undefined, statusId: number | undefined, nationalityId: number | undefined, isMale: boolean | undefined, operationalUnitId: number | undefined, mealSlotId: number | undefined, month: Date | undefined, patientIds: number[] | undefined, monthPresent: Date | undefined, startDateCashMovement: Date | undefined, endDateCashMovement: Date | undefined, cashBoxId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PatientDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Patient/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (doctorId === null)
            throw new Error("The parameter 'doctorId' cannot be null.");
        else if (doctorId !== undefined)
            url_ += "DoctorId=" + encodeURIComponent("" + doctorId) + "&";
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (nationalityId === null)
            throw new Error("The parameter 'nationalityId' cannot be null.");
        else if (nationalityId !== undefined)
            url_ += "NationalityId=" + encodeURIComponent("" + nationalityId) + "&";
        if (isMale === null)
            throw new Error("The parameter 'isMale' cannot be null.");
        else if (isMale !== undefined)
            url_ += "IsMale=" + encodeURIComponent("" + isMale) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (mealSlotId === null)
            throw new Error("The parameter 'mealSlotId' cannot be null.");
        else if (mealSlotId !== undefined)
            url_ += "MealSlotId=" + encodeURIComponent("" + mealSlotId) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent(month ? "" + month.toJSON() : "") + "&";
        if (patientIds === null)
            throw new Error("The parameter 'patientIds' cannot be null.");
        else if (patientIds !== undefined)
            patientIds && patientIds.forEach(item => { url_ += "PatientIds=" + encodeURIComponent("" + item) + "&"; });
        if (monthPresent === null)
            throw new Error("The parameter 'monthPresent' cannot be null.");
        else if (monthPresent !== undefined)
            url_ += "MonthPresent=" + encodeURIComponent(monthPresent ? "" + monthPresent.toJSON() : "") + "&";
        if (startDateCashMovement === null)
            throw new Error("The parameter 'startDateCashMovement' cannot be null.");
        else if (startDateCashMovement !== undefined)
            url_ += "StartDateCashMovement=" + encodeURIComponent(startDateCashMovement ? "" + startDateCashMovement.toJSON() : "") + "&";
        if (endDateCashMovement === null)
            throw new Error("The parameter 'endDateCashMovement' cannot be null.");
        else if (endDateCashMovement !== undefined)
            url_ += "EndDateCashMovement=" + encodeURIComponent(endDateCashMovement ? "" + endDateCashMovement.toJSON() : "") + "&";
        if (cashBoxId === null)
            throw new Error("The parameter 'cashBoxId' cannot be null.");
        else if (cashBoxId !== undefined)
            url_ += "CashBoxId=" + encodeURIComponent("" + cashBoxId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PatientDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PatientDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PatientAttendanceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateList(body: UpdatePatientAttendanceDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientAttendance/UpdateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateList(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientAttendance/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @return Success
     */
    checkAttendanceForOperationalUnit(operationalUnitId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PatientAttendance/CheckAttendanceForOperationalUnit?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "operationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAttendanceForOperationalUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAttendanceForOperationalUnit(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckAttendanceForOperationalUnit(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param month (optional) 
     * @param operationalUnitId (optional) 
     * @param patientIds (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getReportAttence(month: Date | undefined, operationalUnitId: number | undefined, patientIds: number[] | undefined, startDate: Date | undefined, endDate: Date | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<ReportAttenceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientAttendance/GetReportAttence?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent(month ? "" + month.toJSON() : "") + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (patientIds === null)
            throw new Error("The parameter 'patientIds' cannot be null.");
        else if (patientIds !== undefined)
            patientIds && patientIds.forEach(item => { url_ += "PatientIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportAttence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportAttence(<any>response_);
                } catch (e) {
                    return <Observable<ReportAttenceDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReportAttenceDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetReportAttence(response: HttpResponseBase): Observable<ReportAttenceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportAttenceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param month (optional) 
     * @param operationalUnitId (optional) 
     * @param patientIds (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getExportReport(month: Date | undefined, operationalUnitId: number | undefined, patientIds: number[] | undefined, startDate: Date | undefined, endDate: Date | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientAttendance/GetExportReport?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent(month ? "" + month.toJSON() : "") + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (patientIds === null)
            throw new Error("The parameter 'patientIds' cannot be null.");
        else if (patientIds !== undefined)
            patientIds && patientIds.forEach(item => { url_ += "PatientIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportReport(<any>response_);
                } catch (e) {
                    return <Observable<FileExportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetExportReport(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param date (optional) 
     * @param operationalUnitId (optional) 
     * @return Success
     */
    getExportPatientAttendances(date: Date | undefined, operationalUnitId: number | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientAttendance/GetExportPatientAttendances?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "operationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportPatientAttendances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportPatientAttendances(<any>response_);
                } catch (e) {
                    return <Observable<FileExportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetExportPatientAttendances(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePatientAttendanceDto | undefined): Observable<PatientAttendanceDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientAttendance/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PatientAttendanceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientAttendanceDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PatientAttendanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientAttendanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePatientAttendanceDto | undefined): Observable<PatientAttendanceDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientAttendance/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PatientAttendanceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientAttendanceDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PatientAttendanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientAttendanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientAttendance/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PatientAttendanceDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientAttendance/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PatientAttendanceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientAttendanceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PatientAttendanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientAttendanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param month (optional) 
     * @param operationalUnitId (optional) 
     * @param patientIds (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(month: Date | undefined, operationalUnitId: number | undefined, patientIds: number[] | undefined, startDate: Date | undefined, endDate: Date | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PatientAttendanceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientAttendance/GetAll?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent(month ? "" + month.toJSON() : "") + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (patientIds === null)
            throw new Error("The parameter 'patientIds' cannot be null.");
        else if (patientIds !== undefined)
            patientIds && patientIds.forEach(item => { url_ += "PatientIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PatientAttendanceDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientAttendanceDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PatientAttendanceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientAttendanceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PatientDischargeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientDischarge/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePatientDischargeDto | undefined): Observable<PatientDischargeDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientDischarge/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PatientDischargeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientDischargeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PatientDischargeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientDischargeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePatientDischargeDto | undefined): Observable<PatientDischargeDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientDischarge/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PatientDischargeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientDischargeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PatientDischargeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientDischargeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientDischarge/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PatientDischargeDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientDischarge/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PatientDischargeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientDischargeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PatientDischargeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientDischargeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param operationalUnitId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, startDate: Date | undefined, endDate: Date | undefined, operationalUnitId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PatientDischargeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientDischarge/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PatientDischargeDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientDischargeDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PatientDischargeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientDischargeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PatientFileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    exportFile(id: number | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientFile/ExportFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFile(<any>response_);
                } catch (e) {
                    return <Observable<FileExportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExportDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportFile(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePatientFileDto | undefined): Observable<PatientFileDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientFile/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PatientFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PatientFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePatientFileDto | undefined): Observable<PatientFileDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientFile/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PatientFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PatientFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientFile/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PatientFileDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientFile/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PatientFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PatientFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @param operationalUnitId (optional) 
     * @param keyword (optional) 
     * @param fileName (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(patientId: number | undefined, operationalUnitId: number | undefined, keyword: string | undefined, fileName: string | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PatientFileDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientFile/GetAll?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PatientFileDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientFileDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PatientFileDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientFileDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PatientMealServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateList(body: UpdatePatientMealDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientMeal/UpdateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateList(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientMeal/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @return Success
     */
    checkMealsForOperationalUnit(operationalUnitId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PatientMeal/CheckMealsForOperationalUnit?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "operationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckMealsForOperationalUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMealsForOperationalUnit(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckMealsForOperationalUnit(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param month (optional) 
     * @param operationalUnitId (optional) 
     * @param mealSlotId (optional) 
     * @param patientIds (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getReportPatientMeal(month: Date | undefined, operationalUnitId: number | undefined, mealSlotId: number | undefined, patientIds: number[] | undefined, startDate: Date | undefined, endDate: Date | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<ReportPatientMealDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMeal/GetReportPatientMeal?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent(month ? "" + month.toJSON() : "") + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (mealSlotId === null)
            throw new Error("The parameter 'mealSlotId' cannot be null.");
        else if (mealSlotId !== undefined)
            url_ += "MealSlotId=" + encodeURIComponent("" + mealSlotId) + "&";
        if (patientIds === null)
            throw new Error("The parameter 'patientIds' cannot be null.");
        else if (patientIds !== undefined)
            patientIds && patientIds.forEach(item => { url_ += "PatientIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportPatientMeal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportPatientMeal(<any>response_);
                } catch (e) {
                    return <Observable<ReportPatientMealDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReportPatientMealDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetReportPatientMeal(response: HttpResponseBase): Observable<ReportPatientMealDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportPatientMealDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param month (optional) 
     * @param operationalUnitId (optional) 
     * @param mealSlotId (optional) 
     * @param patientIds (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getExportReport(month: Date | undefined, operationalUnitId: number | undefined, mealSlotId: number | undefined, patientIds: number[] | undefined, startDate: Date | undefined, endDate: Date | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMeal/GetExportReport?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent(month ? "" + month.toJSON() : "") + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (mealSlotId === null)
            throw new Error("The parameter 'mealSlotId' cannot be null.");
        else if (mealSlotId !== undefined)
            url_ += "MealSlotId=" + encodeURIComponent("" + mealSlotId) + "&";
        if (patientIds === null)
            throw new Error("The parameter 'patientIds' cannot be null.");
        else if (patientIds !== undefined)
            patientIds && patientIds.forEach(item => { url_ += "PatientIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportReport(<any>response_);
                } catch (e) {
                    return <Observable<FileExportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetExportReport(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePatientMealDto | undefined): Observable<PatientMealDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMeal/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PatientMealDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMealDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PatientMealDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMealDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePatientMealDto | undefined): Observable<PatientMealDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMeal/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PatientMealDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMealDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PatientMealDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMealDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientMeal/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PatientMealDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMeal/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PatientMealDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMealDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PatientMealDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMealDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param month (optional) 
     * @param operationalUnitId (optional) 
     * @param mealSlotId (optional) 
     * @param patientIds (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(month: Date | undefined, operationalUnitId: number | undefined, mealSlotId: number | undefined, patientIds: number[] | undefined, startDate: Date | undefined, endDate: Date | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PatientMealDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMeal/GetAll?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent(month ? "" + month.toJSON() : "") + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (mealSlotId === null)
            throw new Error("The parameter 'mealSlotId' cannot be null.");
        else if (mealSlotId !== undefined)
            url_ += "MealSlotId=" + encodeURIComponent("" + mealSlotId) + "&";
        if (patientIds === null)
            throw new Error("The parameter 'patientIds' cannot be null.");
        else if (patientIds !== undefined)
            patientIds && patientIds.forEach(item => { url_ += "PatientIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PatientMealDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMealDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PatientMealDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMealDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PatientMedicationAdministrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePatientMedicationAdministrationDto | undefined): Observable<PatientMedicationAdministrationDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAdministration/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAdministrationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAdministrationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PatientMedicationAdministrationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAdministrationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAdministration/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apply(body: ApplyPatientMedicationAdministrationDto | undefined): Observable<PatientMedicationAdministrationDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAdministration/Apply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApply(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAdministrationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAdministrationDto>><any>_observableThrow(response_);
        }));
    }

    protected processApply(response: HttpResponseBase): Observable<PatientMedicationAdministrationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAdministrationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    getSlots(patientId: number | undefined): Observable<AdministrationSlotDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAdministration/GetSlots?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSlots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSlots(<any>response_);
                } catch (e) {
                    return <Observable<AdministrationSlotDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdministrationSlotDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSlots(response: HttpResponseBase): Observable<AdministrationSlotDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdministrationSlotDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @return Success
     */
    getBandsStatus(operationalUnitId: number | undefined): Observable<PatientBandsStatusDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAdministration/GetBandsStatus?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBandsStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBandsStatus(<any>response_);
                } catch (e) {
                    return <Observable<PatientBandsStatusDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientBandsStatusDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBandsStatus(response: HttpResponseBase): Observable<PatientBandsStatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientBandsStatusDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCandidateStocks(id: number | undefined): Observable<CandidateStockDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAdministration/GetCandidateStocks?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateStocks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateStocks(<any>response_);
                } catch (e) {
                    return <Observable<CandidateStockDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CandidateStockDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCandidateStocks(response: HttpResponseBase): Observable<CandidateStockDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CandidateStockDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    applyBySlot(body: ApplyBySlotInput | undefined): Observable<PatientMedicationAdministrationDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAdministration/ApplyBySlot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyBySlot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyBySlot(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAdministrationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAdministrationDto>><any>_observableThrow(response_);
        }));
    }

    protected processApplyBySlot(response: HttpResponseBase): Observable<PatientMedicationAdministrationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAdministrationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refuse(body: Int64EntityDto | undefined): Observable<PatientMedicationAdministrationDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAdministration/Refuse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefuse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefuse(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAdministrationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAdministrationDto>><any>_observableThrow(response_);
        }));
    }

    protected processRefuse(response: HttpResponseBase): Observable<PatientMedicationAdministrationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAdministrationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    undoRefusal(body: Int64EntityDto | undefined): Observable<PatientMedicationAdministrationDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAdministration/UndoRefusal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoRefusal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoRefusal(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAdministrationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAdministrationDto>><any>_observableThrow(response_);
        }));
    }

    protected processUndoRefusal(response: HttpResponseBase): Observable<PatientMedicationAdministrationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAdministrationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setNote(body: SetPatientMedicationAdministrationNoteDto | undefined): Observable<PatientMedicationAdministrationDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAdministration/SetNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNote(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAdministrationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAdministrationDto>><any>_observableThrow(response_);
        }));
    }

    protected processSetNote(response: HttpResponseBase): Observable<PatientMedicationAdministrationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAdministrationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePatientMedicationAdministrationDto | undefined): Observable<PatientMedicationAdministrationDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAdministration/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAdministrationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAdministrationDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PatientMedicationAdministrationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAdministrationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rollback(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAdministration/Rollback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRollback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRollback(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRollback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PatientMedicationAdministrationDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAdministration/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAdministrationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAdministrationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PatientMedicationAdministrationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAdministrationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param patientMedicationScheduleId (optional) 
     * @param patientId (optional) 
     * @param isAdministrated (optional) 
     * @param isRefused (optional) 
     * @param startPlannedDate (optional) 
     * @param endPlannedDate (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(patientMedicationScheduleId: number | undefined, patientId: number | undefined, isAdministrated: boolean | undefined, isRefused: boolean | undefined, startPlannedDate: Date | undefined, endPlannedDate: Date | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PatientMedicationAdministrationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAdministration/GetAll?";
        if (patientMedicationScheduleId === null)
            throw new Error("The parameter 'patientMedicationScheduleId' cannot be null.");
        else if (patientMedicationScheduleId !== undefined)
            url_ += "PatientMedicationScheduleId=" + encodeURIComponent("" + patientMedicationScheduleId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (isAdministrated === null)
            throw new Error("The parameter 'isAdministrated' cannot be null.");
        else if (isAdministrated !== undefined)
            url_ += "IsAdministrated=" + encodeURIComponent("" + isAdministrated) + "&";
        if (isRefused === null)
            throw new Error("The parameter 'isRefused' cannot be null.");
        else if (isRefused !== undefined)
            url_ += "IsRefused=" + encodeURIComponent("" + isRefused) + "&";
        if (startPlannedDate === null)
            throw new Error("The parameter 'startPlannedDate' cannot be null.");
        else if (startPlannedDate !== undefined)
            url_ += "StartPlannedDate=" + encodeURIComponent(startPlannedDate ? "" + startPlannedDate.toJSON() : "") + "&";
        if (endPlannedDate === null)
            throw new Error("The parameter 'endPlannedDate' cannot be null.");
        else if (endPlannedDate !== undefined)
            url_ += "EndPlannedDate=" + encodeURIComponent(endPlannedDate ? "" + endPlannedDate.toJSON() : "") + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAdministrationDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAdministrationDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PatientMedicationAdministrationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAdministrationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PatientMedicationAssignmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignMedicationToPatientByQuantity(body: CreatePatientMedicationAssignmentDto | undefined): Observable<PatientMedicationAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAssignment/AssignMedicationToPatientByQuantity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignMedicationToPatientByQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignMedicationToPatientByQuantity(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processAssignMedicationToPatientByQuantity(response: HttpResponseBase): Observable<PatientMedicationAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignMedicationToPatientByStock(body: CreatePatientMedicationAssignmentDto | undefined): Observable<PatientMedicationAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAssignment/AssignMedicationToPatientByStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignMedicationToPatientByStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignMedicationToPatientByStock(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processAssignMedicationToPatientByStock(response: HttpResponseBase): Observable<PatientMedicationAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignMedicationToPatientByCode(body: AssignMedicationByCodeDto | undefined): Observable<PatientMedicationAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAssignment/AssignMedicationToPatientByCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignMedicationToPatientByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignMedicationToPatientByCode(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processAssignMedicationToPatientByCode(response: HttpResponseBase): Observable<PatientMedicationAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param quantity (optional) 
     * @param id (optional) 
     * @return Success
     */
    removePatientMedicationQuantity(quantity: number | undefined, id: number | undefined): Observable<PatientMedicationAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAssignment/RemovePatientMedicationQuantity?";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "Quantity=" + encodeURIComponent("" + quantity) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemovePatientMedicationQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemovePatientMedicationQuantity(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processRemovePatientMedicationQuantity(response: HttpResponseBase): Observable<PatientMedicationAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicationStockId (optional) 
     * @param id (optional) 
     * @return Success
     */
    removePatientMedicationStock(medicationStockId: number | undefined, id: number | undefined): Observable<PatientMedicationAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAssignment/RemovePatientMedicationStock?";
        if (medicationStockId === null)
            throw new Error("The parameter 'medicationStockId' cannot be null.");
        else if (medicationStockId !== undefined)
            url_ += "MedicationStockId=" + encodeURIComponent("" + medicationStockId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemovePatientMedicationStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemovePatientMedicationStock(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processRemovePatientMedicationStock(response: HttpResponseBase): Observable<PatientMedicationAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    transferPatientMedicationQuantity(body: TransferPatientMedicationQuantityDto | undefined): Observable<PatientMedicationAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAssignment/TransferPatientMedicationQuantity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransferPatientMedicationQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferPatientMedicationQuantity(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processTransferPatientMedicationQuantity(response: HttpResponseBase): Observable<PatientMedicationAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    transferPatientMedicationStock(body: TransferPatientMedicationStockDto | undefined): Observable<PatientMedicationAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAssignment/TransferPatientMedicationStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransferPatientMedicationStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferPatientMedicationStock(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processTransferPatientMedicationStock(response: HttpResponseBase): Observable<PatientMedicationAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignMedicationToPatientStandalone(body: CreatePatientMedicationAssignmentStandaloneDto | undefined): Observable<PatientMedicationAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAssignment/AssignMedicationToPatientStandalone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignMedicationToPatientStandalone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignMedicationToPatientStandalone(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processAssignMedicationToPatientStandalone(response: HttpResponseBase): Observable<PatientMedicationAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    loadPatientStock(body: LoadPatientMedicationStockDto | undefined): Observable<PatientMedicationAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAssignment/LoadPatientStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadPatientStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadPatientStock(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processLoadPatientStock(response: HttpResponseBase): Observable<PatientMedicationAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    returnStockToWarehouse(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAssignment/ReturnStockToWarehouse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnStockToWarehouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnStockToWarehouse(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processReturnStockToWarehouse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveStockToCart(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAssignment/MoveStockToCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveStockToCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveStockToCart(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMoveStockToCart(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @param operationalUnitId (optional) 
     * @return Success
     */
    getPatientCart(patientId: number | undefined, operationalUnitId: number | undefined): Observable<PatientCartStockDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAssignment/GetPatientCart?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "operationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientCart(<any>response_);
                } catch (e) {
                    return <Observable<PatientCartStockDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientCartStockDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPatientCart(response: HttpResponseBase): Observable<PatientCartStockDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientCartStockDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePatientMedicationAssignmentDto | undefined): Observable<PatientMedicationAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAssignment/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PatientMedicationAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePatientMedicationAssignmentDto | undefined): Observable<PatientMedicationAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAssignment/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PatientMedicationAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAssignment/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PatientMedicationAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAssignment/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAssignmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PatientMedicationAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param medicationId (optional) 
     * @param patientId (optional) 
     * @param note (optional) 
     * @param onlyOpen (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(operationalUnitId: number | undefined, medicationId: number | undefined, patientId: number | undefined, note: string | undefined, onlyOpen: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PatientMedicationAssignmentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationAssignment/GetAll?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (medicationId === null)
            throw new Error("The parameter 'medicationId' cannot be null.");
        else if (medicationId !== undefined)
            url_ += "MedicationId=" + encodeURIComponent("" + medicationId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (onlyOpen === null)
            throw new Error("The parameter 'onlyOpen' cannot be null.");
        else if (onlyOpen !== undefined)
            url_ += "OnlyOpen=" + encodeURIComponent("" + onlyOpen) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationAssignmentDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationAssignmentDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PatientMedicationAssignmentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationAssignmentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PatientMedicationScheduleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationSchedule/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePatientMedicationScheduleDto | undefined): Observable<PatientMedicationScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationSchedule/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationScheduleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationScheduleDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PatientMedicationScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationScheduleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePatientMedicationScheduleDto | undefined): Observable<PatientMedicationScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationSchedule/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationScheduleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationScheduleDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PatientMedicationScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationScheduleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PatientMedicationScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationSchedule/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationScheduleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationScheduleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PatientMedicationScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationScheduleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param patietntId (optional) 
     * @param patientMedicationTherapyId (optional) 
     * @param medicationId (optional) 
     * @param hasRemaning (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(operationalUnitId: number | undefined, patietntId: number | undefined, patientMedicationTherapyId: number | undefined, medicationId: number | undefined, hasRemaning: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PatientMedicationScheduleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationSchedule/GetAll?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (patietntId === null)
            throw new Error("The parameter 'patietntId' cannot be null.");
        else if (patietntId !== undefined)
            url_ += "PatietntId=" + encodeURIComponent("" + patietntId) + "&";
        if (patientMedicationTherapyId === null)
            throw new Error("The parameter 'patientMedicationTherapyId' cannot be null.");
        else if (patientMedicationTherapyId !== undefined)
            url_ += "PatientMedicationTherapyId=" + encodeURIComponent("" + patientMedicationTherapyId) + "&";
        if (medicationId === null)
            throw new Error("The parameter 'medicationId' cannot be null.");
        else if (medicationId !== undefined)
            url_ += "MedicationId=" + encodeURIComponent("" + medicationId) + "&";
        if (hasRemaning === null)
            throw new Error("The parameter 'hasRemaning' cannot be null.");
        else if (hasRemaning !== undefined)
            url_ += "HasRemaning=" + encodeURIComponent("" + hasRemaning) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationScheduleDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationScheduleDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PatientMedicationScheduleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationScheduleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PatientMedicationTherapyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param patientId (optional) 
     * @param medicationId (optional) 
     * @param operationalUnitId (optional) 
     * @param medicationTherapyTypeIds (optional) 
     * @param medicationAdministrationRouteId (optional) 
     * @param patientMedicationTherapyStatusId (optional) 
     * @param note (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(patientId: number | undefined, medicationId: number | undefined, operationalUnitId: number | undefined, medicationTherapyTypeIds: number[] | undefined, medicationAdministrationRouteId: number | undefined, patientMedicationTherapyStatusId: number | undefined, note: string | undefined, startDate: Date | undefined, endDate: Date | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PatientMedicationTherapyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationTherapy/GetAll?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (medicationId === null)
            throw new Error("The parameter 'medicationId' cannot be null.");
        else if (medicationId !== undefined)
            url_ += "MedicationId=" + encodeURIComponent("" + medicationId) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (medicationTherapyTypeIds === null)
            throw new Error("The parameter 'medicationTherapyTypeIds' cannot be null.");
        else if (medicationTherapyTypeIds !== undefined)
            medicationTherapyTypeIds && medicationTherapyTypeIds.forEach(item => { url_ += "MedicationTherapyTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (medicationAdministrationRouteId === null)
            throw new Error("The parameter 'medicationAdministrationRouteId' cannot be null.");
        else if (medicationAdministrationRouteId !== undefined)
            url_ += "MedicationAdministrationRouteId=" + encodeURIComponent("" + medicationAdministrationRouteId) + "&";
        if (patientMedicationTherapyStatusId === null)
            throw new Error("The parameter 'patientMedicationTherapyStatusId' cannot be null.");
        else if (patientMedicationTherapyStatusId !== undefined)
            url_ += "PatientMedicationTherapyStatusId=" + encodeURIComponent("" + patientMedicationTherapyStatusId) + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationTherapyDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationTherapyDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PatientMedicationTherapyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationTherapyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePatientMedicationTherapyDto | undefined): Observable<PatientMedicationTherapyDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationTherapy/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationTherapyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationTherapyDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PatientMedicationTherapyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationTherapyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePatientMedicationTherapyDto | undefined): Observable<PatientMedicationTherapyDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationTherapy/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationTherapyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationTherapyDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PatientMedicationTherapyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationTherapyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param therapyId (optional) 
     * @return Success
     */
    activateTherapy(therapyId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationTherapy/ActivateTherapy?";
        if (therapyId === null)
            throw new Error("The parameter 'therapyId' cannot be null.");
        else if (therapyId !== undefined)
            url_ += "therapyId=" + encodeURIComponent("" + therapyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateTherapy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateTherapy(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processActivateTherapy(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    suspendTherapy(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationTherapy/SuspendTherapy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuspendTherapy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuspendTherapy(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSuspendTherapy(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    complete(body: Int64EntityDto | undefined): Observable<PatientMedicationTherapyDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationTherapy/Complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComplete(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationTherapyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationTherapyDto>><any>_observableThrow(response_);
        }));
    }

    protected processComplete(response: HttpResponseBase): Observable<PatientMedicationTherapyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationTherapyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationTherapy/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @param medicationId (optional) 
     * @param operationalUnitId (optional) 
     * @param medicationTherapyTypeIds (optional) 
     * @param medicationAdministrationRouteId (optional) 
     * @param patientMedicationTherapyStatusId (optional) 
     * @param note (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getFileExport(patientId: number | undefined, medicationId: number | undefined, operationalUnitId: number | undefined, medicationTherapyTypeIds: number[] | undefined, medicationAdministrationRouteId: number | undefined, patientMedicationTherapyStatusId: number | undefined, note: string | undefined, startDate: Date | undefined, endDate: Date | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationTherapy/GetFileExport?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (medicationId === null)
            throw new Error("The parameter 'medicationId' cannot be null.");
        else if (medicationId !== undefined)
            url_ += "MedicationId=" + encodeURIComponent("" + medicationId) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (medicationTherapyTypeIds === null)
            throw new Error("The parameter 'medicationTherapyTypeIds' cannot be null.");
        else if (medicationTherapyTypeIds !== undefined)
            medicationTherapyTypeIds && medicationTherapyTypeIds.forEach(item => { url_ += "MedicationTherapyTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (medicationAdministrationRouteId === null)
            throw new Error("The parameter 'medicationAdministrationRouteId' cannot be null.");
        else if (medicationAdministrationRouteId !== undefined)
            url_ += "MedicationAdministrationRouteId=" + encodeURIComponent("" + medicationAdministrationRouteId) + "&";
        if (patientMedicationTherapyStatusId === null)
            throw new Error("The parameter 'patientMedicationTherapyStatusId' cannot be null.");
        else if (patientMedicationTherapyStatusId !== undefined)
            url_ += "PatientMedicationTherapyStatusId=" + encodeURIComponent("" + patientMedicationTherapyStatusId) + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileExport(<any>response_);
                } catch (e) {
                    return <Observable<FileExportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileExport(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationTherapy/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PatientMedicationTherapyDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationTherapy/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PatientMedicationTherapyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientMedicationTherapyDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PatientMedicationTherapyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientMedicationTherapyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PatientMedicationTherapyStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientMedicationTherapyStatus/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PatientNoteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param operationalUnitId (optional) 
     * @param patientId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getPatientNotes(keyword: string | undefined, operationalUnitId: number | undefined, patientId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PatientNoteItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientNote/GetPatientNotes?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientNotes(<any>response_);
                } catch (e) {
                    return <Observable<PatientNoteItemDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientNoteItemDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPatientNotes(response: HttpResponseBase): Observable<PatientNoteItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientNoteItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param modifiedSince (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getRecentActivity(modifiedSince: Date | undefined, maxResultCount: number | undefined): Observable<RecentPatientNoteActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientNote/GetRecentActivity?";
        if (modifiedSince === null)
            throw new Error("The parameter 'modifiedSince' cannot be null.");
        else if (modifiedSince !== undefined)
            url_ += "modifiedSince=" + encodeURIComponent(modifiedSince ? "" + modifiedSince.toJSON() : "") + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentActivity(<any>response_);
                } catch (e) {
                    return <Observable<RecentPatientNoteActivityDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecentPatientNoteActivityDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecentActivity(response: HttpResponseBase): Observable<RecentPatientNoteActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecentPatientNoteActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePatientNoteDto | undefined): Observable<PatientNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientNote/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PatientNoteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientNoteDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PatientNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePatientNoteDto | undefined): Observable<PatientNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientNote/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PatientNoteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientNoteDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PatientNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientNote/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PatientNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientNote/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PatientNoteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientNoteDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PatientNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param operationalUnitId (optional) 
     * @param patientId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, operationalUnitId: number | undefined, patientId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PatientNoteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientNote/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PatientNoteDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientNoteDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PatientNoteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientNoteDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PatientNoteTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientNoteType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PatientOperationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePatientOperationDto | undefined): Observable<PatientOperationDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientOperation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PatientOperationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientOperationDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PatientOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePatientOperationDto | undefined): Observable<PatientOperationDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientOperation/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PatientOperationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientOperationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PatientOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientOperation/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PatientOperationDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientOperation/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PatientOperationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientOperationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PatientOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param isAscending (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, isAscending: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, sorting: string | undefined, maxResultCount: number | undefined): Observable<PatientOperationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientOperation/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isAscending === null)
            throw new Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "IsAscending=" + encodeURIComponent("" + isAscending) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PatientOperationDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientOperationDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PatientOperationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientOperationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PatientStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientStatus/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PatientTransferRequestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePatientTransferRequestDto | undefined): Observable<PatientTransferRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientTransferRequest/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PatientTransferRequestDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientTransferRequestDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PatientTransferRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientTransferRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    rejectPatientTransfer(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientTransferRequest/RejectPatientTransfer?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectPatientTransfer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectPatientTransfer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRejectPatientTransfer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    acceptRequestTransfer(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientTransferRequest/AcceptRequestTransfer?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptRequestTransfer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptRequestTransfer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAcceptRequestTransfer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    approvedPatientTransfer(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientTransferRequest/ApprovedPatientTransfer?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprovedPatientTransfer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovedPatientTransfer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApprovedPatientTransfer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @param statusId (optional) 
     * @param fromOperationalUnitId (optional) 
     * @param toOperationalUnitId (optional) 
     * @param keyword (optional) 
     * @param currentOperationalUnitId (optional) 
     * @param userId (optional) 
     * @param isEntry (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAllForOperationalUnit(patientId: number | undefined, statusId: number | undefined, fromOperationalUnitId: number | undefined, toOperationalUnitId: number | undefined, keyword: string | undefined, currentOperationalUnitId: number | undefined, userId: number | undefined, isEntry: boolean | undefined, startDate: Date | undefined, endDate: Date | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PatientTransferRequestDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientTransferRequest/GetAllForOperationalUnit?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (fromOperationalUnitId === null)
            throw new Error("The parameter 'fromOperationalUnitId' cannot be null.");
        else if (fromOperationalUnitId !== undefined)
            url_ += "FromOperationalUnitId=" + encodeURIComponent("" + fromOperationalUnitId) + "&";
        if (toOperationalUnitId === null)
            throw new Error("The parameter 'toOperationalUnitId' cannot be null.");
        else if (toOperationalUnitId !== undefined)
            url_ += "ToOperationalUnitId=" + encodeURIComponent("" + toOperationalUnitId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (currentOperationalUnitId === null)
            throw new Error("The parameter 'currentOperationalUnitId' cannot be null.");
        else if (currentOperationalUnitId !== undefined)
            url_ += "CurrentOperationalUnitId=" + encodeURIComponent("" + currentOperationalUnitId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (isEntry === null)
            throw new Error("The parameter 'isEntry' cannot be null.");
        else if (isEntry !== undefined)
            url_ += "IsEntry=" + encodeURIComponent("" + isEntry) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForOperationalUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForOperationalUnit(<any>response_);
                } catch (e) {
                    return <Observable<PatientTransferRequestDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientTransferRequestDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForOperationalUnit(response: HttpResponseBase): Observable<PatientTransferRequestDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientTransferRequestDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePatientTransferRequestDto | undefined): Observable<PatientTransferRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientTransferRequest/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PatientTransferRequestDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientTransferRequestDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PatientTransferRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientTransferRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PatientTransferRequest/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PatientTransferRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientTransferRequest/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PatientTransferRequestDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientTransferRequestDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PatientTransferRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientTransferRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @param statusId (optional) 
     * @param fromOperationalUnitId (optional) 
     * @param toOperationalUnitId (optional) 
     * @param keyword (optional) 
     * @param currentOperationalUnitId (optional) 
     * @param userId (optional) 
     * @param isEntry (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(patientId: number | undefined, statusId: number | undefined, fromOperationalUnitId: number | undefined, toOperationalUnitId: number | undefined, keyword: string | undefined, currentOperationalUnitId: number | undefined, userId: number | undefined, isEntry: boolean | undefined, startDate: Date | undefined, endDate: Date | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PatientTransferRequestDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientTransferRequest/GetAll?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (fromOperationalUnitId === null)
            throw new Error("The parameter 'fromOperationalUnitId' cannot be null.");
        else if (fromOperationalUnitId !== undefined)
            url_ += "FromOperationalUnitId=" + encodeURIComponent("" + fromOperationalUnitId) + "&";
        if (toOperationalUnitId === null)
            throw new Error("The parameter 'toOperationalUnitId' cannot be null.");
        else if (toOperationalUnitId !== undefined)
            url_ += "ToOperationalUnitId=" + encodeURIComponent("" + toOperationalUnitId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (currentOperationalUnitId === null)
            throw new Error("The parameter 'currentOperationalUnitId' cannot be null.");
        else if (currentOperationalUnitId !== undefined)
            url_ += "CurrentOperationalUnitId=" + encodeURIComponent("" + currentOperationalUnitId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (isEntry === null)
            throw new Error("The parameter 'isEntry' cannot be null.");
        else if (isEntry !== undefined)
            url_ += "IsEntry=" + encodeURIComponent("" + isEntry) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PatientTransferRequestDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientTransferRequestDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PatientTransferRequestDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientTransferRequestDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PatientTransferStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientTransferStatus/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PatientTrasferServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PatientTrasferDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientTrasfer/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PatientTrasferDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientTrasferDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PatientTrasferDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientTrasferDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @param fromOperationalUnitId (optional) 
     * @param toOperationalUnitId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(patientId: number | undefined, fromOperationalUnitId: number | undefined, toOperationalUnitId: number | undefined, startDate: Date | undefined, endDate: Date | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PatientTrasferDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PatientTrasfer/GetAll?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (fromOperationalUnitId === null)
            throw new Error("The parameter 'fromOperationalUnitId' cannot be null.");
        else if (fromOperationalUnitId !== undefined)
            url_ += "FromOperationalUnitId=" + encodeURIComponent("" + fromOperationalUnitId) + "&";
        if (toOperationalUnitId === null)
            throw new Error("The parameter 'toOperationalUnitId' cannot be null.");
        else if (toOperationalUnitId !== undefined)
            url_ += "ToOperationalUnitId=" + encodeURIComponent("" + toOperationalUnitId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PatientTrasferDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatientTrasferDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PatientTrasferDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientTrasferDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PhysiologicalHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePhysiologicalHistoryDto | undefined): Observable<PhysiologicalHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/PhysiologicalHistory/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PhysiologicalHistoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PhysiologicalHistoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PhysiologicalHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhysiologicalHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePhysiologicalHistoryDto | undefined): Observable<PhysiologicalHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/PhysiologicalHistory/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PhysiologicalHistoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PhysiologicalHistoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PhysiologicalHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhysiologicalHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PhysiologicalHistory/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicalHistoryId (optional) 
     * @param id (optional) 
     * @return Success
     */
    get(medicalHistoryId: number | undefined, id: number | undefined): Observable<PhysiologicalHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/PhysiologicalHistory/Get?";
        if (medicalHistoryId === null)
            throw new Error("The parameter 'medicalHistoryId' cannot be null.");
        else if (medicalHistoryId !== undefined)
            url_ += "MedicalHistoryId=" + encodeURIComponent("" + medicalHistoryId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PhysiologicalHistoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PhysiologicalHistoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PhysiologicalHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhysiologicalHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicalHistoryId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(medicalHistoryId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PhysiologicalHistoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PhysiologicalHistory/GetAll?";
        if (medicalHistoryId === null)
            throw new Error("The parameter 'medicalHistoryId' cannot be null.");
        else if (medicalHistoryId !== undefined)
            url_ += "MedicalHistoryId=" + encodeURIComponent("" + medicalHistoryId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PhysiologicalHistoryDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PhysiologicalHistoryDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PhysiologicalHistoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhysiologicalHistoryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PlannedAssignmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createList(body: CreatePlannedAssignmentDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlannedAssignment/CreateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateList(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateList(body: UpdatePlannedAssignmentDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlannedAssignment/UpdateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateList(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param plannedSlotId (optional) 
     * @param userId (optional) 
     * @param operationalUnitId (optional) 
     * @param assignmentTypeId (optional) 
     * @param onCallTypeId (optional) 
     * @param startDateTime (optional) 
     * @param endDateTime (optional) 
     * @param shiftTypeId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getShiftExport(plannedSlotId: number | undefined, userId: number | undefined, operationalUnitId: number | undefined, assignmentTypeId: number | undefined, onCallTypeId: number | undefined, startDateTime: Date | undefined, endDateTime: Date | undefined, shiftTypeId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/api/services/app/PlannedAssignment/GetShiftExport?";
        if (plannedSlotId === null)
            throw new Error("The parameter 'plannedSlotId' cannot be null.");
        else if (plannedSlotId !== undefined)
            url_ += "PlannedSlotId=" + encodeURIComponent("" + plannedSlotId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (assignmentTypeId === null)
            throw new Error("The parameter 'assignmentTypeId' cannot be null.");
        else if (assignmentTypeId !== undefined)
            url_ += "AssignmentTypeId=" + encodeURIComponent("" + assignmentTypeId) + "&";
        if (onCallTypeId === null)
            throw new Error("The parameter 'onCallTypeId' cannot be null.");
        else if (onCallTypeId !== undefined)
            url_ += "OnCallTypeId=" + encodeURIComponent("" + onCallTypeId) + "&";
        if (startDateTime === null)
            throw new Error("The parameter 'startDateTime' cannot be null.");
        else if (startDateTime !== undefined)
            url_ += "StartDateTime=" + encodeURIComponent(startDateTime ? "" + startDateTime.toJSON() : "") + "&";
        if (endDateTime === null)
            throw new Error("The parameter 'endDateTime' cannot be null.");
        else if (endDateTime !== undefined)
            url_ += "EndDateTime=" + encodeURIComponent(endDateTime ? "" + endDateTime.toJSON() : "") + "&";
        if (shiftTypeId === null)
            throw new Error("The parameter 'shiftTypeId' cannot be null.");
        else if (shiftTypeId !== undefined)
            url_ += "ShiftTypeId=" + encodeURIComponent("" + shiftTypeId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftExport(<any>response_);
                } catch (e) {
                    return <Observable<FileExportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetShiftExport(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePlannedAssignmentDto | undefined): Observable<PlannedAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/PlannedAssignment/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PlannedAssignmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlannedAssignmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PlannedAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePlannedAssignmentDto | undefined): Observable<PlannedAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/PlannedAssignment/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PlannedAssignmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlannedAssignmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PlannedAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlannedAssignment/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PlannedAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/PlannedAssignment/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PlannedAssignmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlannedAssignmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PlannedAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param plannedSlotId (optional) 
     * @param userId (optional) 
     * @param operationalUnitId (optional) 
     * @param assignmentTypeId (optional) 
     * @param onCallTypeId (optional) 
     * @param startDateTime (optional) 
     * @param endDateTime (optional) 
     * @param shiftTypeId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(plannedSlotId: number | undefined, userId: number | undefined, operationalUnitId: number | undefined, assignmentTypeId: number | undefined, onCallTypeId: number | undefined, startDateTime: Date | undefined, endDateTime: Date | undefined, shiftTypeId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PlannedAssignmentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PlannedAssignment/GetAll?";
        if (plannedSlotId === null)
            throw new Error("The parameter 'plannedSlotId' cannot be null.");
        else if (plannedSlotId !== undefined)
            url_ += "PlannedSlotId=" + encodeURIComponent("" + plannedSlotId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (assignmentTypeId === null)
            throw new Error("The parameter 'assignmentTypeId' cannot be null.");
        else if (assignmentTypeId !== undefined)
            url_ += "AssignmentTypeId=" + encodeURIComponent("" + assignmentTypeId) + "&";
        if (onCallTypeId === null)
            throw new Error("The parameter 'onCallTypeId' cannot be null.");
        else if (onCallTypeId !== undefined)
            url_ += "OnCallTypeId=" + encodeURIComponent("" + onCallTypeId) + "&";
        if (startDateTime === null)
            throw new Error("The parameter 'startDateTime' cannot be null.");
        else if (startDateTime !== undefined)
            url_ += "StartDateTime=" + encodeURIComponent(startDateTime ? "" + startDateTime.toJSON() : "") + "&";
        if (endDateTime === null)
            throw new Error("The parameter 'endDateTime' cannot be null.");
        else if (endDateTime !== undefined)
            url_ += "EndDateTime=" + encodeURIComponent(endDateTime ? "" + endDateTime.toJSON() : "") + "&";
        if (shiftTypeId === null)
            throw new Error("The parameter 'shiftTypeId' cannot be null.");
        else if (shiftTypeId !== undefined)
            url_ += "ShiftTypeId=" + encodeURIComponent("" + shiftTypeId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PlannedAssignmentDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlannedAssignmentDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PlannedAssignmentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedAssignmentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PlannedSlotServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param date (optional) 
     * @param operationalUnitId (optional) 
     * @return Success
     */
    publishAllPlannedByMonth(date: Date | undefined, operationalUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlannedSlot/PublishAllPlannedByMonth?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "operationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishAllPlannedByMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishAllPlannedByMonth(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPublishAllPlannedByMonth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    publishAllPlannedByListIds(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlannedSlot/PublishAllPlannedByListIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishAllPlannedByListIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishAllPlannedByListIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPublishAllPlannedByListIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param date (optional) 
     * @param operationalUnitId (optional) 
     * @return Success
     */
    lockAllPlannedByMonth(date: Date | undefined, operationalUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlannedSlot/LockAllPlannedByMonth?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "operationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLockAllPlannedByMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLockAllPlannedByMonth(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLockAllPlannedByMonth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    lockAllPlannedByListIds(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlannedSlot/LockAllPlannedByListIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLockAllPlannedByListIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLockAllPlannedByListIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLockAllPlannedByListIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param date (optional) 
     * @return Success
     */
    createMonthlyPlannedSlotsIfMissing(operationalUnitId: number | undefined, date: Date | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PlannedSlot/CreateMonthlyPlannedSlotsIfMissing?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "operationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMonthlyPlannedSlotsIfMissing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMonthlyPlannedSlotsIfMissing(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCreateMonthlyPlannedSlotsIfMissing(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePlannedSlotDto | undefined): Observable<PlannedSlotDto> {
        let url_ = this.baseUrl + "/api/services/app/PlannedSlot/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PlannedSlotDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlannedSlotDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PlannedSlotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedSlotDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePlannedSlotDto | undefined): Observable<PlannedSlotDto> {
        let url_ = this.baseUrl + "/api/services/app/PlannedSlot/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PlannedSlotDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlannedSlotDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PlannedSlotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedSlotDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlannedSlot/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PlannedSlotDto> {
        let url_ = this.baseUrl + "/api/services/app/PlannedSlot/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PlannedSlotDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlannedSlotDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PlannedSlotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedSlotDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param plannedSlotStatusId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(operationalUnitId: number | undefined, plannedSlotStatusId: number | undefined, startDate: Date | undefined, endDate: Date | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PlannedSlotDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PlannedSlot/GetAll?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (plannedSlotStatusId === null)
            throw new Error("The parameter 'plannedSlotStatusId' cannot be null.");
        else if (plannedSlotStatusId !== undefined)
            url_ += "PlannedSlotStatusId=" + encodeURIComponent("" + plannedSlotStatusId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PlannedSlotDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlannedSlotDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PlannedSlotDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedSlotDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PlannedSlotStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlannedSlotStatus/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProtocolTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateProtocolTypeDto | undefined): Observable<ProtocolTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ProtocolType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ProtocolTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProtocolTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProtocolTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProtocolTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateProtocolTypeDto | undefined): Observable<ProtocolTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ProtocolType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ProtocolTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProtocolTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProtocolTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProtocolTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProtocolType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ProtocolTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ProtocolType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ProtocolTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProtocolTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProtocolTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProtocolTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param isAscending (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, isAscending: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, sorting: string | undefined, maxResultCount: number | undefined): Observable<ProtocolTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProtocolType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isAscending === null)
            throw new Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "IsAscending=" + encodeURIComponent("" + isAscending) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ProtocolTypeDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProtocolTypeDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProtocolTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProtocolTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PsychiatricAdmissionExamServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePsychiatricAdmissionExamDto | undefined): Observable<PsychiatricAdmissionExamDto> {
        let url_ = this.baseUrl + "/api/services/app/PsychiatricAdmissionExam/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PsychiatricAdmissionExamDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PsychiatricAdmissionExamDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PsychiatricAdmissionExamDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PsychiatricAdmissionExamDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePsychiatricAdmissionExamDto | undefined): Observable<PsychiatricAdmissionExamDto> {
        let url_ = this.baseUrl + "/api/services/app/PsychiatricAdmissionExam/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PsychiatricAdmissionExamDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PsychiatricAdmissionExamDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PsychiatricAdmissionExamDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PsychiatricAdmissionExamDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PsychiatricAdmissionExam/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicalHistoryId (optional) 
     * @param id (optional) 
     * @return Success
     */
    get(medicalHistoryId: number | undefined, id: number | undefined): Observable<PsychiatricAdmissionExamDto> {
        let url_ = this.baseUrl + "/api/services/app/PsychiatricAdmissionExam/Get?";
        if (medicalHistoryId === null)
            throw new Error("The parameter 'medicalHistoryId' cannot be null.");
        else if (medicalHistoryId !== undefined)
            url_ += "MedicalHistoryId=" + encodeURIComponent("" + medicalHistoryId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PsychiatricAdmissionExamDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PsychiatricAdmissionExamDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PsychiatricAdmissionExamDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PsychiatricAdmissionExamDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicalHistoryId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(medicalHistoryId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PsychiatricAdmissionExamDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PsychiatricAdmissionExam/GetAll?";
        if (medicalHistoryId === null)
            throw new Error("The parameter 'medicalHistoryId' cannot be null.");
        else if (medicalHistoryId !== undefined)
            url_ += "MedicalHistoryId=" + encodeURIComponent("" + medicalHistoryId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PsychiatricAdmissionExamDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PsychiatricAdmissionExamDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PsychiatricAdmissionExamDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PsychiatricAdmissionExamDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PsychiatricProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateList(body: UpdatePsychiatricProfileDto[] | undefined): Observable<PsychiatricProfileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PsychiatricProfile/UpdateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateList(<any>response_);
                } catch (e) {
                    return <Observable<PsychiatricProfileDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PsychiatricProfileDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateList(response: HttpResponseBase): Observable<PsychiatricProfileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PsychiatricProfileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePsychiatricProfileDto | undefined): Observable<PsychiatricProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/PsychiatricProfile/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PsychiatricProfileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PsychiatricProfileDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PsychiatricProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PsychiatricProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePsychiatricProfileDto | undefined): Observable<PsychiatricProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/PsychiatricProfile/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PsychiatricProfileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PsychiatricProfileDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PsychiatricProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PsychiatricProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PsychiatricProfile/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PsychiatricProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/PsychiatricProfile/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PsychiatricProfileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PsychiatricProfileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PsychiatricProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PsychiatricProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicalHistoryId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(medicalHistoryId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<PsychiatricProfileDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PsychiatricProfile/GetAll?";
        if (medicalHistoryId === null)
            throw new Error("The parameter 'medicalHistoryId' cannot be null.");
        else if (medicalHistoryId !== undefined)
            url_ += "MedicalHistoryId=" + encodeURIComponent("" + medicalHistoryId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PsychiatricProfileDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PsychiatricProfileDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PsychiatricProfileDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PsychiatricProfileDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PsychiatricProfileTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PsychiatricProfileType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RecordHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param entityType (optional) 
     * @param entityId (optional) 
     * @param userId (optional) 
     * @param patientId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(entityType: string | undefined, entityId: string | undefined, userId: number | undefined, patientId: number | undefined, startDate: Date | undefined, endDate: Date | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<RecordHistoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/RecordHistory/GetAll?";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "EntityType=" + encodeURIComponent("" + entityType) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RecordHistoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecordHistoryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RecurrenceEndTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RecurrenceEndType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RecurrenceTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RecurrenceType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<RoleListDtoListResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleListDtoListResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(<any>response_);
                } catch (e) {
                    return <Observable<PermissionDtoListResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PermissionDtoListResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRoleForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRoleForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param roleId (optional) 
     * @param isStatic (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, roleId: number | undefined, isStatic: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (isStatic === null)
            throw new Error("The parameter 'isStatic' cannot be null.");
        else if (isStatic !== undefined)
            url_ += "IsStatic=" + encodeURIComponent("" + isStatic) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<RoleDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(<any>response_);
                } catch (e) {
                    return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ShiftTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ShiftType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StaffServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param operationalUnitId (optional) 
     * @param roleId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, operationalUnitId: number | undefined, roleId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Staff/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<UserDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TemperatureServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Temperature/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param temperatureEnvironmentTypeId (optional) 
     * @param temperatureShiftId (optional) 
     * @param recurrentTypeId (optional) 
     * @param recurrentEndTypeId (optional) 
     * @param date (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @param note (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(operationalUnitId: number | undefined, temperatureEnvironmentTypeId: number | undefined, temperatureShiftId: number | undefined, recurrentTypeId: number | undefined, recurrentEndTypeId: number | undefined, date: Date | undefined, dateStart: Date | undefined, dateEnd: Date | undefined, note: string | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<TemperatureDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Temperature/GetAll?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (temperatureEnvironmentTypeId === null)
            throw new Error("The parameter 'temperatureEnvironmentTypeId' cannot be null.");
        else if (temperatureEnvironmentTypeId !== undefined)
            url_ += "TemperatureEnvironmentTypeId=" + encodeURIComponent("" + temperatureEnvironmentTypeId) + "&";
        if (temperatureShiftId === null)
            throw new Error("The parameter 'temperatureShiftId' cannot be null.");
        else if (temperatureShiftId !== undefined)
            url_ += "TemperatureShiftId=" + encodeURIComponent("" + temperatureShiftId) + "&";
        if (recurrentTypeId === null)
            throw new Error("The parameter 'recurrentTypeId' cannot be null.");
        else if (recurrentTypeId !== undefined)
            url_ += "RecurrentTypeId=" + encodeURIComponent("" + recurrentTypeId) + "&";
        if (recurrentEndTypeId === null)
            throw new Error("The parameter 'recurrentEndTypeId' cannot be null.");
        else if (recurrentEndTypeId !== undefined)
            url_ += "RecurrentEndTypeId=" + encodeURIComponent("" + recurrentEndTypeId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        if (dateStart === null)
            throw new Error("The parameter 'dateStart' cannot be null.");
        else if (dateStart !== undefined)
            url_ += "DateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toJSON() : "") + "&";
        if (dateEnd === null)
            throw new Error("The parameter 'dateEnd' cannot be null.");
        else if (dateEnd !== undefined)
            url_ += "DateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toJSON() : "") + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<TemperatureDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TemperatureDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TemperatureDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemperatureDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Temperature/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @param temperatureEnvironmentTypeId (optional) 
     * @param temperatureShiftId (optional) 
     * @param recurrentTypeId (optional) 
     * @param recurrentEndTypeId (optional) 
     * @param date (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @param note (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getFileExport(operationalUnitId: number | undefined, temperatureEnvironmentTypeId: number | undefined, temperatureShiftId: number | undefined, recurrentTypeId: number | undefined, recurrentEndTypeId: number | undefined, date: Date | undefined, dateStart: Date | undefined, dateEnd: Date | undefined, note: string | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/api/services/app/Temperature/GetFileExport?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (temperatureEnvironmentTypeId === null)
            throw new Error("The parameter 'temperatureEnvironmentTypeId' cannot be null.");
        else if (temperatureEnvironmentTypeId !== undefined)
            url_ += "TemperatureEnvironmentTypeId=" + encodeURIComponent("" + temperatureEnvironmentTypeId) + "&";
        if (temperatureShiftId === null)
            throw new Error("The parameter 'temperatureShiftId' cannot be null.");
        else if (temperatureShiftId !== undefined)
            url_ += "TemperatureShiftId=" + encodeURIComponent("" + temperatureShiftId) + "&";
        if (recurrentTypeId === null)
            throw new Error("The parameter 'recurrentTypeId' cannot be null.");
        else if (recurrentTypeId !== undefined)
            url_ += "RecurrentTypeId=" + encodeURIComponent("" + recurrentTypeId) + "&";
        if (recurrentEndTypeId === null)
            throw new Error("The parameter 'recurrentEndTypeId' cannot be null.");
        else if (recurrentEndTypeId !== undefined)
            url_ += "RecurrentEndTypeId=" + encodeURIComponent("" + recurrentEndTypeId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        if (dateStart === null)
            throw new Error("The parameter 'dateStart' cannot be null.");
        else if (dateStart !== undefined)
            url_ += "DateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toJSON() : "") + "&";
        if (dateEnd === null)
            throw new Error("The parameter 'dateEnd' cannot be null.");
        else if (dateEnd !== undefined)
            url_ += "DateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toJSON() : "") + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileExport(<any>response_);
                } catch (e) {
                    return <Observable<FileExportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileExport(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateTemperatureDto | undefined): Observable<TemperatureDto> {
        let url_ = this.baseUrl + "/api/services/app/Temperature/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TemperatureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TemperatureDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TemperatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemperatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTemperatureDto | undefined): Observable<TemperatureDto> {
        let url_ = this.baseUrl + "/api/services/app/Temperature/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<TemperatureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TemperatureDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TemperatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemperatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TemperatureDto> {
        let url_ = this.baseUrl + "/api/services/app/Temperature/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TemperatureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TemperatureDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TemperatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemperatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TemperatureEnvironmentTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateTemperatureEnvironmentTypeDto | undefined): Observable<TemperatureEnvironmentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/TemperatureEnvironmentType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TemperatureEnvironmentTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TemperatureEnvironmentTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TemperatureEnvironmentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemperatureEnvironmentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTemperatureEnvironmentTypeDto | undefined): Observable<TemperatureEnvironmentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/TemperatureEnvironmentType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<TemperatureEnvironmentTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TemperatureEnvironmentTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TemperatureEnvironmentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemperatureEnvironmentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TemperatureEnvironmentType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TemperatureEnvironmentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/TemperatureEnvironmentType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TemperatureEnvironmentTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TemperatureEnvironmentTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TemperatureEnvironmentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemperatureEnvironmentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param isAscending (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, isAscending: boolean | undefined, isPaged: boolean | undefined, skipCount: number | undefined, sorting: string | undefined, maxResultCount: number | undefined): Observable<TemperatureEnvironmentTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TemperatureEnvironmentType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isAscending === null)
            throw new Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "IsAscending=" + encodeURIComponent("" + isAscending) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<TemperatureEnvironmentTypeDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TemperatureEnvironmentTypeDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TemperatureEnvironmentTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemperatureEnvironmentTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TemperatureReadingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TemperatureReading/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateTemperatureReadingDto | undefined): Observable<TemperatureReadingDto> {
        let url_ = this.baseUrl + "/api/services/app/TemperatureReading/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TemperatureReadingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TemperatureReadingDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TemperatureReadingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemperatureReadingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTemperatureReadingDto | undefined): Observable<TemperatureReadingDto> {
        let url_ = this.baseUrl + "/api/services/app/TemperatureReading/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<TemperatureReadingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TemperatureReadingDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TemperatureReadingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemperatureReadingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TemperatureReading/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TemperatureReadingDto> {
        let url_ = this.baseUrl + "/api/services/app/TemperatureReading/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TemperatureReadingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TemperatureReadingDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TemperatureReadingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemperatureReadingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<TemperatureReadingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TemperatureReading/GetAll?";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<TemperatureReadingDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TemperatureReadingDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TemperatureReadingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemperatureReadingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @return Success
     */
    getTenantUrls(): Observable<TenantUrlDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantUrls";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantUrls(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantUrls(<any>response_);
                } catch (e) {
                    return <Observable<TenantUrlDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantUrlDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantUrls(response: HttpResponseBase): Observable<TenantUrlDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantUrlDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<TenantDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TherapeuticAreaTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TherapeuticAreaType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TherapeuticProgramServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TherapeuticProgram/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TherapeuticProgram/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateTherapeuticProgramDto | undefined): Observable<TherapeuticProgramDto> {
        let url_ = this.baseUrl + "/api/services/app/TherapeuticProgram/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TherapeuticProgramDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TherapeuticProgramDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TherapeuticProgramDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TherapeuticProgramDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTherapeuticProgramDto | undefined): Observable<TherapeuticProgramDto> {
        let url_ = this.baseUrl + "/api/services/app/TherapeuticProgram/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<TherapeuticProgramDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TherapeuticProgramDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TherapeuticProgramDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TherapeuticProgramDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TherapeuticProgramDto> {
        let url_ = this.baseUrl + "/api/services/app/TherapeuticProgram/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TherapeuticProgramDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TherapeuticProgramDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TherapeuticProgramDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TherapeuticProgramDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param patientId (optional) 
     * @param operationalUnitId (optional) 
     * @param name (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(patientId: number | undefined, operationalUnitId: number | undefined, name: string | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<TherapeuticProgramDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TherapeuticProgram/GetAll?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<TherapeuticProgramDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TherapeuticProgramDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TherapeuticProgramDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TherapeuticProgramDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(<any>response_);
                } catch (e) {
                    return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param operationalUnitId (optional) 
     * @return Success
     */
    getAllUSimpleUsers(operationalUnitId: number | undefined): Observable<SimpleUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAllUSimpleUsers?";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUSimpleUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUSimpleUsers(<any>response_);
                } catch (e) {
                    return <Observable<SimpleUserDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SimpleUserDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllUSimpleUsers(response: HttpResponseBase): Observable<SimpleUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SimpleUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @return Success
     */
    getMyProfile(): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetMyProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyProfile(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMyProfile(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMyProfile(body: UpdateMyProfileDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateMyProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMyProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMyProfile(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateMyProfile(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    toggleActivationUser(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ToggleActivationUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleActivationUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleActivationUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processToggleActivationUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    unlockLogin(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockLogin?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockLogin(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnlockLogin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forceResetPassword(body: ForceResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ForceResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForceResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processForceResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param isPaginated (optional) 
     * @param isActive (optional) 
     * @param roleId (optional) 
     * @param operationalUnitId (optional) 
     * @param operationalUnitSecondaryId (optional) 
     * @param isManager (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isPaginated: boolean | undefined, isActive: boolean | undefined, roleId: number | undefined, operationalUnitId: number | undefined, operationalUnitSecondaryId: number | undefined, isManager: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isPaginated === null)
            throw new Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (operationalUnitId === null)
            throw new Error("The parameter 'operationalUnitId' cannot be null.");
        else if (operationalUnitId !== undefined)
            url_ += "OperationalUnitId=" + encodeURIComponent("" + operationalUnitId) + "&";
        if (operationalUnitSecondaryId === null)
            throw new Error("The parameter 'operationalUnitSecondaryId' cannot be null.");
        else if (operationalUnitSecondaryId !== undefined)
            url_ += "OperationalUnitSecondaryId=" + encodeURIComponent("" + operationalUnitSecondaryId) + "&";
        if (isManager === null)
            throw new Error("The parameter 'isManager' cannot be null.");
        else if (isManager !== undefined)
            url_ += "IsManager=" + encodeURIComponent("" + isManager) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<UserDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserFileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserFileDto | undefined): Observable<UserFileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserFile/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserFileDto | undefined): Observable<UserFileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserFile/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserFile/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserFileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserFile/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<UserFileDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserFile/GetAll?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<UserFileDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserFileDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserFileDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserFileDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserFileTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserFileType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VaccinationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Vaccination/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateVaccinationDto | undefined): Observable<VaccinationDto> {
        let url_ = this.baseUrl + "/api/services/app/Vaccination/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<VaccinationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VaccinationDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<VaccinationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VaccinationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateVaccinationDto | undefined): Observable<VaccinationDto> {
        let url_ = this.baseUrl + "/api/services/app/Vaccination/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<VaccinationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VaccinationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<VaccinationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VaccinationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Vaccination/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<VaccinationDto> {
        let url_ = this.baseUrl + "/api/services/app/Vaccination/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<VaccinationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VaccinationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VaccinationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VaccinationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicalHistoryId (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(medicalHistoryId: number | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<VaccinationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Vaccination/GetAll?";
        if (medicalHistoryId === null)
            throw new Error("The parameter 'medicalHistoryId' cannot be null.");
        else if (medicalHistoryId !== undefined)
            url_ += "MedicalHistoryId=" + encodeURIComponent("" + medicalHistoryId) + "&";
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<VaccinationDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VaccinationDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VaccinationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VaccinationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VaccinationDictionaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VaccinationDictionary/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VaccinationResultServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VaccinationResult/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VaccinationTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VaccinationType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VitalParameterTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VitalParameterType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VitalSignsRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VitalSignsRecord/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<RecordHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VitalSignsRecord/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<RecordHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RecordHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicalHistoryId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param vitalParameterTypeIds (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getFileExport(medicalHistoryId: number | undefined, startDate: Date | undefined, endDate: Date | undefined, vitalParameterTypeIds: number[] | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<FileExportDto> {
        let url_ = this.baseUrl + "/api/services/app/VitalSignsRecord/GetFileExport?";
        if (medicalHistoryId === null)
            throw new Error("The parameter 'medicalHistoryId' cannot be null.");
        else if (medicalHistoryId !== undefined)
            url_ += "MedicalHistoryId=" + encodeURIComponent("" + medicalHistoryId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (vitalParameterTypeIds === null)
            throw new Error("The parameter 'vitalParameterTypeIds' cannot be null.");
        else if (vitalParameterTypeIds !== undefined)
            vitalParameterTypeIds && vitalParameterTypeIds.forEach(item => { url_ += "VitalParameterTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileExport(<any>response_);
                } catch (e) {
                    return <Observable<FileExportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileExportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileExport(response: HttpResponseBase): Observable<FileExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateVitalSignsRecordDto | undefined): Observable<VitalSignsRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/VitalSignsRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<VitalSignsRecordDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VitalSignsRecordDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<VitalSignsRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VitalSignsRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateVitalSignsRecordDto | undefined): Observable<VitalSignsRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/VitalSignsRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<VitalSignsRecordDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VitalSignsRecordDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<VitalSignsRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VitalSignsRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<VitalSignsRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/VitalSignsRecord/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<VitalSignsRecordDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VitalSignsRecordDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VitalSignsRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VitalSignsRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * @param medicalHistoryId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param vitalParameterTypeIds (optional) 
     * @param isPaged (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(medicalHistoryId: number | undefined, startDate: Date | undefined, endDate: Date | undefined, vitalParameterTypeIds: number[] | undefined, isPaged: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<VitalSignsRecordDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/VitalSignsRecord/GetAll?";
        if (medicalHistoryId === null)
            throw new Error("The parameter 'medicalHistoryId' cannot be null.");
        else if (medicalHistoryId !== undefined)
            url_ += "MedicalHistoryId=" + encodeURIComponent("" + medicalHistoryId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (vitalParameterTypeIds === null)
            throw new Error("The parameter 'vitalParameterTypeIds' cannot be null.");
        else if (vitalParameterTypeIds !== undefined)
            vitalParameterTypeIds && vitalParameterTypeIds.forEach(item => { url_ += "VitalParameterTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (isPaged === null)
            throw new Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<VitalSignsRecordDtoPagedResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VitalSignsRecordDtoPagedResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VitalSignsRecordDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VitalSignsRecordDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WeekDayTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/WeekDayType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<DictionaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DictionaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

export class AddMedicationsToDocumentDto implements IAddMedicationsToDocumentDto {
    documentId!: number;
    medicationIds!: number[] | undefined;

    constructor(data?: IAddMedicationsToDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            if (Array.isArray(_data["medicationIds"])) {
                this.medicationIds = [] as any;
                for (let item of _data["medicationIds"])
                    this.medicationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AddMedicationsToDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddMedicationsToDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        if (Array.isArray(this.medicationIds)) {
            data["medicationIds"] = [];
            for (let item of this.medicationIds)
                data["medicationIds"].push(item);
        }
        return data;
    }

    clone(): AddMedicationsToDocumentDto {
        const json = this.toJSON();
        let result = new AddMedicationsToDocumentDto();
        result.init(json);
        return result;
    }
}

export interface IAddMedicationsToDocumentDto {
    documentId: number;
    medicationIds: number[] | undefined;
}

export class AddressDto implements IAddressDto {
    id!: number;
    name!: string | undefined;
    postalCode!: string | undefined;
    description!: string | undefined;
    isMain!: boolean;
    municipality!: MunicipalityDto;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.postalCode = _data["postalCode"];
            this.description = _data["description"];
            this.isMain = _data["isMain"];
            this.municipality = _data["municipality"] ? MunicipalityDto.fromJS(_data["municipality"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["postalCode"] = this.postalCode;
        data["description"] = this.description;
        data["isMain"] = this.isMain;
        data["municipality"] = this.municipality ? this.municipality.toJSON() : <any>undefined;
        return data;
    }

    clone(): AddressDto {
        const json = this.toJSON();
        let result = new AddressDto();
        result.init(json);
        return result;
    }
}

export interface IAddressDto {
    id: number;
    name: string | undefined;
    postalCode: string | undefined;
    description: string | undefined;
    isMain: boolean;
    municipality: MunicipalityDto;
}

export class AdministrationSlotDto implements IAdministrationSlotDto {
    time!: string;
    total!: number;
    toAdminister!: number;

    constructor(data?: IAdministrationSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.time = _data["time"];
            this.total = _data["total"];
            this.toAdminister = _data["toAdminister"];
        }
    }

    static fromJS(data: any): AdministrationSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdministrationSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time;
        data["total"] = this.total;
        data["toAdminister"] = this.toAdminister;
        return data;
    }

    clone(): AdministrationSlotDto {
        const json = this.toJSON();
        let result = new AdministrationSlotDto();
        result.init(json);
        return result;
    }
}

export interface IAdministrationSlotDto {
    time: string;
    total: number;
    toAdminister: number;
}

export class AllergyDto implements IAllergyDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    diagnosisDate!: Date;
    allergen!: string | undefined;
    note!: string | undefined;
    isOther!: boolean;
    prescribedTherapyMedication!: string | undefined;
    isLifeSaving!: boolean;
    medicationId!: number | undefined;
    medication!: SimpleMedicationDto;

    constructor(data?: IAllergyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.diagnosisDate = _data["diagnosisDate"] ? new Date(_data["diagnosisDate"].toString()) : <any>undefined;
            this.allergen = _data["allergen"];
            this.note = _data["note"];
            this.isOther = _data["isOther"];
            this.prescribedTherapyMedication = _data["prescribedTherapyMedication"];
            this.isLifeSaving = _data["isLifeSaving"];
            this.medicationId = _data["medicationId"];
            this.medication = _data["medication"] ? SimpleMedicationDto.fromJS(_data["medication"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AllergyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllergyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["diagnosisDate"] = this.diagnosisDate ? this.diagnosisDate.toISOString() : <any>undefined;
        data["allergen"] = this.allergen;
        data["note"] = this.note;
        data["isOther"] = this.isOther;
        data["prescribedTherapyMedication"] = this.prescribedTherapyMedication;
        data["isLifeSaving"] = this.isLifeSaving;
        data["medicationId"] = this.medicationId;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        return data;
    }

    clone(): AllergyDto {
        const json = this.toJSON();
        let result = new AllergyDto();
        result.init(json);
        return result;
    }
}

export interface IAllergyDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    diagnosisDate: Date;
    allergen: string | undefined;
    note: string | undefined;
    isOther: boolean;
    prescribedTherapyMedication: string | undefined;
    isLifeSaving: boolean;
    medicationId: number | undefined;
    medication: SimpleMedicationDto;
}

export class AllergyDtoPagedResultDto implements IAllergyDtoPagedResultDto {
    items!: AllergyDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAllergyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AllergyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AllergyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllergyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AllergyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AllergyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAllergyDtoPagedResultDto {
    items: AllergyDto[] | undefined;
    totalCount: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: Date;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = this.features[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: Date;
    features: { [key: string]: boolean; } | undefined;
}

export class ApplyBySlotInput implements IApplyBySlotInput {
    patientId!: number;
    slot!: string;
    medicationStockCode!: string | undefined;

    constructor(data?: IApplyBySlotInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.slot = _data["slot"];
            this.medicationStockCode = _data["medicationStockCode"];
        }
    }

    static fromJS(data: any): ApplyBySlotInput {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyBySlotInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["slot"] = this.slot;
        data["medicationStockCode"] = this.medicationStockCode;
        return data;
    }

    clone(): ApplyBySlotInput {
        const json = this.toJSON();
        let result = new ApplyBySlotInput();
        result.init(json);
        return result;
    }
}

export interface IApplyBySlotInput {
    patientId: number;
    slot: string;
    medicationStockCode: string | undefined;
}

export class ApplyPatientMedicationAdministrationDto implements IApplyPatientMedicationAdministrationDto {
    id!: number;
    administratedAtUtc!: Date | undefined;
    administeredDose!: number;
    note!: string | undefined;
    medicationStockCode!: string | undefined;

    constructor(data?: IApplyPatientMedicationAdministrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.administratedAtUtc = _data["administratedAtUtc"] ? new Date(_data["administratedAtUtc"].toString()) : <any>undefined;
            this.administeredDose = _data["administeredDose"];
            this.note = _data["note"];
            this.medicationStockCode = _data["medicationStockCode"];
        }
    }

    static fromJS(data: any): ApplyPatientMedicationAdministrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyPatientMedicationAdministrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["administratedAtUtc"] = this.administratedAtUtc ? this.administratedAtUtc.toISOString() : <any>undefined;
        data["administeredDose"] = this.administeredDose;
        data["note"] = this.note;
        data["medicationStockCode"] = this.medicationStockCode;
        return data;
    }

    clone(): ApplyPatientMedicationAdministrationDto {
        const json = this.toJSON();
        let result = new ApplyPatientMedicationAdministrationDto();
        result.init(json);
        return result;
    }
}

export interface IApplyPatientMedicationAdministrationDto {
    id: number;
    administratedAtUtc: Date | undefined;
    administeredDose: number;
    note: string | undefined;
    medicationStockCode: string | undefined;
}

export class AslContactDto implements IAslContactDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    doctorName!: string | undefined;
    doctorPhoneNumber!: string | undefined;
    socialWorkerName!: string | undefined;
    socialWorkerPhoneNumber!: string | undefined;
    caseManager!: string | undefined;
    referenceFamilyMemberName!: string | undefined;
    referenceFamilyMemberPhoneNumber!: string | undefined;
    municipality!: MunicipalityDto;
    disabilityService!: string | undefined;

    constructor(data?: IAslContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.doctorName = _data["doctorName"];
            this.doctorPhoneNumber = _data["doctorPhoneNumber"];
            this.socialWorkerName = _data["socialWorkerName"];
            this.socialWorkerPhoneNumber = _data["socialWorkerPhoneNumber"];
            this.caseManager = _data["caseManager"];
            this.referenceFamilyMemberName = _data["referenceFamilyMemberName"];
            this.referenceFamilyMemberPhoneNumber = _data["referenceFamilyMemberPhoneNumber"];
            this.municipality = _data["municipality"] ? MunicipalityDto.fromJS(_data["municipality"]) : <any>undefined;
            this.disabilityService = _data["disabilityService"];
        }
    }

    static fromJS(data: any): AslContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new AslContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["doctorName"] = this.doctorName;
        data["doctorPhoneNumber"] = this.doctorPhoneNumber;
        data["socialWorkerName"] = this.socialWorkerName;
        data["socialWorkerPhoneNumber"] = this.socialWorkerPhoneNumber;
        data["caseManager"] = this.caseManager;
        data["referenceFamilyMemberName"] = this.referenceFamilyMemberName;
        data["referenceFamilyMemberPhoneNumber"] = this.referenceFamilyMemberPhoneNumber;
        data["municipality"] = this.municipality ? this.municipality.toJSON() : <any>undefined;
        data["disabilityService"] = this.disabilityService;
        return data;
    }

    clone(): AslContactDto {
        const json = this.toJSON();
        let result = new AslContactDto();
        result.init(json);
        return result;
    }
}

export interface IAslContactDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    doctorName: string | undefined;
    doctorPhoneNumber: string | undefined;
    socialWorkerName: string | undefined;
    socialWorkerPhoneNumber: string | undefined;
    caseManager: string | undefined;
    referenceFamilyMemberName: string | undefined;
    referenceFamilyMemberPhoneNumber: string | undefined;
    municipality: MunicipalityDto;
    disabilityService: string | undefined;
}

export class AslContactDtoPagedResultDto implements IAslContactDtoPagedResultDto {
    items!: AslContactDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAslContactDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AslContactDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AslContactDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AslContactDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AslContactDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AslContactDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAslContactDtoPagedResultDto {
    items: AslContactDto[] | undefined;
    totalCount: number;
}

export class Assembly implements IAssembly {
    readonly definedTypes!: TypeInfo[] | undefined;
    readonly exportedTypes!: Type[] | undefined;
    readonly codeBase!: string | undefined;
    entryPoint!: MethodInfo;
    readonly fullName!: string | undefined;
    readonly imageRuntimeVersion!: string | undefined;
    readonly isDynamic!: boolean;
    readonly location!: string | undefined;
    readonly reflectionOnly!: boolean;
    readonly isCollectible!: boolean;
    readonly isFullyTrusted!: boolean;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly escapedCodeBase!: string | undefined;
    manifestModule!: Module;
    readonly modules!: Module[] | undefined;
    readonly globalAssemblyCache!: boolean;
    readonly hostContext!: number;
    securityRuleSet!: SecurityRuleSet;

    constructor(data?: IAssembly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["definedTypes"])) {
                (<any>this).definedTypes = [] as any;
                for (let item of _data["definedTypes"])
                    (<any>this).definedTypes!.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data["exportedTypes"])) {
                (<any>this).exportedTypes = [] as any;
                for (let item of _data["exportedTypes"])
                    (<any>this).exportedTypes!.push(Type.fromJS(item));
            }
            (<any>this).codeBase = _data["codeBase"];
            this.entryPoint = _data["entryPoint"] ? MethodInfo.fromJS(_data["entryPoint"]) : <any>undefined;
            (<any>this).fullName = _data["fullName"];
            (<any>this).imageRuntimeVersion = _data["imageRuntimeVersion"];
            (<any>this).isDynamic = _data["isDynamic"];
            (<any>this).location = _data["location"];
            (<any>this).reflectionOnly = _data["reflectionOnly"];
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).isFullyTrusted = _data["isFullyTrusted"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).escapedCodeBase = _data["escapedCodeBase"];
            this.manifestModule = _data["manifestModule"] ? Module.fromJS(_data["manifestModule"]) : <any>undefined;
            if (Array.isArray(_data["modules"])) {
                (<any>this).modules = [] as any;
                for (let item of _data["modules"])
                    (<any>this).modules!.push(Module.fromJS(item));
            }
            (<any>this).globalAssemblyCache = _data["globalAssemblyCache"];
            (<any>this).hostContext = _data["hostContext"];
            this.securityRuleSet = _data["securityRuleSet"];
        }
    }

    static fromJS(data: any): Assembly {
        data = typeof data === 'object' ? data : {};
        let result = new Assembly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definedTypes)) {
            data["definedTypes"] = [];
            for (let item of this.definedTypes)
                data["definedTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.exportedTypes)) {
            data["exportedTypes"] = [];
            for (let item of this.exportedTypes)
                data["exportedTypes"].push(item.toJSON());
        }
        data["codeBase"] = this.codeBase;
        data["entryPoint"] = this.entryPoint ? this.entryPoint.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        data["imageRuntimeVersion"] = this.imageRuntimeVersion;
        data["isDynamic"] = this.isDynamic;
        data["location"] = this.location;
        data["reflectionOnly"] = this.reflectionOnly;
        data["isCollectible"] = this.isCollectible;
        data["isFullyTrusted"] = this.isFullyTrusted;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["escapedCodeBase"] = this.escapedCodeBase;
        data["manifestModule"] = this.manifestModule ? this.manifestModule.toJSON() : <any>undefined;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        data["globalAssemblyCache"] = this.globalAssemblyCache;
        data["hostContext"] = this.hostContext;
        data["securityRuleSet"] = this.securityRuleSet;
        return data;
    }

    clone(): Assembly {
        const json = this.toJSON();
        let result = new Assembly();
        result.init(json);
        return result;
    }
}

export interface IAssembly {
    definedTypes: TypeInfo[] | undefined;
    exportedTypes: Type[] | undefined;
    codeBase: string | undefined;
    entryPoint: MethodInfo;
    fullName: string | undefined;
    imageRuntimeVersion: string | undefined;
    isDynamic: boolean;
    location: string | undefined;
    reflectionOnly: boolean;
    isCollectible: boolean;
    isFullyTrusted: boolean;
    customAttributes: CustomAttributeData[] | undefined;
    escapedCodeBase: string | undefined;
    manifestModule: Module;
    modules: Module[] | undefined;
    globalAssemblyCache: boolean;
    hostContext: number;
    securityRuleSet: SecurityRuleSet;
}

export class AssignMedicationByCodeDto implements IAssignMedicationByCodeDto {
    patientId!: number;
    operationalUnitId!: number;
    medicationStockCodeId!: number;
    note!: string | undefined;
    quantity!: number;

    constructor(data?: IAssignMedicationByCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.operationalUnitId = _data["operationalUnitId"];
            this.medicationStockCodeId = _data["medicationStockCodeId"];
            this.note = _data["note"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): AssignMedicationByCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignMedicationByCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["operationalUnitId"] = this.operationalUnitId;
        data["medicationStockCodeId"] = this.medicationStockCodeId;
        data["note"] = this.note;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): AssignMedicationByCodeDto {
        const json = this.toJSON();
        let result = new AssignMedicationByCodeDto();
        result.init(json);
        return result;
    }
}

export interface IAssignMedicationByCodeDto {
    patientId: number;
    operationalUnitId: number;
    medicationStockCodeId: number;
    note: string | undefined;
    quantity: number;
}

export class AttendanceDto implements IAttendanceDto {
    id!: number;
    attendanceMark!: DictionaryDto;
    date!: Date;
    note!: string | undefined;
    isActive!: boolean;

    constructor(data?: IAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attendanceMark = _data["attendanceMark"] ? DictionaryDto.fromJS(_data["attendanceMark"]) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attendanceMark"] = this.attendanceMark ? this.attendanceMark.toJSON() : <any>undefined;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): AttendanceDto {
        const json = this.toJSON();
        let result = new AttendanceDto();
        result.init(json);
        return result;
    }
}

export interface IAttendanceDto {
    id: number;
    attendanceMark: DictionaryDto;
    date: Date;
    note: string | undefined;
    isActive: boolean;
}

export class AttendanceMarkCountDto implements IAttendanceMarkCountDto {
    attendanceMark!: DictionaryDto;
    count!: number;

    constructor(data?: IAttendanceMarkCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceMark = _data["attendanceMark"] ? DictionaryDto.fromJS(_data["attendanceMark"]) : <any>undefined;
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AttendanceMarkCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceMarkCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceMark"] = this.attendanceMark ? this.attendanceMark.toJSON() : <any>undefined;
        data["count"] = this.count;
        return data;
    }

    clone(): AttendanceMarkCountDto {
        const json = this.toJSON();
        let result = new AttendanceMarkCountDto();
        result.init(json);
        return result;
    }
}

export interface IAttendanceMarkCountDto {
    attendanceMark: DictionaryDto;
    count: number;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    rememberClient!: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    userId!: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

export class BaseMedicationDto implements IBaseMedicationDto {
    id!: number;
    name!: string | undefined;
    barcodes!: MedicationBarcodeDto[] | undefined;

    constructor(data?: IBaseMedicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["barcodes"])) {
                this.barcodes = [] as any;
                for (let item of _data["barcodes"])
                    this.barcodes!.push(MedicationBarcodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseMedicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseMedicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.barcodes)) {
            data["barcodes"] = [];
            for (let item of this.barcodes)
                data["barcodes"].push(item.toJSON());
        }
        return data;
    }

    clone(): BaseMedicationDto {
        const json = this.toJSON();
        let result = new BaseMedicationDto();
        result.init(json);
        return result;
    }
}

export interface IBaseMedicationDto {
    id: number;
    name: string | undefined;
    barcodes: MedicationBarcodeDto[] | undefined;
}

export class CalendarEventDto implements ICalendarEventDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    task!: CalendarTaskDto;
    startDate!: Date;
    note!: string | undefined;
    isExpired!: boolean;
    users!: UserDto[] | undefined;
    patients!: PatientDto[] | undefined;
    calendarEventRecurrence!: CalendarEventRecurrenceDto;
    status!: CalendarStatusDto;
    operationalUnit!: SimpleOperationalUnitDto;

    constructor(data?: ICalendarEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.task = _data["task"] ? CalendarTaskDto.fromJS(_data["task"]) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.isExpired = _data["isExpired"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDto.fromJS(item));
            }
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients!.push(PatientDto.fromJS(item));
            }
            this.calendarEventRecurrence = _data["calendarEventRecurrence"] ? CalendarEventRecurrenceDto.fromJS(_data["calendarEventRecurrence"]) : <any>undefined;
            this.status = _data["status"] ? CalendarStatusDto.fromJS(_data["status"]) : <any>undefined;
            this.operationalUnit = _data["operationalUnit"] ? SimpleOperationalUnitDto.fromJS(_data["operationalUnit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CalendarEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["task"] = this.task ? this.task.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["isExpired"] = this.isExpired;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        data["calendarEventRecurrence"] = this.calendarEventRecurrence ? this.calendarEventRecurrence.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["operationalUnit"] = this.operationalUnit ? this.operationalUnit.toJSON() : <any>undefined;
        return data;
    }

    clone(): CalendarEventDto {
        const json = this.toJSON();
        let result = new CalendarEventDto();
        result.init(json);
        return result;
    }
}

export interface ICalendarEventDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    task: CalendarTaskDto;
    startDate: Date;
    note: string | undefined;
    isExpired: boolean;
    users: UserDto[] | undefined;
    patients: PatientDto[] | undefined;
    calendarEventRecurrence: CalendarEventRecurrenceDto;
    status: CalendarStatusDto;
    operationalUnit: SimpleOperationalUnitDto;
}

export class CalendarEventDtoPagedResultDto implements ICalendarEventDtoPagedResultDto {
    items!: CalendarEventDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICalendarEventDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CalendarEventDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CalendarEventDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarEventDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CalendarEventDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CalendarEventDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICalendarEventDtoPagedResultDto {
    items: CalendarEventDto[] | undefined;
    totalCount: number;
}

export class CalendarEventRecurrenceDto implements ICalendarEventRecurrenceDto {
    id!: number;
    recurrenceType!: DictionaryDto;
    interval!: number;
    weekDays!: DictionaryDto[] | undefined;
    recurrenceEndType!: DictionaryDto;
    endDate!: Date | undefined;
    occurrenceCount!: number | undefined;
    monthlyRecurrenceType!: DictionaryDto;
    weekPosition!: DictionaryDto;

    constructor(data?: ICalendarEventRecurrenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recurrenceType = _data["recurrenceType"] ? DictionaryDto.fromJS(_data["recurrenceType"]) : <any>undefined;
            this.interval = _data["interval"];
            if (Array.isArray(_data["weekDays"])) {
                this.weekDays = [] as any;
                for (let item of _data["weekDays"])
                    this.weekDays!.push(DictionaryDto.fromJS(item));
            }
            this.recurrenceEndType = _data["recurrenceEndType"] ? DictionaryDto.fromJS(_data["recurrenceEndType"]) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.occurrenceCount = _data["occurrenceCount"];
            this.monthlyRecurrenceType = _data["monthlyRecurrenceType"] ? DictionaryDto.fromJS(_data["monthlyRecurrenceType"]) : <any>undefined;
            this.weekPosition = _data["weekPosition"] ? DictionaryDto.fromJS(_data["weekPosition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CalendarEventRecurrenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarEventRecurrenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recurrenceType"] = this.recurrenceType ? this.recurrenceType.toJSON() : <any>undefined;
        data["interval"] = this.interval;
        if (Array.isArray(this.weekDays)) {
            data["weekDays"] = [];
            for (let item of this.weekDays)
                data["weekDays"].push(item.toJSON());
        }
        data["recurrenceEndType"] = this.recurrenceEndType ? this.recurrenceEndType.toJSON() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["occurrenceCount"] = this.occurrenceCount;
        data["monthlyRecurrenceType"] = this.monthlyRecurrenceType ? this.monthlyRecurrenceType.toJSON() : <any>undefined;
        data["weekPosition"] = this.weekPosition ? this.weekPosition.toJSON() : <any>undefined;
        return data;
    }

    clone(): CalendarEventRecurrenceDto {
        const json = this.toJSON();
        let result = new CalendarEventRecurrenceDto();
        result.init(json);
        return result;
    }
}

export interface ICalendarEventRecurrenceDto {
    id: number;
    recurrenceType: DictionaryDto;
    interval: number;
    weekDays: DictionaryDto[] | undefined;
    recurrenceEndType: DictionaryDto;
    endDate: Date | undefined;
    occurrenceCount: number | undefined;
    monthlyRecurrenceType: DictionaryDto;
    weekPosition: DictionaryDto;
}

export class CalendarShiftDto implements ICalendarShiftDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;
    isStatic!: boolean;

    constructor(data?: ICalendarShiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): CalendarShiftDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarShiftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): CalendarShiftDto {
        const json = this.toJSON();
        let result = new CalendarShiftDto();
        result.init(json);
        return result;
    }
}

export interface ICalendarShiftDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
    isStatic: boolean;
}

export class CalendarShiftDtoPagedResultDto implements ICalendarShiftDtoPagedResultDto {
    items!: CalendarShiftDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICalendarShiftDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CalendarShiftDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CalendarShiftDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarShiftDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CalendarShiftDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CalendarShiftDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICalendarShiftDtoPagedResultDto {
    items: CalendarShiftDto[] | undefined;
    totalCount: number;
}

export class CalendarStatusDto implements ICalendarStatusDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    statusType!: DictionaryDto;
    dateTime!: Date;
    user!: UserDto;

    constructor(data?: ICalendarStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.statusType = _data["statusType"] ? DictionaryDto.fromJS(_data["statusType"]) : <any>undefined;
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CalendarStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["statusType"] = this.statusType ? this.statusType.toJSON() : <any>undefined;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }

    clone(): CalendarStatusDto {
        const json = this.toJSON();
        let result = new CalendarStatusDto();
        result.init(json);
        return result;
    }
}

export interface ICalendarStatusDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    statusType: DictionaryDto;
    dateTime: Date;
    user: UserDto;
}

export class CalendarStatusDtoPagedResultDto implements ICalendarStatusDtoPagedResultDto {
    items!: CalendarStatusDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICalendarStatusDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CalendarStatusDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CalendarStatusDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarStatusDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CalendarStatusDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CalendarStatusDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICalendarStatusDtoPagedResultDto {
    items: CalendarStatusDto[] | undefined;
    totalCount: number;
}

export class CalendarTaskDto implements ICalendarTaskDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;
    isStatic!: boolean;

    constructor(data?: ICalendarTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): CalendarTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): CalendarTaskDto {
        const json = this.toJSON();
        let result = new CalendarTaskDto();
        result.init(json);
        return result;
    }
}

export interface ICalendarTaskDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
    isStatic: boolean;
}

export class CalendarTaskDtoPagedResultDto implements ICalendarTaskDtoPagedResultDto {
    items!: CalendarTaskDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICalendarTaskDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CalendarTaskDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CalendarTaskDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarTaskDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CalendarTaskDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CalendarTaskDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICalendarTaskDtoPagedResultDto {
    items: CalendarTaskDto[] | undefined;
    totalCount: number;
}

export enum CallingConventions {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _32 = 32,
    _64 = 64,
}

export class CandidateStockDto implements ICandidateStockDto {
    detailId!: number;
    code!: string | undefined;
    expiryDate!: Date;
    remaining!: number;
    remainingSubUnits!: number | undefined;
    medicationId!: number;
    medicationName!: string | undefined;

    constructor(data?: ICandidateStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.detailId = _data["detailId"];
            this.code = _data["code"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.remaining = _data["remaining"];
            this.remainingSubUnits = _data["remainingSubUnits"];
            this.medicationId = _data["medicationId"];
            this.medicationName = _data["medicationName"];
        }
    }

    static fromJS(data: any): CandidateStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detailId"] = this.detailId;
        data["code"] = this.code;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["remaining"] = this.remaining;
        data["remainingSubUnits"] = this.remainingSubUnits;
        data["medicationId"] = this.medicationId;
        data["medicationName"] = this.medicationName;
        return data;
    }

    clone(): CandidateStockDto {
        const json = this.toJSON();
        let result = new CandidateStockDto();
        result.init(json);
        return result;
    }
}

export interface ICandidateStockDto {
    detailId: number;
    code: string | undefined;
    expiryDate: Date;
    remaining: number;
    remainingSubUnits: number | undefined;
    medicationId: number;
    medicationName: string | undefined;
}

export class CashBoxDto implements ICashBoxDto {
    id!: number;
    owner!: UserDto;

    constructor(data?: ICashBoxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.owner = _data["owner"] ? UserDto.fromJS(_data["owner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CashBoxDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashBoxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        return data;
    }

    clone(): CashBoxDto {
        const json = this.toJSON();
        let result = new CashBoxDto();
        result.init(json);
        return result;
    }
}

export interface ICashBoxDto {
    id: number;
    owner: UserDto;
}

export class CashBoxDtoPagedResultDto implements ICashBoxDtoPagedResultDto {
    items!: CashBoxDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICashBoxDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CashBoxDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CashBoxDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashBoxDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CashBoxDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CashBoxDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICashBoxDtoPagedResultDto {
    items: CashBoxDto[] | undefined;
    totalCount: number;
}

export class CashBoxUserDto implements ICashBoxUserDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    user!: SimpleUserDto;
    entryDate!: Date;
    exitDate!: Date | undefined;
    exitAmount!: number;

    constructor(data?: ICashBoxUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.user = _data["user"] ? SimpleUserDto.fromJS(_data["user"]) : <any>undefined;
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? new Date(_data["exitDate"].toString()) : <any>undefined;
            this.exitAmount = _data["exitAmount"];
        }
    }

    static fromJS(data: any): CashBoxUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashBoxUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toISOString() : <any>undefined;
        data["exitAmount"] = this.exitAmount;
        return data;
    }

    clone(): CashBoxUserDto {
        const json = this.toJSON();
        let result = new CashBoxUserDto();
        result.init(json);
        return result;
    }
}

export interface ICashBoxUserDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    user: SimpleUserDto;
    entryDate: Date;
    exitDate: Date | undefined;
    exitAmount: number;
}

export class CashBoxUserDtoPagedResultDto implements ICashBoxUserDtoPagedResultDto {
    items!: CashBoxUserDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICashBoxUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CashBoxUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CashBoxUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashBoxUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CashBoxUserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CashBoxUserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICashBoxUserDtoPagedResultDto {
    items: CashBoxUserDto[] | undefined;
    totalCount: number;
}

export class CashMovementAmountsDto implements ICashMovementAmountsDto {
    totalPeriodAmount!: number;
    totalPeriodEntryAmount!: number;
    totalPeriodExitAmount!: number;
    finalAmount!: number;

    constructor(data?: ICashMovementAmountsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPeriodAmount = _data["totalPeriodAmount"];
            this.totalPeriodEntryAmount = _data["totalPeriodEntryAmount"];
            this.totalPeriodExitAmount = _data["totalPeriodExitAmount"];
            this.finalAmount = _data["finalAmount"];
        }
    }

    static fromJS(data: any): CashMovementAmountsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashMovementAmountsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPeriodAmount"] = this.totalPeriodAmount;
        data["totalPeriodEntryAmount"] = this.totalPeriodEntryAmount;
        data["totalPeriodExitAmount"] = this.totalPeriodExitAmount;
        data["finalAmount"] = this.finalAmount;
        return data;
    }

    clone(): CashMovementAmountsDto {
        const json = this.toJSON();
        let result = new CashMovementAmountsDto();
        result.init(json);
        return result;
    }
}

export interface ICashMovementAmountsDto {
    totalPeriodAmount: number;
    totalPeriodEntryAmount: number;
    totalPeriodExitAmount: number;
    finalAmount: number;
}

export class CashMovementDto implements ICashMovementDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    cashMovementReason!: CashMovementReasonDto;
    patient!: PatientDto;
    cashMovementType!: DictionaryDto;
    date!: Date;
    amount!: number;
    note!: string | undefined;

    constructor(data?: ICashMovementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.cashMovementReason = _data["cashMovementReason"] ? CashMovementReasonDto.fromJS(_data["cashMovementReason"]) : <any>undefined;
            this.patient = _data["patient"] ? PatientDto.fromJS(_data["patient"]) : <any>undefined;
            this.cashMovementType = _data["cashMovementType"] ? DictionaryDto.fromJS(_data["cashMovementType"]) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CashMovementDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashMovementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["cashMovementReason"] = this.cashMovementReason ? this.cashMovementReason.toJSON() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["cashMovementType"] = this.cashMovementType ? this.cashMovementType.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["note"] = this.note;
        return data;
    }

    clone(): CashMovementDto {
        const json = this.toJSON();
        let result = new CashMovementDto();
        result.init(json);
        return result;
    }
}

export interface ICashMovementDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    cashMovementReason: CashMovementReasonDto;
    patient: PatientDto;
    cashMovementType: DictionaryDto;
    date: Date;
    amount: number;
    note: string | undefined;
}

export class CashMovementDtoPagedResultDto implements ICashMovementDtoPagedResultDto {
    items!: CashMovementDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICashMovementDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CashMovementDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CashMovementDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashMovementDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CashMovementDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CashMovementDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICashMovementDtoPagedResultDto {
    items: CashMovementDto[] | undefined;
    totalCount: number;
}

export class CashMovementPagedResultDto implements ICashMovementPagedResultDto {
    items!: CashMovementDto[] | undefined;
    totalCount!: number;
    totalPeriodAmount!: number;
    totalPeriodEntryAmount!: number;
    totalPeriodExitAmount!: number;
    finalAmount!: number;

    constructor(data?: ICashMovementPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CashMovementDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.totalPeriodAmount = _data["totalPeriodAmount"];
            this.totalPeriodEntryAmount = _data["totalPeriodEntryAmount"];
            this.totalPeriodExitAmount = _data["totalPeriodExitAmount"];
            this.finalAmount = _data["finalAmount"];
        }
    }

    static fromJS(data: any): CashMovementPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashMovementPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["totalPeriodAmount"] = this.totalPeriodAmount;
        data["totalPeriodEntryAmount"] = this.totalPeriodEntryAmount;
        data["totalPeriodExitAmount"] = this.totalPeriodExitAmount;
        data["finalAmount"] = this.finalAmount;
        return data;
    }

    clone(): CashMovementPagedResultDto {
        const json = this.toJSON();
        let result = new CashMovementPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICashMovementPagedResultDto {
    items: CashMovementDto[] | undefined;
    totalCount: number;
    totalPeriodAmount: number;
    totalPeriodEntryAmount: number;
    totalPeriodExitAmount: number;
    finalAmount: number;
}

export class CashMovementReasonDto implements ICashMovementReasonDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;
    isStatic!: boolean;
    reason!: string | undefined;
    cashMovementType!: DictionaryDto;

    constructor(data?: ICashMovementReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
            this.isStatic = _data["isStatic"];
            this.reason = _data["reason"];
            this.cashMovementType = _data["cashMovementType"] ? DictionaryDto.fromJS(_data["cashMovementType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CashMovementReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashMovementReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        data["isStatic"] = this.isStatic;
        data["reason"] = this.reason;
        data["cashMovementType"] = this.cashMovementType ? this.cashMovementType.toJSON() : <any>undefined;
        return data;
    }

    clone(): CashMovementReasonDto {
        const json = this.toJSON();
        let result = new CashMovementReasonDto();
        result.init(json);
        return result;
    }
}

export interface ICashMovementReasonDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
    isStatic: boolean;
    reason: string | undefined;
    cashMovementType: DictionaryDto;
}

export class CashMovementReasonDtoPagedResultDto implements ICashMovementReasonDtoPagedResultDto {
    items!: CashMovementReasonDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICashMovementReasonDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CashMovementReasonDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CashMovementReasonDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashMovementReasonDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CashMovementReasonDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CashMovementReasonDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICashMovementReasonDtoPagedResultDto {
    items: CashMovementReasonDto[] | undefined;
    totalCount: number;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme!: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChronologyDto implements IChronologyDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    medication!: MedicationItemDto;
    chronologyEvent!: DictionaryDto;
    description!: string | undefined;
    operationalUnit!: SimpleOperationalUnitDto;

    constructor(data?: IChronologyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.medication = _data["medication"] ? MedicationItemDto.fromJS(_data["medication"]) : <any>undefined;
            this.chronologyEvent = _data["chronologyEvent"] ? DictionaryDto.fromJS(_data["chronologyEvent"]) : <any>undefined;
            this.description = _data["description"];
            this.operationalUnit = _data["operationalUnit"] ? SimpleOperationalUnitDto.fromJS(_data["operationalUnit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChronologyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChronologyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        data["chronologyEvent"] = this.chronologyEvent ? this.chronologyEvent.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["operationalUnit"] = this.operationalUnit ? this.operationalUnit.toJSON() : <any>undefined;
        return data;
    }

    clone(): ChronologyDto {
        const json = this.toJSON();
        let result = new ChronologyDto();
        result.init(json);
        return result;
    }
}

export interface IChronologyDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    medication: MedicationItemDto;
    chronologyEvent: DictionaryDto;
    description: string | undefined;
    operationalUnit: SimpleOperationalUnitDto;
}

export class ChronologyDtoPagedResultDto implements IChronologyDtoPagedResultDto {
    items!: ChronologyDto[] | undefined;
    totalCount!: number;

    constructor(data?: IChronologyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChronologyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ChronologyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChronologyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ChronologyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ChronologyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IChronologyDtoPagedResultDto {
    items: ChronologyDto[] | undefined;
    totalCount: number;
}

export class CleaningEventDto implements ICleaningEventDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    operationalUnit!: SimpleOperationalUnitDto;
    calendarShift!: CalendarShiftDto;
    environmentType!: EnvironmentTypeDto;
    startDate!: Date;
    note!: string | undefined;
    isPostponed!: boolean;
    postponementReason!: string | undefined;
    cleaningEventRecurrence!: CleaningEventRecurrenceDto;
    cleaningStatus!: CleaningStatusDto;

    constructor(data?: ICleaningEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.operationalUnit = _data["operationalUnit"] ? SimpleOperationalUnitDto.fromJS(_data["operationalUnit"]) : <any>undefined;
            this.calendarShift = _data["calendarShift"] ? CalendarShiftDto.fromJS(_data["calendarShift"]) : <any>undefined;
            this.environmentType = _data["environmentType"] ? EnvironmentTypeDto.fromJS(_data["environmentType"]) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.isPostponed = _data["isPostponed"];
            this.postponementReason = _data["postponementReason"];
            this.cleaningEventRecurrence = _data["cleaningEventRecurrence"] ? CleaningEventRecurrenceDto.fromJS(_data["cleaningEventRecurrence"]) : <any>undefined;
            this.cleaningStatus = _data["cleaningStatus"] ? CleaningStatusDto.fromJS(_data["cleaningStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CleaningEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CleaningEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["operationalUnit"] = this.operationalUnit ? this.operationalUnit.toJSON() : <any>undefined;
        data["calendarShift"] = this.calendarShift ? this.calendarShift.toJSON() : <any>undefined;
        data["environmentType"] = this.environmentType ? this.environmentType.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["isPostponed"] = this.isPostponed;
        data["postponementReason"] = this.postponementReason;
        data["cleaningEventRecurrence"] = this.cleaningEventRecurrence ? this.cleaningEventRecurrence.toJSON() : <any>undefined;
        data["cleaningStatus"] = this.cleaningStatus ? this.cleaningStatus.toJSON() : <any>undefined;
        return data;
    }

    clone(): CleaningEventDto {
        const json = this.toJSON();
        let result = new CleaningEventDto();
        result.init(json);
        return result;
    }
}

export interface ICleaningEventDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    operationalUnit: SimpleOperationalUnitDto;
    calendarShift: CalendarShiftDto;
    environmentType: EnvironmentTypeDto;
    startDate: Date;
    note: string | undefined;
    isPostponed: boolean;
    postponementReason: string | undefined;
    cleaningEventRecurrence: CleaningEventRecurrenceDto;
    cleaningStatus: CleaningStatusDto;
}

export class CleaningEventDtoPagedResultDto implements ICleaningEventDtoPagedResultDto {
    items!: CleaningEventDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICleaningEventDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CleaningEventDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CleaningEventDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CleaningEventDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CleaningEventDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CleaningEventDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICleaningEventDtoPagedResultDto {
    items: CleaningEventDto[] | undefined;
    totalCount: number;
}

export class CleaningEventRecurrenceDto implements ICleaningEventRecurrenceDto {
    id!: number;
    recurrenceType!: DictionaryDto;
    interval!: number;
    weekDays!: DictionaryDto[] | undefined;
    recurrenceEndType!: DictionaryDto;
    endDate!: Date | undefined;
    occurrenceCount!: number | undefined;
    monthlyRecurrenceType!: DictionaryDto;
    weekPosition!: DictionaryDto;

    constructor(data?: ICleaningEventRecurrenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recurrenceType = _data["recurrenceType"] ? DictionaryDto.fromJS(_data["recurrenceType"]) : <any>undefined;
            this.interval = _data["interval"];
            if (Array.isArray(_data["weekDays"])) {
                this.weekDays = [] as any;
                for (let item of _data["weekDays"])
                    this.weekDays!.push(DictionaryDto.fromJS(item));
            }
            this.recurrenceEndType = _data["recurrenceEndType"] ? DictionaryDto.fromJS(_data["recurrenceEndType"]) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.occurrenceCount = _data["occurrenceCount"];
            this.monthlyRecurrenceType = _data["monthlyRecurrenceType"] ? DictionaryDto.fromJS(_data["monthlyRecurrenceType"]) : <any>undefined;
            this.weekPosition = _data["weekPosition"] ? DictionaryDto.fromJS(_data["weekPosition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CleaningEventRecurrenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CleaningEventRecurrenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recurrenceType"] = this.recurrenceType ? this.recurrenceType.toJSON() : <any>undefined;
        data["interval"] = this.interval;
        if (Array.isArray(this.weekDays)) {
            data["weekDays"] = [];
            for (let item of this.weekDays)
                data["weekDays"].push(item.toJSON());
        }
        data["recurrenceEndType"] = this.recurrenceEndType ? this.recurrenceEndType.toJSON() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["occurrenceCount"] = this.occurrenceCount;
        data["monthlyRecurrenceType"] = this.monthlyRecurrenceType ? this.monthlyRecurrenceType.toJSON() : <any>undefined;
        data["weekPosition"] = this.weekPosition ? this.weekPosition.toJSON() : <any>undefined;
        return data;
    }

    clone(): CleaningEventRecurrenceDto {
        const json = this.toJSON();
        let result = new CleaningEventRecurrenceDto();
        result.init(json);
        return result;
    }
}

export interface ICleaningEventRecurrenceDto {
    id: number;
    recurrenceType: DictionaryDto;
    interval: number;
    weekDays: DictionaryDto[] | undefined;
    recurrenceEndType: DictionaryDto;
    endDate: Date | undefined;
    occurrenceCount: number | undefined;
    monthlyRecurrenceType: DictionaryDto;
    weekPosition: DictionaryDto;
}

export class CleaningStatusDto implements ICleaningStatusDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    cleaningStatusType!: DictionaryDto;
    dateTime!: Date;
    note!: string | undefined;

    constructor(data?: ICleaningStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.cleaningStatusType = _data["cleaningStatusType"] ? DictionaryDto.fromJS(_data["cleaningStatusType"]) : <any>undefined;
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CleaningStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CleaningStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["cleaningStatusType"] = this.cleaningStatusType ? this.cleaningStatusType.toJSON() : <any>undefined;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["note"] = this.note;
        return data;
    }

    clone(): CleaningStatusDto {
        const json = this.toJSON();
        let result = new CleaningStatusDto();
        result.init(json);
        return result;
    }
}

export interface ICleaningStatusDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    cleaningStatusType: DictionaryDto;
    dateTime: Date;
    note: string | undefined;
}

export class CleaningStatusDtoPagedResultDto implements ICleaningStatusDtoPagedResultDto {
    items!: CleaningStatusDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICleaningStatusDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CleaningStatusDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CleaningStatusDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CleaningStatusDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CleaningStatusDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CleaningStatusDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICleaningStatusDtoPagedResultDto {
    items: CleaningStatusDto[] | undefined;
    totalCount: number;
}

export class ClinicalSummaryDto implements IClinicalSummaryDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    clinicalSummaryType!: DictionaryDto;
    note!: string | undefined;

    constructor(data?: IClinicalSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.clinicalSummaryType = _data["clinicalSummaryType"] ? DictionaryDto.fromJS(_data["clinicalSummaryType"]) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ClinicalSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicalSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["clinicalSummaryType"] = this.clinicalSummaryType ? this.clinicalSummaryType.toJSON() : <any>undefined;
        data["note"] = this.note;
        return data;
    }

    clone(): ClinicalSummaryDto {
        const json = this.toJSON();
        let result = new ClinicalSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IClinicalSummaryDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    clinicalSummaryType: DictionaryDto;
    note: string | undefined;
}

export class ClinicalSummaryDtoPagedResultDto implements IClinicalSummaryDtoPagedResultDto {
    items!: ClinicalSummaryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IClinicalSummaryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClinicalSummaryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ClinicalSummaryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicalSummaryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ClinicalSummaryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ClinicalSummaryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IClinicalSummaryDtoPagedResultDto {
    items: ClinicalSummaryDto[] | undefined;
    totalCount: number;
}

export class ConstructorInfo implements IConstructorInfo {
    readonly name!: string | undefined;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    attributes!: MethodAttributes;
    methodImplementationFlags!: MethodImplAttributes;
    callingConvention!: CallingConventions;
    readonly isAbstract!: boolean;
    readonly isConstructor!: boolean;
    readonly isFinal!: boolean;
    readonly isHideBySig!: boolean;
    readonly isSpecialName!: boolean;
    readonly isStatic!: boolean;
    readonly isVirtual!: boolean;
    readonly isAssembly!: boolean;
    readonly isFamily!: boolean;
    readonly isFamilyAndAssembly!: boolean;
    readonly isFamilyOrAssembly!: boolean;
    readonly isPrivate!: boolean;
    readonly isPublic!: boolean;
    readonly isConstructedGenericMethod!: boolean;
    readonly isGenericMethod!: boolean;
    readonly isGenericMethodDefinition!: boolean;
    readonly containsGenericParameters!: boolean;
    methodHandle!: RuntimeMethodHandle;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    memberType!: MemberTypes;

    constructor(data?: IConstructorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.memberType = _data["memberType"];
        }
    }

    static fromJS(data: any): ConstructorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["memberType"] = this.memberType;
        return data;
    }

    clone(): ConstructorInfo {
        const json = this.toJSON();
        let result = new ConstructorInfo();
        result.init(json);
        return result;
    }
}

export interface IConstructorInfo {
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    memberType: MemberTypes;
}

export class CreateAddressDto implements ICreateAddressDto {
    name!: string | undefined;
    description!: string | undefined;
    postalCode!: string | undefined;
    municipalityId!: number;

    constructor(data?: ICreateAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.postalCode = _data["postalCode"];
            this.municipalityId = _data["municipalityId"];
        }
    }

    static fromJS(data: any): CreateAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["postalCode"] = this.postalCode;
        data["municipalityId"] = this.municipalityId;
        return data;
    }

    clone(): CreateAddressDto {
        const json = this.toJSON();
        let result = new CreateAddressDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAddressDto {
    name: string | undefined;
    description: string | undefined;
    postalCode: string | undefined;
    municipalityId: number;
}

export class CreateAllergyDto implements ICreateAllergyDto {
    medicalHistoryId!: number;
    diagnosisDate!: Date;
    allergen!: string;
    note!: string | undefined;
    isOther!: boolean;
    prescribedTherapyMedication!: string | undefined;
    isLifeSaving!: boolean;
    medicationId!: number | undefined;

    constructor(data?: ICreateAllergyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalHistoryId = _data["medicalHistoryId"];
            this.diagnosisDate = _data["diagnosisDate"] ? new Date(_data["diagnosisDate"].toString()) : <any>undefined;
            this.allergen = _data["allergen"];
            this.note = _data["note"];
            this.isOther = _data["isOther"];
            this.prescribedTherapyMedication = _data["prescribedTherapyMedication"];
            this.isLifeSaving = _data["isLifeSaving"];
            this.medicationId = _data["medicationId"];
        }
    }

    static fromJS(data: any): CreateAllergyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAllergyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalHistoryId"] = this.medicalHistoryId;
        data["diagnosisDate"] = this.diagnosisDate ? this.diagnosisDate.toISOString() : <any>undefined;
        data["allergen"] = this.allergen;
        data["note"] = this.note;
        data["isOther"] = this.isOther;
        data["prescribedTherapyMedication"] = this.prescribedTherapyMedication;
        data["isLifeSaving"] = this.isLifeSaving;
        data["medicationId"] = this.medicationId;
        return data;
    }

    clone(): CreateAllergyDto {
        const json = this.toJSON();
        let result = new CreateAllergyDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAllergyDto {
    medicalHistoryId: number;
    diagnosisDate: Date;
    allergen: string;
    note: string | undefined;
    isOther: boolean;
    prescribedTherapyMedication: string | undefined;
    isLifeSaving: boolean;
    medicationId: number | undefined;
}

export class CreateAslContactDto implements ICreateAslContactDto {

    constructor(data?: ICreateAslContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreateAslContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAslContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CreateAslContactDto {
        const json = this.toJSON();
        let result = new CreateAslContactDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAslContactDto {
}

export class CreateCalendarEventDto implements ICreateCalendarEventDto {
    operationalUnitId!: number;
    taskId!: number;
    startDate!: Date;
    note!: string | undefined;
    userIds!: number[] | undefined;
    patientIds!: number[] | undefined;
    recurrence!: CreateCalendarEventRecurrenceDto;

    constructor(data?: ICreateCalendarEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationalUnitId = _data["operationalUnitId"];
            this.taskId = _data["taskId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.note = _data["note"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            if (Array.isArray(_data["patientIds"])) {
                this.patientIds = [] as any;
                for (let item of _data["patientIds"])
                    this.patientIds!.push(item);
            }
            this.recurrence = _data["recurrence"] ? CreateCalendarEventRecurrenceDto.fromJS(_data["recurrence"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCalendarEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCalendarEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationalUnitId"] = this.operationalUnitId;
        data["taskId"] = this.taskId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        if (Array.isArray(this.patientIds)) {
            data["patientIds"] = [];
            for (let item of this.patientIds)
                data["patientIds"].push(item);
        }
        data["recurrence"] = this.recurrence ? this.recurrence.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateCalendarEventDto {
        const json = this.toJSON();
        let result = new CreateCalendarEventDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCalendarEventDto {
    operationalUnitId: number;
    taskId: number;
    startDate: Date;
    note: string | undefined;
    userIds: number[] | undefined;
    patientIds: number[] | undefined;
    recurrence: CreateCalendarEventRecurrenceDto;
}

export class CreateCalendarEventRecurrenceDto implements ICreateCalendarEventRecurrenceDto {
    recurrenceTypeId!: number | undefined;
    interval!: number | undefined;
    weekDayIds!: number[] | undefined;
    recurrenceEndTypeId!: number | undefined;
    endDate!: Date | undefined;
    occurrenceCount!: number | undefined;
    monthlyRecurrenceTypeId!: number | undefined;
    weekPositionId!: number | undefined;

    constructor(data?: ICreateCalendarEventRecurrenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recurrenceTypeId = _data["recurrenceTypeId"];
            this.interval = _data["interval"];
            if (Array.isArray(_data["weekDayIds"])) {
                this.weekDayIds = [] as any;
                for (let item of _data["weekDayIds"])
                    this.weekDayIds!.push(item);
            }
            this.recurrenceEndTypeId = _data["recurrenceEndTypeId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.occurrenceCount = _data["occurrenceCount"];
            this.monthlyRecurrenceTypeId = _data["monthlyRecurrenceTypeId"];
            this.weekPositionId = _data["weekPositionId"];
        }
    }

    static fromJS(data: any): CreateCalendarEventRecurrenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCalendarEventRecurrenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recurrenceTypeId"] = this.recurrenceTypeId;
        data["interval"] = this.interval;
        if (Array.isArray(this.weekDayIds)) {
            data["weekDayIds"] = [];
            for (let item of this.weekDayIds)
                data["weekDayIds"].push(item);
        }
        data["recurrenceEndTypeId"] = this.recurrenceEndTypeId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["occurrenceCount"] = this.occurrenceCount;
        data["monthlyRecurrenceTypeId"] = this.monthlyRecurrenceTypeId;
        data["weekPositionId"] = this.weekPositionId;
        return data;
    }

    clone(): CreateCalendarEventRecurrenceDto {
        const json = this.toJSON();
        let result = new CreateCalendarEventRecurrenceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCalendarEventRecurrenceDto {
    recurrenceTypeId: number | undefined;
    interval: number | undefined;
    weekDayIds: number[] | undefined;
    recurrenceEndTypeId: number | undefined;
    endDate: Date | undefined;
    occurrenceCount: number | undefined;
    monthlyRecurrenceTypeId: number | undefined;
    weekPositionId: number | undefined;
}

export class CreateCalendarShiftDto implements ICreateCalendarShiftDto {
    description!: string | undefined;
    displayOrder!: number | undefined;

    constructor(data?: ICreateCalendarShiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): CreateCalendarShiftDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCalendarShiftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): CreateCalendarShiftDto {
        const json = this.toJSON();
        let result = new CreateCalendarShiftDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCalendarShiftDto {
    description: string | undefined;
    displayOrder: number | undefined;
}

export class CreateCalendarStatusDto implements ICreateCalendarStatusDto {
    calendarId!: number;
    statusId!: number;
    dateTime!: Date;
    userId!: number;

    constructor(data?: ICreateCalendarStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calendarId = _data["calendarId"];
            this.statusId = _data["statusId"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CreateCalendarStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCalendarStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarId"] = this.calendarId;
        data["statusId"] = this.statusId;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        return data;
    }

    clone(): CreateCalendarStatusDto {
        const json = this.toJSON();
        let result = new CreateCalendarStatusDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCalendarStatusDto {
    calendarId: number;
    statusId: number;
    dateTime: Date;
    userId: number;
}

export class CreateCalendarTaskDto implements ICreateCalendarTaskDto {
    description!: string | undefined;
    displayOrder!: number | undefined;

    constructor(data?: ICreateCalendarTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): CreateCalendarTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCalendarTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): CreateCalendarTaskDto {
        const json = this.toJSON();
        let result = new CreateCalendarTaskDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCalendarTaskDto {
    description: string | undefined;
    displayOrder: number | undefined;
}

export class CreateCashBoxUserDto implements ICreateCashBoxUserDto {
    cashBoxId!: number;
    userId!: number;

    constructor(data?: ICreateCashBoxUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cashBoxId = _data["cashBoxId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CreateCashBoxUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCashBoxUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cashBoxId"] = this.cashBoxId;
        data["userId"] = this.userId;
        return data;
    }

    clone(): CreateCashBoxUserDto {
        const json = this.toJSON();
        let result = new CreateCashBoxUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCashBoxUserDto {
    cashBoxId: number;
    userId: number;
}

export class CreateCashMovementDto implements ICreateCashMovementDto {
    cashBoxId!: number;
    cashMovementReasonId!: number;
    patientId!: number | undefined;
    cashMovementTypeId!: number;
    date!: Date;
    amount!: number;
    note!: string | undefined;

    constructor(data?: ICreateCashMovementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cashBoxId = _data["cashBoxId"];
            this.cashMovementReasonId = _data["cashMovementReasonId"];
            this.patientId = _data["patientId"];
            this.cashMovementTypeId = _data["cashMovementTypeId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateCashMovementDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCashMovementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cashBoxId"] = this.cashBoxId;
        data["cashMovementReasonId"] = this.cashMovementReasonId;
        data["patientId"] = this.patientId;
        data["cashMovementTypeId"] = this.cashMovementTypeId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["note"] = this.note;
        return data;
    }

    clone(): CreateCashMovementDto {
        const json = this.toJSON();
        let result = new CreateCashMovementDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCashMovementDto {
    cashBoxId: number;
    cashMovementReasonId: number;
    patientId: number | undefined;
    cashMovementTypeId: number;
    date: Date;
    amount: number;
    note: string | undefined;
}

export class CreateCashMovementReasonDto implements ICreateCashMovementReasonDto {
    description!: string | undefined;
    displayOrder!: number | undefined;
    reason!: string | undefined;
    cashMovementTypeId!: number;

    constructor(data?: ICreateCashMovementReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.reason = _data["reason"];
            this.cashMovementTypeId = _data["cashMovementTypeId"];
        }
    }

    static fromJS(data: any): CreateCashMovementReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCashMovementReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["reason"] = this.reason;
        data["cashMovementTypeId"] = this.cashMovementTypeId;
        return data;
    }

    clone(): CreateCashMovementReasonDto {
        const json = this.toJSON();
        let result = new CreateCashMovementReasonDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCashMovementReasonDto {
    description: string | undefined;
    displayOrder: number | undefined;
    reason: string | undefined;
    cashMovementTypeId: number;
}

export class CreateCleaningEventDto implements ICreateCleaningEventDto {
    shiftId!: number;
    environmentTypeId!: number;
    operationalUnitId!: number;
    startDate!: Date;
    note!: string | undefined;
    isPostponed!: boolean;
    postponementReason!: string | undefined;
    recurrence!: CreateCleaningEventRecurrenceDto;

    constructor(data?: ICreateCleaningEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftId = _data["shiftId"];
            this.environmentTypeId = _data["environmentTypeId"];
            this.operationalUnitId = _data["operationalUnitId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.isPostponed = _data["isPostponed"];
            this.postponementReason = _data["postponementReason"];
            this.recurrence = _data["recurrence"] ? CreateCleaningEventRecurrenceDto.fromJS(_data["recurrence"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCleaningEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCleaningEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftId"] = this.shiftId;
        data["environmentTypeId"] = this.environmentTypeId;
        data["operationalUnitId"] = this.operationalUnitId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["isPostponed"] = this.isPostponed;
        data["postponementReason"] = this.postponementReason;
        data["recurrence"] = this.recurrence ? this.recurrence.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateCleaningEventDto {
        const json = this.toJSON();
        let result = new CreateCleaningEventDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCleaningEventDto {
    shiftId: number;
    environmentTypeId: number;
    operationalUnitId: number;
    startDate: Date;
    note: string | undefined;
    isPostponed: boolean;
    postponementReason: string | undefined;
    recurrence: CreateCleaningEventRecurrenceDto;
}

export class CreateCleaningEventRecurrenceDto implements ICreateCleaningEventRecurrenceDto {
    recurrenceTypeId!: number | undefined;
    interval!: number | undefined;
    weekDayIds!: number[] | undefined;
    recurrenceEndTypeId!: number | undefined;
    endDate!: Date | undefined;
    occurrenceCount!: number | undefined;
    monthlyRecurrenceTypeId!: number | undefined;
    weekPositionId!: number | undefined;

    constructor(data?: ICreateCleaningEventRecurrenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recurrenceTypeId = _data["recurrenceTypeId"];
            this.interval = _data["interval"];
            if (Array.isArray(_data["weekDayIds"])) {
                this.weekDayIds = [] as any;
                for (let item of _data["weekDayIds"])
                    this.weekDayIds!.push(item);
            }
            this.recurrenceEndTypeId = _data["recurrenceEndTypeId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.occurrenceCount = _data["occurrenceCount"];
            this.monthlyRecurrenceTypeId = _data["monthlyRecurrenceTypeId"];
            this.weekPositionId = _data["weekPositionId"];
        }
    }

    static fromJS(data: any): CreateCleaningEventRecurrenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCleaningEventRecurrenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recurrenceTypeId"] = this.recurrenceTypeId;
        data["interval"] = this.interval;
        if (Array.isArray(this.weekDayIds)) {
            data["weekDayIds"] = [];
            for (let item of this.weekDayIds)
                data["weekDayIds"].push(item);
        }
        data["recurrenceEndTypeId"] = this.recurrenceEndTypeId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["occurrenceCount"] = this.occurrenceCount;
        data["monthlyRecurrenceTypeId"] = this.monthlyRecurrenceTypeId;
        data["weekPositionId"] = this.weekPositionId;
        return data;
    }

    clone(): CreateCleaningEventRecurrenceDto {
        const json = this.toJSON();
        let result = new CreateCleaningEventRecurrenceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCleaningEventRecurrenceDto {
    recurrenceTypeId: number | undefined;
    interval: number | undefined;
    weekDayIds: number[] | undefined;
    recurrenceEndTypeId: number | undefined;
    endDate: Date | undefined;
    occurrenceCount: number | undefined;
    monthlyRecurrenceTypeId: number | undefined;
    weekPositionId: number | undefined;
}

export class CreateCleaningStatusDto implements ICreateCleaningStatusDto {
    cleaningEventId!: number;
    cleaningStatusTypeId!: number;
    dateTime!: Date;
    note!: string | undefined;
    targetDate!: Date | undefined;
    targetCalendarShiftId!: number | undefined;
    reason!: string | undefined;

    constructor(data?: ICreateCleaningStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cleaningEventId = _data["cleaningEventId"];
            this.cleaningStatusTypeId = _data["cleaningStatusTypeId"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.targetDate = _data["targetDate"] ? new Date(_data["targetDate"].toString()) : <any>undefined;
            this.targetCalendarShiftId = _data["targetCalendarShiftId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): CreateCleaningStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCleaningStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cleaningEventId"] = this.cleaningEventId;
        data["cleaningStatusTypeId"] = this.cleaningStatusTypeId;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["targetDate"] = this.targetDate ? this.targetDate.toISOString() : <any>undefined;
        data["targetCalendarShiftId"] = this.targetCalendarShiftId;
        data["reason"] = this.reason;
        return data;
    }

    clone(): CreateCleaningStatusDto {
        const json = this.toJSON();
        let result = new CreateCleaningStatusDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCleaningStatusDto {
    cleaningEventId: number;
    cleaningStatusTypeId: number;
    dateTime: Date;
    note: string | undefined;
    targetDate: Date | undefined;
    targetCalendarShiftId: number | undefined;
    reason: string | undefined;
}

export class CreateClinicalSummaryDto implements ICreateClinicalSummaryDto {

    constructor(data?: ICreateClinicalSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreateClinicalSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClinicalSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CreateClinicalSummaryDto {
        const json = this.toJSON();
        let result = new CreateClinicalSummaryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateClinicalSummaryDto {
}

export class CreateDependencyDto implements ICreateDependencyDto {
    dependencyHistoryId!: number;
    dependencyType!: string | undefined;
    isActive!: boolean;
    firstContactDate!: Date | undefined;
    lastContactDate!: Date | undefined;
    note!: string | undefined;

    constructor(data?: ICreateDependencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dependencyHistoryId = _data["dependencyHistoryId"];
            this.dependencyType = _data["dependencyType"];
            this.isActive = _data["isActive"];
            this.firstContactDate = _data["firstContactDate"] ? new Date(_data["firstContactDate"].toString()) : <any>undefined;
            this.lastContactDate = _data["lastContactDate"] ? new Date(_data["lastContactDate"].toString()) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateDependencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDependencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dependencyHistoryId"] = this.dependencyHistoryId;
        data["dependencyType"] = this.dependencyType;
        data["isActive"] = this.isActive;
        data["firstContactDate"] = this.firstContactDate ? this.firstContactDate.toISOString() : <any>undefined;
        data["lastContactDate"] = this.lastContactDate ? this.lastContactDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        return data;
    }

    clone(): CreateDependencyDto {
        const json = this.toJSON();
        let result = new CreateDependencyDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDependencyDto {
    dependencyHistoryId: number;
    dependencyType: string | undefined;
    isActive: boolean;
    firstContactDate: Date | undefined;
    lastContactDate: Date | undefined;
    note: string | undefined;
}

export class CreateDiaryDto implements ICreateDiaryDto {
    patientId!: number;
    operationalUnitId!: number;
    diaryTypeId!: number;
    date!: Date;
    observations!: string;
    interventions!: string | undefined;

    constructor(data?: ICreateDiaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.operationalUnitId = _data["operationalUnitId"];
            this.diaryTypeId = _data["diaryTypeId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.observations = _data["observations"];
            this.interventions = _data["interventions"];
        }
    }

    static fromJS(data: any): CreateDiaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDiaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["operationalUnitId"] = this.operationalUnitId;
        data["diaryTypeId"] = this.diaryTypeId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["observations"] = this.observations;
        data["interventions"] = this.interventions;
        return data;
    }

    clone(): CreateDiaryDto {
        const json = this.toJSON();
        let result = new CreateDiaryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDiaryDto {
    patientId: number;
    operationalUnitId: number;
    diaryTypeId: number;
    date: Date;
    observations: string;
    interventions: string | undefined;
}

export class CreateDocumentDto implements ICreateDocumentDto {
    patientId!: number;
    operationalUnitId!: number;
    date!: Date;
    documentDate!: Date;
    expirationDate!: Date | undefined;
    sender!: string;
    recipient!: string;
    description!: string | undefined;
    documentTypeId!: number;
    fileId!: number;
    isIncoming!: boolean;
    protocolTypeId!: number | undefined;
    isTherapeuticPrescription!: boolean;
    medicationIds!: number[] | undefined;

    constructor(data?: ICreateDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.operationalUnitId = _data["operationalUnitId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.sender = _data["sender"];
            this.recipient = _data["recipient"];
            this.description = _data["description"];
            this.documentTypeId = _data["documentTypeId"];
            this.fileId = _data["fileId"];
            this.isIncoming = _data["isIncoming"];
            this.protocolTypeId = _data["protocolTypeId"];
            this.isTherapeuticPrescription = _data["isTherapeuticPrescription"];
            if (Array.isArray(_data["medicationIds"])) {
                this.medicationIds = [] as any;
                for (let item of _data["medicationIds"])
                    this.medicationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["operationalUnitId"] = this.operationalUnitId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["sender"] = this.sender;
        data["recipient"] = this.recipient;
        data["description"] = this.description;
        data["documentTypeId"] = this.documentTypeId;
        data["fileId"] = this.fileId;
        data["isIncoming"] = this.isIncoming;
        data["protocolTypeId"] = this.protocolTypeId;
        data["isTherapeuticPrescription"] = this.isTherapeuticPrescription;
        if (Array.isArray(this.medicationIds)) {
            data["medicationIds"] = [];
            for (let item of this.medicationIds)
                data["medicationIds"].push(item);
        }
        return data;
    }

    clone(): CreateDocumentDto {
        const json = this.toJSON();
        let result = new CreateDocumentDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDocumentDto {
    patientId: number;
    operationalUnitId: number;
    date: Date;
    documentDate: Date;
    expirationDate: Date | undefined;
    sender: string;
    recipient: string;
    description: string | undefined;
    documentTypeId: number;
    fileId: number;
    isIncoming: boolean;
    protocolTypeId: number | undefined;
    isTherapeuticPrescription: boolean;
    medicationIds: number[] | undefined;
}

export class CreateDocumentTypeDto implements ICreateDocumentTypeDto {
    description!: string | undefined;
    displayOrder!: number | undefined;

    constructor(data?: ICreateDocumentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): CreateDocumentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): CreateDocumentTypeDto {
        const json = this.toJSON();
        let result = new CreateDocumentTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDocumentTypeDto {
    description: string | undefined;
    displayOrder: number | undefined;
}

export class CreateEnvironmentTypeDto implements ICreateEnvironmentTypeDto {
    description!: string | undefined;
    displayOrder!: number | undefined;

    constructor(data?: ICreateEnvironmentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): CreateEnvironmentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEnvironmentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): CreateEnvironmentTypeDto {
        const json = this.toJSON();
        let result = new CreateEnvironmentTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEnvironmentTypeDto {
    description: string | undefined;
    displayOrder: number | undefined;
}

export class CreateFamilyHistoryDto implements ICreateFamilyHistoryDto {

    constructor(data?: ICreateFamilyHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreateFamilyHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFamilyHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CreateFamilyHistoryDto {
        const json = this.toJSON();
        let result = new CreateFamilyHistoryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateFamilyHistoryDto {
}

export class CreateFamilyMemberDto implements ICreateFamilyMemberDto {
    familyHistoryId!: number;
    familyMemberTypeId!: number;
    name!: string | undefined;
    age!: number | undefined;
    isDeceased!: boolean;
    disease!: string | undefined;
    profession!: string | undefined;
    residence!: string | undefined;
    note!: string | undefined;

    constructor(data?: ICreateFamilyMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.familyHistoryId = _data["familyHistoryId"];
            this.familyMemberTypeId = _data["familyMemberTypeId"];
            this.name = _data["name"];
            this.age = _data["age"];
            this.isDeceased = _data["isDeceased"];
            this.disease = _data["disease"];
            this.profession = _data["profession"];
            this.residence = _data["residence"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateFamilyMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFamilyMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["familyHistoryId"] = this.familyHistoryId;
        data["familyMemberTypeId"] = this.familyMemberTypeId;
        data["name"] = this.name;
        data["age"] = this.age;
        data["isDeceased"] = this.isDeceased;
        data["disease"] = this.disease;
        data["profession"] = this.profession;
        data["residence"] = this.residence;
        data["note"] = this.note;
        return data;
    }

    clone(): CreateFamilyMemberDto {
        const json = this.toJSON();
        let result = new CreateFamilyMemberDto();
        result.init(json);
        return result;
    }
}

export interface ICreateFamilyMemberDto {
    familyHistoryId: number;
    familyMemberTypeId: number;
    name: string | undefined;
    age: number | undefined;
    isDeceased: boolean;
    disease: string | undefined;
    profession: string | undefined;
    residence: string | undefined;
    note: string | undefined;
}

export class CreateForensicProfileDto implements ICreateForensicProfileDto {

    constructor(data?: ICreateForensicProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreateForensicProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateForensicProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CreateForensicProfileDto {
        const json = this.toJSON();
        let result = new CreateForensicProfileDto();
        result.init(json);
        return result;
    }
}

export interface ICreateForensicProfileDto {
}

export class CreateHandoverNoteDto implements ICreateHandoverNoteDto {
    operationalUnitId!: number;
    handoverNoteTypeId!: number;
    shiftTypeId!: number;
    dateTime!: Date;
    note!: string | undefined;

    constructor(data?: ICreateHandoverNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationalUnitId = _data["operationalUnitId"];
            this.handoverNoteTypeId = _data["handoverNoteTypeId"];
            this.shiftTypeId = _data["shiftTypeId"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateHandoverNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHandoverNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationalUnitId"] = this.operationalUnitId;
        data["handoverNoteTypeId"] = this.handoverNoteTypeId;
        data["shiftTypeId"] = this.shiftTypeId;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["note"] = this.note;
        return data;
    }

    clone(): CreateHandoverNoteDto {
        const json = this.toJSON();
        let result = new CreateHandoverNoteDto();
        result.init(json);
        return result;
    }
}

export interface ICreateHandoverNoteDto {
    operationalUnitId: number;
    handoverNoteTypeId: number;
    shiftTypeId: number;
    dateTime: Date;
    note: string | undefined;
}

export class CreateHistoryNoteDto implements ICreateHistoryNoteDto {

    constructor(data?: ICreateHistoryNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreateHistoryNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHistoryNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CreateHistoryNoteDto {
        const json = this.toJSON();
        let result = new CreateHistoryNoteDto();
        result.init(json);
        return result;
    }
}

export interface ICreateHistoryNoteDto {
}

export class CreateIntoleranceDto implements ICreateIntoleranceDto {
    medicalHistoryId!: number;
    diagnosisDate!: Date;
    substance!: string;
    note!: string | undefined;
    isOther!: boolean;

    constructor(data?: ICreateIntoleranceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalHistoryId = _data["medicalHistoryId"];
            this.diagnosisDate = _data["diagnosisDate"] ? new Date(_data["diagnosisDate"].toString()) : <any>undefined;
            this.substance = _data["substance"];
            this.note = _data["note"];
            this.isOther = _data["isOther"];
        }
    }

    static fromJS(data: any): CreateIntoleranceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIntoleranceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalHistoryId"] = this.medicalHistoryId;
        data["diagnosisDate"] = this.diagnosisDate ? this.diagnosisDate.toISOString() : <any>undefined;
        data["substance"] = this.substance;
        data["note"] = this.note;
        data["isOther"] = this.isOther;
        return data;
    }

    clone(): CreateIntoleranceDto {
        const json = this.toJSON();
        let result = new CreateIntoleranceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateIntoleranceDto {
    medicalHistoryId: number;
    diagnosisDate: Date;
    substance: string;
    note: string | undefined;
    isOther: boolean;
}

export class CreateMedicalHistoryDto implements ICreateMedicalHistoryDto {

    constructor(data?: ICreateMedicalHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreateMedicalHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicalHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CreateMedicalHistoryDto {
        const json = this.toJSON();
        let result = new CreateMedicalHistoryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicalHistoryDto {
}

export class CreateMedicalHistoryFileDto implements ICreateMedicalHistoryFileDto {
    allergyId!: number | undefined;
    intoleranceId!: number | undefined;
    fileId!: number;

    constructor(data?: ICreateMedicalHistoryFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allergyId = _data["allergyId"];
            this.intoleranceId = _data["intoleranceId"];
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): CreateMedicalHistoryFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicalHistoryFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allergyId"] = this.allergyId;
        data["intoleranceId"] = this.intoleranceId;
        data["fileId"] = this.fileId;
        return data;
    }

    clone(): CreateMedicalHistoryFileDto {
        const json = this.toJSON();
        let result = new CreateMedicalHistoryFileDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicalHistoryFileDto {
    allergyId: number | undefined;
    intoleranceId: number | undefined;
    fileId: number;
}

export class CreateMedicationBarcodeDto implements ICreateMedicationBarcodeDto {
    medicationId!: number;
    code!: string | undefined;

    constructor(data?: ICreateMedicationBarcodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicationId = _data["medicationId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CreateMedicationBarcodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicationBarcodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicationId"] = this.medicationId;
        data["code"] = this.code;
        return data;
    }

    clone(): CreateMedicationBarcodeDto {
        const json = this.toJSON();
        let result = new CreateMedicationBarcodeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicationBarcodeDto {
    medicationId: number;
    code: string | undefined;
}

export class CreateMedicationDto implements ICreateMedicationDto {
    isActive!: boolean;
    requiresDoubleCheck!: boolean;
    name!: string | undefined;
    officialName!: string | undefined;
    manufacturer!: string | undefined;
    productCode!: string | undefined;
    eanCode!: string | undefined;
    atcCode!: string | undefined;
    cufNoteNumber!: string | undefined;
    identificationCode!: string | undefined;
    medicationPharmaceuticalFormTypeId!: number;
    medicationPackagingTypeId!: number;
    medicationStrengthUnitTypeId!: number | undefined;
    packageQuantity!: number;
    strengthValue!: number | undefined;
    drugClass!: string | undefined;
    productType!: string | undefined;
    prescriptionCategory!: string | undefined;
    prescribability!: string | undefined;
    pharmacotherapeuticCategory!: string | undefined;
    pharmaceuticalForm!: string | undefined;
    pharmaceuticalFormDetail!: string | undefined;
    storageTemperature!: string | undefined;
    activeIngredientDescription!: string | undefined;
    activeIngredients!: string | undefined;
    excipients!: string | undefined;
    indications!: string | undefined;
    contraindicationsAndSideEffects!: string | undefined;
    posology!: string | undefined;
    precautions!: string | undefined;
    warnings!: string | undefined;
    interactions!: string | undefined;
    undesirableEffects!: string | undefined;
    pregnancyAndLactation!: string | undefined;

    constructor(data?: ICreateMedicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.requiresDoubleCheck = _data["requiresDoubleCheck"];
            this.name = _data["name"];
            this.officialName = _data["officialName"];
            this.manufacturer = _data["manufacturer"];
            this.productCode = _data["productCode"];
            this.eanCode = _data["eanCode"];
            this.atcCode = _data["atcCode"];
            this.cufNoteNumber = _data["cufNoteNumber"];
            this.identificationCode = _data["identificationCode"];
            this.medicationPharmaceuticalFormTypeId = _data["medicationPharmaceuticalFormTypeId"];
            this.medicationPackagingTypeId = _data["medicationPackagingTypeId"];
            this.medicationStrengthUnitTypeId = _data["medicationStrengthUnitTypeId"];
            this.packageQuantity = _data["packageQuantity"];
            this.strengthValue = _data["strengthValue"];
            this.drugClass = _data["drugClass"];
            this.productType = _data["productType"];
            this.prescriptionCategory = _data["prescriptionCategory"];
            this.prescribability = _data["prescribability"];
            this.pharmacotherapeuticCategory = _data["pharmacotherapeuticCategory"];
            this.pharmaceuticalForm = _data["pharmaceuticalForm"];
            this.pharmaceuticalFormDetail = _data["pharmaceuticalFormDetail"];
            this.storageTemperature = _data["storageTemperature"];
            this.activeIngredientDescription = _data["activeIngredientDescription"];
            this.activeIngredients = _data["activeIngredients"];
            this.excipients = _data["excipients"];
            this.indications = _data["indications"];
            this.contraindicationsAndSideEffects = _data["contraindicationsAndSideEffects"];
            this.posology = _data["posology"];
            this.precautions = _data["precautions"];
            this.warnings = _data["warnings"];
            this.interactions = _data["interactions"];
            this.undesirableEffects = _data["undesirableEffects"];
            this.pregnancyAndLactation = _data["pregnancyAndLactation"];
        }
    }

    static fromJS(data: any): CreateMedicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["requiresDoubleCheck"] = this.requiresDoubleCheck;
        data["name"] = this.name;
        data["officialName"] = this.officialName;
        data["manufacturer"] = this.manufacturer;
        data["productCode"] = this.productCode;
        data["eanCode"] = this.eanCode;
        data["atcCode"] = this.atcCode;
        data["cufNoteNumber"] = this.cufNoteNumber;
        data["identificationCode"] = this.identificationCode;
        data["medicationPharmaceuticalFormTypeId"] = this.medicationPharmaceuticalFormTypeId;
        data["medicationPackagingTypeId"] = this.medicationPackagingTypeId;
        data["medicationStrengthUnitTypeId"] = this.medicationStrengthUnitTypeId;
        data["packageQuantity"] = this.packageQuantity;
        data["strengthValue"] = this.strengthValue;
        data["drugClass"] = this.drugClass;
        data["productType"] = this.productType;
        data["prescriptionCategory"] = this.prescriptionCategory;
        data["prescribability"] = this.prescribability;
        data["pharmacotherapeuticCategory"] = this.pharmacotherapeuticCategory;
        data["pharmaceuticalForm"] = this.pharmaceuticalForm;
        data["pharmaceuticalFormDetail"] = this.pharmaceuticalFormDetail;
        data["storageTemperature"] = this.storageTemperature;
        data["activeIngredientDescription"] = this.activeIngredientDescription;
        data["activeIngredients"] = this.activeIngredients;
        data["excipients"] = this.excipients;
        data["indications"] = this.indications;
        data["contraindicationsAndSideEffects"] = this.contraindicationsAndSideEffects;
        data["posology"] = this.posology;
        data["precautions"] = this.precautions;
        data["warnings"] = this.warnings;
        data["interactions"] = this.interactions;
        data["undesirableEffects"] = this.undesirableEffects;
        data["pregnancyAndLactation"] = this.pregnancyAndLactation;
        return data;
    }

    clone(): CreateMedicationDto {
        const json = this.toJSON();
        let result = new CreateMedicationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicationDto {
    isActive: boolean;
    requiresDoubleCheck: boolean;
    name: string | undefined;
    officialName: string | undefined;
    manufacturer: string | undefined;
    productCode: string | undefined;
    eanCode: string | undefined;
    atcCode: string | undefined;
    cufNoteNumber: string | undefined;
    identificationCode: string | undefined;
    medicationPharmaceuticalFormTypeId: number;
    medicationPackagingTypeId: number;
    medicationStrengthUnitTypeId: number | undefined;
    packageQuantity: number;
    strengthValue: number | undefined;
    drugClass: string | undefined;
    productType: string | undefined;
    prescriptionCategory: string | undefined;
    prescribability: string | undefined;
    pharmacotherapeuticCategory: string | undefined;
    pharmaceuticalForm: string | undefined;
    pharmaceuticalFormDetail: string | undefined;
    storageTemperature: string | undefined;
    activeIngredientDescription: string | undefined;
    activeIngredients: string | undefined;
    excipients: string | undefined;
    indications: string | undefined;
    contraindicationsAndSideEffects: string | undefined;
    posology: string | undefined;
    precautions: string | undefined;
    warnings: string | undefined;
    interactions: string | undefined;
    undesirableEffects: string | undefined;
    pregnancyAndLactation: string | undefined;
}

export class CreateMedicationEquivalenceListDto implements ICreateMedicationEquivalenceListDto {
    medicationId!: number;
    medicationEquivalenceIds!: number[] | undefined;

    constructor(data?: ICreateMedicationEquivalenceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicationId = _data["medicationId"];
            if (Array.isArray(_data["medicationEquivalenceIds"])) {
                this.medicationEquivalenceIds = [] as any;
                for (let item of _data["medicationEquivalenceIds"])
                    this.medicationEquivalenceIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateMedicationEquivalenceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicationEquivalenceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicationId"] = this.medicationId;
        if (Array.isArray(this.medicationEquivalenceIds)) {
            data["medicationEquivalenceIds"] = [];
            for (let item of this.medicationEquivalenceIds)
                data["medicationEquivalenceIds"].push(item);
        }
        return data;
    }

    clone(): CreateMedicationEquivalenceListDto {
        const json = this.toJSON();
        let result = new CreateMedicationEquivalenceListDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicationEquivalenceListDto {
    medicationId: number;
    medicationEquivalenceIds: number[] | undefined;
}

export class CreateMedicationOrderDetailDto implements ICreateMedicationOrderDetailDto {
    medicationOrderId!: number;
    medicationId!: number;
    quantity!: number;
    forecastDays!: number;
    note!: string | undefined;

    constructor(data?: ICreateMedicationOrderDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicationOrderId = _data["medicationOrderId"];
            this.medicationId = _data["medicationId"];
            this.quantity = _data["quantity"];
            this.forecastDays = _data["forecastDays"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateMedicationOrderDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicationOrderDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicationOrderId"] = this.medicationOrderId;
        data["medicationId"] = this.medicationId;
        data["quantity"] = this.quantity;
        data["forecastDays"] = this.forecastDays;
        data["note"] = this.note;
        return data;
    }

    clone(): CreateMedicationOrderDetailDto {
        const json = this.toJSON();
        let result = new CreateMedicationOrderDetailDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicationOrderDetailDto {
    medicationOrderId: number;
    medicationId: number;
    quantity: number;
    forecastDays: number;
    note: string | undefined;
}

export class CreateMedicationOrderDto implements ICreateMedicationOrderDto {
    operationalUnitId!: number;
    patientId!: number | undefined;
    orderDate!: Date;
    note!: string | undefined;

    constructor(data?: ICreateMedicationOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationalUnitId = _data["operationalUnitId"];
            this.patientId = _data["patientId"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateMedicationOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicationOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationalUnitId"] = this.operationalUnitId;
        data["patientId"] = this.patientId;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        return data;
    }

    clone(): CreateMedicationOrderDto {
        const json = this.toJSON();
        let result = new CreateMedicationOrderDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicationOrderDto {
    operationalUnitId: number;
    patientId: number | undefined;
    orderDate: Date;
    note: string | undefined;
}

export class CreateMedicationStockCodeDto implements ICreateMedicationStockCodeDto {
    medicationStockId!: number;
    code!: string | undefined;

    constructor(data?: ICreateMedicationStockCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicationStockId = _data["medicationStockId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CreateMedicationStockCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicationStockCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicationStockId"] = this.medicationStockId;
        data["code"] = this.code;
        return data;
    }

    clone(): CreateMedicationStockCodeDto {
        const json = this.toJSON();
        let result = new CreateMedicationStockCodeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicationStockCodeDto {
    medicationStockId: number;
    code: string | undefined;
}

export class CreateMedicationStockDto implements ICreateMedicationStockDto {
    operationalUnityId!: number;
    medicationId!: number;
    label!: string | undefined;
    boxCode!: string | undefined;
    totalQuantity!: number;
    expiryDate!: Date;
    note!: string | undefined;
    totalSubUnits!: number | undefined;
    batchNumber!: string | undefined;
    markingCode!: string | undefined;

    constructor(data?: ICreateMedicationStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationalUnityId = _data["operationalUnityId"];
            this.medicationId = _data["medicationId"];
            this.label = _data["label"];
            this.boxCode = _data["boxCode"];
            this.totalQuantity = _data["totalQuantity"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.totalSubUnits = _data["totalSubUnits"];
            this.batchNumber = _data["batchNumber"];
            this.markingCode = _data["markingCode"];
        }
    }

    static fromJS(data: any): CreateMedicationStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicationStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationalUnityId"] = this.operationalUnityId;
        data["medicationId"] = this.medicationId;
        data["label"] = this.label;
        data["boxCode"] = this.boxCode;
        data["totalQuantity"] = this.totalQuantity;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["totalSubUnits"] = this.totalSubUnits;
        data["batchNumber"] = this.batchNumber;
        data["markingCode"] = this.markingCode;
        return data;
    }

    clone(): CreateMedicationStockDto {
        const json = this.toJSON();
        let result = new CreateMedicationStockDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicationStockDto {
    operationalUnityId: number;
    medicationId: number;
    label: string | undefined;
    boxCode: string | undefined;
    totalQuantity: number;
    expiryDate: Date;
    note: string | undefined;
    totalSubUnits: number | undefined;
    batchNumber: string | undefined;
    markingCode: string | undefined;
}

export class CreateMedicationStockReasonDto implements ICreateMedicationStockReasonDto {
    description!: string | undefined;
    displayOrder!: number | undefined;
    applicableToUnitIncrease!: boolean;
    applicableToUnitDecrease!: boolean;
    applicableToPackageDischarge!: boolean;

    constructor(data?: ICreateMedicationStockReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.applicableToUnitIncrease = _data["applicableToUnitIncrease"];
            this.applicableToUnitDecrease = _data["applicableToUnitDecrease"];
            this.applicableToPackageDischarge = _data["applicableToPackageDischarge"];
        }
    }

    static fromJS(data: any): CreateMedicationStockReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicationStockReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["applicableToUnitIncrease"] = this.applicableToUnitIncrease;
        data["applicableToUnitDecrease"] = this.applicableToUnitDecrease;
        data["applicableToPackageDischarge"] = this.applicableToPackageDischarge;
        return data;
    }

    clone(): CreateMedicationStockReasonDto {
        const json = this.toJSON();
        let result = new CreateMedicationStockReasonDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMedicationStockReasonDto {
    description: string | undefined;
    displayOrder: number | undefined;
    applicableToUnitIncrease: boolean;
    applicableToUnitDecrease: boolean;
    applicableToPackageDischarge: boolean;
}

export class CreateMeetingMinuteDto implements ICreateMeetingMinuteDto {
    meetingTypeId!: number;
    operationalUnitId!: number;
    topic!: string | undefined;
    meetingDate!: Date | undefined;
    duration!: number;
    minuteNote!: string | undefined;
    patientIds!: number[] | undefined;
    userChairId!: number;
    userIds!: number[] | undefined;
    othersIds!: number[] | undefined;

    constructor(data?: ICreateMeetingMinuteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meetingTypeId = _data["meetingTypeId"];
            this.operationalUnitId = _data["operationalUnitId"];
            this.topic = _data["topic"];
            this.meetingDate = _data["meetingDate"] ? new Date(_data["meetingDate"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.minuteNote = _data["minuteNote"];
            if (Array.isArray(_data["patientIds"])) {
                this.patientIds = [] as any;
                for (let item of _data["patientIds"])
                    this.patientIds!.push(item);
            }
            this.userChairId = _data["userChairId"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            if (Array.isArray(_data["othersIds"])) {
                this.othersIds = [] as any;
                for (let item of _data["othersIds"])
                    this.othersIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateMeetingMinuteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMeetingMinuteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meetingTypeId"] = this.meetingTypeId;
        data["operationalUnitId"] = this.operationalUnitId;
        data["topic"] = this.topic;
        data["meetingDate"] = this.meetingDate ? this.meetingDate.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["minuteNote"] = this.minuteNote;
        if (Array.isArray(this.patientIds)) {
            data["patientIds"] = [];
            for (let item of this.patientIds)
                data["patientIds"].push(item);
        }
        data["userChairId"] = this.userChairId;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        if (Array.isArray(this.othersIds)) {
            data["othersIds"] = [];
            for (let item of this.othersIds)
                data["othersIds"].push(item);
        }
        return data;
    }

    clone(): CreateMeetingMinuteDto {
        const json = this.toJSON();
        let result = new CreateMeetingMinuteDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMeetingMinuteDto {
    meetingTypeId: number;
    operationalUnitId: number;
    topic: string | undefined;
    meetingDate: Date | undefined;
    duration: number;
    minuteNote: string | undefined;
    patientIds: number[] | undefined;
    userChairId: number;
    userIds: number[] | undefined;
    othersIds: number[] | undefined;
}

export class CreateMeetingTypeDto implements ICreateMeetingTypeDto {
    description!: string | undefined;
    displayOrder!: number | undefined;

    constructor(data?: ICreateMeetingTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): CreateMeetingTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMeetingTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): CreateMeetingTypeDto {
        const json = this.toJSON();
        let result = new CreateMeetingTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMeetingTypeDto {
    description: string | undefined;
    displayOrder: number | undefined;
}

export class CreateOnCallActivationDto implements ICreateOnCallActivationDto {
    plannedAssignmentId!: number;
    startDateTime!: Date;
    endDateTime!: Date;

    constructor(data?: ICreateOnCallActivationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedAssignmentId = _data["plannedAssignmentId"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOnCallActivationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOnCallActivationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedAssignmentId"] = this.plannedAssignmentId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): CreateOnCallActivationDto {
        const json = this.toJSON();
        let result = new CreateOnCallActivationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOnCallActivationDto {
    plannedAssignmentId: number;
    startDateTime: Date;
    endDateTime: Date;
}

export class CreateOperationalUnitDto implements ICreateOperationalUnitDto {
    name!: string | undefined;
    description!: string | undefined;
    code!: string;
    unitManagerId!: number;
    userIds!: number[] | undefined;

    constructor(data?: ICreateOperationalUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.code = _data["code"];
            this.unitManagerId = _data["unitManagerId"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOperationalUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOperationalUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["code"] = this.code;
        data["unitManagerId"] = this.unitManagerId;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        return data;
    }

    clone(): CreateOperationalUnitDto {
        const json = this.toJSON();
        let result = new CreateOperationalUnitDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOperationalUnitDto {
    name: string | undefined;
    description: string | undefined;
    code: string;
    unitManagerId: number;
    userIds: number[] | undefined;
}

export class CreateOperationalUnitExpirationAlertDto implements ICreateOperationalUnitExpirationAlertDto {
    operationalUnitId!: number;
    expirationWarningDays!: number;

    constructor(data?: ICreateOperationalUnitExpirationAlertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationalUnitId = _data["operationalUnitId"];
            this.expirationWarningDays = _data["expirationWarningDays"];
        }
    }

    static fromJS(data: any): CreateOperationalUnitExpirationAlertDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOperationalUnitExpirationAlertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationalUnitId"] = this.operationalUnitId;
        data["expirationWarningDays"] = this.expirationWarningDays;
        return data;
    }

    clone(): CreateOperationalUnitExpirationAlertDto {
        const json = this.toJSON();
        let result = new CreateOperationalUnitExpirationAlertDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOperationalUnitExpirationAlertDto {
    operationalUnitId: number;
    expirationWarningDays: number;
}

export class CreateOperationalUnitFileDto implements ICreateOperationalUnitFileDto {
    name!: string | undefined;
    fileId!: number;
    operationalUnitId!: number;

    constructor(data?: ICreateOperationalUnitFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.fileId = _data["fileId"];
            this.operationalUnitId = _data["operationalUnitId"];
        }
    }

    static fromJS(data: any): CreateOperationalUnitFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOperationalUnitFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["fileId"] = this.fileId;
        data["operationalUnitId"] = this.operationalUnitId;
        return data;
    }

    clone(): CreateOperationalUnitFileDto {
        const json = this.toJSON();
        let result = new CreateOperationalUnitFileDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOperationalUnitFileDto {
    name: string | undefined;
    fileId: number;
    operationalUnitId: number;
}

export class CreateOperationalUnitShiftSlotDto implements ICreateOperationalUnitShiftSlotDto {
    operationalUnitId!: number;
    shiftTypeId!: number;
    startTime!: Date;
    endTime!: Date;
    validFrom!: Date;
    validTo!: Date | undefined;
    requiredCount!: number | undefined;

    constructor(data?: ICreateOperationalUnitShiftSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationalUnitId = _data["operationalUnitId"];
            this.shiftTypeId = _data["shiftTypeId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.requiredCount = _data["requiredCount"];
        }
    }

    static fromJS(data: any): CreateOperationalUnitShiftSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOperationalUnitShiftSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationalUnitId"] = this.operationalUnitId;
        data["shiftTypeId"] = this.shiftTypeId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["validFrom"] = this.validFrom ? formatDate(this.validFrom) : <any>undefined;
        data["validTo"] = this.validTo ? formatDate(this.validTo) : <any>undefined;
        data["requiredCount"] = this.requiredCount;
        return data;
    }

    clone(): CreateOperationalUnitShiftSlotDto {
        const json = this.toJSON();
        let result = new CreateOperationalUnitShiftSlotDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOperationalUnitShiftSlotDto {
    operationalUnitId: number;
    shiftTypeId: number;
    startTime: Date;
    endTime: Date;
    validFrom: Date;
    validTo: Date | undefined;
    requiredCount: number | undefined;
}

export class CreatePatientAttendanceDto implements ICreatePatientAttendanceDto {

    constructor(data?: ICreatePatientAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreatePatientAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CreatePatientAttendanceDto {
        const json = this.toJSON();
        let result = new CreatePatientAttendanceDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePatientAttendanceDto {
}

export class CreatePatientDischargeDto implements ICreatePatientDischargeDto {
    patientId!: number;
    operationalUnitId!: number;
    exitDate!: Date;
    reason!: string | undefined;

    constructor(data?: ICreatePatientDischargeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.operationalUnitId = _data["operationalUnitId"];
            this.exitDate = _data["exitDate"] ? new Date(_data["exitDate"].toString()) : <any>undefined;
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): CreatePatientDischargeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientDischargeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["operationalUnitId"] = this.operationalUnitId;
        data["exitDate"] = this.exitDate ? this.exitDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        return data;
    }

    clone(): CreatePatientDischargeDto {
        const json = this.toJSON();
        let result = new CreatePatientDischargeDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePatientDischargeDto {
    patientId: number;
    operationalUnitId: number;
    exitDate: Date;
    reason: string | undefined;
}

export class CreatePatientDto implements ICreatePatientDto {
    name!: string;
    surname!: string;
    email!: string | undefined;
    phoneNumber!: string | undefined;
    fiscalCode!: string;
    healthCard!: string | undefined;
    isMale!: boolean;
    birthDate!: Date;
    birthPlace!: string;
    occupation!: string | undefined;
    note!: string | undefined;
    doctorId!: number | undefined;
    operationalUnitId!: number;
    nationalityId!: number | undefined;
    address!: CreateAddressDto;

    constructor(data?: ICreatePatientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.address = new CreateAddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.fiscalCode = _data["fiscalCode"];
            this.healthCard = _data["healthCard"];
            this.isMale = _data["isMale"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.birthPlace = _data["birthPlace"];
            this.occupation = _data["occupation"];
            this.note = _data["note"];
            this.doctorId = _data["doctorId"];
            this.operationalUnitId = _data["operationalUnitId"];
            this.nationalityId = _data["nationalityId"];
            this.address = _data["address"] ? CreateAddressDto.fromJS(_data["address"]) : new CreateAddressDto();
        }
    }

    static fromJS(data: any): CreatePatientDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["fiscalCode"] = this.fiscalCode;
        data["healthCard"] = this.healthCard;
        data["isMale"] = this.isMale;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["birthPlace"] = this.birthPlace;
        data["occupation"] = this.occupation;
        data["note"] = this.note;
        data["doctorId"] = this.doctorId;
        data["operationalUnitId"] = this.operationalUnitId;
        data["nationalityId"] = this.nationalityId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreatePatientDto {
        const json = this.toJSON();
        let result = new CreatePatientDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePatientDto {
    name: string;
    surname: string;
    email: string | undefined;
    phoneNumber: string | undefined;
    fiscalCode: string;
    healthCard: string | undefined;
    isMale: boolean;
    birthDate: Date;
    birthPlace: string;
    occupation: string | undefined;
    note: string | undefined;
    doctorId: number | undefined;
    operationalUnitId: number;
    nationalityId: number | undefined;
    address: CreateAddressDto;
}

export class CreatePatientFileDto implements ICreatePatientFileDto {
    name!: string | undefined;
    fileId!: number;
    operationalUnitId!: number;
    patientId!: number | undefined;

    constructor(data?: ICreatePatientFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.fileId = _data["fileId"];
            this.operationalUnitId = _data["operationalUnitId"];
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): CreatePatientFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["fileId"] = this.fileId;
        data["operationalUnitId"] = this.operationalUnitId;
        data["patientId"] = this.patientId;
        return data;
    }

    clone(): CreatePatientFileDto {
        const json = this.toJSON();
        let result = new CreatePatientFileDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePatientFileDto {
    name: string | undefined;
    fileId: number;
    operationalUnitId: number;
    patientId: number | undefined;
}

export class CreatePatientMealDto implements ICreatePatientMealDto {

    constructor(data?: ICreatePatientMealDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreatePatientMealDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientMealDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CreatePatientMealDto {
        const json = this.toJSON();
        let result = new CreatePatientMealDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePatientMealDto {
}

export class CreatePatientMedicationAdministrationDto implements ICreatePatientMedicationAdministrationDto {
    patientMedicationScheduleId!: number;
    administratedAt!: Date | undefined;
    quantity!: number;
    note!: string | undefined;
    patientMedicationTherapyId!: number;
    medicationStockCode!: string | undefined;

    constructor(data?: ICreatePatientMedicationAdministrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientMedicationScheduleId = _data["patientMedicationScheduleId"];
            this.administratedAt = _data["administratedAt"] ? new Date(_data["administratedAt"].toString()) : <any>undefined;
            this.quantity = _data["quantity"];
            this.note = _data["note"];
            this.patientMedicationTherapyId = _data["patientMedicationTherapyId"];
            this.medicationStockCode = _data["medicationStockCode"];
        }
    }

    static fromJS(data: any): CreatePatientMedicationAdministrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientMedicationAdministrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientMedicationScheduleId"] = this.patientMedicationScheduleId;
        data["administratedAt"] = this.administratedAt ? this.administratedAt.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["note"] = this.note;
        data["patientMedicationTherapyId"] = this.patientMedicationTherapyId;
        data["medicationStockCode"] = this.medicationStockCode;
        return data;
    }

    clone(): CreatePatientMedicationAdministrationDto {
        const json = this.toJSON();
        let result = new CreatePatientMedicationAdministrationDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePatientMedicationAdministrationDto {
    patientMedicationScheduleId: number;
    administratedAt: Date | undefined;
    quantity: number;
    note: string | undefined;
    patientMedicationTherapyId: number;
    medicationStockCode: string | undefined;
}

export class CreatePatientMedicationAssignmentDto implements ICreatePatientMedicationAssignmentDto {
    operationalUnitId!: number;
    medicationId!: number;
    patientId!: number;
    medicationStock!: number;
    quantity!: number;
    note!: string | undefined;

    constructor(data?: ICreatePatientMedicationAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationalUnitId = _data["operationalUnitId"];
            this.medicationId = _data["medicationId"];
            this.patientId = _data["patientId"];
            this.medicationStock = _data["medicationStock"];
            this.quantity = _data["quantity"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreatePatientMedicationAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientMedicationAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationalUnitId"] = this.operationalUnitId;
        data["medicationId"] = this.medicationId;
        data["patientId"] = this.patientId;
        data["medicationStock"] = this.medicationStock;
        data["quantity"] = this.quantity;
        data["note"] = this.note;
        return data;
    }

    clone(): CreatePatientMedicationAssignmentDto {
        const json = this.toJSON();
        let result = new CreatePatientMedicationAssignmentDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePatientMedicationAssignmentDto {
    operationalUnitId: number;
    medicationId: number;
    patientId: number;
    medicationStock: number;
    quantity: number;
    note: string | undefined;
}

export class CreatePatientMedicationAssignmentStandaloneDto implements ICreatePatientMedicationAssignmentStandaloneDto {
    operationalUnitId!: number;
    medicationId!: number;
    patientId!: number;
    quantity!: number;
    label!: string | undefined;
    boxCode!: string | undefined;
    note!: string | undefined;
    expireDate!: Date;

    constructor(data?: ICreatePatientMedicationAssignmentStandaloneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationalUnitId = _data["operationalUnitId"];
            this.medicationId = _data["medicationId"];
            this.patientId = _data["patientId"];
            this.quantity = _data["quantity"];
            this.label = _data["label"];
            this.boxCode = _data["boxCode"];
            this.note = _data["note"];
            this.expireDate = _data["expireDate"] ? new Date(_data["expireDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreatePatientMedicationAssignmentStandaloneDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientMedicationAssignmentStandaloneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationalUnitId"] = this.operationalUnitId;
        data["medicationId"] = this.medicationId;
        data["patientId"] = this.patientId;
        data["quantity"] = this.quantity;
        data["label"] = this.label;
        data["boxCode"] = this.boxCode;
        data["note"] = this.note;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): CreatePatientMedicationAssignmentStandaloneDto {
        const json = this.toJSON();
        let result = new CreatePatientMedicationAssignmentStandaloneDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePatientMedicationAssignmentStandaloneDto {
    operationalUnitId: number;
    medicationId: number;
    patientId: number;
    quantity: number;
    label: string | undefined;
    boxCode: string | undefined;
    note: string | undefined;
    expireDate: Date;
}

export class CreatePatientMedicationScheduleDto implements ICreatePatientMedicationScheduleDto {
    patientMedicationTherapyId!: number;
    plannedQuantity!: number;
    time!: Date;
    note!: string | undefined;

    constructor(data?: ICreatePatientMedicationScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientMedicationTherapyId = _data["patientMedicationTherapyId"];
            this.plannedQuantity = _data["plannedQuantity"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreatePatientMedicationScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientMedicationScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientMedicationTherapyId"] = this.patientMedicationTherapyId;
        data["plannedQuantity"] = this.plannedQuantity;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["note"] = this.note;
        return data;
    }

    clone(): CreatePatientMedicationScheduleDto {
        const json = this.toJSON();
        let result = new CreatePatientMedicationScheduleDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePatientMedicationScheduleDto {
    patientMedicationTherapyId: number;
    plannedQuantity: number;
    time: Date;
    note: string | undefined;
}

export class CreatePatientMedicationTherapyDto implements ICreatePatientMedicationTherapyDto {
    patientId!: number;
    medicationId!: number;
    operationalUnitId!: number;
    medicationTherapyTypeId!: number;
    medicationAdministrationRouteId!: number;
    dose!: number;
    maxDailyDose!: number | undefined;
    note!: string | undefined;
    startDate!: Date;
    endDate!: Date | undefined;
    documentMedicationIds!: number[] | undefined;
    patientMedicationTherapyRecurrences!: CreatePatientMedicationTherapyRecurrenceDto[] | undefined;
    patientMedicationTherapyTaperings!: CreatePatientMedicationTherapyTaperingDto[] | undefined;

    constructor(data?: ICreatePatientMedicationTherapyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.medicationId = _data["medicationId"];
            this.operationalUnitId = _data["operationalUnitId"];
            this.medicationTherapyTypeId = _data["medicationTherapyTypeId"];
            this.medicationAdministrationRouteId = _data["medicationAdministrationRouteId"];
            this.dose = _data["dose"];
            this.maxDailyDose = _data["maxDailyDose"];
            this.note = _data["note"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["documentMedicationIds"])) {
                this.documentMedicationIds = [] as any;
                for (let item of _data["documentMedicationIds"])
                    this.documentMedicationIds!.push(item);
            }
            if (Array.isArray(_data["patientMedicationTherapyRecurrences"])) {
                this.patientMedicationTherapyRecurrences = [] as any;
                for (let item of _data["patientMedicationTherapyRecurrences"])
                    this.patientMedicationTherapyRecurrences!.push(CreatePatientMedicationTherapyRecurrenceDto.fromJS(item));
            }
            if (Array.isArray(_data["patientMedicationTherapyTaperings"])) {
                this.patientMedicationTherapyTaperings = [] as any;
                for (let item of _data["patientMedicationTherapyTaperings"])
                    this.patientMedicationTherapyTaperings!.push(CreatePatientMedicationTherapyTaperingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePatientMedicationTherapyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientMedicationTherapyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["medicationId"] = this.medicationId;
        data["operationalUnitId"] = this.operationalUnitId;
        data["medicationTherapyTypeId"] = this.medicationTherapyTypeId;
        data["medicationAdministrationRouteId"] = this.medicationAdministrationRouteId;
        data["dose"] = this.dose;
        data["maxDailyDose"] = this.maxDailyDose;
        data["note"] = this.note;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.documentMedicationIds)) {
            data["documentMedicationIds"] = [];
            for (let item of this.documentMedicationIds)
                data["documentMedicationIds"].push(item);
        }
        if (Array.isArray(this.patientMedicationTherapyRecurrences)) {
            data["patientMedicationTherapyRecurrences"] = [];
            for (let item of this.patientMedicationTherapyRecurrences)
                data["patientMedicationTherapyRecurrences"].push(item.toJSON());
        }
        if (Array.isArray(this.patientMedicationTherapyTaperings)) {
            data["patientMedicationTherapyTaperings"] = [];
            for (let item of this.patientMedicationTherapyTaperings)
                data["patientMedicationTherapyTaperings"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreatePatientMedicationTherapyDto {
        const json = this.toJSON();
        let result = new CreatePatientMedicationTherapyDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePatientMedicationTherapyDto {
    patientId: number;
    medicationId: number;
    operationalUnitId: number;
    medicationTherapyTypeId: number;
    medicationAdministrationRouteId: number;
    dose: number;
    maxDailyDose: number | undefined;
    note: string | undefined;
    startDate: Date;
    endDate: Date | undefined;
    documentMedicationIds: number[] | undefined;
    patientMedicationTherapyRecurrences: CreatePatientMedicationTherapyRecurrenceDto[] | undefined;
    patientMedicationTherapyTaperings: CreatePatientMedicationTherapyTaperingDto[] | undefined;
}

export class CreatePatientMedicationTherapyRecurrenceDto implements ICreatePatientMedicationTherapyRecurrenceDto {
    timeOfDay!: Date;
    dose!: number | undefined;

    constructor(data?: ICreatePatientMedicationTherapyRecurrenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeOfDay = _data["timeOfDay"] ? new Date(_data["timeOfDay"].toString()) : <any>undefined;
            this.dose = _data["dose"];
        }
    }

    static fromJS(data: any): CreatePatientMedicationTherapyRecurrenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientMedicationTherapyRecurrenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeOfDay"] = this.timeOfDay ? this.timeOfDay.toISOString() : <any>undefined;
        data["dose"] = this.dose;
        return data;
    }

    clone(): CreatePatientMedicationTherapyRecurrenceDto {
        const json = this.toJSON();
        let result = new CreatePatientMedicationTherapyRecurrenceDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePatientMedicationTherapyRecurrenceDto {
    timeOfDay: Date;
    dose: number | undefined;
}

export class CreatePatientMedicationTherapyTaperingDto implements ICreatePatientMedicationTherapyTaperingDto {
    dayOffset!: number;
    timeOfDay!: Date | undefined;
    dose!: number;

    constructor(data?: ICreatePatientMedicationTherapyTaperingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayOffset = _data["dayOffset"];
            this.timeOfDay = _data["timeOfDay"] ? new Date(_data["timeOfDay"].toString()) : <any>undefined;
            this.dose = _data["dose"];
        }
    }

    static fromJS(data: any): CreatePatientMedicationTherapyTaperingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientMedicationTherapyTaperingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayOffset"] = this.dayOffset;
        data["timeOfDay"] = this.timeOfDay ? this.timeOfDay.toISOString() : <any>undefined;
        data["dose"] = this.dose;
        return data;
    }

    clone(): CreatePatientMedicationTherapyTaperingDto {
        const json = this.toJSON();
        let result = new CreatePatientMedicationTherapyTaperingDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePatientMedicationTherapyTaperingDto {
    dayOffset: number;
    timeOfDay: Date | undefined;
    dose: number;
}

export class CreatePatientNoteDto implements ICreatePatientNoteDto {

    constructor(data?: ICreatePatientNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreatePatientNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CreatePatientNoteDto {
        const json = this.toJSON();
        let result = new CreatePatientNoteDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePatientNoteDto {
}

export class CreatePatientOperationDto implements ICreatePatientOperationDto {
    description!: string | undefined;
    displayOrder!: number | undefined;

    constructor(data?: ICreatePatientOperationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): CreatePatientOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientOperationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): CreatePatientOperationDto {
        const json = this.toJSON();
        let result = new CreatePatientOperationDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePatientOperationDto {
    description: string | undefined;
    displayOrder: number | undefined;
}

export class CreatePatientTransferRequestDto implements ICreatePatientTransferRequestDto {
    patientId!: number;
    fromOperationalUnitId!: number;
    toOperationalUnitId!: number;

    constructor(data?: ICreatePatientTransferRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.fromOperationalUnitId = _data["fromOperationalUnitId"];
            this.toOperationalUnitId = _data["toOperationalUnitId"];
        }
    }

    static fromJS(data: any): CreatePatientTransferRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientTransferRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["fromOperationalUnitId"] = this.fromOperationalUnitId;
        data["toOperationalUnitId"] = this.toOperationalUnitId;
        return data;
    }

    clone(): CreatePatientTransferRequestDto {
        const json = this.toJSON();
        let result = new CreatePatientTransferRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePatientTransferRequestDto {
    patientId: number;
    fromOperationalUnitId: number;
    toOperationalUnitId: number;
}

export class CreatePhysiologicalHistoryDto implements ICreatePhysiologicalHistoryDto {

    constructor(data?: ICreatePhysiologicalHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreatePhysiologicalHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePhysiologicalHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CreatePhysiologicalHistoryDto {
        const json = this.toJSON();
        let result = new CreatePhysiologicalHistoryDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePhysiologicalHistoryDto {
}

export class CreatePlannedAssignmentDto implements ICreatePlannedAssignmentDto {
    plannedSlotId!: number;
    userId!: number;
    assignmentTypeId!: number;
    onCallTypeId!: number | undefined;
    startDateTime!: Date;
    endDateTime!: Date;

    constructor(data?: ICreatePlannedAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedSlotId = _data["plannedSlotId"];
            this.userId = _data["userId"];
            this.assignmentTypeId = _data["assignmentTypeId"];
            this.onCallTypeId = _data["onCallTypeId"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreatePlannedAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlannedAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedSlotId"] = this.plannedSlotId;
        data["userId"] = this.userId;
        data["assignmentTypeId"] = this.assignmentTypeId;
        data["onCallTypeId"] = this.onCallTypeId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): CreatePlannedAssignmentDto {
        const json = this.toJSON();
        let result = new CreatePlannedAssignmentDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePlannedAssignmentDto {
    plannedSlotId: number;
    userId: number;
    assignmentTypeId: number;
    onCallTypeId: number | undefined;
    startDateTime: Date;
    endDateTime: Date;
}

export class CreatePlannedSlotDto implements ICreatePlannedSlotDto {

    constructor(data?: ICreatePlannedSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreatePlannedSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlannedSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CreatePlannedSlotDto {
        const json = this.toJSON();
        let result = new CreatePlannedSlotDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePlannedSlotDto {
}

export class CreateProtocolTypeDto implements ICreateProtocolTypeDto {
    description!: string | undefined;
    displayOrder!: number | undefined;

    constructor(data?: ICreateProtocolTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): CreateProtocolTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProtocolTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        return data;
    }

    clone(): CreateProtocolTypeDto {
        const json = this.toJSON();
        let result = new CreateProtocolTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProtocolTypeDto {
    description: string | undefined;
    displayOrder: number | undefined;
}

export class CreatePsychiatricAdmissionExamDto implements ICreatePsychiatricAdmissionExamDto {

    constructor(data?: ICreatePsychiatricAdmissionExamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreatePsychiatricAdmissionExamDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePsychiatricAdmissionExamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CreatePsychiatricAdmissionExamDto {
        const json = this.toJSON();
        let result = new CreatePsychiatricAdmissionExamDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePsychiatricAdmissionExamDto {
}

export class CreatePsychiatricProfileDto implements ICreatePsychiatricProfileDto {

    constructor(data?: ICreatePsychiatricProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreatePsychiatricProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePsychiatricProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CreatePsychiatricProfileDto {
        const json = this.toJSON();
        let result = new CreatePsychiatricProfileDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePsychiatricProfileDto {
}

export class CreateRoleDto implements ICreateRoleDto {
    name!: string;
    displayName!: string;
    normalizedName!: string | undefined;
    description!: string | undefined;
    grantedPermissions!: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class CreateTemperatureDto implements ICreateTemperatureDto {
    operationalUnitId!: number;
    temperatureEnvironmentTypeId!: number;
    temperatureShiftId!: number | undefined;
    note!: string | undefined;
    dateTime!: Date;
    recurrence!: CreateTemperatureRecurrenceDto;

    constructor(data?: ICreateTemperatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationalUnitId = _data["operationalUnitId"];
            this.temperatureEnvironmentTypeId = _data["temperatureEnvironmentTypeId"];
            this.temperatureShiftId = _data["temperatureShiftId"];
            this.note = _data["note"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.recurrence = _data["recurrence"] ? CreateTemperatureRecurrenceDto.fromJS(_data["recurrence"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateTemperatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTemperatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationalUnitId"] = this.operationalUnitId;
        data["temperatureEnvironmentTypeId"] = this.temperatureEnvironmentTypeId;
        data["temperatureShiftId"] = this.temperatureShiftId;
        data["note"] = this.note;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["recurrence"] = this.recurrence ? this.recurrence.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateTemperatureDto {
        const json = this.toJSON();
        let result = new CreateTemperatureDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTemperatureDto {
    operationalUnitId: number;
    temperatureEnvironmentTypeId: number;
    temperatureShiftId: number | undefined;
    note: string | undefined;
    dateTime: Date;
    recurrence: CreateTemperatureRecurrenceDto;
}

export class CreateTemperatureEnvironmentTypeDto implements ICreateTemperatureEnvironmentTypeDto {
    description!: string | undefined;
    displayOrder!: number | undefined;
    minValue!: number;
    maxValue!: number;

    constructor(data?: ICreateTemperatureEnvironmentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
        }
    }

    static fromJS(data: any): CreateTemperatureEnvironmentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTemperatureEnvironmentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        return data;
    }

    clone(): CreateTemperatureEnvironmentTypeDto {
        const json = this.toJSON();
        let result = new CreateTemperatureEnvironmentTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTemperatureEnvironmentTypeDto {
    description: string | undefined;
    displayOrder: number | undefined;
    minValue: number;
    maxValue: number;
}

export class CreateTemperatureReadingDto implements ICreateTemperatureReadingDto {
    temperatureId!: number;
    value!: number;
    measuredAt!: Date;
    detectionNote!: string | undefined;

    constructor(data?: ICreateTemperatureReadingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.temperatureId = _data["temperatureId"];
            this.value = _data["value"];
            this.measuredAt = _data["measuredAt"] ? new Date(_data["measuredAt"].toString()) : <any>undefined;
            this.detectionNote = _data["detectionNote"];
        }
    }

    static fromJS(data: any): CreateTemperatureReadingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTemperatureReadingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temperatureId"] = this.temperatureId;
        data["value"] = this.value;
        data["measuredAt"] = this.measuredAt ? this.measuredAt.toISOString() : <any>undefined;
        data["detectionNote"] = this.detectionNote;
        return data;
    }

    clone(): CreateTemperatureReadingDto {
        const json = this.toJSON();
        let result = new CreateTemperatureReadingDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTemperatureReadingDto {
    temperatureId: number;
    value: number;
    measuredAt: Date;
    detectionNote: string | undefined;
}

export class CreateTemperatureRecurrenceDto implements ICreateTemperatureRecurrenceDto {
    recurrenceTypeId!: number | undefined;
    interval!: number | undefined;
    weekDayIds!: number[] | undefined;
    recurreEndTypeId!: number | undefined;
    endDate!: Date | undefined;
    occurrenceCount!: number | undefined;
    monthlyRecurrenceTypeId!: number | undefined;
    weekPositionId!: number | undefined;

    constructor(data?: ICreateTemperatureRecurrenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recurrenceTypeId = _data["recurrenceTypeId"];
            this.interval = _data["interval"];
            if (Array.isArray(_data["weekDayIds"])) {
                this.weekDayIds = [] as any;
                for (let item of _data["weekDayIds"])
                    this.weekDayIds!.push(item);
            }
            this.recurreEndTypeId = _data["recurreEndTypeId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.occurrenceCount = _data["occurrenceCount"];
            this.monthlyRecurrenceTypeId = _data["monthlyRecurrenceTypeId"];
            this.weekPositionId = _data["weekPositionId"];
        }
    }

    static fromJS(data: any): CreateTemperatureRecurrenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTemperatureRecurrenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recurrenceTypeId"] = this.recurrenceTypeId;
        data["interval"] = this.interval;
        if (Array.isArray(this.weekDayIds)) {
            data["weekDayIds"] = [];
            for (let item of this.weekDayIds)
                data["weekDayIds"].push(item);
        }
        data["recurreEndTypeId"] = this.recurreEndTypeId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["occurrenceCount"] = this.occurrenceCount;
        data["monthlyRecurrenceTypeId"] = this.monthlyRecurrenceTypeId;
        data["weekPositionId"] = this.weekPositionId;
        return data;
    }

    clone(): CreateTemperatureRecurrenceDto {
        const json = this.toJSON();
        let result = new CreateTemperatureRecurrenceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTemperatureRecurrenceDto {
    recurrenceTypeId: number | undefined;
    interval: number | undefined;
    weekDayIds: number[] | undefined;
    recurreEndTypeId: number | undefined;
    endDate: Date | undefined;
    occurrenceCount: number | undefined;
    monthlyRecurrenceTypeId: number | undefined;
    weekPositionId: number | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    connectionString!: string | undefined;
    isActive!: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

export class CreateTherapeuticGoalDto implements ICreateTherapeuticGoalDto {
    therapeuticAreaTypeId!: number;
    goalDefinition!: string | undefined;
    actions!: string | undefined;
    goalEvaluation!: string | undefined;
    actionsEvaluation!: string | undefined;

    constructor(data?: ICreateTherapeuticGoalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.therapeuticAreaTypeId = _data["therapeuticAreaTypeId"];
            this.goalDefinition = _data["goalDefinition"];
            this.actions = _data["actions"];
            this.goalEvaluation = _data["goalEvaluation"];
            this.actionsEvaluation = _data["actionsEvaluation"];
        }
    }

    static fromJS(data: any): CreateTherapeuticGoalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTherapeuticGoalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["therapeuticAreaTypeId"] = this.therapeuticAreaTypeId;
        data["goalDefinition"] = this.goalDefinition;
        data["actions"] = this.actions;
        data["goalEvaluation"] = this.goalEvaluation;
        data["actionsEvaluation"] = this.actionsEvaluation;
        return data;
    }

    clone(): CreateTherapeuticGoalDto {
        const json = this.toJSON();
        let result = new CreateTherapeuticGoalDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTherapeuticGoalDto {
    therapeuticAreaTypeId: number;
    goalDefinition: string | undefined;
    actions: string | undefined;
    goalEvaluation: string | undefined;
    actionsEvaluation: string | undefined;
}

export class CreateTherapeuticProgramDto implements ICreateTherapeuticProgramDto {
    patientId!: number;
    operationalUnitId!: number;
    name!: string | undefined;
    date!: Date;
    finalExamination!: string | undefined;
    therapeuticGoals!: CreateTherapeuticGoalDto[] | undefined;

    constructor(data?: ICreateTherapeuticProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.operationalUnitId = _data["operationalUnitId"];
            this.name = _data["name"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.finalExamination = _data["finalExamination"];
            if (Array.isArray(_data["therapeuticGoals"])) {
                this.therapeuticGoals = [] as any;
                for (let item of _data["therapeuticGoals"])
                    this.therapeuticGoals!.push(CreateTherapeuticGoalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateTherapeuticProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTherapeuticProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["operationalUnitId"] = this.operationalUnitId;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["finalExamination"] = this.finalExamination;
        if (Array.isArray(this.therapeuticGoals)) {
            data["therapeuticGoals"] = [];
            for (let item of this.therapeuticGoals)
                data["therapeuticGoals"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateTherapeuticProgramDto {
        const json = this.toJSON();
        let result = new CreateTherapeuticProgramDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTherapeuticProgramDto {
    patientId: number;
    operationalUnitId: number;
    name: string | undefined;
    date: Date;
    finalExamination: string | undefined;
    therapeuticGoals: CreateTherapeuticGoalDto[] | undefined;
}

export class CreateUserDto implements ICreateUserDto {
    name!: string;
    surname!: string;
    username!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    birthDate!: Date | undefined;
    birthPlace!: string | undefined;
    fiscalCode!: string | undefined;
    genderId!: number | undefined;
    isActive!: boolean;
    roleNames!: string[] | undefined;
    operationalUnitIds!: number[] | undefined;
    note!: string | undefined;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.username = _data["username"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.birthPlace = _data["birthPlace"];
            this.fiscalCode = _data["fiscalCode"];
            this.genderId = _data["genderId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            if (Array.isArray(_data["operationalUnitIds"])) {
                this.operationalUnitIds = [] as any;
                for (let item of _data["operationalUnitIds"])
                    this.operationalUnitIds!.push(item);
            }
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["username"] = this.username;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["birthPlace"] = this.birthPlace;
        data["fiscalCode"] = this.fiscalCode;
        data["genderId"] = this.genderId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        if (Array.isArray(this.operationalUnitIds)) {
            data["operationalUnitIds"] = [];
            for (let item of this.operationalUnitIds)
                data["operationalUnitIds"].push(item);
        }
        data["note"] = this.note;
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    name: string;
    surname: string;
    username: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    birthDate: Date | undefined;
    birthPlace: string | undefined;
    fiscalCode: string | undefined;
    genderId: number | undefined;
    isActive: boolean;
    roleNames: string[] | undefined;
    operationalUnitIds: number[] | undefined;
    note: string | undefined;
}

export class CreateUserFileDto implements ICreateUserFileDto {
    fileId!: number;
    userFileTypeId!: number;
    expirationDate!: Date | undefined;

    constructor(data?: ICreateUserFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.userFileTypeId = _data["userFileTypeId"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateUserFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["userFileTypeId"] = this.userFileTypeId;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): CreateUserFileDto {
        const json = this.toJSON();
        let result = new CreateUserFileDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserFileDto {
    fileId: number;
    userFileTypeId: number;
    expirationDate: Date | undefined;
}

export class CreateVaccinationDto implements ICreateVaccinationDto {
    medicalHistoryId!: number;
    vaccinationDictionaryId!: number;
    vaccinationTypeId!: number;
    date!: Date;
    organizationOrDoctor!: string | undefined;
    description!: string | undefined;
    vaccinationResultId!: number | undefined;

    constructor(data?: ICreateVaccinationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalHistoryId = _data["medicalHistoryId"];
            this.vaccinationDictionaryId = _data["vaccinationDictionaryId"];
            this.vaccinationTypeId = _data["vaccinationTypeId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.organizationOrDoctor = _data["organizationOrDoctor"];
            this.description = _data["description"];
            this.vaccinationResultId = _data["vaccinationResultId"];
        }
    }

    static fromJS(data: any): CreateVaccinationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVaccinationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalHistoryId"] = this.medicalHistoryId;
        data["vaccinationDictionaryId"] = this.vaccinationDictionaryId;
        data["vaccinationTypeId"] = this.vaccinationTypeId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["organizationOrDoctor"] = this.organizationOrDoctor;
        data["description"] = this.description;
        data["vaccinationResultId"] = this.vaccinationResultId;
        return data;
    }

    clone(): CreateVaccinationDto {
        const json = this.toJSON();
        let result = new CreateVaccinationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateVaccinationDto {
    medicalHistoryId: number;
    vaccinationDictionaryId: number;
    vaccinationTypeId: number;
    date: Date;
    organizationOrDoctor: string | undefined;
    description: string | undefined;
    vaccinationResultId: number | undefined;
}

export class CreateVitalSignsRecordDto implements ICreateVitalSignsRecordDto {
    medicalHistoryId!: number;
    recordedAt!: Date;

    constructor(data?: ICreateVitalSignsRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalHistoryId = _data["medicalHistoryId"];
            this.recordedAt = _data["recordedAt"] ? new Date(_data["recordedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateVitalSignsRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVitalSignsRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalHistoryId"] = this.medicalHistoryId;
        data["recordedAt"] = this.recordedAt ? this.recordedAt.toISOString() : <any>undefined;
        return data;
    }

    clone(): CreateVitalSignsRecordDto {
        const json = this.toJSON();
        let result = new CreateVitalSignsRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateVitalSignsRecordDto {
    medicalHistoryId: number;
    recordedAt: Date;
}

export class CustomAttributeData implements ICustomAttributeData {
    attributeType!: Type;
    constructor_!: ConstructorInfo;
    readonly constructorArguments!: CustomAttributeTypedArgument[] | undefined;
    readonly namedArguments!: CustomAttributeNamedArgument[] | undefined;

    constructor(data?: ICustomAttributeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeType = _data["attributeType"] ? Type.fromJS(_data["attributeType"]) : <any>undefined;
            this.constructor_ = _data["constructor"] ? ConstructorInfo.fromJS(_data["constructor"]) : <any>undefined;
            if (Array.isArray(_data["constructorArguments"])) {
                (<any>this).constructorArguments = [] as any;
                for (let item of _data["constructorArguments"])
                    (<any>this).constructorArguments!.push(CustomAttributeTypedArgument.fromJS(item));
            }
            if (Array.isArray(_data["namedArguments"])) {
                (<any>this).namedArguments = [] as any;
                for (let item of _data["namedArguments"])
                    (<any>this).namedArguments!.push(CustomAttributeNamedArgument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomAttributeData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType ? this.attributeType.toJSON() : <any>undefined;
        data["constructor"] = this.constructor_ ? this.constructor_.toJSON() : <any>undefined;
        if (Array.isArray(this.constructorArguments)) {
            data["constructorArguments"] = [];
            for (let item of this.constructorArguments)
                data["constructorArguments"].push(item.toJSON());
        }
        if (Array.isArray(this.namedArguments)) {
            data["namedArguments"] = [];
            for (let item of this.namedArguments)
                data["namedArguments"].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomAttributeData {
        const json = this.toJSON();
        let result = new CustomAttributeData();
        result.init(json);
        return result;
    }
}

export interface ICustomAttributeData {
    attributeType: Type;
    constructor_: ConstructorInfo;
    constructorArguments: CustomAttributeTypedArgument[] | undefined;
    namedArguments: CustomAttributeNamedArgument[] | undefined;
}

export class CustomAttributeNamedArgument implements ICustomAttributeNamedArgument {
    memberInfo!: MemberInfo;
    typedValue!: CustomAttributeTypedArgument;
    readonly memberName!: string | undefined;
    readonly isField!: boolean;

    constructor(data?: ICustomAttributeNamedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberInfo = _data["memberInfo"] ? MemberInfo.fromJS(_data["memberInfo"]) : <any>undefined;
            this.typedValue = _data["typedValue"] ? CustomAttributeTypedArgument.fromJS(_data["typedValue"]) : <any>undefined;
            (<any>this).memberName = _data["memberName"];
            (<any>this).isField = _data["isField"];
        }
    }

    static fromJS(data: any): CustomAttributeNamedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeNamedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberInfo"] = this.memberInfo ? this.memberInfo.toJSON() : <any>undefined;
        data["typedValue"] = this.typedValue ? this.typedValue.toJSON() : <any>undefined;
        data["memberName"] = this.memberName;
        data["isField"] = this.isField;
        return data;
    }

    clone(): CustomAttributeNamedArgument {
        const json = this.toJSON();
        let result = new CustomAttributeNamedArgument();
        result.init(json);
        return result;
    }
}

export interface ICustomAttributeNamedArgument {
    memberInfo: MemberInfo;
    typedValue: CustomAttributeTypedArgument;
    memberName: string | undefined;
    isField: boolean;
}

export class CustomAttributeTypedArgument implements ICustomAttributeTypedArgument {
    argumentType!: Type;
    value!: any | undefined;

    constructor(data?: ICustomAttributeTypedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.argumentType = _data["argumentType"] ? Type.fromJS(_data["argumentType"]) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomAttributeTypedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeTypedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argumentType"] = this.argumentType ? this.argumentType.toJSON() : <any>undefined;
        data["value"] = this.value;
        return data;
    }

    clone(): CustomAttributeTypedArgument {
        const json = this.toJSON();
        let result = new CustomAttributeTypedArgument();
        result.init(json);
        return result;
    }
}

export interface ICustomAttributeTypedArgument {
    argumentType: Type;
    value: any | undefined;
}

export class DependencyDto implements IDependencyDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    dependencyType!: string | undefined;
    isActive!: boolean;
    firstContactDate!: Date | undefined;
    lastContactDate!: Date | undefined;
    note!: string | undefined;

    constructor(data?: IDependencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.dependencyType = _data["dependencyType"];
            this.isActive = _data["isActive"];
            this.firstContactDate = _data["firstContactDate"] ? new Date(_data["firstContactDate"].toString()) : <any>undefined;
            this.lastContactDate = _data["lastContactDate"] ? new Date(_data["lastContactDate"].toString()) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): DependencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DependencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["dependencyType"] = this.dependencyType;
        data["isActive"] = this.isActive;
        data["firstContactDate"] = this.firstContactDate ? this.firstContactDate.toISOString() : <any>undefined;
        data["lastContactDate"] = this.lastContactDate ? this.lastContactDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        return data;
    }

    clone(): DependencyDto {
        const json = this.toJSON();
        let result = new DependencyDto();
        result.init(json);
        return result;
    }
}

export interface IDependencyDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    dependencyType: string | undefined;
    isActive: boolean;
    firstContactDate: Date | undefined;
    lastContactDate: Date | undefined;
    note: string | undefined;
}

export class DependencyDtoPagedResultDto implements IDependencyDtoPagedResultDto {
    items!: DependencyDto[] | undefined;
    totalCount!: number;

    constructor(data?: IDependencyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DependencyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DependencyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DependencyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DependencyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DependencyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDependencyDtoPagedResultDto {
    items: DependencyDto[] | undefined;
    totalCount: number;
}

export class DependencyHistoryDto implements IDependencyHistoryDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    dependencies!: DependencyDto[] | undefined;

    constructor(data?: IDependencyHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["dependencies"])) {
                this.dependencies = [] as any;
                for (let item of _data["dependencies"])
                    this.dependencies!.push(DependencyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DependencyHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DependencyHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.dependencies)) {
            data["dependencies"] = [];
            for (let item of this.dependencies)
                data["dependencies"].push(item.toJSON());
        }
        return data;
    }

    clone(): DependencyHistoryDto {
        const json = this.toJSON();
        let result = new DependencyHistoryDto();
        result.init(json);
        return result;
    }
}

export interface IDependencyHistoryDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    dependencies: DependencyDto[] | undefined;
}

export class DependencyHistoryDtoPagedResultDto implements IDependencyHistoryDtoPagedResultDto {
    items!: DependencyHistoryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IDependencyHistoryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DependencyHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DependencyHistoryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DependencyHistoryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DependencyHistoryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DependencyHistoryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDependencyHistoryDtoPagedResultDto {
    items: DependencyHistoryDto[] | undefined;
    totalCount: number;
}

export class DiaryDto implements IDiaryDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    date!: Date;
    observations!: string | undefined;
    interventions!: string | undefined;
    diaryType!: DictionaryDto;

    constructor(data?: IDiaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.observations = _data["observations"];
            this.interventions = _data["interventions"];
            this.diaryType = _data["diaryType"] ? DictionaryDto.fromJS(_data["diaryType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DiaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["observations"] = this.observations;
        data["interventions"] = this.interventions;
        data["diaryType"] = this.diaryType ? this.diaryType.toJSON() : <any>undefined;
        return data;
    }

    clone(): DiaryDto {
        const json = this.toJSON();
        let result = new DiaryDto();
        result.init(json);
        return result;
    }
}

export interface IDiaryDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    date: Date;
    observations: string | undefined;
    interventions: string | undefined;
    diaryType: DictionaryDto;
}

export class DiaryDtoPagedResultDto implements IDiaryDtoPagedResultDto {
    items!: DiaryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IDiaryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DiaryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DiaryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiaryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DiaryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DiaryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDiaryDtoPagedResultDto {
    items: DiaryDto[] | undefined;
    totalCount: number;
}

export class DictionaryDto implements IDictionaryDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;

    constructor(data?: IDictionaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
        }
    }

    static fromJS(data: any): DictionaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DictionaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        return data;
    }

    clone(): DictionaryDto {
        const json = this.toJSON();
        let result = new DictionaryDto();
        result.init(json);
        return result;
    }
}

export interface IDictionaryDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
}

export class DischargePackageInput implements IDischargePackageInput {
    medicationStockCode!: string;
    reasonId!: number;
    note!: string | undefined;
    secondOperatorUserNameOrEmail!: string | undefined;
    secondOperatorPassword!: string | undefined;

    constructor(data?: IDischargePackageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicationStockCode = _data["medicationStockCode"];
            this.reasonId = _data["reasonId"];
            this.note = _data["note"];
            this.secondOperatorUserNameOrEmail = _data["secondOperatorUserNameOrEmail"];
            this.secondOperatorPassword = _data["secondOperatorPassword"];
        }
    }

    static fromJS(data: any): DischargePackageInput {
        data = typeof data === 'object' ? data : {};
        let result = new DischargePackageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicationStockCode"] = this.medicationStockCode;
        data["reasonId"] = this.reasonId;
        data["note"] = this.note;
        data["secondOperatorUserNameOrEmail"] = this.secondOperatorUserNameOrEmail;
        data["secondOperatorPassword"] = this.secondOperatorPassword;
        return data;
    }

    clone(): DischargePackageInput {
        const json = this.toJSON();
        let result = new DischargePackageInput();
        result.init(json);
        return result;
    }
}

export interface IDischargePackageInput {
    medicationStockCode: string;
    reasonId: number;
    note: string | undefined;
    secondOperatorUserNameOrEmail: string | undefined;
    secondOperatorPassword: string | undefined;
}

export class DischargeUnitsInput implements IDischargeUnitsInput {
    medicationStockCode!: string;
    patientId!: number | undefined;
    units!: number;
    reasonId!: number;
    note!: string | undefined;
    secondOperatorUserNameOrEmail!: string | undefined;
    secondOperatorPassword!: string | undefined;

    constructor(data?: IDischargeUnitsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicationStockCode = _data["medicationStockCode"];
            this.patientId = _data["patientId"];
            this.units = _data["units"];
            this.reasonId = _data["reasonId"];
            this.note = _data["note"];
            this.secondOperatorUserNameOrEmail = _data["secondOperatorUserNameOrEmail"];
            this.secondOperatorPassword = _data["secondOperatorPassword"];
        }
    }

    static fromJS(data: any): DischargeUnitsInput {
        data = typeof data === 'object' ? data : {};
        let result = new DischargeUnitsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicationStockCode"] = this.medicationStockCode;
        data["patientId"] = this.patientId;
        data["units"] = this.units;
        data["reasonId"] = this.reasonId;
        data["note"] = this.note;
        data["secondOperatorUserNameOrEmail"] = this.secondOperatorUserNameOrEmail;
        data["secondOperatorPassword"] = this.secondOperatorPassword;
        return data;
    }

    clone(): DischargeUnitsInput {
        const json = this.toJSON();
        let result = new DischargeUnitsInput();
        result.init(json);
        return result;
    }
}

export interface IDischargeUnitsInput {
    medicationStockCode: string;
    patientId: number | undefined;
    units: number;
    reasonId: number;
    note: string | undefined;
    secondOperatorUserNameOrEmail: string | undefined;
    secondOperatorPassword: string | undefined;
}

export class DocumentDto implements IDocumentDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    protocolNumber!: string | undefined;
    date!: Date;
    documentDate!: Date;
    expirationDate!: Date | undefined;
    expirationStatus!: string | undefined;
    sender!: string | undefined;
    recipient!: string | undefined;
    description!: string | undefined;
    documentType!: DocumentTypeDto;
    file!: FileDto;
    isIncoming!: boolean;
    protocolType!: ProtocolTypeDto;
    isArchived!: boolean;
    isTherapeuticPrescription!: boolean;
    documentMedications!: DocumentMedicationDto[] | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.protocolNumber = _data["protocolNumber"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.expirationStatus = _data["expirationStatus"];
            this.sender = _data["sender"];
            this.recipient = _data["recipient"];
            this.description = _data["description"];
            this.documentType = _data["documentType"] ? DocumentTypeDto.fromJS(_data["documentType"]) : <any>undefined;
            this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : <any>undefined;
            this.isIncoming = _data["isIncoming"];
            this.protocolType = _data["protocolType"] ? ProtocolTypeDto.fromJS(_data["protocolType"]) : <any>undefined;
            this.isArchived = _data["isArchived"];
            this.isTherapeuticPrescription = _data["isTherapeuticPrescription"];
            if (Array.isArray(_data["documentMedications"])) {
                this.documentMedications = [] as any;
                for (let item of _data["documentMedications"])
                    this.documentMedications!.push(DocumentMedicationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["protocolNumber"] = this.protocolNumber;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["expirationStatus"] = this.expirationStatus;
        data["sender"] = this.sender;
        data["recipient"] = this.recipient;
        data["description"] = this.description;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["isIncoming"] = this.isIncoming;
        data["protocolType"] = this.protocolType ? this.protocolType.toJSON() : <any>undefined;
        data["isArchived"] = this.isArchived;
        data["isTherapeuticPrescription"] = this.isTherapeuticPrescription;
        if (Array.isArray(this.documentMedications)) {
            data["documentMedications"] = [];
            for (let item of this.documentMedications)
                data["documentMedications"].push(item.toJSON());
        }
        return data;
    }

    clone(): DocumentDto {
        const json = this.toJSON();
        let result = new DocumentDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    protocolNumber: string | undefined;
    date: Date;
    documentDate: Date;
    expirationDate: Date | undefined;
    expirationStatus: string | undefined;
    sender: string | undefined;
    recipient: string | undefined;
    description: string | undefined;
    documentType: DocumentTypeDto;
    file: FileDto;
    isIncoming: boolean;
    protocolType: ProtocolTypeDto;
    isArchived: boolean;
    isTherapeuticPrescription: boolean;
    documentMedications: DocumentMedicationDto[] | undefined;
}

export class DocumentDtoPagedResultDto implements IDocumentDtoPagedResultDto {
    items!: DocumentDto[] | undefined;
    totalCount!: number;

    constructor(data?: IDocumentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DocumentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DocumentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DocumentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DocumentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentDtoPagedResultDto {
    items: DocumentDto[] | undefined;
    totalCount: number;
}

export class DocumentMedicationDto implements IDocumentMedicationDto {
    id!: number;
    medication!: SimpleMedicationDto;

    constructor(data?: IDocumentMedicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.medication = _data["medication"] ? SimpleMedicationDto.fromJS(_data["medication"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentMedicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentMedicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        return data;
    }

    clone(): DocumentMedicationDto {
        const json = this.toJSON();
        let result = new DocumentMedicationDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentMedicationDto {
    id: number;
    medication: SimpleMedicationDto;
}

export class DocumentTypeDto implements IDocumentTypeDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;
    isStatic!: boolean;

    constructor(data?: IDocumentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): DocumentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): DocumentTypeDto {
        const json = this.toJSON();
        let result = new DocumentTypeDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentTypeDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
    isStatic: boolean;
}

export class DocumentTypeDtoPagedResultDto implements IDocumentTypeDtoPagedResultDto {
    items!: DocumentTypeDto[] | undefined;
    totalCount!: number;

    constructor(data?: IDocumentTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DocumentTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DocumentTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DocumentTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DocumentTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentTypeDtoPagedResultDto {
    items: DocumentTypeDto[] | undefined;
    totalCount: number;
}

export class EnvironmentTypeDto implements IEnvironmentTypeDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;
    isStatic!: boolean;

    constructor(data?: IEnvironmentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): EnvironmentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnvironmentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): EnvironmentTypeDto {
        const json = this.toJSON();
        let result = new EnvironmentTypeDto();
        result.init(json);
        return result;
    }
}

export interface IEnvironmentTypeDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
    isStatic: boolean;
}

export class EnvironmentTypeDtoPagedResultDto implements IEnvironmentTypeDtoPagedResultDto {
    items!: EnvironmentTypeDto[] | undefined;
    totalCount!: number;

    constructor(data?: IEnvironmentTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EnvironmentTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): EnvironmentTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnvironmentTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): EnvironmentTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new EnvironmentTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IEnvironmentTypeDtoPagedResultDto {
    items: EnvironmentTypeDto[] | undefined;
    totalCount: number;
}

export enum EventAttributes {
    _0 = 0,
    _512 = 512,
    _1024 = 1024,
}

export class EventInfo implements IEventInfo {
    readonly name!: string | undefined;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    memberType!: MemberTypes;
    attributes!: EventAttributes;
    readonly isSpecialName!: boolean;
    addMethod!: MethodInfo;
    removeMethod!: MethodInfo;
    raiseMethod!: MethodInfo;
    readonly isMulticast!: boolean;
    eventHandlerType!: Type;

    constructor(data?: IEventInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            this.addMethod = _data["addMethod"] ? MethodInfo.fromJS(_data["addMethod"]) : <any>undefined;
            this.removeMethod = _data["removeMethod"] ? MethodInfo.fromJS(_data["removeMethod"]) : <any>undefined;
            this.raiseMethod = _data["raiseMethod"] ? MethodInfo.fromJS(_data["raiseMethod"]) : <any>undefined;
            (<any>this).isMulticast = _data["isMulticast"];
            this.eventHandlerType = _data["eventHandlerType"] ? Type.fromJS(_data["eventHandlerType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EventInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["addMethod"] = this.addMethod ? this.addMethod.toJSON() : <any>undefined;
        data["removeMethod"] = this.removeMethod ? this.removeMethod.toJSON() : <any>undefined;
        data["raiseMethod"] = this.raiseMethod ? this.raiseMethod.toJSON() : <any>undefined;
        data["isMulticast"] = this.isMulticast;
        data["eventHandlerType"] = this.eventHandlerType ? this.eventHandlerType.toJSON() : <any>undefined;
        return data;
    }

    clone(): EventInfo {
        const json = this.toJSON();
        let result = new EventInfo();
        result.init(json);
        return result;
    }
}

export interface IEventInfo {
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    memberType: MemberTypes;
    attributes: EventAttributes;
    isSpecialName: boolean;
    addMethod: MethodInfo;
    removeMethod: MethodInfo;
    raiseMethod: MethodInfo;
    isMulticast: boolean;
    eventHandlerType: Type;
}

export class ExpiringDocumentDto implements IExpiringDocumentDto {
    id!: number;
    documentType!: DocumentTypeDto;
    description!: string | undefined;
    expirationDate!: Date | undefined;
    expirationStatus!: string | undefined;
    isIncoming!: boolean;
    patient!: SimplePatientDto;
    operationalUnit!: SimpleOperationalUnitDto;

    constructor(data?: IExpiringDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentType = _data["documentType"] ? DocumentTypeDto.fromJS(_data["documentType"]) : <any>undefined;
            this.description = _data["description"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.expirationStatus = _data["expirationStatus"];
            this.isIncoming = _data["isIncoming"];
            this.patient = _data["patient"] ? SimplePatientDto.fromJS(_data["patient"]) : <any>undefined;
            this.operationalUnit = _data["operationalUnit"] ? SimpleOperationalUnitDto.fromJS(_data["operationalUnit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExpiringDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["expirationStatus"] = this.expirationStatus;
        data["isIncoming"] = this.isIncoming;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["operationalUnit"] = this.operationalUnit ? this.operationalUnit.toJSON() : <any>undefined;
        return data;
    }

    clone(): ExpiringDocumentDto {
        const json = this.toJSON();
        let result = new ExpiringDocumentDto();
        result.init(json);
        return result;
    }
}

export interface IExpiringDocumentDto {
    id: number;
    documentType: DocumentTypeDto;
    description: string | undefined;
    expirationDate: Date | undefined;
    expirationStatus: string | undefined;
    isIncoming: boolean;
    patient: SimplePatientDto;
    operationalUnit: SimpleOperationalUnitDto;
}

export class ExpiringDocumentDtoPagedResultDto implements IExpiringDocumentDtoPagedResultDto {
    items!: ExpiringDocumentDto[] | undefined;
    totalCount!: number;

    constructor(data?: IExpiringDocumentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExpiringDocumentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ExpiringDocumentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringDocumentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ExpiringDocumentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ExpiringDocumentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IExpiringDocumentDtoPagedResultDto {
    items: ExpiringDocumentDto[] | undefined;
    totalCount: number;
}

export class ExpiringMedicationStockDto implements IExpiringMedicationStockDto {
    id!: number;
    medication!: SimpleMedicationDto;
    label!: string | undefined;
    boxCode!: string | undefined;
    expiryDate!: Date;
    totalQuantity!: number;
    operationalUnit!: SimpleOperationalUnitDto;

    constructor(data?: IExpiringMedicationStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.medication = _data["medication"] ? SimpleMedicationDto.fromJS(_data["medication"]) : <any>undefined;
            this.label = _data["label"];
            this.boxCode = _data["boxCode"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.totalQuantity = _data["totalQuantity"];
            this.operationalUnit = _data["operationalUnit"] ? SimpleOperationalUnitDto.fromJS(_data["operationalUnit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExpiringMedicationStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringMedicationStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        data["label"] = this.label;
        data["boxCode"] = this.boxCode;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["totalQuantity"] = this.totalQuantity;
        data["operationalUnit"] = this.operationalUnit ? this.operationalUnit.toJSON() : <any>undefined;
        return data;
    }

    clone(): ExpiringMedicationStockDto {
        const json = this.toJSON();
        let result = new ExpiringMedicationStockDto();
        result.init(json);
        return result;
    }
}

export interface IExpiringMedicationStockDto {
    id: number;
    medication: SimpleMedicationDto;
    label: string | undefined;
    boxCode: string | undefined;
    expiryDate: Date;
    totalQuantity: number;
    operationalUnit: SimpleOperationalUnitDto;
}

export class ExpiringMedicationStockDtoPagedResultDto implements IExpiringMedicationStockDtoPagedResultDto {
    items!: ExpiringMedicationStockDto[] | undefined;
    totalCount!: number;

    constructor(data?: IExpiringMedicationStockDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExpiringMedicationStockDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ExpiringMedicationStockDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringMedicationStockDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ExpiringMedicationStockDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ExpiringMedicationStockDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IExpiringMedicationStockDtoPagedResultDto {
    items: ExpiringMedicationStockDto[] | undefined;
    totalCount: number;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data;
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    waitingForActivation!: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data;
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class FamilyHistoryDto implements IFamilyHistoryDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    familialPathologies!: string | undefined;
    acquiredFamilyPathologies!: string | undefined;
    familyMembers!: FamilyMemberDto[] | undefined;

    constructor(data?: IFamilyHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.familialPathologies = _data["familialPathologies"];
            this.acquiredFamilyPathologies = _data["acquiredFamilyPathologies"];
            if (Array.isArray(_data["familyMembers"])) {
                this.familyMembers = [] as any;
                for (let item of _data["familyMembers"])
                    this.familyMembers!.push(FamilyMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FamilyHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["familialPathologies"] = this.familialPathologies;
        data["acquiredFamilyPathologies"] = this.acquiredFamilyPathologies;
        if (Array.isArray(this.familyMembers)) {
            data["familyMembers"] = [];
            for (let item of this.familyMembers)
                data["familyMembers"].push(item.toJSON());
        }
        return data;
    }

    clone(): FamilyHistoryDto {
        const json = this.toJSON();
        let result = new FamilyHistoryDto();
        result.init(json);
        return result;
    }
}

export interface IFamilyHistoryDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    familialPathologies: string | undefined;
    acquiredFamilyPathologies: string | undefined;
    familyMembers: FamilyMemberDto[] | undefined;
}

export class FamilyHistoryDtoPagedResultDto implements IFamilyHistoryDtoPagedResultDto {
    items!: FamilyHistoryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IFamilyHistoryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FamilyHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): FamilyHistoryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyHistoryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): FamilyHistoryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FamilyHistoryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFamilyHistoryDtoPagedResultDto {
    items: FamilyHistoryDto[] | undefined;
    totalCount: number;
}

export class FamilyMemberDto implements IFamilyMemberDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    familyMemberType!: DictionaryDto;
    name!: string | undefined;
    age!: number | undefined;
    isDeceased!: boolean;
    disease!: string | undefined;
    profession!: string | undefined;
    residence!: string | undefined;
    note!: string | undefined;

    constructor(data?: IFamilyMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.familyMemberType = _data["familyMemberType"] ? DictionaryDto.fromJS(_data["familyMemberType"]) : <any>undefined;
            this.name = _data["name"];
            this.age = _data["age"];
            this.isDeceased = _data["isDeceased"];
            this.disease = _data["disease"];
            this.profession = _data["profession"];
            this.residence = _data["residence"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): FamilyMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["familyMemberType"] = this.familyMemberType ? this.familyMemberType.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["age"] = this.age;
        data["isDeceased"] = this.isDeceased;
        data["disease"] = this.disease;
        data["profession"] = this.profession;
        data["residence"] = this.residence;
        data["note"] = this.note;
        return data;
    }

    clone(): FamilyMemberDto {
        const json = this.toJSON();
        let result = new FamilyMemberDto();
        result.init(json);
        return result;
    }
}

export interface IFamilyMemberDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    familyMemberType: DictionaryDto;
    name: string | undefined;
    age: number | undefined;
    isDeceased: boolean;
    disease: string | undefined;
    profession: string | undefined;
    residence: string | undefined;
    note: string | undefined;
}

export class FamilyMemberDtoPagedResultDto implements IFamilyMemberDtoPagedResultDto {
    items!: FamilyMemberDto[] | undefined;
    totalCount!: number;

    constructor(data?: IFamilyMemberDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FamilyMemberDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): FamilyMemberDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyMemberDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): FamilyMemberDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FamilyMemberDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFamilyMemberDtoPagedResultDto {
    items: FamilyMemberDto[] | undefined;
    totalCount: number;
}

export enum FieldAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _1024 = 1024,
    _4096 = 4096,
    _8192 = 8192,
    _32768 = 32768,
    _38144 = 38144,
}

export class FieldInfo implements IFieldInfo {
    readonly name!: string | undefined;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    memberType!: MemberTypes;
    attributes!: FieldAttributes;
    fieldType!: Type;
    readonly isInitOnly!: boolean;
    readonly isLiteral!: boolean;
    readonly isNotSerialized!: boolean;
    readonly isPinvokeImpl!: boolean;
    readonly isSpecialName!: boolean;
    readonly isStatic!: boolean;
    readonly isAssembly!: boolean;
    readonly isFamily!: boolean;
    readonly isFamilyAndAssembly!: boolean;
    readonly isFamilyOrAssembly!: boolean;
    readonly isPrivate!: boolean;
    readonly isPublic!: boolean;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    fieldHandle!: RuntimeFieldHandle;

    constructor(data?: IFieldInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            this.fieldType = _data["fieldType"] ? Type.fromJS(_data["fieldType"]) : <any>undefined;
            (<any>this).isInitOnly = _data["isInitOnly"];
            (<any>this).isLiteral = _data["isLiteral"];
            (<any>this).isNotSerialized = _data["isNotSerialized"];
            (<any>this).isPinvokeImpl = _data["isPinvokeImpl"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.fieldHandle = _data["fieldHandle"] ? RuntimeFieldHandle.fromJS(_data["fieldHandle"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FieldInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FieldInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["fieldType"] = this.fieldType ? this.fieldType.toJSON() : <any>undefined;
        data["isInitOnly"] = this.isInitOnly;
        data["isLiteral"] = this.isLiteral;
        data["isNotSerialized"] = this.isNotSerialized;
        data["isPinvokeImpl"] = this.isPinvokeImpl;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["fieldHandle"] = this.fieldHandle ? this.fieldHandle.toJSON() : <any>undefined;
        return data;
    }

    clone(): FieldInfo {
        const json = this.toJSON();
        let result = new FieldInfo();
        result.init(json);
        return result;
    }
}

export interface IFieldInfo {
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    memberType: MemberTypes;
    attributes: FieldAttributes;
    fieldType: Type;
    isInitOnly: boolean;
    isLiteral: boolean;
    isNotSerialized: boolean;
    isPinvokeImpl: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    fieldHandle: RuntimeFieldHandle;
}

export class FileDownloadDto implements IFileDownloadDto {
    id!: number;
    fileName!: string | undefined;
    mimeType!: string | undefined;
    size!: number;
    byteArray!: string | undefined;

    constructor(data?: IFileDownloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
            this.size = _data["size"];
            this.byteArray = _data["byteArray"];
        }
    }

    static fromJS(data: any): FileDownloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        data["size"] = this.size;
        data["byteArray"] = this.byteArray;
        return data;
    }

    clone(): FileDownloadDto {
        const json = this.toJSON();
        let result = new FileDownloadDto();
        result.init(json);
        return result;
    }
}

export interface IFileDownloadDto {
    id: number;
    fileName: string | undefined;
    mimeType: string | undefined;
    size: number;
    byteArray: string | undefined;
}

export class FileDto implements IFileDto {
    id!: number;
    mask!: string | undefined;
    name!: string | undefined;
    extension!: string | undefined;
    mimeType!: string | undefined;
    size!: number;
    signedUrl!: string | undefined;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mask = _data["mask"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.mimeType = _data["mimeType"];
            this.size = _data["size"];
            this.signedUrl = _data["signedUrl"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mask"] = this.mask;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["mimeType"] = this.mimeType;
        data["size"] = this.size;
        data["signedUrl"] = this.signedUrl;
        return data;
    }

    clone(): FileDto {
        const json = this.toJSON();
        let result = new FileDto();
        result.init(json);
        return result;
    }
}

export interface IFileDto {
    id: number;
    mask: string | undefined;
    name: string | undefined;
    extension: string | undefined;
    mimeType: string | undefined;
    size: number;
    signedUrl: string | undefined;
}

export class FileDtoPagedResultDto implements IFileDtoPagedResultDto {
    items!: FileDto[] | undefined;
    totalCount!: number;

    constructor(data?: IFileDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FileDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): FileDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): FileDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FileDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFileDtoPagedResultDto {
    items: FileDto[] | undefined;
    totalCount: number;
}

export class FileExportDto implements IFileExportDto {
    fileName!: string | undefined;
    fileData!: string | undefined;
    mimeType!: string | undefined;

    constructor(data?: IFileExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileData = _data["fileData"];
            this.mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): FileExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileData"] = this.fileData;
        data["mimeType"] = this.mimeType;
        return data;
    }

    clone(): FileExportDto {
        const json = this.toJSON();
        let result = new FileExportDto();
        result.init(json);
        return result;
    }
}

export interface IFileExportDto {
    fileName: string | undefined;
    fileData: string | undefined;
    mimeType: string | undefined;
}

export class FileExtendedDto implements IFileExtendedDto {
    byteArray!: string | undefined;
    signedUrl!: string | undefined;

    constructor(data?: IFileExtendedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.byteArray = _data["byteArray"];
            this.signedUrl = _data["signedUrl"];
        }
    }

    static fromJS(data: any): FileExtendedDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileExtendedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["byteArray"] = this.byteArray;
        data["signedUrl"] = this.signedUrl;
        return data;
    }

    clone(): FileExtendedDto {
        const json = this.toJSON();
        let result = new FileExtendedDto();
        result.init(json);
        return result;
    }
}

export interface IFileExtendedDto {
    byteArray: string | undefined;
    signedUrl: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class ForceResetPasswordDto implements IForceResetPasswordDto {
    adminPassword!: string;
    userId!: number;
    newPassword!: string;

    constructor(data?: IForceResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ForceResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForceResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ForceResetPasswordDto {
        const json = this.toJSON();
        let result = new ForceResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IForceResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class ForensicProfileDto implements IForensicProfileDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    currentConviction!: string | undefined;
    expertJudgment!: string | undefined;
    firstOPGAdmissionAge!: number | undefined;
    opgStayYears!: number | undefined;
    opgAdmissionDiagnosis!: string | undefined;
    securityMeasureExpirationDate!: Date | undefined;
    selfHarmSuicidalHistory!: string | undefined;

    constructor(data?: IForensicProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.currentConviction = _data["currentConviction"];
            this.expertJudgment = _data["expertJudgment"];
            this.firstOPGAdmissionAge = _data["firstOPGAdmissionAge"];
            this.opgStayYears = _data["opgStayYears"];
            this.opgAdmissionDiagnosis = _data["opgAdmissionDiagnosis"];
            this.securityMeasureExpirationDate = _data["securityMeasureExpirationDate"] ? new Date(_data["securityMeasureExpirationDate"].toString()) : <any>undefined;
            this.selfHarmSuicidalHistory = _data["selfHarmSuicidalHistory"];
        }
    }

    static fromJS(data: any): ForensicProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForensicProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["currentConviction"] = this.currentConviction;
        data["expertJudgment"] = this.expertJudgment;
        data["firstOPGAdmissionAge"] = this.firstOPGAdmissionAge;
        data["opgStayYears"] = this.opgStayYears;
        data["opgAdmissionDiagnosis"] = this.opgAdmissionDiagnosis;
        data["securityMeasureExpirationDate"] = this.securityMeasureExpirationDate ? this.securityMeasureExpirationDate.toISOString() : <any>undefined;
        data["selfHarmSuicidalHistory"] = this.selfHarmSuicidalHistory;
        return data;
    }

    clone(): ForensicProfileDto {
        const json = this.toJSON();
        let result = new ForensicProfileDto();
        result.init(json);
        return result;
    }
}

export interface IForensicProfileDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    currentConviction: string | undefined;
    expertJudgment: string | undefined;
    firstOPGAdmissionAge: number | undefined;
    opgStayYears: number | undefined;
    opgAdmissionDiagnosis: string | undefined;
    securityMeasureExpirationDate: Date | undefined;
    selfHarmSuicidalHistory: string | undefined;
}

export class ForensicProfileDtoPagedResultDto implements IForensicProfileDtoPagedResultDto {
    items!: ForensicProfileDto[] | undefined;
    totalCount!: number;

    constructor(data?: IForensicProfileDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ForensicProfileDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ForensicProfileDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForensicProfileDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ForensicProfileDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ForensicProfileDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IForensicProfileDtoPagedResultDto {
    items: ForensicProfileDto[] | undefined;
    totalCount: number;
}

export class ForgotPasswordDto implements IForgotPasswordDto {
    emailAddress!: string;

    constructor(data?: IForgotPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ForgotPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): ForgotPasswordDto {
        const json = this.toJSON();
        let result = new ForgotPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IForgotPasswordDto {
    emailAddress: string;
}

export enum GenericParameterAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _28 = 28,
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application!: ApplicationInfoDto;
    user!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class HandoverNoteDto implements IHandoverNoteDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    handoverNoteType!: DictionaryDto;
    shiftType!: DictionaryDto;
    dateTime!: Date;
    note!: string | undefined;

    constructor(data?: IHandoverNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.handoverNoteType = _data["handoverNoteType"] ? DictionaryDto.fromJS(_data["handoverNoteType"]) : <any>undefined;
            this.shiftType = _data["shiftType"] ? DictionaryDto.fromJS(_data["shiftType"]) : <any>undefined;
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): HandoverNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new HandoverNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["handoverNoteType"] = this.handoverNoteType ? this.handoverNoteType.toJSON() : <any>undefined;
        data["shiftType"] = this.shiftType ? this.shiftType.toJSON() : <any>undefined;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["note"] = this.note;
        return data;
    }

    clone(): HandoverNoteDto {
        const json = this.toJSON();
        let result = new HandoverNoteDto();
        result.init(json);
        return result;
    }
}

export interface IHandoverNoteDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    handoverNoteType: DictionaryDto;
    shiftType: DictionaryDto;
    dateTime: Date;
    note: string | undefined;
}

export class HandoverNoteDtoPagedResultDto implements IHandoverNoteDtoPagedResultDto {
    items!: HandoverNoteDto[] | undefined;
    totalCount!: number;

    constructor(data?: IHandoverNoteDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HandoverNoteDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): HandoverNoteDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HandoverNoteDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): HandoverNoteDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HandoverNoteDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHandoverNoteDtoPagedResultDto {
    items: HandoverNoteDto[] | undefined;
    totalCount: number;
}

export class HistoryNoteDto implements IHistoryNoteDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    noteType!: DictionaryDto;
    note!: string | undefined;

    constructor(data?: IHistoryNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.noteType = _data["noteType"] ? DictionaryDto.fromJS(_data["noteType"]) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): HistoryNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["noteType"] = this.noteType ? this.noteType.toJSON() : <any>undefined;
        data["note"] = this.note;
        return data;
    }

    clone(): HistoryNoteDto {
        const json = this.toJSON();
        let result = new HistoryNoteDto();
        result.init(json);
        return result;
    }
}

export interface IHistoryNoteDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    noteType: DictionaryDto;
    note: string | undefined;
}

export class HistoryNoteDtoPagedResultDto implements IHistoryNoteDtoPagedResultDto {
    items!: HistoryNoteDto[] | undefined;
    totalCount!: number;

    constructor(data?: IHistoryNoteDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HistoryNoteDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): HistoryNoteDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryNoteDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): HistoryNoteDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HistoryNoteDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHistoryNoteDtoPagedResultDto {
    items: HistoryNoteDto[] | undefined;
    totalCount: number;
}

export class ICustomAttributeProvider implements IICustomAttributeProvider {

    constructor(data?: IICustomAttributeProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ICustomAttributeProvider {
        data = typeof data === 'object' ? data : {};
        let result = new ICustomAttributeProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ICustomAttributeProvider {
        const json = this.toJSON();
        let result = new ICustomAttributeProvider();
        result.init(json);
        return result;
    }
}

export interface IICustomAttributeProvider {
}

export class IdentityError implements IIdentityError {
    code!: string | undefined;
    description!: string | undefined;

    constructor(data?: IIdentityError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): IdentityError {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }

    clone(): IdentityError {
        const json = this.toJSON();
        let result = new IdentityError();
        result.init(json);
        return result;
    }
}

export interface IIdentityError {
    code: string | undefined;
    description: string | undefined;
}

export class IdentityResult implements IIdentityResult {
    readonly succeeded!: boolean;
    readonly errors!: IdentityError[] | undefined;

    constructor(data?: IIdentityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(IdentityError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdentityResult {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }

    clone(): IdentityResult {
        const json = this.toJSON();
        let result = new IdentityResult();
        result.init(json);
        return result;
    }
}

export interface IIdentityResult {
    succeeded: boolean;
    errors: IdentityError[] | undefined;
}

export class Int64EntityDto implements IInt64EntityDto {
    id!: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): Int64EntityDto {
        const json = this.toJSON();
        let result = new Int64EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class IntoleranceDto implements IIntoleranceDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    diagnosisDate!: Date;
    substance!: string | undefined;
    note!: string | undefined;
    isOther!: boolean;

    constructor(data?: IIntoleranceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.diagnosisDate = _data["diagnosisDate"] ? new Date(_data["diagnosisDate"].toString()) : <any>undefined;
            this.substance = _data["substance"];
            this.note = _data["note"];
            this.isOther = _data["isOther"];
        }
    }

    static fromJS(data: any): IntoleranceDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntoleranceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["diagnosisDate"] = this.diagnosisDate ? this.diagnosisDate.toISOString() : <any>undefined;
        data["substance"] = this.substance;
        data["note"] = this.note;
        data["isOther"] = this.isOther;
        return data;
    }

    clone(): IntoleranceDto {
        const json = this.toJSON();
        let result = new IntoleranceDto();
        result.init(json);
        return result;
    }
}

export interface IIntoleranceDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    diagnosisDate: Date;
    substance: string | undefined;
    note: string | undefined;
    isOther: boolean;
}

export class IntoleranceDtoPagedResultDto implements IIntoleranceDtoPagedResultDto {
    items!: IntoleranceDto[] | undefined;
    totalCount!: number;

    constructor(data?: IIntoleranceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IntoleranceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): IntoleranceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntoleranceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): IntoleranceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new IntoleranceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IIntoleranceDtoPagedResultDto {
    items: IntoleranceDto[] | undefined;
    totalCount: number;
}

export class IntPtr implements IIntPtr {

    constructor(data?: IIntPtr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IntPtr {
        data = typeof data === 'object' ? data : {};
        let result = new IntPtr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): IntPtr {
        const json = this.toJSON();
        let result = new IntPtr();
        result.init(json);
        return result;
    }
}

export interface IIntPtr {
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyUrl!: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyUrl = _data["tenancyUrl"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyUrl"] = this.tenancyUrl;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyUrl: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: TenantAvailabilityState;
    tenantId!: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export enum LayoutKind {
    _0 = 0,
    _2 = 2,
    _3 = 3,
}

export class LendMedicationStockInput implements ILendMedicationStockInput {
    medicationStockCode!: string;
    donorPatientId!: number;
    receiverAdministrationId!: number;

    constructor(data?: ILendMedicationStockInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicationStockCode = _data["medicationStockCode"];
            this.donorPatientId = _data["donorPatientId"];
            this.receiverAdministrationId = _data["receiverAdministrationId"];
        }
    }

    static fromJS(data: any): LendMedicationStockInput {
        data = typeof data === 'object' ? data : {};
        let result = new LendMedicationStockInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicationStockCode"] = this.medicationStockCode;
        data["donorPatientId"] = this.donorPatientId;
        data["receiverAdministrationId"] = this.receiverAdministrationId;
        return data;
    }

    clone(): LendMedicationStockInput {
        const json = this.toJSON();
        let result = new LendMedicationStockInput();
        result.init(json);
        return result;
    }
}

export interface ILendMedicationStockInput {
    medicationStockCode: string;
    donorPatientId: number;
    receiverAdministrationId: number;
}

export class LendMedicationStockResultDto implements ILendMedicationStockResultDto {
    loanId!: number;
    warning!: string | undefined;

    constructor(data?: ILendMedicationStockResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanId = _data["loanId"];
            this.warning = _data["warning"];
        }
    }

    static fromJS(data: any): LendMedicationStockResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LendMedicationStockResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanId"] = this.loanId;
        data["warning"] = this.warning;
        return data;
    }

    clone(): LendMedicationStockResultDto {
        const json = this.toJSON();
        let result = new LendMedicationStockResultDto();
        result.init(json);
        return result;
    }
}

export interface ILendMedicationStockResultDto {
    loanId: number;
    warning: string | undefined;
}

export class LinkPrescriptionDto implements ILinkPrescriptionDto {
    documentMedicationId!: number;
    patientMedicationAssignmentDetailIds!: number[] | undefined;
    patientMedicationTherapyIds!: number[] | undefined;

    constructor(data?: ILinkPrescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentMedicationId = _data["documentMedicationId"];
            if (Array.isArray(_data["patientMedicationAssignmentDetailIds"])) {
                this.patientMedicationAssignmentDetailIds = [] as any;
                for (let item of _data["patientMedicationAssignmentDetailIds"])
                    this.patientMedicationAssignmentDetailIds!.push(item);
            }
            if (Array.isArray(_data["patientMedicationTherapyIds"])) {
                this.patientMedicationTherapyIds = [] as any;
                for (let item of _data["patientMedicationTherapyIds"])
                    this.patientMedicationTherapyIds!.push(item);
            }
        }
    }

    static fromJS(data: any): LinkPrescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkPrescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentMedicationId"] = this.documentMedicationId;
        if (Array.isArray(this.patientMedicationAssignmentDetailIds)) {
            data["patientMedicationAssignmentDetailIds"] = [];
            for (let item of this.patientMedicationAssignmentDetailIds)
                data["patientMedicationAssignmentDetailIds"].push(item);
        }
        if (Array.isArray(this.patientMedicationTherapyIds)) {
            data["patientMedicationTherapyIds"] = [];
            for (let item of this.patientMedicationTherapyIds)
                data["patientMedicationTherapyIds"].push(item);
        }
        return data;
    }

    clone(): LinkPrescriptionDto {
        const json = this.toJSON();
        let result = new LinkPrescriptionDto();
        result.init(json);
        return result;
    }
}

export interface ILinkPrescriptionDto {
    documentMedicationId: number;
    patientMedicationAssignmentDetailIds: number[] | undefined;
    patientMedicationTherapyIds: number[] | undefined;
}

export class LoadPatientMedicationStockDto implements ILoadPatientMedicationStockDto {
    patientId!: number;
    operationalUnitId!: number;
    medicationId!: number;
    code!: string;
    totalQuantity!: number;
    expiryDate!: Date;
    batchNumber!: string | undefined;
    markingCode!: string | undefined;
    note!: string | undefined;
    documentMedicationIds!: number[] | undefined;

    constructor(data?: ILoadPatientMedicationStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.operationalUnitId = _data["operationalUnitId"];
            this.medicationId = _data["medicationId"];
            this.code = _data["code"];
            this.totalQuantity = _data["totalQuantity"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.batchNumber = _data["batchNumber"];
            this.markingCode = _data["markingCode"];
            this.note = _data["note"];
            if (Array.isArray(_data["documentMedicationIds"])) {
                this.documentMedicationIds = [] as any;
                for (let item of _data["documentMedicationIds"])
                    this.documentMedicationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): LoadPatientMedicationStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoadPatientMedicationStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["operationalUnitId"] = this.operationalUnitId;
        data["medicationId"] = this.medicationId;
        data["code"] = this.code;
        data["totalQuantity"] = this.totalQuantity;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["batchNumber"] = this.batchNumber;
        data["markingCode"] = this.markingCode;
        data["note"] = this.note;
        if (Array.isArray(this.documentMedicationIds)) {
            data["documentMedicationIds"] = [];
            for (let item of this.documentMedicationIds)
                data["documentMedicationIds"].push(item);
        }
        return data;
    }

    clone(): LoadPatientMedicationStockDto {
        const json = this.toJSON();
        let result = new LoadPatientMedicationStockDto();
        result.init(json);
        return result;
    }
}

export interface ILoadPatientMedicationStockDto {
    patientId: number;
    operationalUnitId: number;
    medicationId: number;
    code: string;
    totalQuantity: number;
    expiryDate: Date;
    batchNumber: string | undefined;
    markingCode: string | undefined;
    note: string | undefined;
    documentMedicationIds: number[] | undefined;
}

export class LoadStructureMedicationStockDto implements ILoadStructureMedicationStockDto {
    operationalUnitId!: number;
    medicationId!: number;
    code!: string | undefined;
    totalQuantity!: number;
    expiryDate!: Date;
    batchNumber!: string | undefined;
    markingCode!: string | undefined;
    note!: string | undefined;

    constructor(data?: ILoadStructureMedicationStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationalUnitId = _data["operationalUnitId"];
            this.medicationId = _data["medicationId"];
            this.code = _data["code"];
            this.totalQuantity = _data["totalQuantity"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.batchNumber = _data["batchNumber"];
            this.markingCode = _data["markingCode"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): LoadStructureMedicationStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoadStructureMedicationStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationalUnitId"] = this.operationalUnitId;
        data["medicationId"] = this.medicationId;
        data["code"] = this.code;
        data["totalQuantity"] = this.totalQuantity;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["batchNumber"] = this.batchNumber;
        data["markingCode"] = this.markingCode;
        data["note"] = this.note;
        return data;
    }

    clone(): LoadStructureMedicationStockDto {
        const json = this.toJSON();
        let result = new LoadStructureMedicationStockDto();
        result.init(json);
        return result;
    }
}

export interface ILoadStructureMedicationStockDto {
    operationalUnitId: number;
    medicationId: number;
    code: string | undefined;
    totalQuantity: number;
    expiryDate: Date;
    batchNumber: string | undefined;
    markingCode: string | undefined;
    note: string | undefined;
}

export class LoanCandidateRowDto implements ILoanCandidateRowDto {
    administrationId!: number;
    plannedDateTime!: Date;
    medicationId!: number;
    medicationName!: string | undefined;
    isEquivalent!: boolean;

    constructor(data?: ILoanCandidateRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.administrationId = _data["administrationId"];
            this.plannedDateTime = _data["plannedDateTime"] ? new Date(_data["plannedDateTime"].toString()) : <any>undefined;
            this.medicationId = _data["medicationId"];
            this.medicationName = _data["medicationName"];
            this.isEquivalent = _data["isEquivalent"];
        }
    }

    static fromJS(data: any): LoanCandidateRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoanCandidateRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["administrationId"] = this.administrationId;
        data["plannedDateTime"] = this.plannedDateTime ? this.plannedDateTime.toISOString() : <any>undefined;
        data["medicationId"] = this.medicationId;
        data["medicationName"] = this.medicationName;
        data["isEquivalent"] = this.isEquivalent;
        return data;
    }

    clone(): LoanCandidateRowDto {
        const json = this.toJSON();
        let result = new LoanCandidateRowDto();
        result.init(json);
        return result;
    }
}

export interface ILoanCandidateRowDto {
    administrationId: number;
    plannedDateTime: Date;
    medicationId: number;
    medicationName: string | undefined;
    isEquivalent: boolean;
}

export class MealCountDto implements IMealCountDto {
    mealMark!: DictionaryDto;
    count!: number;

    constructor(data?: IMealCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mealMark = _data["mealMark"] ? DictionaryDto.fromJS(_data["mealMark"]) : <any>undefined;
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): MealCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new MealCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mealMark"] = this.mealMark ? this.mealMark.toJSON() : <any>undefined;
        data["count"] = this.count;
        return data;
    }

    clone(): MealCountDto {
        const json = this.toJSON();
        let result = new MealCountDto();
        result.init(json);
        return result;
    }
}

export interface IMealCountDto {
    mealMark: DictionaryDto;
    count: number;
}

export class MealDto implements IMealDto {
    id!: number;
    mealMark!: DictionaryDto;
    date!: Date;
    note!: string | undefined;
    isActive!: boolean;

    constructor(data?: IMealDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mealMark = _data["mealMark"] ? DictionaryDto.fromJS(_data["mealMark"]) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MealDto {
        data = typeof data === 'object' ? data : {};
        let result = new MealDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mealMark"] = this.mealMark ? this.mealMark.toJSON() : <any>undefined;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): MealDto {
        const json = this.toJSON();
        let result = new MealDto();
        result.init(json);
        return result;
    }
}

export interface IMealDto {
    id: number;
    mealMark: DictionaryDto;
    date: Date;
    note: string | undefined;
    isActive: boolean;
}

export class MealSlotItemDto implements IMealSlotItemDto {
    mealSlot!: DictionaryDto;
    meals!: MealDto[] | undefined;

    constructor(data?: IMealSlotItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mealSlot = _data["mealSlot"] ? DictionaryDto.fromJS(_data["mealSlot"]) : <any>undefined;
            if (Array.isArray(_data["meals"])) {
                this.meals = [] as any;
                for (let item of _data["meals"])
                    this.meals!.push(MealDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MealSlotItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MealSlotItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mealSlot"] = this.mealSlot ? this.mealSlot.toJSON() : <any>undefined;
        if (Array.isArray(this.meals)) {
            data["meals"] = [];
            for (let item of this.meals)
                data["meals"].push(item.toJSON());
        }
        return data;
    }

    clone(): MealSlotItemDto {
        const json = this.toJSON();
        let result = new MealSlotItemDto();
        result.init(json);
        return result;
    }
}

export interface IMealSlotItemDto {
    mealSlot: DictionaryDto;
    meals: MealDto[] | undefined;
}

export class MedicalHistoryDto implements IMedicalHistoryDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    identifier!: string | undefined;
    patient!: PatientDto;
    physiologicalHistory!: PhysiologicalHistoryDto;
    aslContact!: AslContactDto;
    historyNotes!: HistoryNoteDto[] | undefined;
    familyHistory!: FamilyHistoryDto;
    dependencyHistory!: DependencyHistoryDto;
    clinicalSummaries!: ClinicalSummaryDto[] | undefined;
    psychiatricProfiles!: PsychiatricProfileDto[] | undefined;
    forensicProfile!: ForensicProfileDto;
    psychiatricAdmissionExam!: PsychiatricAdmissionExamDto;
    isPrimaryDiagnosisMissing!: boolean;
    primaryDiagnosisCountdownStartDate!: Date | undefined;

    constructor(data?: IMedicalHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.identifier = _data["identifier"];
            this.patient = _data["patient"] ? PatientDto.fromJS(_data["patient"]) : <any>undefined;
            this.physiologicalHistory = _data["physiologicalHistory"] ? PhysiologicalHistoryDto.fromJS(_data["physiologicalHistory"]) : <any>undefined;
            this.aslContact = _data["aslContact"] ? AslContactDto.fromJS(_data["aslContact"]) : <any>undefined;
            if (Array.isArray(_data["historyNotes"])) {
                this.historyNotes = [] as any;
                for (let item of _data["historyNotes"])
                    this.historyNotes!.push(HistoryNoteDto.fromJS(item));
            }
            this.familyHistory = _data["familyHistory"] ? FamilyHistoryDto.fromJS(_data["familyHistory"]) : <any>undefined;
            this.dependencyHistory = _data["dependencyHistory"] ? DependencyHistoryDto.fromJS(_data["dependencyHistory"]) : <any>undefined;
            if (Array.isArray(_data["clinicalSummaries"])) {
                this.clinicalSummaries = [] as any;
                for (let item of _data["clinicalSummaries"])
                    this.clinicalSummaries!.push(ClinicalSummaryDto.fromJS(item));
            }
            if (Array.isArray(_data["psychiatricProfiles"])) {
                this.psychiatricProfiles = [] as any;
                for (let item of _data["psychiatricProfiles"])
                    this.psychiatricProfiles!.push(PsychiatricProfileDto.fromJS(item));
            }
            this.forensicProfile = _data["forensicProfile"] ? ForensicProfileDto.fromJS(_data["forensicProfile"]) : <any>undefined;
            this.psychiatricAdmissionExam = _data["psychiatricAdmissionExam"] ? PsychiatricAdmissionExamDto.fromJS(_data["psychiatricAdmissionExam"]) : <any>undefined;
            this.isPrimaryDiagnosisMissing = _data["isPrimaryDiagnosisMissing"];
            this.primaryDiagnosisCountdownStartDate = _data["primaryDiagnosisCountdownStartDate"] ? new Date(_data["primaryDiagnosisCountdownStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MedicalHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["identifier"] = this.identifier;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["physiologicalHistory"] = this.physiologicalHistory ? this.physiologicalHistory.toJSON() : <any>undefined;
        data["aslContact"] = this.aslContact ? this.aslContact.toJSON() : <any>undefined;
        if (Array.isArray(this.historyNotes)) {
            data["historyNotes"] = [];
            for (let item of this.historyNotes)
                data["historyNotes"].push(item.toJSON());
        }
        data["familyHistory"] = this.familyHistory ? this.familyHistory.toJSON() : <any>undefined;
        data["dependencyHistory"] = this.dependencyHistory ? this.dependencyHistory.toJSON() : <any>undefined;
        if (Array.isArray(this.clinicalSummaries)) {
            data["clinicalSummaries"] = [];
            for (let item of this.clinicalSummaries)
                data["clinicalSummaries"].push(item.toJSON());
        }
        if (Array.isArray(this.psychiatricProfiles)) {
            data["psychiatricProfiles"] = [];
            for (let item of this.psychiatricProfiles)
                data["psychiatricProfiles"].push(item.toJSON());
        }
        data["forensicProfile"] = this.forensicProfile ? this.forensicProfile.toJSON() : <any>undefined;
        data["psychiatricAdmissionExam"] = this.psychiatricAdmissionExam ? this.psychiatricAdmissionExam.toJSON() : <any>undefined;
        data["isPrimaryDiagnosisMissing"] = this.isPrimaryDiagnosisMissing;
        data["primaryDiagnosisCountdownStartDate"] = this.primaryDiagnosisCountdownStartDate ? this.primaryDiagnosisCountdownStartDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): MedicalHistoryDto {
        const json = this.toJSON();
        let result = new MedicalHistoryDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalHistoryDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    identifier: string | undefined;
    patient: PatientDto;
    physiologicalHistory: PhysiologicalHistoryDto;
    aslContact: AslContactDto;
    historyNotes: HistoryNoteDto[] | undefined;
    familyHistory: FamilyHistoryDto;
    dependencyHistory: DependencyHistoryDto;
    clinicalSummaries: ClinicalSummaryDto[] | undefined;
    psychiatricProfiles: PsychiatricProfileDto[] | undefined;
    forensicProfile: ForensicProfileDto;
    psychiatricAdmissionExam: PsychiatricAdmissionExamDto;
    isPrimaryDiagnosisMissing: boolean;
    primaryDiagnosisCountdownStartDate: Date | undefined;
}

export class MedicalHistoryDtoPagedResultDto implements IMedicalHistoryDtoPagedResultDto {
    items!: MedicalHistoryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMedicalHistoryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MedicalHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MedicalHistoryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalHistoryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MedicalHistoryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MedicalHistoryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalHistoryDtoPagedResultDto {
    items: MedicalHistoryDto[] | undefined;
    totalCount: number;
}

export class MedicalHistoryFileDto implements IMedicalHistoryFileDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    allergyId!: number | undefined;
    intoleranceId!: number | undefined;
    file!: FileDto;

    constructor(data?: IMedicalHistoryFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.allergyId = _data["allergyId"];
            this.intoleranceId = _data["intoleranceId"];
            this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MedicalHistoryFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalHistoryFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["allergyId"] = this.allergyId;
        data["intoleranceId"] = this.intoleranceId;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }

    clone(): MedicalHistoryFileDto {
        const json = this.toJSON();
        let result = new MedicalHistoryFileDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalHistoryFileDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    allergyId: number | undefined;
    intoleranceId: number | undefined;
    file: FileDto;
}

export class MedicalHistoryFileDtoPagedResultDto implements IMedicalHistoryFileDtoPagedResultDto {
    items!: MedicalHistoryFileDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMedicalHistoryFileDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MedicalHistoryFileDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MedicalHistoryFileDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalHistoryFileDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MedicalHistoryFileDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MedicalHistoryFileDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMedicalHistoryFileDtoPagedResultDto {
    items: MedicalHistoryFileDto[] | undefined;
    totalCount: number;
}

export class MedicationBarcodeDto implements IMedicationBarcodeDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    code!: string | undefined;
    medicationId!: number;

    constructor(data?: IMedicationBarcodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.code = _data["code"];
            this.medicationId = _data["medicationId"];
        }
    }

    static fromJS(data: any): MedicationBarcodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationBarcodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["medicationId"] = this.medicationId;
        return data;
    }

    clone(): MedicationBarcodeDto {
        const json = this.toJSON();
        let result = new MedicationBarcodeDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationBarcodeDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    code: string | undefined;
    medicationId: number;
}

export class MedicationBarcodeDtoPagedResultDto implements IMedicationBarcodeDtoPagedResultDto {
    items!: MedicationBarcodeDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMedicationBarcodeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MedicationBarcodeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MedicationBarcodeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationBarcodeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MedicationBarcodeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MedicationBarcodeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationBarcodeDtoPagedResultDto {
    items: MedicationBarcodeDto[] | undefined;
    totalCount: number;
}

export class MedicationDto implements IMedicationDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    identifier!: string | undefined;
    name!: string | undefined;
    officialName!: string | undefined;
    manufacturer!: string | undefined;
    productCode!: string | undefined;
    eanCode!: string | undefined;
    atcCode!: string | undefined;
    cufNoteNumber!: string | undefined;
    identificationCode!: string | undefined;
    medicationPharmaceuticalFormType!: DictionaryDto;
    medicationPackagingType!: DictionaryDto;
    medicationStrengthUnitType!: DictionaryDto;
    packageQuantity!: number;
    strengthValue!: number | undefined;
    drugClass!: string | undefined;
    productType!: string | undefined;
    prescriptionCategory!: string | undefined;
    prescribability!: string | undefined;
    pharmacotherapeuticCategory!: string | undefined;
    pharmaceuticalForm!: string | undefined;
    pharmaceuticalFormDetail!: string | undefined;
    storageTemperature!: string | undefined;
    activeIngredientDescription!: string | undefined;
    activeIngredients!: string | undefined;
    excipients!: string | undefined;
    indications!: string | undefined;
    contraindicationsAndSideEffects!: string | undefined;
    posology!: string | undefined;
    precautions!: string | undefined;
    warnings!: string | undefined;
    interactions!: string | undefined;
    undesirableEffects!: string | undefined;
    pregnancyAndLactation!: string | undefined;
    isActive!: boolean;
    requiresDoubleCheck!: boolean;
    equivalentMedications!: SimpleMedicationDto[] | undefined;

    constructor(data?: IMedicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.officialName = _data["officialName"];
            this.manufacturer = _data["manufacturer"];
            this.productCode = _data["productCode"];
            this.eanCode = _data["eanCode"];
            this.atcCode = _data["atcCode"];
            this.cufNoteNumber = _data["cufNoteNumber"];
            this.identificationCode = _data["identificationCode"];
            this.medicationPharmaceuticalFormType = _data["medicationPharmaceuticalFormType"] ? DictionaryDto.fromJS(_data["medicationPharmaceuticalFormType"]) : <any>undefined;
            this.medicationPackagingType = _data["medicationPackagingType"] ? DictionaryDto.fromJS(_data["medicationPackagingType"]) : <any>undefined;
            this.medicationStrengthUnitType = _data["medicationStrengthUnitType"] ? DictionaryDto.fromJS(_data["medicationStrengthUnitType"]) : <any>undefined;
            this.packageQuantity = _data["packageQuantity"];
            this.strengthValue = _data["strengthValue"];
            this.drugClass = _data["drugClass"];
            this.productType = _data["productType"];
            this.prescriptionCategory = _data["prescriptionCategory"];
            this.prescribability = _data["prescribability"];
            this.pharmacotherapeuticCategory = _data["pharmacotherapeuticCategory"];
            this.pharmaceuticalForm = _data["pharmaceuticalForm"];
            this.pharmaceuticalFormDetail = _data["pharmaceuticalFormDetail"];
            this.storageTemperature = _data["storageTemperature"];
            this.activeIngredientDescription = _data["activeIngredientDescription"];
            this.activeIngredients = _data["activeIngredients"];
            this.excipients = _data["excipients"];
            this.indications = _data["indications"];
            this.contraindicationsAndSideEffects = _data["contraindicationsAndSideEffects"];
            this.posology = _data["posology"];
            this.precautions = _data["precautions"];
            this.warnings = _data["warnings"];
            this.interactions = _data["interactions"];
            this.undesirableEffects = _data["undesirableEffects"];
            this.pregnancyAndLactation = _data["pregnancyAndLactation"];
            this.isActive = _data["isActive"];
            this.requiresDoubleCheck = _data["requiresDoubleCheck"];
            if (Array.isArray(_data["equivalentMedications"])) {
                this.equivalentMedications = [] as any;
                for (let item of _data["equivalentMedications"])
                    this.equivalentMedications!.push(SimpleMedicationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["officialName"] = this.officialName;
        data["manufacturer"] = this.manufacturer;
        data["productCode"] = this.productCode;
        data["eanCode"] = this.eanCode;
        data["atcCode"] = this.atcCode;
        data["cufNoteNumber"] = this.cufNoteNumber;
        data["identificationCode"] = this.identificationCode;
        data["medicationPharmaceuticalFormType"] = this.medicationPharmaceuticalFormType ? this.medicationPharmaceuticalFormType.toJSON() : <any>undefined;
        data["medicationPackagingType"] = this.medicationPackagingType ? this.medicationPackagingType.toJSON() : <any>undefined;
        data["medicationStrengthUnitType"] = this.medicationStrengthUnitType ? this.medicationStrengthUnitType.toJSON() : <any>undefined;
        data["packageQuantity"] = this.packageQuantity;
        data["strengthValue"] = this.strengthValue;
        data["drugClass"] = this.drugClass;
        data["productType"] = this.productType;
        data["prescriptionCategory"] = this.prescriptionCategory;
        data["prescribability"] = this.prescribability;
        data["pharmacotherapeuticCategory"] = this.pharmacotherapeuticCategory;
        data["pharmaceuticalForm"] = this.pharmaceuticalForm;
        data["pharmaceuticalFormDetail"] = this.pharmaceuticalFormDetail;
        data["storageTemperature"] = this.storageTemperature;
        data["activeIngredientDescription"] = this.activeIngredientDescription;
        data["activeIngredients"] = this.activeIngredients;
        data["excipients"] = this.excipients;
        data["indications"] = this.indications;
        data["contraindicationsAndSideEffects"] = this.contraindicationsAndSideEffects;
        data["posology"] = this.posology;
        data["precautions"] = this.precautions;
        data["warnings"] = this.warnings;
        data["interactions"] = this.interactions;
        data["undesirableEffects"] = this.undesirableEffects;
        data["pregnancyAndLactation"] = this.pregnancyAndLactation;
        data["isActive"] = this.isActive;
        data["requiresDoubleCheck"] = this.requiresDoubleCheck;
        if (Array.isArray(this.equivalentMedications)) {
            data["equivalentMedications"] = [];
            for (let item of this.equivalentMedications)
                data["equivalentMedications"].push(item.toJSON());
        }
        return data;
    }

    clone(): MedicationDto {
        const json = this.toJSON();
        let result = new MedicationDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    identifier: string | undefined;
    name: string | undefined;
    officialName: string | undefined;
    manufacturer: string | undefined;
    productCode: string | undefined;
    eanCode: string | undefined;
    atcCode: string | undefined;
    cufNoteNumber: string | undefined;
    identificationCode: string | undefined;
    medicationPharmaceuticalFormType: DictionaryDto;
    medicationPackagingType: DictionaryDto;
    medicationStrengthUnitType: DictionaryDto;
    packageQuantity: number;
    strengthValue: number | undefined;
    drugClass: string | undefined;
    productType: string | undefined;
    prescriptionCategory: string | undefined;
    prescribability: string | undefined;
    pharmacotherapeuticCategory: string | undefined;
    pharmaceuticalForm: string | undefined;
    pharmaceuticalFormDetail: string | undefined;
    storageTemperature: string | undefined;
    activeIngredientDescription: string | undefined;
    activeIngredients: string | undefined;
    excipients: string | undefined;
    indications: string | undefined;
    contraindicationsAndSideEffects: string | undefined;
    posology: string | undefined;
    precautions: string | undefined;
    warnings: string | undefined;
    interactions: string | undefined;
    undesirableEffects: string | undefined;
    pregnancyAndLactation: string | undefined;
    isActive: boolean;
    requiresDoubleCheck: boolean;
    equivalentMedications: SimpleMedicationDto[] | undefined;
}

export class MedicationImportLog implements IMedicationImportLog {
    totalRows!: number;
    medicationsCreated!: number;
    medicationsUpdated!: number;
    medicationsSkippedInactive!: number;
    medicationsSkippedInvalidKey!: number;
    equivalencesCreatedOrUpdated!: number;
    equivalencesSkippedManual!: number;
    errors!: string[] | undefined;

    constructor(data?: IMedicationImportLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            this.medicationsCreated = _data["medicationsCreated"];
            this.medicationsUpdated = _data["medicationsUpdated"];
            this.medicationsSkippedInactive = _data["medicationsSkippedInactive"];
            this.medicationsSkippedInvalidKey = _data["medicationsSkippedInvalidKey"];
            this.equivalencesCreatedOrUpdated = _data["equivalencesCreatedOrUpdated"];
            this.equivalencesSkippedManual = _data["equivalencesSkippedManual"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): MedicationImportLog {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationImportLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        data["medicationsCreated"] = this.medicationsCreated;
        data["medicationsUpdated"] = this.medicationsUpdated;
        data["medicationsSkippedInactive"] = this.medicationsSkippedInactive;
        data["medicationsSkippedInvalidKey"] = this.medicationsSkippedInvalidKey;
        data["equivalencesCreatedOrUpdated"] = this.equivalencesCreatedOrUpdated;
        data["equivalencesSkippedManual"] = this.equivalencesSkippedManual;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }

    clone(): MedicationImportLog {
        const json = this.toJSON();
        let result = new MedicationImportLog();
        result.init(json);
        return result;
    }
}

export interface IMedicationImportLog {
    totalRows: number;
    medicationsCreated: number;
    medicationsUpdated: number;
    medicationsSkippedInactive: number;
    medicationsSkippedInvalidKey: number;
    equivalencesCreatedOrUpdated: number;
    equivalencesSkippedManual: number;
    errors: string[] | undefined;
}

export class MedicationItemDto implements IMedicationItemDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    name!: string | undefined;
    identifier!: string | undefined;
    manufacturer!: string | undefined;
    packageQuantity!: number;
    strengthValue!: number | undefined;
    medicationStrengthUnitTypeDescription!: string | undefined;
    medicationPharmaceuticalFormTypeDescription!: string | undefined;
    activeIngredients!: string | undefined;
    isActive!: boolean;
    equivalentMedications!: SimpleMedicationDto[] | undefined;

    constructor(data?: IMedicationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.manufacturer = _data["manufacturer"];
            this.packageQuantity = _data["packageQuantity"];
            this.strengthValue = _data["strengthValue"];
            this.medicationStrengthUnitTypeDescription = _data["medicationStrengthUnitTypeDescription"];
            this.medicationPharmaceuticalFormTypeDescription = _data["medicationPharmaceuticalFormTypeDescription"];
            this.activeIngredients = _data["activeIngredients"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["equivalentMedications"])) {
                this.equivalentMedications = [] as any;
                for (let item of _data["equivalentMedications"])
                    this.equivalentMedications!.push(SimpleMedicationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["manufacturer"] = this.manufacturer;
        data["packageQuantity"] = this.packageQuantity;
        data["strengthValue"] = this.strengthValue;
        data["medicationStrengthUnitTypeDescription"] = this.medicationStrengthUnitTypeDescription;
        data["medicationPharmaceuticalFormTypeDescription"] = this.medicationPharmaceuticalFormTypeDescription;
        data["activeIngredients"] = this.activeIngredients;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.equivalentMedications)) {
            data["equivalentMedications"] = [];
            for (let item of this.equivalentMedications)
                data["equivalentMedications"].push(item.toJSON());
        }
        return data;
    }

    clone(): MedicationItemDto {
        const json = this.toJSON();
        let result = new MedicationItemDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationItemDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    name: string | undefined;
    identifier: string | undefined;
    manufacturer: string | undefined;
    packageQuantity: number;
    strengthValue: number | undefined;
    medicationStrengthUnitTypeDescription: string | undefined;
    medicationPharmaceuticalFormTypeDescription: string | undefined;
    activeIngredients: string | undefined;
    isActive: boolean;
    equivalentMedications: SimpleMedicationDto[] | undefined;
}

export class MedicationItemDtoPagedResultDto implements IMedicationItemDtoPagedResultDto {
    items!: MedicationItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMedicationItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MedicationItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MedicationItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MedicationItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MedicationItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationItemDtoPagedResultDto {
    items: MedicationItemDto[] | undefined;
    totalCount: number;
}

export class MedicationOrderDetailDto implements IMedicationOrderDetailDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    medication!: MedicationItemDto;
    quantity!: number;
    remainingQuantity!: number | undefined;
    recommendedQuantity!: number | undefined;
    note!: string | undefined;

    constructor(data?: IMedicationOrderDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.medication = _data["medication"] ? MedicationItemDto.fromJS(_data["medication"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.remainingQuantity = _data["remainingQuantity"];
            this.recommendedQuantity = _data["recommendedQuantity"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): MedicationOrderDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationOrderDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["remainingQuantity"] = this.remainingQuantity;
        data["recommendedQuantity"] = this.recommendedQuantity;
        data["note"] = this.note;
        return data;
    }

    clone(): MedicationOrderDetailDto {
        const json = this.toJSON();
        let result = new MedicationOrderDetailDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationOrderDetailDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    medication: MedicationItemDto;
    quantity: number;
    remainingQuantity: number | undefined;
    recommendedQuantity: number | undefined;
    note: string | undefined;
}

export class MedicationOrderDetailDtoPagedResultDto implements IMedicationOrderDetailDtoPagedResultDto {
    items!: MedicationOrderDetailDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMedicationOrderDetailDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MedicationOrderDetailDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MedicationOrderDetailDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationOrderDetailDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MedicationOrderDetailDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MedicationOrderDetailDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationOrderDetailDtoPagedResultDto {
    items: MedicationOrderDetailDto[] | undefined;
    totalCount: number;
}

export class MedicationOrderDto implements IMedicationOrderDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    orderNumber!: string | undefined;
    orderDate!: Date;
    orderStatus!: DictionaryDto;
    isActive!: boolean;
    note!: string | undefined;
    sentAt!: Date | undefined;
    medicationOrderDetails!: MedicationOrderDetailDto[] | undefined;

    constructor(data?: IMedicationOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.orderNumber = _data["orderNumber"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.orderStatus = _data["orderStatus"] ? DictionaryDto.fromJS(_data["orderStatus"]) : <any>undefined;
            this.isActive = _data["isActive"];
            this.note = _data["note"];
            this.sentAt = _data["sentAt"] ? new Date(_data["sentAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["medicationOrderDetails"])) {
                this.medicationOrderDetails = [] as any;
                for (let item of _data["medicationOrderDetails"])
                    this.medicationOrderDetails!.push(MedicationOrderDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicationOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["orderNumber"] = this.orderNumber;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["orderStatus"] = this.orderStatus ? this.orderStatus.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["note"] = this.note;
        data["sentAt"] = this.sentAt ? this.sentAt.toISOString() : <any>undefined;
        if (Array.isArray(this.medicationOrderDetails)) {
            data["medicationOrderDetails"] = [];
            for (let item of this.medicationOrderDetails)
                data["medicationOrderDetails"].push(item.toJSON());
        }
        return data;
    }

    clone(): MedicationOrderDto {
        const json = this.toJSON();
        let result = new MedicationOrderDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationOrderDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    orderNumber: string | undefined;
    orderDate: Date;
    orderStatus: DictionaryDto;
    isActive: boolean;
    note: string | undefined;
    sentAt: Date | undefined;
    medicationOrderDetails: MedicationOrderDetailDto[] | undefined;
}

export class MedicationOrderDtoPagedResultDto implements IMedicationOrderDtoPagedResultDto {
    items!: MedicationOrderDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMedicationOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MedicationOrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MedicationOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MedicationOrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MedicationOrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationOrderDtoPagedResultDto {
    items: MedicationOrderDto[] | undefined;
    totalCount: number;
}

export class MedicationStockCodeDto implements IMedicationStockCodeDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    code!: string | undefined;
    medicationStockId!: number | undefined;
    medicationStockMedicationName!: string | undefined;
    printedAt!: Date | undefined;

    constructor(data?: IMedicationStockCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.code = _data["code"];
            this.medicationStockId = _data["medicationStockId"];
            this.medicationStockMedicationName = _data["medicationStockMedicationName"];
            this.printedAt = _data["printedAt"] ? new Date(_data["printedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MedicationStockCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationStockCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["medicationStockId"] = this.medicationStockId;
        data["medicationStockMedicationName"] = this.medicationStockMedicationName;
        data["printedAt"] = this.printedAt ? this.printedAt.toISOString() : <any>undefined;
        return data;
    }

    clone(): MedicationStockCodeDto {
        const json = this.toJSON();
        let result = new MedicationStockCodeDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationStockCodeDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    code: string | undefined;
    medicationStockId: number | undefined;
    medicationStockMedicationName: string | undefined;
    printedAt: Date | undefined;
}

export class MedicationStockCodeDtoPagedResultDto implements IMedicationStockCodeDtoPagedResultDto {
    items!: MedicationStockCodeDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMedicationStockCodeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MedicationStockCodeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MedicationStockCodeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationStockCodeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MedicationStockCodeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MedicationStockCodeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationStockCodeDtoPagedResultDto {
    items: MedicationStockCodeDto[] | undefined;
    totalCount: number;
}

export class MedicationStockCodeLookupDto implements IMedicationStockCodeLookupDto {
    scannedCode!: string | undefined;
    isEanCodeMatch!: boolean;
    medicationStock!: MedicationStockDto;
    medication!: SimpleMedicationDto;
    assignedPatients!: SimplePatientDto[] | undefined;
    labelStatus!: string | undefined;

    constructor(data?: IMedicationStockCodeLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scannedCode = _data["scannedCode"];
            this.isEanCodeMatch = _data["isEanCodeMatch"];
            this.medicationStock = _data["medicationStock"] ? MedicationStockDto.fromJS(_data["medicationStock"]) : <any>undefined;
            this.medication = _data["medication"] ? SimpleMedicationDto.fromJS(_data["medication"]) : <any>undefined;
            if (Array.isArray(_data["assignedPatients"])) {
                this.assignedPatients = [] as any;
                for (let item of _data["assignedPatients"])
                    this.assignedPatients!.push(SimplePatientDto.fromJS(item));
            }
            this.labelStatus = _data["labelStatus"];
        }
    }

    static fromJS(data: any): MedicationStockCodeLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationStockCodeLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scannedCode"] = this.scannedCode;
        data["isEanCodeMatch"] = this.isEanCodeMatch;
        data["medicationStock"] = this.medicationStock ? this.medicationStock.toJSON() : <any>undefined;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedPatients)) {
            data["assignedPatients"] = [];
            for (let item of this.assignedPatients)
                data["assignedPatients"].push(item.toJSON());
        }
        data["labelStatus"] = this.labelStatus;
        return data;
    }

    clone(): MedicationStockCodeLookupDto {
        const json = this.toJSON();
        let result = new MedicationStockCodeLookupDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationStockCodeLookupDto {
    scannedCode: string | undefined;
    isEanCodeMatch: boolean;
    medicationStock: MedicationStockDto;
    medication: SimpleMedicationDto;
    assignedPatients: SimplePatientDto[] | undefined;
    labelStatus: string | undefined;
}

export class MedicationStockDto implements IMedicationStockDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    medication!: MedicationItemDto;
    label!: string | undefined;
    boxCode!: string | undefined;
    totalQuantity!: number;
    assignedQuantity!: number;
    readonly availableQuantity!: number;
    expiryDate!: Date;
    note!: string | undefined;
    totalSubUnits!: number | undefined;
    assignedSubUnits!: number | undefined;
    batchNumber!: string | undefined;
    markingCode!: string | undefined;
    medicationStockLocationStaticCode!: string | undefined;
    assignments!: SimplePatientAssignmentDto[] | undefined;
    medicationStockCodes!: MedicationStockCodeDto[] | undefined;
    remainingUnits!: number | undefined;

    constructor(data?: IMedicationStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.medication = _data["medication"] ? MedicationItemDto.fromJS(_data["medication"]) : <any>undefined;
            this.label = _data["label"];
            this.boxCode = _data["boxCode"];
            this.totalQuantity = _data["totalQuantity"];
            this.assignedQuantity = _data["assignedQuantity"];
            (<any>this).availableQuantity = _data["availableQuantity"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.totalSubUnits = _data["totalSubUnits"];
            this.assignedSubUnits = _data["assignedSubUnits"];
            this.batchNumber = _data["batchNumber"];
            this.markingCode = _data["markingCode"];
            this.medicationStockLocationStaticCode = _data["medicationStockLocationStaticCode"];
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(SimplePatientAssignmentDto.fromJS(item));
            }
            if (Array.isArray(_data["medicationStockCodes"])) {
                this.medicationStockCodes = [] as any;
                for (let item of _data["medicationStockCodes"])
                    this.medicationStockCodes!.push(MedicationStockCodeDto.fromJS(item));
            }
            this.remainingUnits = _data["remainingUnits"];
        }
    }

    static fromJS(data: any): MedicationStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        data["label"] = this.label;
        data["boxCode"] = this.boxCode;
        data["totalQuantity"] = this.totalQuantity;
        data["assignedQuantity"] = this.assignedQuantity;
        data["availableQuantity"] = this.availableQuantity;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["totalSubUnits"] = this.totalSubUnits;
        data["assignedSubUnits"] = this.assignedSubUnits;
        data["batchNumber"] = this.batchNumber;
        data["markingCode"] = this.markingCode;
        data["medicationStockLocationStaticCode"] = this.medicationStockLocationStaticCode;
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item.toJSON());
        }
        if (Array.isArray(this.medicationStockCodes)) {
            data["medicationStockCodes"] = [];
            for (let item of this.medicationStockCodes)
                data["medicationStockCodes"].push(item.toJSON());
        }
        data["remainingUnits"] = this.remainingUnits;
        return data;
    }

    clone(): MedicationStockDto {
        const json = this.toJSON();
        let result = new MedicationStockDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationStockDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    medication: MedicationItemDto;
    label: string | undefined;
    boxCode: string | undefined;
    totalQuantity: number;
    assignedQuantity: number;
    availableQuantity: number;
    expiryDate: Date;
    note: string | undefined;
    totalSubUnits: number | undefined;
    assignedSubUnits: number | undefined;
    batchNumber: string | undefined;
    markingCode: string | undefined;
    medicationStockLocationStaticCode: string | undefined;
    assignments: SimplePatientAssignmentDto[] | undefined;
    medicationStockCodes: MedicationStockCodeDto[] | undefined;
    remainingUnits: number | undefined;
}

export class MedicationStockDtoPagedResultDto implements IMedicationStockDtoPagedResultDto {
    items!: MedicationStockDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMedicationStockDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MedicationStockDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MedicationStockDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationStockDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MedicationStockDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MedicationStockDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationStockDtoPagedResultDto {
    items: MedicationStockDto[] | undefined;
    totalCount: number;
}

export class MedicationStockExpirationDto implements IMedicationStockExpirationDto {
    id!: number;
    medication!: SimpleMedicationDto;
    label!: string | undefined;
    batchNumber!: string | undefined;
    expiryDate!: Date;
    totalQuantity!: number;
    isInCart!: boolean;
    patient!: SimplePatientDto;
    isFacilityStock!: boolean;
    expirationStatusStaticCode!: string | undefined;

    constructor(data?: IMedicationStockExpirationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.medication = _data["medication"] ? SimpleMedicationDto.fromJS(_data["medication"]) : <any>undefined;
            this.label = _data["label"];
            this.batchNumber = _data["batchNumber"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.totalQuantity = _data["totalQuantity"];
            this.isInCart = _data["isInCart"];
            this.patient = _data["patient"] ? SimplePatientDto.fromJS(_data["patient"]) : <any>undefined;
            this.isFacilityStock = _data["isFacilityStock"];
            this.expirationStatusStaticCode = _data["expirationStatusStaticCode"];
        }
    }

    static fromJS(data: any): MedicationStockExpirationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationStockExpirationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        data["label"] = this.label;
        data["batchNumber"] = this.batchNumber;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["totalQuantity"] = this.totalQuantity;
        data["isInCart"] = this.isInCart;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["isFacilityStock"] = this.isFacilityStock;
        data["expirationStatusStaticCode"] = this.expirationStatusStaticCode;
        return data;
    }

    clone(): MedicationStockExpirationDto {
        const json = this.toJSON();
        let result = new MedicationStockExpirationDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationStockExpirationDto {
    id: number;
    medication: SimpleMedicationDto;
    label: string | undefined;
    batchNumber: string | undefined;
    expiryDate: Date;
    totalQuantity: number;
    isInCart: boolean;
    patient: SimplePatientDto;
    isFacilityStock: boolean;
    expirationStatusStaticCode: string | undefined;
}

export class MedicationStockExpirationDtoPagedResultDto implements IMedicationStockExpirationDtoPagedResultDto {
    items!: MedicationStockExpirationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMedicationStockExpirationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MedicationStockExpirationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MedicationStockExpirationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationStockExpirationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MedicationStockExpirationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MedicationStockExpirationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationStockExpirationDtoPagedResultDto {
    items: MedicationStockExpirationDto[] | undefined;
    totalCount: number;
}

export class MedicationStockReasonDto implements IMedicationStockReasonDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;
    isStatic!: boolean;
    applicableToUnitIncrease!: boolean;
    applicableToUnitDecrease!: boolean;
    applicableToPackageDischarge!: boolean;

    constructor(data?: IMedicationStockReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
            this.isStatic = _data["isStatic"];
            this.applicableToUnitIncrease = _data["applicableToUnitIncrease"];
            this.applicableToUnitDecrease = _data["applicableToUnitDecrease"];
            this.applicableToPackageDischarge = _data["applicableToPackageDischarge"];
        }
    }

    static fromJS(data: any): MedicationStockReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationStockReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        data["isStatic"] = this.isStatic;
        data["applicableToUnitIncrease"] = this.applicableToUnitIncrease;
        data["applicableToUnitDecrease"] = this.applicableToUnitDecrease;
        data["applicableToPackageDischarge"] = this.applicableToPackageDischarge;
        return data;
    }

    clone(): MedicationStockReasonDto {
        const json = this.toJSON();
        let result = new MedicationStockReasonDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationStockReasonDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
    isStatic: boolean;
    applicableToUnitIncrease: boolean;
    applicableToUnitDecrease: boolean;
    applicableToPackageDischarge: boolean;
}

export class MedicationStockReasonDtoPagedResultDto implements IMedicationStockReasonDtoPagedResultDto {
    items!: MedicationStockReasonDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMedicationStockReasonDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MedicationStockReasonDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MedicationStockReasonDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationStockReasonDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MedicationStockReasonDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MedicationStockReasonDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationStockReasonDtoPagedResultDto {
    items: MedicationStockReasonDto[] | undefined;
    totalCount: number;
}

export class MedicationUnderStockDto implements IMedicationUnderStockDto {
    id!: number;
    medication!: MedicationItemDto;
    expiryDate!: Date | undefined;
    remainingQuantity!: number;
    assignedQuantity!: number;
    availableQuantity!: number;
    underStock!: number;
    recommendedPackages!: number;
    quantityToOrder!: number;
    packageQuantity!: number;

    constructor(data?: IMedicationUnderStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.medication = _data["medication"] ? MedicationItemDto.fromJS(_data["medication"]) : <any>undefined;
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.remainingQuantity = _data["remainingQuantity"];
            this.assignedQuantity = _data["assignedQuantity"];
            this.availableQuantity = _data["availableQuantity"];
            this.underStock = _data["underStock"];
            this.recommendedPackages = _data["recommendedPackages"];
            this.quantityToOrder = _data["quantityToOrder"];
            this.packageQuantity = _data["packageQuantity"];
        }
    }

    static fromJS(data: any): MedicationUnderStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationUnderStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["remainingQuantity"] = this.remainingQuantity;
        data["assignedQuantity"] = this.assignedQuantity;
        data["availableQuantity"] = this.availableQuantity;
        data["underStock"] = this.underStock;
        data["recommendedPackages"] = this.recommendedPackages;
        data["quantityToOrder"] = this.quantityToOrder;
        data["packageQuantity"] = this.packageQuantity;
        return data;
    }

    clone(): MedicationUnderStockDto {
        const json = this.toJSON();
        let result = new MedicationUnderStockDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationUnderStockDto {
    id: number;
    medication: MedicationItemDto;
    expiryDate: Date | undefined;
    remainingQuantity: number;
    assignedQuantity: number;
    availableQuantity: number;
    underStock: number;
    recommendedPackages: number;
    quantityToOrder: number;
    packageQuantity: number;
}

export class MedicationUnderStockDtoPagedResultDto implements IMedicationUnderStockDtoPagedResultDto {
    items!: MedicationUnderStockDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMedicationUnderStockDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MedicationUnderStockDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MedicationUnderStockDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationUnderStockDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MedicationUnderStockDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MedicationUnderStockDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMedicationUnderStockDtoPagedResultDto {
    items: MedicationUnderStockDto[] | undefined;
    totalCount: number;
}

export class MeetingMinuteDto implements IMeetingMinuteDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    meetingType!: MeetingTypeDto;
    operationalUnit!: OperationalUnitDto;
    topic!: string | undefined;
    date!: Date;
    meetingDate!: Date | undefined;
    duration!: number;
    minuteNote!: string | undefined;
    patients!: PatientDto[] | undefined;
    userChair!: UserDto;
    users!: UserDto[] | undefined;
    others!: UserDto[] | undefined;

    constructor(data?: IMeetingMinuteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.meetingType = _data["meetingType"] ? MeetingTypeDto.fromJS(_data["meetingType"]) : <any>undefined;
            this.operationalUnit = _data["operationalUnit"] ? OperationalUnitDto.fromJS(_data["operationalUnit"]) : <any>undefined;
            this.topic = _data["topic"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.meetingDate = _data["meetingDate"] ? new Date(_data["meetingDate"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.minuteNote = _data["minuteNote"];
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients!.push(PatientDto.fromJS(item));
            }
            this.userChair = _data["userChair"] ? UserDto.fromJS(_data["userChair"]) : <any>undefined;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDto.fromJS(item));
            }
            if (Array.isArray(_data["others"])) {
                this.others = [] as any;
                for (let item of _data["others"])
                    this.others!.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeetingMinuteDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingMinuteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["meetingType"] = this.meetingType ? this.meetingType.toJSON() : <any>undefined;
        data["operationalUnit"] = this.operationalUnit ? this.operationalUnit.toJSON() : <any>undefined;
        data["topic"] = this.topic;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["meetingDate"] = this.meetingDate ? this.meetingDate.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["minuteNote"] = this.minuteNote;
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        data["userChair"] = this.userChair ? this.userChair.toJSON() : <any>undefined;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.others)) {
            data["others"] = [];
            for (let item of this.others)
                data["others"].push(item.toJSON());
        }
        return data;
    }

    clone(): MeetingMinuteDto {
        const json = this.toJSON();
        let result = new MeetingMinuteDto();
        result.init(json);
        return result;
    }
}

export interface IMeetingMinuteDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    meetingType: MeetingTypeDto;
    operationalUnit: OperationalUnitDto;
    topic: string | undefined;
    date: Date;
    meetingDate: Date | undefined;
    duration: number;
    minuteNote: string | undefined;
    patients: PatientDto[] | undefined;
    userChair: UserDto;
    users: UserDto[] | undefined;
    others: UserDto[] | undefined;
}

export class MeetingMinuteDtoPagedResultDto implements IMeetingMinuteDtoPagedResultDto {
    items!: MeetingMinuteDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMeetingMinuteDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeetingMinuteDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MeetingMinuteDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingMinuteDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MeetingMinuteDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MeetingMinuteDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMeetingMinuteDtoPagedResultDto {
    items: MeetingMinuteDto[] | undefined;
    totalCount: number;
}

export class MeetingMinutePatientReportDto implements IMeetingMinutePatientReportDto {
    patient!: PatientDto;
    total!: number;

    constructor(data?: IMeetingMinutePatientReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patient = _data["patient"] ? PatientDto.fromJS(_data["patient"]) : <any>undefined;
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): MeetingMinutePatientReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingMinutePatientReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["total"] = this.total;
        return data;
    }

    clone(): MeetingMinutePatientReportDto {
        const json = this.toJSON();
        let result = new MeetingMinutePatientReportDto();
        result.init(json);
        return result;
    }
}

export interface IMeetingMinutePatientReportDto {
    patient: PatientDto;
    total: number;
}

export class MeetingMinutePatientReportDtoPagedResultDto implements IMeetingMinutePatientReportDtoPagedResultDto {
    items!: MeetingMinutePatientReportDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMeetingMinutePatientReportDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeetingMinutePatientReportDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MeetingMinutePatientReportDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingMinutePatientReportDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MeetingMinutePatientReportDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MeetingMinutePatientReportDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMeetingMinutePatientReportDtoPagedResultDto {
    items: MeetingMinutePatientReportDto[] | undefined;
    totalCount: number;
}

export class MeetingMinuteUserReportDto implements IMeetingMinuteUserReportDto {
    user!: UserDto;
    total!: number;
    totalIsChair!: number;
    totalIsPresent!: number;
    totalIsOther!: number;

    constructor(data?: IMeetingMinuteUserReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.total = _data["total"];
            this.totalIsChair = _data["totalIsChair"];
            this.totalIsPresent = _data["totalIsPresent"];
            this.totalIsOther = _data["totalIsOther"];
        }
    }

    static fromJS(data: any): MeetingMinuteUserReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingMinuteUserReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["total"] = this.total;
        data["totalIsChair"] = this.totalIsChair;
        data["totalIsPresent"] = this.totalIsPresent;
        data["totalIsOther"] = this.totalIsOther;
        return data;
    }

    clone(): MeetingMinuteUserReportDto {
        const json = this.toJSON();
        let result = new MeetingMinuteUserReportDto();
        result.init(json);
        return result;
    }
}

export interface IMeetingMinuteUserReportDto {
    user: UserDto;
    total: number;
    totalIsChair: number;
    totalIsPresent: number;
    totalIsOther: number;
}

export class MeetingMinuteUserReportDtoPagedResultDto implements IMeetingMinuteUserReportDtoPagedResultDto {
    items!: MeetingMinuteUserReportDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMeetingMinuteUserReportDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeetingMinuteUserReportDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MeetingMinuteUserReportDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingMinuteUserReportDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MeetingMinuteUserReportDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MeetingMinuteUserReportDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMeetingMinuteUserReportDtoPagedResultDto {
    items: MeetingMinuteUserReportDto[] | undefined;
    totalCount: number;
}

export class MeetingTypeDto implements IMeetingTypeDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;
    isStatic!: boolean;

    constructor(data?: IMeetingTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): MeetingTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): MeetingTypeDto {
        const json = this.toJSON();
        let result = new MeetingTypeDto();
        result.init(json);
        return result;
    }
}

export interface IMeetingTypeDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
    isStatic: boolean;
}

export class MeetingTypeDtoPagedResultDto implements IMeetingTypeDtoPagedResultDto {
    items!: MeetingTypeDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMeetingTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeetingTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MeetingTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MeetingTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MeetingTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMeetingTypeDtoPagedResultDto {
    items: MeetingTypeDto[] | undefined;
    totalCount: number;
}

export class MemberInfo implements IMemberInfo {
    memberType!: MemberTypes;
    declaringType!: Type;
    reflectedType!: Type;
    readonly name!: string | undefined;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;

    constructor(data?: IMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            (<any>this).name = _data["name"];
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): MemberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }

    clone(): MemberInfo {
        const json = this.toJSON();
        let result = new MemberInfo();
        result.init(json);
        return result;
    }
}

export interface IMemberInfo {
    memberType: MemberTypes;
    declaringType: Type;
    reflectedType: Type;
    name: string | undefined;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export enum MemberTypes {
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _191 = 191,
}

export enum MethodAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _1024 = 1024,
    _2048 = 2048,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _53248 = 53248,
}

export class MethodBase implements IMethodBase {
    memberType!: MemberTypes;
    readonly name!: string | undefined;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    attributes!: MethodAttributes;
    methodImplementationFlags!: MethodImplAttributes;
    callingConvention!: CallingConventions;
    readonly isAbstract!: boolean;
    readonly isConstructor!: boolean;
    readonly isFinal!: boolean;
    readonly isHideBySig!: boolean;
    readonly isSpecialName!: boolean;
    readonly isStatic!: boolean;
    readonly isVirtual!: boolean;
    readonly isAssembly!: boolean;
    readonly isFamily!: boolean;
    readonly isFamilyAndAssembly!: boolean;
    readonly isFamilyOrAssembly!: boolean;
    readonly isPrivate!: boolean;
    readonly isPublic!: boolean;
    readonly isConstructedGenericMethod!: boolean;
    readonly isGenericMethod!: boolean;
    readonly isGenericMethodDefinition!: boolean;
    readonly containsGenericParameters!: boolean;
    methodHandle!: RuntimeMethodHandle;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;

    constructor(data?: IMethodBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
        }
    }

    static fromJS(data: any): MethodBase {
        data = typeof data === 'object' ? data : {};
        let result = new MethodBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        return data;
    }

    clone(): MethodBase {
        const json = this.toJSON();
        let result = new MethodBase();
        result.init(json);
        return result;
    }
}

export interface IMethodBase {
    memberType: MemberTypes;
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
}

export enum MethodImplAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _4096 = 4096,
    _65535 = 65535,
}

export class MethodInfo implements IMethodInfo {
    readonly name!: string | undefined;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    attributes!: MethodAttributes;
    methodImplementationFlags!: MethodImplAttributes;
    callingConvention!: CallingConventions;
    readonly isAbstract!: boolean;
    readonly isConstructor!: boolean;
    readonly isFinal!: boolean;
    readonly isHideBySig!: boolean;
    readonly isSpecialName!: boolean;
    readonly isStatic!: boolean;
    readonly isVirtual!: boolean;
    readonly isAssembly!: boolean;
    readonly isFamily!: boolean;
    readonly isFamilyAndAssembly!: boolean;
    readonly isFamilyOrAssembly!: boolean;
    readonly isPrivate!: boolean;
    readonly isPublic!: boolean;
    readonly isConstructedGenericMethod!: boolean;
    readonly isGenericMethod!: boolean;
    readonly isGenericMethodDefinition!: boolean;
    readonly containsGenericParameters!: boolean;
    methodHandle!: RuntimeMethodHandle;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    memberType!: MemberTypes;
    returnParameter!: ParameterInfo;
    returnType!: Type;
    returnTypeCustomAttributes!: ICustomAttributeProvider;

    constructor(data?: IMethodInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.memberType = _data["memberType"];
            this.returnParameter = _data["returnParameter"] ? ParameterInfo.fromJS(_data["returnParameter"]) : <any>undefined;
            this.returnType = _data["returnType"] ? Type.fromJS(_data["returnType"]) : <any>undefined;
            this.returnTypeCustomAttributes = _data["returnTypeCustomAttributes"] ? ICustomAttributeProvider.fromJS(_data["returnTypeCustomAttributes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MethodInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MethodInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["memberType"] = this.memberType;
        data["returnParameter"] = this.returnParameter ? this.returnParameter.toJSON() : <any>undefined;
        data["returnType"] = this.returnType ? this.returnType.toJSON() : <any>undefined;
        data["returnTypeCustomAttributes"] = this.returnTypeCustomAttributes ? this.returnTypeCustomAttributes.toJSON() : <any>undefined;
        return data;
    }

    clone(): MethodInfo {
        const json = this.toJSON();
        let result = new MethodInfo();
        result.init(json);
        return result;
    }
}

export interface IMethodInfo {
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    memberType: MemberTypes;
    returnParameter: ParameterInfo;
    returnType: Type;
    returnTypeCustomAttributes: ICustomAttributeProvider;
}

export class Module implements IModule {
    assembly!: Assembly;
    readonly fullyQualifiedName!: string | undefined;
    readonly name!: string | undefined;
    readonly mdStreamVersion!: number;
    readonly moduleVersionId!: string;
    readonly scopeName!: string | undefined;
    moduleHandle!: ModuleHandle;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly metadataToken!: number;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            (<any>this).fullyQualifiedName = _data["fullyQualifiedName"];
            (<any>this).name = _data["name"];
            (<any>this).mdStreamVersion = _data["mdStreamVersion"];
            (<any>this).moduleVersionId = _data["moduleVersionId"];
            (<any>this).scopeName = _data["scopeName"];
            this.moduleHandle = _data["moduleHandle"] ? ModuleHandle.fromJS(_data["moduleHandle"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["fullyQualifiedName"] = this.fullyQualifiedName;
        data["name"] = this.name;
        data["mdStreamVersion"] = this.mdStreamVersion;
        data["moduleVersionId"] = this.moduleVersionId;
        data["scopeName"] = this.scopeName;
        data["moduleHandle"] = this.moduleHandle ? this.moduleHandle.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }

    clone(): Module {
        const json = this.toJSON();
        let result = new Module();
        result.init(json);
        return result;
    }
}

export interface IModule {
    assembly: Assembly;
    fullyQualifiedName: string | undefined;
    name: string | undefined;
    mdStreamVersion: number;
    moduleVersionId: string;
    scopeName: string | undefined;
    moduleHandle: ModuleHandle;
    customAttributes: CustomAttributeData[] | undefined;
    metadataToken: number;
}

export class ModuleHandle implements IModuleHandle {
    readonly mdStreamVersion!: number;

    constructor(data?: IModuleHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).mdStreamVersion = _data["mdStreamVersion"];
        }
    }

    static fromJS(data: any): ModuleHandle {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mdStreamVersion"] = this.mdStreamVersion;
        return data;
    }

    clone(): ModuleHandle {
        const json = this.toJSON();
        let result = new ModuleHandle();
        result.init(json);
        return result;
    }
}

export interface IModuleHandle {
    mdStreamVersion: number;
}

export class MunicipalityDto implements IMunicipalityDto {
    id!: number;
    name!: string | undefined;
    isChiefTown!: boolean;
    province!: ProvinceDto;

    constructor(data?: IMunicipalityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isChiefTown = _data["isChiefTown"];
            this.province = _data["province"] ? ProvinceDto.fromJS(_data["province"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MunicipalityDto {
        data = typeof data === 'object' ? data : {};
        let result = new MunicipalityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isChiefTown"] = this.isChiefTown;
        data["province"] = this.province ? this.province.toJSON() : <any>undefined;
        return data;
    }

    clone(): MunicipalityDto {
        const json = this.toJSON();
        let result = new MunicipalityDto();
        result.init(json);
        return result;
    }
}

export interface IMunicipalityDto {
    id: number;
    name: string | undefined;
    isChiefTown: boolean;
    province: ProvinceDto;
}

export class NoteItemDto implements INoteItemDto {
    id!: number;
    noteType!: DictionaryDto;
    text!: string | undefined;
    lastModificationTime!: Date | undefined;

    constructor(data?: INoteItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.noteType = _data["noteType"] ? DictionaryDto.fromJS(_data["noteType"]) : <any>undefined;
            this.text = _data["text"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NoteItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoteItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["noteType"] = this.noteType ? this.noteType.toJSON() : <any>undefined;
        data["text"] = this.text;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): NoteItemDto {
        const json = this.toJSON();
        let result = new NoteItemDto();
        result.init(json);
        return result;
    }
}

export interface INoteItemDto {
    id: number;
    noteType: DictionaryDto;
    text: string | undefined;
    lastModificationTime: Date | undefined;
}

export class NotificationData implements INotificationData {
    readonly type!: string | undefined;
    properties!: { [key: string]: any; } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).type = _data["type"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key];
            }
        }
        return data;
    }

    clone(): NotificationData {
        const json = this.toJSON();
        let result = new NotificationData();
        result.init(json);
        return result;
    }
}

export interface INotificationData {
    type: string | undefined;
    properties: { [key: string]: any; } | undefined;
}

export enum NotificationSeverity {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class OnCallActivationDto implements IOnCallActivationDto {
    id!: number;
    startDateTime!: Date;
    endDateTime!: Date;

    constructor(data?: IOnCallActivationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OnCallActivationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OnCallActivationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): OnCallActivationDto {
        const json = this.toJSON();
        let result = new OnCallActivationDto();
        result.init(json);
        return result;
    }
}

export interface IOnCallActivationDto {
    id: number;
    startDateTime: Date;
    endDateTime: Date;
}

export class OnCallActivationDtoPagedResultDto implements IOnCallActivationDtoPagedResultDto {
    items!: OnCallActivationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IOnCallActivationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OnCallActivationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OnCallActivationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OnCallActivationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OnCallActivationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OnCallActivationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOnCallActivationDtoPagedResultDto {
    items: OnCallActivationDto[] | undefined;
    totalCount: number;
}

export class OperationalUnitDto implements IOperationalUnitDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    code!: string | undefined;
    isArchived!: boolean;
    unitManager!: UserDto;
    users!: UserDto[] | undefined;
    simpleUsers!: SimpleUserDto[] | undefined;
    patients!: PatientDto[] | undefined;

    constructor(data?: IOperationalUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.code = _data["code"];
            this.isArchived = _data["isArchived"];
            this.unitManager = _data["unitManager"] ? UserDto.fromJS(_data["unitManager"]) : <any>undefined;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDto.fromJS(item));
            }
            if (Array.isArray(_data["simpleUsers"])) {
                this.simpleUsers = [] as any;
                for (let item of _data["simpleUsers"])
                    this.simpleUsers!.push(SimpleUserDto.fromJS(item));
            }
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients!.push(PatientDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OperationalUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["code"] = this.code;
        data["isArchived"] = this.isArchived;
        data["unitManager"] = this.unitManager ? this.unitManager.toJSON() : <any>undefined;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.simpleUsers)) {
            data["simpleUsers"] = [];
            for (let item of this.simpleUsers)
                data["simpleUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        return data;
    }

    clone(): OperationalUnitDto {
        const json = this.toJSON();
        let result = new OperationalUnitDto();
        result.init(json);
        return result;
    }
}

export interface IOperationalUnitDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    code: string | undefined;
    isArchived: boolean;
    unitManager: UserDto;
    users: UserDto[] | undefined;
    simpleUsers: SimpleUserDto[] | undefined;
    patients: PatientDto[] | undefined;
}

export class OperationalUnitDtoPagedResultDto implements IOperationalUnitDtoPagedResultDto {
    items!: OperationalUnitDto[] | undefined;
    totalCount!: number;

    constructor(data?: IOperationalUnitDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OperationalUnitDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OperationalUnitDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalUnitDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OperationalUnitDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OperationalUnitDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOperationalUnitDtoPagedResultDto {
    items: OperationalUnitDto[] | undefined;
    totalCount: number;
}

export class OperationalUnitExpirationAlertDto implements IOperationalUnitExpirationAlertDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    operationalUnit!: SimpleOperationalUnitDto;
    expirationWarningDays!: number;

    constructor(data?: IOperationalUnitExpirationAlertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.operationalUnit = _data["operationalUnit"] ? SimpleOperationalUnitDto.fromJS(_data["operationalUnit"]) : <any>undefined;
            this.expirationWarningDays = _data["expirationWarningDays"];
        }
    }

    static fromJS(data: any): OperationalUnitExpirationAlertDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalUnitExpirationAlertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["operationalUnit"] = this.operationalUnit ? this.operationalUnit.toJSON() : <any>undefined;
        data["expirationWarningDays"] = this.expirationWarningDays;
        return data;
    }

    clone(): OperationalUnitExpirationAlertDto {
        const json = this.toJSON();
        let result = new OperationalUnitExpirationAlertDto();
        result.init(json);
        return result;
    }
}

export interface IOperationalUnitExpirationAlertDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    operationalUnit: SimpleOperationalUnitDto;
    expirationWarningDays: number;
}

export class OperationalUnitExpirationAlertDtoPagedResultDto implements IOperationalUnitExpirationAlertDtoPagedResultDto {
    items!: OperationalUnitExpirationAlertDto[] | undefined;
    totalCount!: number;

    constructor(data?: IOperationalUnitExpirationAlertDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OperationalUnitExpirationAlertDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OperationalUnitExpirationAlertDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalUnitExpirationAlertDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OperationalUnitExpirationAlertDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OperationalUnitExpirationAlertDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOperationalUnitExpirationAlertDtoPagedResultDto {
    items: OperationalUnitExpirationAlertDto[] | undefined;
    totalCount: number;
}

export class OperationalUnitFileDto implements IOperationalUnitFileDto {
    id!: number;
    name!: string | undefined;
    file!: FileDto;
    operationalUnit!: OperationalUnitDto;
    expirationDate!: Date | undefined;
    expirationStatus!: string | undefined;

    constructor(data?: IOperationalUnitFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : <any>undefined;
            this.operationalUnit = _data["operationalUnit"] ? OperationalUnitDto.fromJS(_data["operationalUnit"]) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.expirationStatus = _data["expirationStatus"];
        }
    }

    static fromJS(data: any): OperationalUnitFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalUnitFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["operationalUnit"] = this.operationalUnit ? this.operationalUnit.toJSON() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["expirationStatus"] = this.expirationStatus;
        return data;
    }

    clone(): OperationalUnitFileDto {
        const json = this.toJSON();
        let result = new OperationalUnitFileDto();
        result.init(json);
        return result;
    }
}

export interface IOperationalUnitFileDto {
    id: number;
    name: string | undefined;
    file: FileDto;
    operationalUnit: OperationalUnitDto;
    expirationDate: Date | undefined;
    expirationStatus: string | undefined;
}

export class OperationalUnitFileDtoPagedResultDto implements IOperationalUnitFileDtoPagedResultDto {
    items!: OperationalUnitFileDto[] | undefined;
    totalCount!: number;

    constructor(data?: IOperationalUnitFileDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OperationalUnitFileDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OperationalUnitFileDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalUnitFileDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OperationalUnitFileDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OperationalUnitFileDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOperationalUnitFileDtoPagedResultDto {
    items: OperationalUnitFileDto[] | undefined;
    totalCount: number;
}

export class OperationalUnitShiftSlotDto implements IOperationalUnitShiftSlotDto {
    id!: number;
    operationalUnit!: OperationalUnitDto;
    shiftType!: DictionaryDto;
    startTime!: Date;
    endTime!: Date;
    validFrom!: Date;
    validTo!: Date | undefined;
    requiredCount!: number | undefined;

    constructor(data?: IOperationalUnitShiftSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.operationalUnit = _data["operationalUnit"] ? OperationalUnitDto.fromJS(_data["operationalUnit"]) : <any>undefined;
            this.shiftType = _data["shiftType"] ? DictionaryDto.fromJS(_data["shiftType"]) : <any>undefined;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.requiredCount = _data["requiredCount"];
        }
    }

    static fromJS(data: any): OperationalUnitShiftSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalUnitShiftSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["operationalUnit"] = this.operationalUnit ? this.operationalUnit.toJSON() : <any>undefined;
        data["shiftType"] = this.shiftType ? this.shiftType.toJSON() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["validFrom"] = this.validFrom ? formatDate(this.validFrom) : <any>undefined;
        data["validTo"] = this.validTo ? formatDate(this.validTo) : <any>undefined;
        data["requiredCount"] = this.requiredCount;
        return data;
    }

    clone(): OperationalUnitShiftSlotDto {
        const json = this.toJSON();
        let result = new OperationalUnitShiftSlotDto();
        result.init(json);
        return result;
    }
}

export interface IOperationalUnitShiftSlotDto {
    id: number;
    operationalUnit: OperationalUnitDto;
    shiftType: DictionaryDto;
    startTime: Date;
    endTime: Date;
    validFrom: Date;
    validTo: Date | undefined;
    requiredCount: number | undefined;
}

export class OperationalUnitShiftSlotDtoPagedResultDto implements IOperationalUnitShiftSlotDtoPagedResultDto {
    items!: OperationalUnitShiftSlotDto[] | undefined;
    totalCount!: number;

    constructor(data?: IOperationalUnitShiftSlotDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OperationalUnitShiftSlotDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OperationalUnitShiftSlotDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalUnitShiftSlotDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OperationalUnitShiftSlotDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OperationalUnitShiftSlotDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOperationalUnitShiftSlotDtoPagedResultDto {
    items: OperationalUnitShiftSlotDto[] | undefined;
    totalCount: number;
}

export class OperationalUnitUserIdDto implements IOperationalUnitUserIdDto {
    userId!: number;
    operationalUnitId!: number;

    constructor(data?: IOperationalUnitUserIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.operationalUnitId = _data["operationalUnitId"];
        }
    }

    static fromJS(data: any): OperationalUnitUserIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalUnitUserIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["operationalUnitId"] = this.operationalUnitId;
        return data;
    }

    clone(): OperationalUnitUserIdDto {
        const json = this.toJSON();
        let result = new OperationalUnitUserIdDto();
        result.init(json);
        return result;
    }
}

export interface IOperationalUnitUserIdDto {
    userId: number;
    operationalUnitId: number;
}

export class OperationalUnitUserIdsDto implements IOperationalUnitUserIdsDto {
    userIds!: number[] | undefined;
    operationalUnitIds!: number[] | undefined;

    constructor(data?: IOperationalUnitUserIdsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            if (Array.isArray(_data["operationalUnitIds"])) {
                this.operationalUnitIds = [] as any;
                for (let item of _data["operationalUnitIds"])
                    this.operationalUnitIds!.push(item);
            }
        }
    }

    static fromJS(data: any): OperationalUnitUserIdsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationalUnitUserIdsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        if (Array.isArray(this.operationalUnitIds)) {
            data["operationalUnitIds"] = [];
            for (let item of this.operationalUnitIds)
                data["operationalUnitIds"].push(item);
        }
        return data;
    }

    clone(): OperationalUnitUserIdsDto {
        const json = this.toJSON();
        let result = new OperationalUnitUserIdsDto();
        result.init(json);
        return result;
    }
}

export interface IOperationalUnitUserIdsDto {
    userIds: number[] | undefined;
    operationalUnitIds: number[] | undefined;
}

export enum ParameterAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _61440 = 61440,
}

export class ParameterInfo implements IParameterInfo {
    attributes!: ParameterAttributes;
    member!: MemberInfo;
    readonly name!: string | undefined;
    parameterType!: Type;
    readonly position!: number;
    readonly isIn!: boolean;
    readonly isLcid!: boolean;
    readonly isOptional!: boolean;
    readonly isOut!: boolean;
    readonly isRetval!: boolean;
    readonly defaultValue!: any | undefined;
    readonly rawDefaultValue!: any | undefined;
    readonly hasDefaultValue!: boolean;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly metadataToken!: number;

    constructor(data?: IParameterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributes = _data["attributes"];
            this.member = _data["member"] ? MemberInfo.fromJS(_data["member"]) : <any>undefined;
            (<any>this).name = _data["name"];
            this.parameterType = _data["parameterType"] ? Type.fromJS(_data["parameterType"]) : <any>undefined;
            (<any>this).position = _data["position"];
            (<any>this).isIn = _data["isIn"];
            (<any>this).isLcid = _data["isLcid"];
            (<any>this).isOptional = _data["isOptional"];
            (<any>this).isOut = _data["isOut"];
            (<any>this).isRetval = _data["isRetval"];
            (<any>this).defaultValue = _data["defaultValue"];
            (<any>this).rawDefaultValue = _data["rawDefaultValue"];
            (<any>this).hasDefaultValue = _data["hasDefaultValue"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): ParameterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType ? this.parameterType.toJSON() : <any>undefined;
        data["position"] = this.position;
        data["isIn"] = this.isIn;
        data["isLcid"] = this.isLcid;
        data["isOptional"] = this.isOptional;
        data["isOut"] = this.isOut;
        data["isRetval"] = this.isRetval;
        data["defaultValue"] = this.defaultValue;
        data["rawDefaultValue"] = this.rawDefaultValue;
        data["hasDefaultValue"] = this.hasDefaultValue;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }

    clone(): ParameterInfo {
        const json = this.toJSON();
        let result = new ParameterInfo();
        result.init(json);
        return result;
    }
}

export interface IParameterInfo {
    attributes: ParameterAttributes;
    member: MemberInfo;
    name: string | undefined;
    parameterType: Type;
    position: number;
    isIn: boolean;
    isLcid: boolean;
    isOptional: boolean;
    isOut: boolean;
    isRetval: boolean;
    defaultValue: any | undefined;
    rawDefaultValue: any | undefined;
    hasDefaultValue: boolean;
    customAttributes: CustomAttributeData[] | undefined;
    metadataToken: number;
}

export class PatientAttendanceDto implements IPatientAttendanceDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    patient!: PatientDto;
    attendanceMark!: DictionaryDto;
    date!: Date;
    isActive!: boolean;
    note!: string | undefined;

    constructor(data?: IPatientAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.patient = _data["patient"] ? PatientDto.fromJS(_data["patient"]) : <any>undefined;
            this.attendanceMark = _data["attendanceMark"] ? DictionaryDto.fromJS(_data["attendanceMark"]) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): PatientAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["attendanceMark"] = this.attendanceMark ? this.attendanceMark.toJSON() : <any>undefined;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["isActive"] = this.isActive;
        data["note"] = this.note;
        return data;
    }

    clone(): PatientAttendanceDto {
        const json = this.toJSON();
        let result = new PatientAttendanceDto();
        result.init(json);
        return result;
    }
}

export interface IPatientAttendanceDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    patient: PatientDto;
    attendanceMark: DictionaryDto;
    date: Date;
    isActive: boolean;
    note: string | undefined;
}

export class PatientAttendanceDtoPagedResultDto implements IPatientAttendanceDtoPagedResultDto {
    items!: PatientAttendanceDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPatientAttendanceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientAttendanceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PatientAttendanceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAttendanceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PatientAttendanceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PatientAttendanceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatientAttendanceDtoPagedResultDto {
    items: PatientAttendanceDto[] | undefined;
    totalCount: number;
}

export class PatientAttendanceItemDto implements IPatientAttendanceItemDto {
    surname!: string | undefined;
    name!: string | undefined;
    attendances!: AttendanceDto[] | undefined;

    constructor(data?: IPatientAttendanceItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surname = _data["surname"];
            this.name = _data["name"];
            if (Array.isArray(_data["attendances"])) {
                this.attendances = [] as any;
                for (let item of _data["attendances"])
                    this.attendances!.push(AttendanceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientAttendanceItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAttendanceItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surname"] = this.surname;
        data["name"] = this.name;
        if (Array.isArray(this.attendances)) {
            data["attendances"] = [];
            for (let item of this.attendances)
                data["attendances"].push(item.toJSON());
        }
        return data;
    }

    clone(): PatientAttendanceItemDto {
        const json = this.toJSON();
        let result = new PatientAttendanceItemDto();
        result.init(json);
        return result;
    }
}

export interface IPatientAttendanceItemDto {
    surname: string | undefined;
    name: string | undefined;
    attendances: AttendanceDto[] | undefined;
}

export class PatientAttendanceItemDtoPagedResultDto implements IPatientAttendanceItemDtoPagedResultDto {
    items!: PatientAttendanceItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPatientAttendanceItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientAttendanceItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PatientAttendanceItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAttendanceItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PatientAttendanceItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PatientAttendanceItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatientAttendanceItemDtoPagedResultDto {
    items: PatientAttendanceItemDto[] | undefined;
    totalCount: number;
}

export class PatientBandsStatusDto implements IPatientBandsStatusDto {
    patientId!: number;
    bands!: PatientBandStatusDto[] | undefined;

    constructor(data?: IPatientBandsStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            if (Array.isArray(_data["bands"])) {
                this.bands = [] as any;
                for (let item of _data["bands"])
                    this.bands!.push(PatientBandStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientBandsStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientBandsStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        if (Array.isArray(this.bands)) {
            data["bands"] = [];
            for (let item of this.bands)
                data["bands"].push(item.toJSON());
        }
        return data;
    }

    clone(): PatientBandsStatusDto {
        const json = this.toJSON();
        let result = new PatientBandsStatusDto();
        result.init(json);
        return result;
    }
}

export interface IPatientBandsStatusDto {
    patientId: number;
    bands: PatientBandStatusDto[] | undefined;
}

export class PatientBandStatusDto implements IPatientBandStatusDto {
    band!: DictionaryDto;
    status!: DictionaryDto;

    constructor(data?: IPatientBandStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.band = _data["band"] ? DictionaryDto.fromJS(_data["band"]) : <any>undefined;
            this.status = _data["status"] ? DictionaryDto.fromJS(_data["status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientBandStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientBandStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["band"] = this.band ? this.band.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        return data;
    }

    clone(): PatientBandStatusDto {
        const json = this.toJSON();
        let result = new PatientBandStatusDto();
        result.init(json);
        return result;
    }
}

export interface IPatientBandStatusDto {
    band: DictionaryDto;
    status: DictionaryDto;
}

export class PatientCartStockDto implements IPatientCartStockDto {
    medicationStockId!: number;
    patientMedicationAssignmentId!: number;
    patientMedicationAssignmentDetailId!: number;
    medication!: SimpleMedicationDto;
    packageQuantity!: number;
    medicationStockCodeId!: number | undefined;
    code!: string | undefined;
    expiryDate!: Date;
    openedAt!: Date | undefined;
    totalQuantity!: number;
    totalSubUnits!: number | undefined;
    remainingUnits!: number;
    remainingSubUnits!: number | undefined;
    isPrescribed!: boolean;
    latestPrescriptionDate!: Date | undefined;
    isPrescriptionExpired!: boolean;

    constructor(data?: IPatientCartStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicationStockId = _data["medicationStockId"];
            this.patientMedicationAssignmentId = _data["patientMedicationAssignmentId"];
            this.patientMedicationAssignmentDetailId = _data["patientMedicationAssignmentDetailId"];
            this.medication = _data["medication"] ? SimpleMedicationDto.fromJS(_data["medication"]) : <any>undefined;
            this.packageQuantity = _data["packageQuantity"];
            this.medicationStockCodeId = _data["medicationStockCodeId"];
            this.code = _data["code"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.openedAt = _data["openedAt"] ? new Date(_data["openedAt"].toString()) : <any>undefined;
            this.totalQuantity = _data["totalQuantity"];
            this.totalSubUnits = _data["totalSubUnits"];
            this.remainingUnits = _data["remainingUnits"];
            this.remainingSubUnits = _data["remainingSubUnits"];
            this.isPrescribed = _data["isPrescribed"];
            this.latestPrescriptionDate = _data["latestPrescriptionDate"] ? new Date(_data["latestPrescriptionDate"].toString()) : <any>undefined;
            this.isPrescriptionExpired = _data["isPrescriptionExpired"];
        }
    }

    static fromJS(data: any): PatientCartStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientCartStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicationStockId"] = this.medicationStockId;
        data["patientMedicationAssignmentId"] = this.patientMedicationAssignmentId;
        data["patientMedicationAssignmentDetailId"] = this.patientMedicationAssignmentDetailId;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        data["packageQuantity"] = this.packageQuantity;
        data["medicationStockCodeId"] = this.medicationStockCodeId;
        data["code"] = this.code;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["openedAt"] = this.openedAt ? this.openedAt.toISOString() : <any>undefined;
        data["totalQuantity"] = this.totalQuantity;
        data["totalSubUnits"] = this.totalSubUnits;
        data["remainingUnits"] = this.remainingUnits;
        data["remainingSubUnits"] = this.remainingSubUnits;
        data["isPrescribed"] = this.isPrescribed;
        data["latestPrescriptionDate"] = this.latestPrescriptionDate ? this.latestPrescriptionDate.toISOString() : <any>undefined;
        data["isPrescriptionExpired"] = this.isPrescriptionExpired;
        return data;
    }

    clone(): PatientCartStockDto {
        const json = this.toJSON();
        let result = new PatientCartStockDto();
        result.init(json);
        return result;
    }
}

export interface IPatientCartStockDto {
    medicationStockId: number;
    patientMedicationAssignmentId: number;
    patientMedicationAssignmentDetailId: number;
    medication: SimpleMedicationDto;
    packageQuantity: number;
    medicationStockCodeId: number | undefined;
    code: string | undefined;
    expiryDate: Date;
    openedAt: Date | undefined;
    totalQuantity: number;
    totalSubUnits: number | undefined;
    remainingUnits: number;
    remainingSubUnits: number | undefined;
    isPrescribed: boolean;
    latestPrescriptionDate: Date | undefined;
    isPrescriptionExpired: boolean;
}

export class PatientCashMovementDto implements IPatientCashMovementDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    isInCurrentOperationalUnit!: boolean;
    totalAmount!: number;

    constructor(data?: IPatientCashMovementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.isInCurrentOperationalUnit = _data["isInCurrentOperationalUnit"];
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): PatientCashMovementDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientCashMovementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["isInCurrentOperationalUnit"] = this.isInCurrentOperationalUnit;
        data["totalAmount"] = this.totalAmount;
        return data;
    }

    clone(): PatientCashMovementDto {
        const json = this.toJSON();
        let result = new PatientCashMovementDto();
        result.init(json);
        return result;
    }
}

export interface IPatientCashMovementDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    isInCurrentOperationalUnit: boolean;
    totalAmount: number;
}

export class PatientCashMovimentPagedResultDto implements IPatientCashMovimentPagedResultDto {
    items!: PatientCashMovementDto[] | undefined;
    totalCount!: number;
    totalPeriodAmount!: number;
    totalPeriodEntryAmount!: number;
    totalPeriodExitAmount!: number;
    finalAmount!: number;

    constructor(data?: IPatientCashMovimentPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientCashMovementDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.totalPeriodAmount = _data["totalPeriodAmount"];
            this.totalPeriodEntryAmount = _data["totalPeriodEntryAmount"];
            this.totalPeriodExitAmount = _data["totalPeriodExitAmount"];
            this.finalAmount = _data["finalAmount"];
        }
    }

    static fromJS(data: any): PatientCashMovimentPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientCashMovimentPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["totalPeriodAmount"] = this.totalPeriodAmount;
        data["totalPeriodEntryAmount"] = this.totalPeriodEntryAmount;
        data["totalPeriodExitAmount"] = this.totalPeriodExitAmount;
        data["finalAmount"] = this.finalAmount;
        return data;
    }

    clone(): PatientCashMovimentPagedResultDto {
        const json = this.toJSON();
        let result = new PatientCashMovimentPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatientCashMovimentPagedResultDto {
    items: PatientCashMovementDto[] | undefined;
    totalCount: number;
    totalPeriodAmount: number;
    totalPeriodEntryAmount: number;
    totalPeriodExitAmount: number;
    finalAmount: number;
}

export class PatientDischargeDto implements IPatientDischargeDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    patient!: PatientDto;
    operationalUnit!: OperationalUnitDto;
    exitDate!: Date;
    isReintegrated!: boolean;
    reason!: string | undefined;

    constructor(data?: IPatientDischargeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.patient = _data["patient"] ? PatientDto.fromJS(_data["patient"]) : <any>undefined;
            this.operationalUnit = _data["operationalUnit"] ? OperationalUnitDto.fromJS(_data["operationalUnit"]) : <any>undefined;
            this.exitDate = _data["exitDate"] ? new Date(_data["exitDate"].toString()) : <any>undefined;
            this.isReintegrated = _data["isReintegrated"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): PatientDischargeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDischargeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["operationalUnit"] = this.operationalUnit ? this.operationalUnit.toJSON() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toISOString() : <any>undefined;
        data["isReintegrated"] = this.isReintegrated;
        data["reason"] = this.reason;
        return data;
    }

    clone(): PatientDischargeDto {
        const json = this.toJSON();
        let result = new PatientDischargeDto();
        result.init(json);
        return result;
    }
}

export interface IPatientDischargeDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    patient: PatientDto;
    operationalUnit: OperationalUnitDto;
    exitDate: Date;
    isReintegrated: boolean;
    reason: string | undefined;
}

export class PatientDischargeDtoPagedResultDto implements IPatientDischargeDtoPagedResultDto {
    items!: PatientDischargeDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPatientDischargeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientDischargeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PatientDischargeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDischargeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PatientDischargeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PatientDischargeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatientDischargeDtoPagedResultDto {
    items: PatientDischargeDto[] | undefined;
    totalCount: number;
}

export class PatientDto implements IPatientDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    email!: string | undefined;
    phoneNumber!: string | undefined;
    fiscalCode!: string | undefined;
    healthCard!: string | undefined;
    isMale!: boolean;
    birthDate!: Date | undefined;
    birthPlace!: string | undefined;
    occupation!: string | undefined;
    note!: string | undefined;
    doctor!: UserDto;
    status!: DictionaryDto;
    nationality!: DictionaryDto;
    address!: AddressDto;
    operationalUnit!: OperationalUnitDto;

    constructor(data?: IPatientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.fiscalCode = _data["fiscalCode"];
            this.healthCard = _data["healthCard"];
            this.isMale = _data["isMale"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.birthPlace = _data["birthPlace"];
            this.occupation = _data["occupation"];
            this.note = _data["note"];
            this.doctor = _data["doctor"] ? UserDto.fromJS(_data["doctor"]) : <any>undefined;
            this.status = _data["status"] ? DictionaryDto.fromJS(_data["status"]) : <any>undefined;
            this.nationality = _data["nationality"] ? DictionaryDto.fromJS(_data["nationality"]) : <any>undefined;
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.operationalUnit = _data["operationalUnit"] ? OperationalUnitDto.fromJS(_data["operationalUnit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["fiscalCode"] = this.fiscalCode;
        data["healthCard"] = this.healthCard;
        data["isMale"] = this.isMale;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["birthPlace"] = this.birthPlace;
        data["occupation"] = this.occupation;
        data["note"] = this.note;
        data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["nationality"] = this.nationality ? this.nationality.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["operationalUnit"] = this.operationalUnit ? this.operationalUnit.toJSON() : <any>undefined;
        return data;
    }

    clone(): PatientDto {
        const json = this.toJSON();
        let result = new PatientDto();
        result.init(json);
        return result;
    }
}

export interface IPatientDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    fiscalCode: string | undefined;
    healthCard: string | undefined;
    isMale: boolean;
    birthDate: Date | undefined;
    birthPlace: string | undefined;
    occupation: string | undefined;
    note: string | undefined;
    doctor: UserDto;
    status: DictionaryDto;
    nationality: DictionaryDto;
    address: AddressDto;
    operationalUnit: OperationalUnitDto;
}

export class PatientDtoPagedResultDto implements IPatientDtoPagedResultDto {
    items!: PatientDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPatientDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PatientDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PatientDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PatientDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatientDtoPagedResultDto {
    items: PatientDto[] | undefined;
    totalCount: number;
}

export class PatientFileDto implements IPatientFileDto {
    id!: number;
    name!: string | undefined;
    file!: FileDto;
    operationalUnit!: OperationalUnitDto;
    patient!: PatientDto;

    constructor(data?: IPatientFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : <any>undefined;
            this.operationalUnit = _data["operationalUnit"] ? OperationalUnitDto.fromJS(_data["operationalUnit"]) : <any>undefined;
            this.patient = _data["patient"] ? PatientDto.fromJS(_data["patient"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["operationalUnit"] = this.operationalUnit ? this.operationalUnit.toJSON() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        return data;
    }

    clone(): PatientFileDto {
        const json = this.toJSON();
        let result = new PatientFileDto();
        result.init(json);
        return result;
    }
}

export interface IPatientFileDto {
    id: number;
    name: string | undefined;
    file: FileDto;
    operationalUnit: OperationalUnitDto;
    patient: PatientDto;
}

export class PatientFileDtoPagedResultDto implements IPatientFileDtoPagedResultDto {
    items!: PatientFileDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPatientFileDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientFileDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PatientFileDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientFileDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PatientFileDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PatientFileDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatientFileDtoPagedResultDto {
    items: PatientFileDto[] | undefined;
    totalCount: number;
}

export class PatientMealDto implements IPatientMealDto {
    id!: number;
    patient!: PatientDto;
    operationalUnit!: OperationalUnitDto;
    mealSlot!: DictionaryDto;
    mealMark!: DictionaryDto;
    date!: Date;
    note!: string | undefined;

    constructor(data?: IPatientMealDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patient = _data["patient"] ? PatientDto.fromJS(_data["patient"]) : <any>undefined;
            this.operationalUnit = _data["operationalUnit"] ? OperationalUnitDto.fromJS(_data["operationalUnit"]) : <any>undefined;
            this.mealSlot = _data["mealSlot"] ? DictionaryDto.fromJS(_data["mealSlot"]) : <any>undefined;
            this.mealMark = _data["mealMark"] ? DictionaryDto.fromJS(_data["mealMark"]) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): PatientMealDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMealDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["operationalUnit"] = this.operationalUnit ? this.operationalUnit.toJSON() : <any>undefined;
        data["mealSlot"] = this.mealSlot ? this.mealSlot.toJSON() : <any>undefined;
        data["mealMark"] = this.mealMark ? this.mealMark.toJSON() : <any>undefined;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["note"] = this.note;
        return data;
    }

    clone(): PatientMealDto {
        const json = this.toJSON();
        let result = new PatientMealDto();
        result.init(json);
        return result;
    }
}

export interface IPatientMealDto {
    id: number;
    patient: PatientDto;
    operationalUnit: OperationalUnitDto;
    mealSlot: DictionaryDto;
    mealMark: DictionaryDto;
    date: Date;
    note: string | undefined;
}

export class PatientMealDtoPagedResultDto implements IPatientMealDtoPagedResultDto {
    items!: PatientMealDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPatientMealDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientMealDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PatientMealDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMealDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PatientMealDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PatientMealDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatientMealDtoPagedResultDto {
    items: PatientMealDto[] | undefined;
    totalCount: number;
}

export class PatientMealItemDto implements IPatientMealItemDto {
    surname!: string | undefined;
    name!: string | undefined;
    mealSlots!: MealSlotItemDto[] | undefined;

    constructor(data?: IPatientMealItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surname = _data["surname"];
            this.name = _data["name"];
            if (Array.isArray(_data["mealSlots"])) {
                this.mealSlots = [] as any;
                for (let item of _data["mealSlots"])
                    this.mealSlots!.push(MealSlotItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientMealItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMealItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surname"] = this.surname;
        data["name"] = this.name;
        if (Array.isArray(this.mealSlots)) {
            data["mealSlots"] = [];
            for (let item of this.mealSlots)
                data["mealSlots"].push(item.toJSON());
        }
        return data;
    }

    clone(): PatientMealItemDto {
        const json = this.toJSON();
        let result = new PatientMealItemDto();
        result.init(json);
        return result;
    }
}

export interface IPatientMealItemDto {
    surname: string | undefined;
    name: string | undefined;
    mealSlots: MealSlotItemDto[] | undefined;
}

export class PatientMealItemDtoPagedResultDto implements IPatientMealItemDtoPagedResultDto {
    items!: PatientMealItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPatientMealItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientMealItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PatientMealItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMealItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PatientMealItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PatientMealItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatientMealItemDtoPagedResultDto {
    items: PatientMealItemDto[] | undefined;
    totalCount: number;
}

export class PatientMedicationAdministrationDto implements IPatientMedicationAdministrationDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    plannedDateTime!: Date;
    administratedAt!: Date | undefined;
    quantity!: number;
    note!: string | undefined;
    isAdministrated!: boolean;
    administeredByUserId!: number | undefined;
    isRefused!: boolean;
    refusedByUserId!: number | undefined;
    noteAuthorUserId!: number | undefined;
    isNoteAutomatic!: boolean;
    isNoteDiscarded!: boolean;
    latestPrescriptionDate!: Date | undefined;
    isPrescriptionExpired!: boolean;
    patientMedicationTherapy!: PatientMedicationTherapyDto;

    constructor(data?: IPatientMedicationAdministrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.plannedDateTime = _data["plannedDateTime"] ? new Date(_data["plannedDateTime"].toString()) : <any>undefined;
            this.administratedAt = _data["administratedAt"] ? new Date(_data["administratedAt"].toString()) : <any>undefined;
            this.quantity = _data["quantity"];
            this.note = _data["note"];
            this.isAdministrated = _data["isAdministrated"];
            this.administeredByUserId = _data["administeredByUserId"];
            this.isRefused = _data["isRefused"];
            this.refusedByUserId = _data["refusedByUserId"];
            this.noteAuthorUserId = _data["noteAuthorUserId"];
            this.isNoteAutomatic = _data["isNoteAutomatic"];
            this.isNoteDiscarded = _data["isNoteDiscarded"];
            this.latestPrescriptionDate = _data["latestPrescriptionDate"] ? new Date(_data["latestPrescriptionDate"].toString()) : <any>undefined;
            this.isPrescriptionExpired = _data["isPrescriptionExpired"];
            this.patientMedicationTherapy = _data["patientMedicationTherapy"] ? PatientMedicationTherapyDto.fromJS(_data["patientMedicationTherapy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientMedicationAdministrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicationAdministrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["plannedDateTime"] = this.plannedDateTime ? this.plannedDateTime.toISOString() : <any>undefined;
        data["administratedAt"] = this.administratedAt ? this.administratedAt.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["note"] = this.note;
        data["isAdministrated"] = this.isAdministrated;
        data["administeredByUserId"] = this.administeredByUserId;
        data["isRefused"] = this.isRefused;
        data["refusedByUserId"] = this.refusedByUserId;
        data["noteAuthorUserId"] = this.noteAuthorUserId;
        data["isNoteAutomatic"] = this.isNoteAutomatic;
        data["isNoteDiscarded"] = this.isNoteDiscarded;
        data["latestPrescriptionDate"] = this.latestPrescriptionDate ? this.latestPrescriptionDate.toISOString() : <any>undefined;
        data["isPrescriptionExpired"] = this.isPrescriptionExpired;
        data["patientMedicationTherapy"] = this.patientMedicationTherapy ? this.patientMedicationTherapy.toJSON() : <any>undefined;
        return data;
    }

    clone(): PatientMedicationAdministrationDto {
        const json = this.toJSON();
        let result = new PatientMedicationAdministrationDto();
        result.init(json);
        return result;
    }
}

export interface IPatientMedicationAdministrationDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    plannedDateTime: Date;
    administratedAt: Date | undefined;
    quantity: number;
    note: string | undefined;
    isAdministrated: boolean;
    administeredByUserId: number | undefined;
    isRefused: boolean;
    refusedByUserId: number | undefined;
    noteAuthorUserId: number | undefined;
    isNoteAutomatic: boolean;
    isNoteDiscarded: boolean;
    latestPrescriptionDate: Date | undefined;
    isPrescriptionExpired: boolean;
    patientMedicationTherapy: PatientMedicationTherapyDto;
}

export class PatientMedicationAdministrationDtoPagedResultDto implements IPatientMedicationAdministrationDtoPagedResultDto {
    items!: PatientMedicationAdministrationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPatientMedicationAdministrationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientMedicationAdministrationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PatientMedicationAdministrationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicationAdministrationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PatientMedicationAdministrationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PatientMedicationAdministrationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatientMedicationAdministrationDtoPagedResultDto {
    items: PatientMedicationAdministrationDto[] | undefined;
    totalCount: number;
}

export class PatientMedicationAssignmentDetailDto implements IPatientMedicationAssignmentDetailDto {
    id!: number;
    medicationStock!: MedicationStockDto;
    quantity!: number;
    subUnitsQuantity!: number | undefined;
    isPrescribed!: boolean;
    latestPrescriptionDate!: Date | undefined;
    isPrescriptionExpired!: boolean;

    constructor(data?: IPatientMedicationAssignmentDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.medicationStock = _data["medicationStock"] ? MedicationStockDto.fromJS(_data["medicationStock"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.subUnitsQuantity = _data["subUnitsQuantity"];
            this.isPrescribed = _data["isPrescribed"];
            this.latestPrescriptionDate = _data["latestPrescriptionDate"] ? new Date(_data["latestPrescriptionDate"].toString()) : <any>undefined;
            this.isPrescriptionExpired = _data["isPrescriptionExpired"];
        }
    }

    static fromJS(data: any): PatientMedicationAssignmentDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicationAssignmentDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["medicationStock"] = this.medicationStock ? this.medicationStock.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["subUnitsQuantity"] = this.subUnitsQuantity;
        data["isPrescribed"] = this.isPrescribed;
        data["latestPrescriptionDate"] = this.latestPrescriptionDate ? this.latestPrescriptionDate.toISOString() : <any>undefined;
        data["isPrescriptionExpired"] = this.isPrescriptionExpired;
        return data;
    }

    clone(): PatientMedicationAssignmentDetailDto {
        const json = this.toJSON();
        let result = new PatientMedicationAssignmentDetailDto();
        result.init(json);
        return result;
    }
}

export interface IPatientMedicationAssignmentDetailDto {
    id: number;
    medicationStock: MedicationStockDto;
    quantity: number;
    subUnitsQuantity: number | undefined;
    isPrescribed: boolean;
    latestPrescriptionDate: Date | undefined;
    isPrescriptionExpired: boolean;
}

export class PatientMedicationAssignmentDto implements IPatientMedicationAssignmentDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    quantity!: number;
    assignmentDate!: Date;
    note!: string | undefined;
    remainingQuantity!: number;
    patientMedicationAssignmentDetails!: PatientMedicationAssignmentDetailDto[] | undefined;
    isPrescribed!: boolean;
    latestPrescriptionDate!: Date | undefined;
    isPrescriptionExpired!: boolean;

    constructor(data?: IPatientMedicationAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.quantity = _data["quantity"];
            this.assignmentDate = _data["assignmentDate"] ? new Date(_data["assignmentDate"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.remainingQuantity = _data["remainingQuantity"];
            if (Array.isArray(_data["patientMedicationAssignmentDetails"])) {
                this.patientMedicationAssignmentDetails = [] as any;
                for (let item of _data["patientMedicationAssignmentDetails"])
                    this.patientMedicationAssignmentDetails!.push(PatientMedicationAssignmentDetailDto.fromJS(item));
            }
            this.isPrescribed = _data["isPrescribed"];
            this.latestPrescriptionDate = _data["latestPrescriptionDate"] ? new Date(_data["latestPrescriptionDate"].toString()) : <any>undefined;
            this.isPrescriptionExpired = _data["isPrescriptionExpired"];
        }
    }

    static fromJS(data: any): PatientMedicationAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicationAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["assignmentDate"] = this.assignmentDate ? this.assignmentDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["remainingQuantity"] = this.remainingQuantity;
        if (Array.isArray(this.patientMedicationAssignmentDetails)) {
            data["patientMedicationAssignmentDetails"] = [];
            for (let item of this.patientMedicationAssignmentDetails)
                data["patientMedicationAssignmentDetails"].push(item.toJSON());
        }
        data["isPrescribed"] = this.isPrescribed;
        data["latestPrescriptionDate"] = this.latestPrescriptionDate ? this.latestPrescriptionDate.toISOString() : <any>undefined;
        data["isPrescriptionExpired"] = this.isPrescriptionExpired;
        return data;
    }

    clone(): PatientMedicationAssignmentDto {
        const json = this.toJSON();
        let result = new PatientMedicationAssignmentDto();
        result.init(json);
        return result;
    }
}

export interface IPatientMedicationAssignmentDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    quantity: number;
    assignmentDate: Date;
    note: string | undefined;
    remainingQuantity: number;
    patientMedicationAssignmentDetails: PatientMedicationAssignmentDetailDto[] | undefined;
    isPrescribed: boolean;
    latestPrescriptionDate: Date | undefined;
    isPrescriptionExpired: boolean;
}

export class PatientMedicationAssignmentDtoPagedResultDto implements IPatientMedicationAssignmentDtoPagedResultDto {
    items!: PatientMedicationAssignmentDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPatientMedicationAssignmentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientMedicationAssignmentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PatientMedicationAssignmentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicationAssignmentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PatientMedicationAssignmentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PatientMedicationAssignmentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatientMedicationAssignmentDtoPagedResultDto {
    items: PatientMedicationAssignmentDto[] | undefined;
    totalCount: number;
}

export class PatientMedicationScheduleDto implements IPatientMedicationScheduleDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    patientMedicationTherapy!: PatientMedicationTherapyDto;
    plannedQuantity!: number;
    time!: Date;
    note!: string | undefined;
    patientMedicationAdministrations!: PatientMedicationAdministrationDto[] | undefined;

    constructor(data?: IPatientMedicationScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.patientMedicationTherapy = _data["patientMedicationTherapy"] ? PatientMedicationTherapyDto.fromJS(_data["patientMedicationTherapy"]) : <any>undefined;
            this.plannedQuantity = _data["plannedQuantity"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.note = _data["note"];
            if (Array.isArray(_data["patientMedicationAdministrations"])) {
                this.patientMedicationAdministrations = [] as any;
                for (let item of _data["patientMedicationAdministrations"])
                    this.patientMedicationAdministrations!.push(PatientMedicationAdministrationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientMedicationScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicationScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["patientMedicationTherapy"] = this.patientMedicationTherapy ? this.patientMedicationTherapy.toJSON() : <any>undefined;
        data["plannedQuantity"] = this.plannedQuantity;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["note"] = this.note;
        if (Array.isArray(this.patientMedicationAdministrations)) {
            data["patientMedicationAdministrations"] = [];
            for (let item of this.patientMedicationAdministrations)
                data["patientMedicationAdministrations"].push(item.toJSON());
        }
        return data;
    }

    clone(): PatientMedicationScheduleDto {
        const json = this.toJSON();
        let result = new PatientMedicationScheduleDto();
        result.init(json);
        return result;
    }
}

export interface IPatientMedicationScheduleDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    patientMedicationTherapy: PatientMedicationTherapyDto;
    plannedQuantity: number;
    time: Date;
    note: string | undefined;
    patientMedicationAdministrations: PatientMedicationAdministrationDto[] | undefined;
}

export class PatientMedicationScheduleDtoPagedResultDto implements IPatientMedicationScheduleDtoPagedResultDto {
    items!: PatientMedicationScheduleDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPatientMedicationScheduleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientMedicationScheduleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PatientMedicationScheduleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicationScheduleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PatientMedicationScheduleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PatientMedicationScheduleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatientMedicationScheduleDtoPagedResultDto {
    items: PatientMedicationScheduleDto[] | undefined;
    totalCount: number;
}

export class PatientMedicationTherapyDto implements IPatientMedicationTherapyDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    patient!: SimplePatientDto;
    medication!: MedicationItemDto;
    medicationTherapyType!: DictionaryDto;
    medicationAdministrationRoute!: DictionaryDto;
    patientMedicationTherapyStatus!: DictionaryDto;
    dose!: number;
    maxDailyDose!: number | undefined;
    note!: string | undefined;
    startDate!: Date;
    endDate!: Date | undefined;
    patientMedicationTherapyRecurrences!: PatientMedicationTherapyRecurrenceDto[] | undefined;
    patientMedicationTherapyTaperings!: PatientMedicationTherapyTaperingDto[] | undefined;
    isPrescribed!: boolean;
    latestPrescriptionDate!: Date | undefined;
    isPrescriptionExpired!: boolean;
    isOutOfStock!: boolean;

    constructor(data?: IPatientMedicationTherapyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.patient = _data["patient"] ? SimplePatientDto.fromJS(_data["patient"]) : <any>undefined;
            this.medication = _data["medication"] ? MedicationItemDto.fromJS(_data["medication"]) : <any>undefined;
            this.medicationTherapyType = _data["medicationTherapyType"] ? DictionaryDto.fromJS(_data["medicationTherapyType"]) : <any>undefined;
            this.medicationAdministrationRoute = _data["medicationAdministrationRoute"] ? DictionaryDto.fromJS(_data["medicationAdministrationRoute"]) : <any>undefined;
            this.patientMedicationTherapyStatus = _data["patientMedicationTherapyStatus"] ? DictionaryDto.fromJS(_data["patientMedicationTherapyStatus"]) : <any>undefined;
            this.dose = _data["dose"];
            this.maxDailyDose = _data["maxDailyDose"];
            this.note = _data["note"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["patientMedicationTherapyRecurrences"])) {
                this.patientMedicationTherapyRecurrences = [] as any;
                for (let item of _data["patientMedicationTherapyRecurrences"])
                    this.patientMedicationTherapyRecurrences!.push(PatientMedicationTherapyRecurrenceDto.fromJS(item));
            }
            if (Array.isArray(_data["patientMedicationTherapyTaperings"])) {
                this.patientMedicationTherapyTaperings = [] as any;
                for (let item of _data["patientMedicationTherapyTaperings"])
                    this.patientMedicationTherapyTaperings!.push(PatientMedicationTherapyTaperingDto.fromJS(item));
            }
            this.isPrescribed = _data["isPrescribed"];
            this.latestPrescriptionDate = _data["latestPrescriptionDate"] ? new Date(_data["latestPrescriptionDate"].toString()) : <any>undefined;
            this.isPrescriptionExpired = _data["isPrescriptionExpired"];
            this.isOutOfStock = _data["isOutOfStock"];
        }
    }

    static fromJS(data: any): PatientMedicationTherapyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicationTherapyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        data["medicationTherapyType"] = this.medicationTherapyType ? this.medicationTherapyType.toJSON() : <any>undefined;
        data["medicationAdministrationRoute"] = this.medicationAdministrationRoute ? this.medicationAdministrationRoute.toJSON() : <any>undefined;
        data["patientMedicationTherapyStatus"] = this.patientMedicationTherapyStatus ? this.patientMedicationTherapyStatus.toJSON() : <any>undefined;
        data["dose"] = this.dose;
        data["maxDailyDose"] = this.maxDailyDose;
        data["note"] = this.note;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.patientMedicationTherapyRecurrences)) {
            data["patientMedicationTherapyRecurrences"] = [];
            for (let item of this.patientMedicationTherapyRecurrences)
                data["patientMedicationTherapyRecurrences"].push(item.toJSON());
        }
        if (Array.isArray(this.patientMedicationTherapyTaperings)) {
            data["patientMedicationTherapyTaperings"] = [];
            for (let item of this.patientMedicationTherapyTaperings)
                data["patientMedicationTherapyTaperings"].push(item.toJSON());
        }
        data["isPrescribed"] = this.isPrescribed;
        data["latestPrescriptionDate"] = this.latestPrescriptionDate ? this.latestPrescriptionDate.toISOString() : <any>undefined;
        data["isPrescriptionExpired"] = this.isPrescriptionExpired;
        data["isOutOfStock"] = this.isOutOfStock;
        return data;
    }

    clone(): PatientMedicationTherapyDto {
        const json = this.toJSON();
        let result = new PatientMedicationTherapyDto();
        result.init(json);
        return result;
    }
}

export interface IPatientMedicationTherapyDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    patient: SimplePatientDto;
    medication: MedicationItemDto;
    medicationTherapyType: DictionaryDto;
    medicationAdministrationRoute: DictionaryDto;
    patientMedicationTherapyStatus: DictionaryDto;
    dose: number;
    maxDailyDose: number | undefined;
    note: string | undefined;
    startDate: Date;
    endDate: Date | undefined;
    patientMedicationTherapyRecurrences: PatientMedicationTherapyRecurrenceDto[] | undefined;
    patientMedicationTherapyTaperings: PatientMedicationTherapyTaperingDto[] | undefined;
    isPrescribed: boolean;
    latestPrescriptionDate: Date | undefined;
    isPrescriptionExpired: boolean;
    isOutOfStock: boolean;
}

export class PatientMedicationTherapyDtoPagedResultDto implements IPatientMedicationTherapyDtoPagedResultDto {
    items!: PatientMedicationTherapyDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPatientMedicationTherapyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientMedicationTherapyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PatientMedicationTherapyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicationTherapyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PatientMedicationTherapyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PatientMedicationTherapyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatientMedicationTherapyDtoPagedResultDto {
    items: PatientMedicationTherapyDto[] | undefined;
    totalCount: number;
}

export class PatientMedicationTherapyRecurrenceDto implements IPatientMedicationTherapyRecurrenceDto {
    id!: number;
    timeOfDay!: Date;
    dose!: number | undefined;

    constructor(data?: IPatientMedicationTherapyRecurrenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.timeOfDay = _data["timeOfDay"] ? new Date(_data["timeOfDay"].toString()) : <any>undefined;
            this.dose = _data["dose"];
        }
    }

    static fromJS(data: any): PatientMedicationTherapyRecurrenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicationTherapyRecurrenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timeOfDay"] = this.timeOfDay ? this.timeOfDay.toISOString() : <any>undefined;
        data["dose"] = this.dose;
        return data;
    }

    clone(): PatientMedicationTherapyRecurrenceDto {
        const json = this.toJSON();
        let result = new PatientMedicationTherapyRecurrenceDto();
        result.init(json);
        return result;
    }
}

export interface IPatientMedicationTherapyRecurrenceDto {
    id: number;
    timeOfDay: Date;
    dose: number | undefined;
}

export class PatientMedicationTherapyTaperingDto implements IPatientMedicationTherapyTaperingDto {
    id!: number;
    dayOffset!: number;
    timeOfDay!: Date | undefined;
    dose!: number;

    constructor(data?: IPatientMedicationTherapyTaperingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dayOffset = _data["dayOffset"];
            this.timeOfDay = _data["timeOfDay"] ? new Date(_data["timeOfDay"].toString()) : <any>undefined;
            this.dose = _data["dose"];
        }
    }

    static fromJS(data: any): PatientMedicationTherapyTaperingDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicationTherapyTaperingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dayOffset"] = this.dayOffset;
        data["timeOfDay"] = this.timeOfDay ? this.timeOfDay.toISOString() : <any>undefined;
        data["dose"] = this.dose;
        return data;
    }

    clone(): PatientMedicationTherapyTaperingDto {
        const json = this.toJSON();
        let result = new PatientMedicationTherapyTaperingDto();
        result.init(json);
        return result;
    }
}

export interface IPatientMedicationTherapyTaperingDto {
    id: number;
    dayOffset: number;
    timeOfDay: Date | undefined;
    dose: number;
}

export class PatientNoteDto implements IPatientNoteDto {
    id!: number;
    patient!: PatientDto;
    noteType!: DictionaryDto;
    text!: string | undefined;
    lastModificationTime!: Date | undefined;

    constructor(data?: IPatientNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patient = _data["patient"] ? PatientDto.fromJS(_data["patient"]) : <any>undefined;
            this.noteType = _data["noteType"] ? DictionaryDto.fromJS(_data["noteType"]) : <any>undefined;
            this.text = _data["text"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["noteType"] = this.noteType ? this.noteType.toJSON() : <any>undefined;
        data["text"] = this.text;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): PatientNoteDto {
        const json = this.toJSON();
        let result = new PatientNoteDto();
        result.init(json);
        return result;
    }
}

export interface IPatientNoteDto {
    id: number;
    patient: PatientDto;
    noteType: DictionaryDto;
    text: string | undefined;
    lastModificationTime: Date | undefined;
}

export class PatientNoteDtoPagedResultDto implements IPatientNoteDtoPagedResultDto {
    items!: PatientNoteDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPatientNoteDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientNoteDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PatientNoteDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientNoteDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PatientNoteDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PatientNoteDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatientNoteDtoPagedResultDto {
    items: PatientNoteDto[] | undefined;
    totalCount: number;
}

export class PatientNoteItemDto implements IPatientNoteItemDto {
    patient!: PatientDto;
    notes!: NoteItemDto[] | undefined;

    constructor(data?: IPatientNoteItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patient = _data["patient"] ? PatientDto.fromJS(_data["patient"]) : <any>undefined;
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NoteItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientNoteItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientNoteItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        return data;
    }

    clone(): PatientNoteItemDto {
        const json = this.toJSON();
        let result = new PatientNoteItemDto();
        result.init(json);
        return result;
    }
}

export interface IPatientNoteItemDto {
    patient: PatientDto;
    notes: NoteItemDto[] | undefined;
}

export class PatientNoteItemDtoPagedResultDto implements IPatientNoteItemDtoPagedResultDto {
    items!: PatientNoteItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPatientNoteItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientNoteItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PatientNoteItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientNoteItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PatientNoteItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PatientNoteItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatientNoteItemDtoPagedResultDto {
    items: PatientNoteItemDto[] | undefined;
    totalCount: number;
}

export class PatientOperationDto implements IPatientOperationDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;
    isStatic!: boolean;

    constructor(data?: IPatientOperationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): PatientOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientOperationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): PatientOperationDto {
        const json = this.toJSON();
        let result = new PatientOperationDto();
        result.init(json);
        return result;
    }
}

export interface IPatientOperationDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
    isStatic: boolean;
}

export class PatientOperationDtoPagedResultDto implements IPatientOperationDtoPagedResultDto {
    items!: PatientOperationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPatientOperationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientOperationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PatientOperationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientOperationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PatientOperationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PatientOperationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatientOperationDtoPagedResultDto {
    items: PatientOperationDto[] | undefined;
    totalCount: number;
}

export class PatientTransferRequestDto implements IPatientTransferRequestDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    patient!: PatientDto;
    fromOperationalUnit!: OperationalUnitDto;
    toOperationalUnit!: OperationalUnitDto;
    status!: DictionaryDto;
    isEntry!: boolean;

    constructor(data?: IPatientTransferRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.patient = _data["patient"] ? PatientDto.fromJS(_data["patient"]) : <any>undefined;
            this.fromOperationalUnit = _data["fromOperationalUnit"] ? OperationalUnitDto.fromJS(_data["fromOperationalUnit"]) : <any>undefined;
            this.toOperationalUnit = _data["toOperationalUnit"] ? OperationalUnitDto.fromJS(_data["toOperationalUnit"]) : <any>undefined;
            this.status = _data["status"] ? DictionaryDto.fromJS(_data["status"]) : <any>undefined;
            this.isEntry = _data["isEntry"];
        }
    }

    static fromJS(data: any): PatientTransferRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientTransferRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["fromOperationalUnit"] = this.fromOperationalUnit ? this.fromOperationalUnit.toJSON() : <any>undefined;
        data["toOperationalUnit"] = this.toOperationalUnit ? this.toOperationalUnit.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["isEntry"] = this.isEntry;
        return data;
    }

    clone(): PatientTransferRequestDto {
        const json = this.toJSON();
        let result = new PatientTransferRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPatientTransferRequestDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    patient: PatientDto;
    fromOperationalUnit: OperationalUnitDto;
    toOperationalUnit: OperationalUnitDto;
    status: DictionaryDto;
    isEntry: boolean;
}

export class PatientTransferRequestDtoPagedResultDto implements IPatientTransferRequestDtoPagedResultDto {
    items!: PatientTransferRequestDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPatientTransferRequestDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientTransferRequestDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PatientTransferRequestDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientTransferRequestDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PatientTransferRequestDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PatientTransferRequestDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatientTransferRequestDtoPagedResultDto {
    items: PatientTransferRequestDto[] | undefined;
    totalCount: number;
}

export class PatientTrasferDto implements IPatientTrasferDto {
    id!: number;
    patient!: PatientDto;
    fromOperationalUnit!: OperationalUnitDto;
    toOperationalUnit!: OperationalUnitDto;
    entryDate!: Date;
    exitDate!: Date;

    constructor(data?: IPatientTrasferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patient = _data["patient"] ? PatientDto.fromJS(_data["patient"]) : <any>undefined;
            this.fromOperationalUnit = _data["fromOperationalUnit"] ? OperationalUnitDto.fromJS(_data["fromOperationalUnit"]) : <any>undefined;
            this.toOperationalUnit = _data["toOperationalUnit"] ? OperationalUnitDto.fromJS(_data["toOperationalUnit"]) : <any>undefined;
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? new Date(_data["exitDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientTrasferDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientTrasferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["fromOperationalUnit"] = this.fromOperationalUnit ? this.fromOperationalUnit.toJSON() : <any>undefined;
        data["toOperationalUnit"] = this.toOperationalUnit ? this.toOperationalUnit.toJSON() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): PatientTrasferDto {
        const json = this.toJSON();
        let result = new PatientTrasferDto();
        result.init(json);
        return result;
    }
}

export interface IPatientTrasferDto {
    id: number;
    patient: PatientDto;
    fromOperationalUnit: OperationalUnitDto;
    toOperationalUnit: OperationalUnitDto;
    entryDate: Date;
    exitDate: Date;
}

export class PatientTrasferDtoPagedResultDto implements IPatientTrasferDtoPagedResultDto {
    items!: PatientTrasferDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPatientTrasferDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientTrasferDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PatientTrasferDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientTrasferDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PatientTrasferDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PatientTrasferDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatientTrasferDtoPagedResultDto {
    items: PatientTrasferDto[] | undefined;
    totalCount: number;
}

export class PermissionDto implements IPermissionDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items!: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class PhysiologicalHistoryDto implements IPhysiologicalHistoryDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    weightKg!: number | undefined;
    heightCm!: number | undefined;
    bloodGroup!: DictionaryDto;
    note!: string | undefined;

    constructor(data?: IPhysiologicalHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.weightKg = _data["weightKg"];
            this.heightCm = _data["heightCm"];
            this.bloodGroup = _data["bloodGroup"] ? DictionaryDto.fromJS(_data["bloodGroup"]) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): PhysiologicalHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhysiologicalHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["weightKg"] = this.weightKg;
        data["heightCm"] = this.heightCm;
        data["bloodGroup"] = this.bloodGroup ? this.bloodGroup.toJSON() : <any>undefined;
        data["note"] = this.note;
        return data;
    }

    clone(): PhysiologicalHistoryDto {
        const json = this.toJSON();
        let result = new PhysiologicalHistoryDto();
        result.init(json);
        return result;
    }
}

export interface IPhysiologicalHistoryDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    weightKg: number | undefined;
    heightCm: number | undefined;
    bloodGroup: DictionaryDto;
    note: string | undefined;
}

export class PhysiologicalHistoryDtoPagedResultDto implements IPhysiologicalHistoryDtoPagedResultDto {
    items!: PhysiologicalHistoryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPhysiologicalHistoryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PhysiologicalHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PhysiologicalHistoryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhysiologicalHistoryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PhysiologicalHistoryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PhysiologicalHistoryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPhysiologicalHistoryDtoPagedResultDto {
    items: PhysiologicalHistoryDto[] | undefined;
    totalCount: number;
}

export class PlannedAssignmentDto implements IPlannedAssignmentDto {
    id!: number;
    plannedSlot!: PlannedSlotDto;
    user!: UserDto;
    assignmentType!: DictionaryDto;
    onCallType!: DictionaryDto;
    startDateTime!: Date;
    endDateTime!: Date;
    onCallActivations!: OnCallActivationDto[] | undefined;

    constructor(data?: IPlannedAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plannedSlot = _data["plannedSlot"] ? PlannedSlotDto.fromJS(_data["plannedSlot"]) : <any>undefined;
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.assignmentType = _data["assignmentType"] ? DictionaryDto.fromJS(_data["assignmentType"]) : <any>undefined;
            this.onCallType = _data["onCallType"] ? DictionaryDto.fromJS(_data["onCallType"]) : <any>undefined;
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["onCallActivations"])) {
                this.onCallActivations = [] as any;
                for (let item of _data["onCallActivations"])
                    this.onCallActivations!.push(OnCallActivationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlannedAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plannedSlot"] = this.plannedSlot ? this.plannedSlot.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["assignmentType"] = this.assignmentType ? this.assignmentType.toJSON() : <any>undefined;
        data["onCallType"] = this.onCallType ? this.onCallType.toJSON() : <any>undefined;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.onCallActivations)) {
            data["onCallActivations"] = [];
            for (let item of this.onCallActivations)
                data["onCallActivations"].push(item.toJSON());
        }
        return data;
    }

    clone(): PlannedAssignmentDto {
        const json = this.toJSON();
        let result = new PlannedAssignmentDto();
        result.init(json);
        return result;
    }
}

export interface IPlannedAssignmentDto {
    id: number;
    plannedSlot: PlannedSlotDto;
    user: UserDto;
    assignmentType: DictionaryDto;
    onCallType: DictionaryDto;
    startDateTime: Date;
    endDateTime: Date;
    onCallActivations: OnCallActivationDto[] | undefined;
}

export class PlannedAssignmentDtoPagedResultDto implements IPlannedAssignmentDtoPagedResultDto {
    items!: PlannedAssignmentDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPlannedAssignmentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PlannedAssignmentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PlannedAssignmentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedAssignmentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PlannedAssignmentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PlannedAssignmentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPlannedAssignmentDtoPagedResultDto {
    items: PlannedAssignmentDto[] | undefined;
    totalCount: number;
}

export class PlannedSlotDto implements IPlannedSlotDto {
    id!: number;
    shiftType!: DictionaryDto;
    date!: Date;
    requiredCount!: number | undefined;
    minMinutesToCount!: number | undefined;
    plannedSlotStatus!: DictionaryDto;

    constructor(data?: IPlannedSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shiftType = _data["shiftType"] ? DictionaryDto.fromJS(_data["shiftType"]) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.requiredCount = _data["requiredCount"];
            this.minMinutesToCount = _data["minMinutesToCount"];
            this.plannedSlotStatus = _data["plannedSlotStatus"] ? DictionaryDto.fromJS(_data["plannedSlotStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlannedSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shiftType"] = this.shiftType ? this.shiftType.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["requiredCount"] = this.requiredCount;
        data["minMinutesToCount"] = this.minMinutesToCount;
        data["plannedSlotStatus"] = this.plannedSlotStatus ? this.plannedSlotStatus.toJSON() : <any>undefined;
        return data;
    }

    clone(): PlannedSlotDto {
        const json = this.toJSON();
        let result = new PlannedSlotDto();
        result.init(json);
        return result;
    }
}

export interface IPlannedSlotDto {
    id: number;
    shiftType: DictionaryDto;
    date: Date;
    requiredCount: number | undefined;
    minMinutesToCount: number | undefined;
    plannedSlotStatus: DictionaryDto;
}

export class PlannedSlotDtoPagedResultDto implements IPlannedSlotDtoPagedResultDto {
    items!: PlannedSlotDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPlannedSlotDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PlannedSlotDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PlannedSlotDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedSlotDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PlannedSlotDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PlannedSlotDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPlannedSlotDtoPagedResultDto {
    items: PlannedSlotDto[] | undefined;
    totalCount: number;
}

export class PrescriptionLinkCandidateItemDto implements IPrescriptionLinkCandidateItemDto {
    documentMedicationId!: number;
    medication!: SimpleMedicationDto;
    stocks!: StockLinkCandidateDto[] | undefined;
    therapies!: TherapyLinkCandidateDto[] | undefined;

    constructor(data?: IPrescriptionLinkCandidateItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentMedicationId = _data["documentMedicationId"];
            this.medication = _data["medication"] ? SimpleMedicationDto.fromJS(_data["medication"]) : <any>undefined;
            if (Array.isArray(_data["stocks"])) {
                this.stocks = [] as any;
                for (let item of _data["stocks"])
                    this.stocks!.push(StockLinkCandidateDto.fromJS(item));
            }
            if (Array.isArray(_data["therapies"])) {
                this.therapies = [] as any;
                for (let item of _data["therapies"])
                    this.therapies!.push(TherapyLinkCandidateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PrescriptionLinkCandidateItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionLinkCandidateItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentMedicationId"] = this.documentMedicationId;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        if (Array.isArray(this.stocks)) {
            data["stocks"] = [];
            for (let item of this.stocks)
                data["stocks"].push(item.toJSON());
        }
        if (Array.isArray(this.therapies)) {
            data["therapies"] = [];
            for (let item of this.therapies)
                data["therapies"].push(item.toJSON());
        }
        return data;
    }

    clone(): PrescriptionLinkCandidateItemDto {
        const json = this.toJSON();
        let result = new PrescriptionLinkCandidateItemDto();
        result.init(json);
        return result;
    }
}

export interface IPrescriptionLinkCandidateItemDto {
    documentMedicationId: number;
    medication: SimpleMedicationDto;
    stocks: StockLinkCandidateDto[] | undefined;
    therapies: TherapyLinkCandidateDto[] | undefined;
}

export class PrescriptionLinkCandidatesDto implements IPrescriptionLinkCandidatesDto {
    items!: PrescriptionLinkCandidateItemDto[] | undefined;

    constructor(data?: IPrescriptionLinkCandidatesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PrescriptionLinkCandidateItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PrescriptionLinkCandidatesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionLinkCandidatesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PrescriptionLinkCandidatesDto {
        const json = this.toJSON();
        let result = new PrescriptionLinkCandidatesDto();
        result.init(json);
        return result;
    }
}

export interface IPrescriptionLinkCandidatesDto {
    items: PrescriptionLinkCandidateItemDto[] | undefined;
}

export class PrescriptionRowDto implements IPrescriptionRowDto {
    documentMedicationId!: number;
    medication!: SimpleMedicationDto;
    protocolNumber!: string | undefined;
    documentDate!: Date;
    sender!: string | undefined;

    constructor(data?: IPrescriptionRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentMedicationId = _data["documentMedicationId"];
            this.medication = _data["medication"] ? SimpleMedicationDto.fromJS(_data["medication"]) : <any>undefined;
            this.protocolNumber = _data["protocolNumber"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.sender = _data["sender"];
        }
    }

    static fromJS(data: any): PrescriptionRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentMedicationId"] = this.documentMedicationId;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        data["protocolNumber"] = this.protocolNumber;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["sender"] = this.sender;
        return data;
    }

    clone(): PrescriptionRowDto {
        const json = this.toJSON();
        let result = new PrescriptionRowDto();
        result.init(json);
        return result;
    }
}

export interface IPrescriptionRowDto {
    documentMedicationId: number;
    medication: SimpleMedicationDto;
    protocolNumber: string | undefined;
    documentDate: Date;
    sender: string | undefined;
}

export class PrescriptionRowDtoListResultDto implements IPrescriptionRowDtoListResultDto {
    items!: PrescriptionRowDto[] | undefined;

    constructor(data?: IPrescriptionRowDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PrescriptionRowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PrescriptionRowDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionRowDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PrescriptionRowDtoListResultDto {
        const json = this.toJSON();
        let result = new PrescriptionRowDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPrescriptionRowDtoListResultDto {
    items: PrescriptionRowDto[] | undefined;
}

export class PrintMedicationStockCodesDto implements IPrintMedicationStockCodesDto {
    operationalUnitId!: number;
    count!: number;
    labelsPerSheet!: number | undefined;

    constructor(data?: IPrintMedicationStockCodesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationalUnitId = _data["operationalUnitId"];
            this.count = _data["count"];
            this.labelsPerSheet = _data["labelsPerSheet"];
        }
    }

    static fromJS(data: any): PrintMedicationStockCodesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrintMedicationStockCodesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationalUnitId"] = this.operationalUnitId;
        data["count"] = this.count;
        data["labelsPerSheet"] = this.labelsPerSheet;
        return data;
    }

    clone(): PrintMedicationStockCodesDto {
        const json = this.toJSON();
        let result = new PrintMedicationStockCodesDto();
        result.init(json);
        return result;
    }
}

export interface IPrintMedicationStockCodesDto {
    operationalUnitId: number;
    count: number;
    labelsPerSheet: number | undefined;
}

export class PrintMedicationStockCodesResultDto implements IPrintMedicationStockCodesResultDto {
    codes!: MedicationStockCodeDto[] | undefined;
    labelSheet!: FileExportDto;

    constructor(data?: IPrintMedicationStockCodesResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["codes"])) {
                this.codes = [] as any;
                for (let item of _data["codes"])
                    this.codes!.push(MedicationStockCodeDto.fromJS(item));
            }
            this.labelSheet = _data["labelSheet"] ? FileExportDto.fromJS(_data["labelSheet"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PrintMedicationStockCodesResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrintMedicationStockCodesResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.codes)) {
            data["codes"] = [];
            for (let item of this.codes)
                data["codes"].push(item.toJSON());
        }
        data["labelSheet"] = this.labelSheet ? this.labelSheet.toJSON() : <any>undefined;
        return data;
    }

    clone(): PrintMedicationStockCodesResultDto {
        const json = this.toJSON();
        let result = new PrintMedicationStockCodesResultDto();
        result.init(json);
        return result;
    }
}

export interface IPrintMedicationStockCodesResultDto {
    codes: MedicationStockCodeDto[] | undefined;
    labelSheet: FileExportDto;
}

export enum PropertyAttributes {
    _0 = 0,
    _512 = 512,
    _1024 = 1024,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _62464 = 62464,
}

export class PropertyInfo implements IPropertyInfo {
    readonly name!: string | undefined;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    memberType!: MemberTypes;
    propertyType!: Type;
    attributes!: PropertyAttributes;
    readonly isSpecialName!: boolean;
    readonly canRead!: boolean;
    readonly canWrite!: boolean;
    getMethod!: MethodInfo;
    setMethod!: MethodInfo;

    constructor(data?: IPropertyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.propertyType = _data["propertyType"] ? Type.fromJS(_data["propertyType"]) : <any>undefined;
            this.attributes = _data["attributes"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).canRead = _data["canRead"];
            (<any>this).canWrite = _data["canWrite"];
            this.getMethod = _data["getMethod"] ? MethodInfo.fromJS(_data["getMethod"]) : <any>undefined;
            this.setMethod = _data["setMethod"] ? MethodInfo.fromJS(_data["setMethod"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["propertyType"] = this.propertyType ? this.propertyType.toJSON() : <any>undefined;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["canRead"] = this.canRead;
        data["canWrite"] = this.canWrite;
        data["getMethod"] = this.getMethod ? this.getMethod.toJSON() : <any>undefined;
        data["setMethod"] = this.setMethod ? this.setMethod.toJSON() : <any>undefined;
        return data;
    }

    clone(): PropertyInfo {
        const json = this.toJSON();
        let result = new PropertyInfo();
        result.init(json);
        return result;
    }
}

export interface IPropertyInfo {
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    memberType: MemberTypes;
    propertyType: Type;
    attributes: PropertyAttributes;
    isSpecialName: boolean;
    canRead: boolean;
    canWrite: boolean;
    getMethod: MethodInfo;
    setMethod: MethodInfo;
}

export class ProtocolTypeDto implements IProtocolTypeDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;
    isStatic!: boolean;

    constructor(data?: IProtocolTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): ProtocolTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProtocolTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): ProtocolTypeDto {
        const json = this.toJSON();
        let result = new ProtocolTypeDto();
        result.init(json);
        return result;
    }
}

export interface IProtocolTypeDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
    isStatic: boolean;
}

export class ProtocolTypeDtoPagedResultDto implements IProtocolTypeDtoPagedResultDto {
    items!: ProtocolTypeDto[] | undefined;
    totalCount!: number;

    constructor(data?: IProtocolTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProtocolTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ProtocolTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProtocolTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ProtocolTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProtocolTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProtocolTypeDtoPagedResultDto {
    items: ProtocolTypeDto[] | undefined;
    totalCount: number;
}

export class ProvinceDto implements IProvinceDto {
    id!: number;
    name!: string | undefined;
    abbreviation!: string | undefined;
    region!: RegionDto;

    constructor(data?: IProvinceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.abbreviation = _data["abbreviation"];
            this.region = _data["region"] ? RegionDto.fromJS(_data["region"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProvinceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["abbreviation"] = this.abbreviation;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        return data;
    }

    clone(): ProvinceDto {
        const json = this.toJSON();
        let result = new ProvinceDto();
        result.init(json);
        return result;
    }
}

export interface IProvinceDto {
    id: number;
    name: string | undefined;
    abbreviation: string | undefined;
    region: RegionDto;
}

export class PsychiatricAdmissionExamDto implements IPsychiatricAdmissionExamDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    note!: string | undefined;

    constructor(data?: IPsychiatricAdmissionExamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): PsychiatricAdmissionExamDto {
        data = typeof data === 'object' ? data : {};
        let result = new PsychiatricAdmissionExamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["note"] = this.note;
        return data;
    }

    clone(): PsychiatricAdmissionExamDto {
        const json = this.toJSON();
        let result = new PsychiatricAdmissionExamDto();
        result.init(json);
        return result;
    }
}

export interface IPsychiatricAdmissionExamDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    note: string | undefined;
}

export class PsychiatricAdmissionExamDtoPagedResultDto implements IPsychiatricAdmissionExamDtoPagedResultDto {
    items!: PsychiatricAdmissionExamDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPsychiatricAdmissionExamDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PsychiatricAdmissionExamDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PsychiatricAdmissionExamDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PsychiatricAdmissionExamDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PsychiatricAdmissionExamDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PsychiatricAdmissionExamDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPsychiatricAdmissionExamDtoPagedResultDto {
    items: PsychiatricAdmissionExamDto[] | undefined;
    totalCount: number;
}

export class PsychiatricProfileDto implements IPsychiatricProfileDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    psychiatricProfileType!: DictionaryDto;
    note!: string | undefined;

    constructor(data?: IPsychiatricProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.psychiatricProfileType = _data["psychiatricProfileType"] ? DictionaryDto.fromJS(_data["psychiatricProfileType"]) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): PsychiatricProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new PsychiatricProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["psychiatricProfileType"] = this.psychiatricProfileType ? this.psychiatricProfileType.toJSON() : <any>undefined;
        data["note"] = this.note;
        return data;
    }

    clone(): PsychiatricProfileDto {
        const json = this.toJSON();
        let result = new PsychiatricProfileDto();
        result.init(json);
        return result;
    }
}

export interface IPsychiatricProfileDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    psychiatricProfileType: DictionaryDto;
    note: string | undefined;
}

export class PsychiatricProfileDtoPagedResultDto implements IPsychiatricProfileDtoPagedResultDto {
    items!: PsychiatricProfileDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPsychiatricProfileDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PsychiatricProfileDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PsychiatricProfileDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PsychiatricProfileDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PsychiatricProfileDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PsychiatricProfileDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPsychiatricProfileDtoPagedResultDto {
    items: PsychiatricProfileDto[] | undefined;
    totalCount: number;
}

export class RecentPatientNoteActivityDto implements IRecentPatientNoteActivityDto {
    patient!: SimplePatientDto;
    lastActivityTime!: Date | undefined;
    operationalUnitId!: number | undefined;
    operationalUnitName!: string | undefined;

    constructor(data?: IRecentPatientNoteActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patient = _data["patient"] ? SimplePatientDto.fromJS(_data["patient"]) : <any>undefined;
            this.lastActivityTime = _data["lastActivityTime"] ? new Date(_data["lastActivityTime"].toString()) : <any>undefined;
            this.operationalUnitId = _data["operationalUnitId"];
            this.operationalUnitName = _data["operationalUnitName"];
        }
    }

    static fromJS(data: any): RecentPatientNoteActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecentPatientNoteActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["lastActivityTime"] = this.lastActivityTime ? this.lastActivityTime.toISOString() : <any>undefined;
        data["operationalUnitId"] = this.operationalUnitId;
        data["operationalUnitName"] = this.operationalUnitName;
        return data;
    }

    clone(): RecentPatientNoteActivityDto {
        const json = this.toJSON();
        let result = new RecentPatientNoteActivityDto();
        result.init(json);
        return result;
    }
}

export interface IRecentPatientNoteActivityDto {
    patient: SimplePatientDto;
    lastActivityTime: Date | undefined;
    operationalUnitId: number | undefined;
    operationalUnitName: string | undefined;
}

export class RecordHistoryDto implements IRecordHistoryDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    entityType!: string | undefined;
    entityId!: string | undefined;
    action!: DictionaryDto;
    changesDescription!: string | undefined;
    label!: string | undefined;
    patientId!: number | undefined;
    patientLabel!: string | undefined;

    constructor(data?: IRecordHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.action = _data["action"] ? DictionaryDto.fromJS(_data["action"]) : <any>undefined;
            this.changesDescription = _data["changesDescription"];
            this.label = _data["label"];
            this.patientId = _data["patientId"];
            this.patientLabel = _data["patientLabel"];
        }
    }

    static fromJS(data: any): RecordHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["action"] = this.action ? this.action.toJSON() : <any>undefined;
        data["changesDescription"] = this.changesDescription;
        data["label"] = this.label;
        data["patientId"] = this.patientId;
        data["patientLabel"] = this.patientLabel;
        return data;
    }

    clone(): RecordHistoryDto {
        const json = this.toJSON();
        let result = new RecordHistoryDto();
        result.init(json);
        return result;
    }
}

export interface IRecordHistoryDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    entityType: string | undefined;
    entityId: string | undefined;
    action: DictionaryDto;
    changesDescription: string | undefined;
    label: string | undefined;
    patientId: number | undefined;
    patientLabel: string | undefined;
}

export class RecordHistoryDtoPagedResultDto implements IRecordHistoryDtoPagedResultDto {
    items!: RecordHistoryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IRecordHistoryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RecordHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RecordHistoryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordHistoryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RecordHistoryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RecordHistoryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRecordHistoryDtoPagedResultDto {
    items: RecordHistoryDto[] | undefined;
    totalCount: number;
}

export class RegionDto implements IRegionDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): RegionDto {
        const json = this.toJSON();
        let result = new RegionDto();
        result.init(json);
        return result;
    }
}

export interface IRegionDto {
    id: number;
    name: string | undefined;
}

export class RegisterInput implements IRegisterInput {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse!: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin!: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class ReHospitalizePatientDto implements IReHospitalizePatientDto {
    patientId!: number;
    operationalUnitId!: number;

    constructor(data?: IReHospitalizePatientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.operationalUnitId = _data["operationalUnitId"];
        }
    }

    static fromJS(data: any): ReHospitalizePatientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReHospitalizePatientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["operationalUnitId"] = this.operationalUnitId;
        return data;
    }

    clone(): ReHospitalizePatientDto {
        const json = this.toJSON();
        let result = new ReHospitalizePatientDto();
        result.init(json);
        return result;
    }
}

export interface IReHospitalizePatientDto {
    patientId: number;
    operationalUnitId: number;
}

export class ReportAttenceDto implements IReportAttenceDto {
    patient!: PatientDto;
    attendanceMarkCount!: AttendanceMarkCountDto[] | undefined;

    constructor(data?: IReportAttenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patient = _data["patient"] ? PatientDto.fromJS(_data["patient"]) : <any>undefined;
            if (Array.isArray(_data["attendanceMarkCount"])) {
                this.attendanceMarkCount = [] as any;
                for (let item of _data["attendanceMarkCount"])
                    this.attendanceMarkCount!.push(AttendanceMarkCountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportAttenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportAttenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        if (Array.isArray(this.attendanceMarkCount)) {
            data["attendanceMarkCount"] = [];
            for (let item of this.attendanceMarkCount)
                data["attendanceMarkCount"].push(item.toJSON());
        }
        return data;
    }

    clone(): ReportAttenceDto {
        const json = this.toJSON();
        let result = new ReportAttenceDto();
        result.init(json);
        return result;
    }
}

export interface IReportAttenceDto {
    patient: PatientDto;
    attendanceMarkCount: AttendanceMarkCountDto[] | undefined;
}

export class ReportAttenceDtoPagedResultDto implements IReportAttenceDtoPagedResultDto {
    items!: ReportAttenceDto[] | undefined;
    totalCount!: number;

    constructor(data?: IReportAttenceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportAttenceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ReportAttenceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportAttenceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ReportAttenceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReportAttenceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReportAttenceDtoPagedResultDto {
    items: ReportAttenceDto[] | undefined;
    totalCount: number;
}

export class ReportMealSlotDto implements IReportMealSlotDto {
    mealSlot!: DictionaryDto;
    mealCounts!: MealCountDto[] | undefined;

    constructor(data?: IReportMealSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mealSlot = _data["mealSlot"] ? DictionaryDto.fromJS(_data["mealSlot"]) : <any>undefined;
            if (Array.isArray(_data["mealCounts"])) {
                this.mealCounts = [] as any;
                for (let item of _data["mealCounts"])
                    this.mealCounts!.push(MealCountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportMealSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportMealSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mealSlot"] = this.mealSlot ? this.mealSlot.toJSON() : <any>undefined;
        if (Array.isArray(this.mealCounts)) {
            data["mealCounts"] = [];
            for (let item of this.mealCounts)
                data["mealCounts"].push(item.toJSON());
        }
        return data;
    }

    clone(): ReportMealSlotDto {
        const json = this.toJSON();
        let result = new ReportMealSlotDto();
        result.init(json);
        return result;
    }
}

export interface IReportMealSlotDto {
    mealSlot: DictionaryDto;
    mealCounts: MealCountDto[] | undefined;
}

export class ReportPatientMealDto implements IReportPatientMealDto {
    patient!: PatientDto;
    mealSlots!: ReportMealSlotDto[] | undefined;

    constructor(data?: IReportPatientMealDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patient = _data["patient"] ? PatientDto.fromJS(_data["patient"]) : <any>undefined;
            if (Array.isArray(_data["mealSlots"])) {
                this.mealSlots = [] as any;
                for (let item of _data["mealSlots"])
                    this.mealSlots!.push(ReportMealSlotDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportPatientMealDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportPatientMealDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        if (Array.isArray(this.mealSlots)) {
            data["mealSlots"] = [];
            for (let item of this.mealSlots)
                data["mealSlots"].push(item.toJSON());
        }
        return data;
    }

    clone(): ReportPatientMealDto {
        const json = this.toJSON();
        let result = new ReportPatientMealDto();
        result.init(json);
        return result;
    }
}

export interface IReportPatientMealDto {
    patient: PatientDto;
    mealSlots: ReportMealSlotDto[] | undefined;
}

export class ReportPatientMealDtoPagedResultDto implements IReportPatientMealDtoPagedResultDto {
    items!: ReportPatientMealDto[] | undefined;
    totalCount!: number;

    constructor(data?: IReportPatientMealDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportPatientMealDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ReportPatientMealDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportPatientMealDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ReportPatientMealDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReportPatientMealDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReportPatientMealDtoPagedResultDto {
    items: ReportPatientMealDto[] | undefined;
    totalCount: number;
}

export class ResetPasswordResultDto implements IResetPasswordResultDto {
    result!: IdentityResult;
    userId!: number;
    isUserActive!: boolean;

    constructor(data?: IResetPasswordResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? IdentityResult.fromJS(_data["result"]) : <any>undefined;
            this.userId = _data["userId"];
            this.isUserActive = _data["isUserActive"];
        }
    }

    static fromJS(data: any): ResetPasswordResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["isUserActive"] = this.isUserActive;
        return data;
    }

    clone(): ResetPasswordResultDto {
        const json = this.toJSON();
        let result = new ResetPasswordResultDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordResultDto {
    result: IdentityResult;
    userId: number;
    isUserActive: boolean;
}

export class RestoreUnitsInput implements IRestoreUnitsInput {
    medicationStockCode!: string;
    patientId!: number | undefined;
    units!: number;
    reasonId!: number;
    note!: string | undefined;

    constructor(data?: IRestoreUnitsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicationStockCode = _data["medicationStockCode"];
            this.patientId = _data["patientId"];
            this.units = _data["units"];
            this.reasonId = _data["reasonId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): RestoreUnitsInput {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreUnitsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicationStockCode"] = this.medicationStockCode;
        data["patientId"] = this.patientId;
        data["units"] = this.units;
        data["reasonId"] = this.reasonId;
        data["note"] = this.note;
        return data;
    }

    clone(): RestoreUnitsInput {
        const json = this.toJSON();
        let result = new RestoreUnitsInput();
        result.init(json);
        return result;
    }
}

export interface IRestoreUnitsInput {
    medicationStockCode: string;
    patientId: number | undefined;
    units: number;
    reasonId: number;
    note: string | undefined;
}

export class RoleDto implements IRoleDto {
    id!: number;
    name!: string;
    displayName!: string;
    normalizedName!: string | undefined;
    description!: string | undefined;
    grantedPermissions!: string[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    items!: RoleDto[] | undefined;
    totalCount!: number;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number;
    name!: string;
    displayName!: string;
    description!: string | undefined;
    isStatic!: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
}

export class RoleListDto implements IRoleListDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    creationTime!: Date;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: Date;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class RuntimeFieldHandle implements IRuntimeFieldHandle {
    value!: IntPtr;

    constructor(data?: IRuntimeFieldHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeFieldHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeFieldHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }

    clone(): RuntimeFieldHandle {
        const json = this.toJSON();
        let result = new RuntimeFieldHandle();
        result.init(json);
        return result;
    }
}

export interface IRuntimeFieldHandle {
    value: IntPtr;
}

export class RuntimeMethodHandle implements IRuntimeMethodHandle {
    value!: IntPtr;

    constructor(data?: IRuntimeMethodHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeMethodHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeMethodHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }

    clone(): RuntimeMethodHandle {
        const json = this.toJSON();
        let result = new RuntimeMethodHandle();
        result.init(json);
        return result;
    }
}

export interface IRuntimeMethodHandle {
    value: IntPtr;
}

export class RuntimeTypeHandle implements IRuntimeTypeHandle {
    value!: IntPtr;

    constructor(data?: IRuntimeTypeHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeTypeHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeTypeHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }

    clone(): RuntimeTypeHandle {
        const json = this.toJSON();
        let result = new RuntimeTypeHandle();
        result.init(json);
        return result;
    }
}

export interface IRuntimeTypeHandle {
    value: IntPtr;
}

export enum SecurityRuleSet {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class SetPatientMedicationAdministrationNoteDto implements ISetPatientMedicationAdministrationNoteDto {
    id!: number;
    note!: string | undefined;

    constructor(data?: ISetPatientMedicationAdministrationNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): SetPatientMedicationAdministrationNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetPatientMedicationAdministrationNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["note"] = this.note;
        return data;
    }

    clone(): SetPatientMedicationAdministrationNoteDto {
        const json = this.toJSON();
        let result = new SetPatientMedicationAdministrationNoteDto();
        result.init(json);
        return result;
    }
}

export interface ISetPatientMedicationAdministrationNoteDto {
    id: number;
    note: string | undefined;
}

export class SimpleMedicationDto implements ISimpleMedicationDto {
    id!: number;
    name!: string | undefined;
    identifier!: string | undefined;

    constructor(data?: ISimpleMedicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): SimpleMedicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleMedicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        return data;
    }

    clone(): SimpleMedicationDto {
        const json = this.toJSON();
        let result = new SimpleMedicationDto();
        result.init(json);
        return result;
    }
}

export interface ISimpleMedicationDto {
    id: number;
    name: string | undefined;
    identifier: string | undefined;
}

export class SimpleMedicationOrderDto implements ISimpleMedicationOrderDto {
    id!: number;
    orderNumber!: string | undefined;
    orderDate!: Date;
    orderStatus!: DictionaryDto;
    isActive!: boolean;
    note!: string | undefined;

    constructor(data?: ISimpleMedicationOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.orderStatus = _data["orderStatus"] ? DictionaryDto.fromJS(_data["orderStatus"]) : <any>undefined;
            this.isActive = _data["isActive"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): SimpleMedicationOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleMedicationOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["orderStatus"] = this.orderStatus ? this.orderStatus.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["note"] = this.note;
        return data;
    }

    clone(): SimpleMedicationOrderDto {
        const json = this.toJSON();
        let result = new SimpleMedicationOrderDto();
        result.init(json);
        return result;
    }
}

export interface ISimpleMedicationOrderDto {
    id: number;
    orderNumber: string | undefined;
    orderDate: Date;
    orderStatus: DictionaryDto;
    isActive: boolean;
    note: string | undefined;
}

export class SimpleOperationalUnitDto implements ISimpleOperationalUnitDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: ISimpleOperationalUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SimpleOperationalUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleOperationalUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): SimpleOperationalUnitDto {
        const json = this.toJSON();
        let result = new SimpleOperationalUnitDto();
        result.init(json);
        return result;
    }
}

export interface ISimpleOperationalUnitDto {
    id: number;
    name: string | undefined;
}

export class SimplePatientAssignmentDto implements ISimplePatientAssignmentDto {
    id!: number;
    assignedId!: number;
    patient!: SimplePatientDto;
    quantity!: number;

    constructor(data?: ISimplePatientAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assignedId = _data["assignedId"];
            this.patient = _data["patient"] ? SimplePatientDto.fromJS(_data["patient"]) : <any>undefined;
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): SimplePatientAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimplePatientAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assignedId"] = this.assignedId;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): SimplePatientAssignmentDto {
        const json = this.toJSON();
        let result = new SimplePatientAssignmentDto();
        result.init(json);
        return result;
    }
}

export interface ISimplePatientAssignmentDto {
    id: number;
    assignedId: number;
    patient: SimplePatientDto;
    quantity: number;
}

export class SimplePatientDto implements ISimplePatientDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    fullName!: string | undefined;

    constructor(data?: ISimplePatientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): SimplePatientDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimplePatientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        return data;
    }

    clone(): SimplePatientDto {
        const json = this.toJSON();
        let result = new SimplePatientDto();
        result.init(json);
        return result;
    }
}

export interface ISimplePatientDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
}

export class SimplePatientDtoPagedResultDto implements ISimplePatientDtoPagedResultDto {
    items!: SimplePatientDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISimplePatientDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SimplePatientDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SimplePatientDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimplePatientDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SimplePatientDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SimplePatientDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISimplePatientDtoPagedResultDto {
    items: SimplePatientDto[] | undefined;
    totalCount: number;
}

export class SimpleUserDto implements ISimpleUserDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    readonly fullName!: string | undefined;

    constructor(data?: ISimpleUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): SimpleUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        return data;
    }

    clone(): SimpleUserDto {
        const json = this.toJSON();
        let result = new SimpleUserDto();
        result.init(json);
        return result;
    }
}

export interface ISimpleUserDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
}

export class StockAdjustmentResultDto implements IStockAdjustmentResultDto {
    movementCount!: number;

    constructor(data?: IStockAdjustmentResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.movementCount = _data["movementCount"];
        }
    }

    static fromJS(data: any): StockAdjustmentResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockAdjustmentResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["movementCount"] = this.movementCount;
        return data;
    }

    clone(): StockAdjustmentResultDto {
        const json = this.toJSON();
        let result = new StockAdjustmentResultDto();
        result.init(json);
        return result;
    }
}

export interface IStockAdjustmentResultDto {
    movementCount: number;
}

export class StockHistoryEntryDto implements IStockHistoryEntryDto {
    movementId!: number;
    movementTypeStaticCode!: string | undefined;
    movementTypeDescription!: string | undefined;
    creationTime!: Date;
    creatorUserId!: number | undefined;
    operatorName!: string | undefined;
    unitsQuantity!: number | undefined;
    subUnitsQuantity!: number | undefined;
    note!: string | undefined;
    reasonDescription!: string | undefined;
    fromPatientId!: number | undefined;
    fromPatientName!: string | undefined;
    toPatientId!: number | undefined;
    toPatientName!: string | undefined;
    operationalUnitId!: number | undefined;
    operationalUnitName!: string | undefined;
    fromOperationalUnitId!: number | undefined;
    fromOperationalUnitName!: string | undefined;
    confirmedByUserId!: number | undefined;
    confirmedByName!: string | undefined;

    constructor(data?: IStockHistoryEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.movementId = _data["movementId"];
            this.movementTypeStaticCode = _data["movementTypeStaticCode"];
            this.movementTypeDescription = _data["movementTypeDescription"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.operatorName = _data["operatorName"];
            this.unitsQuantity = _data["unitsQuantity"];
            this.subUnitsQuantity = _data["subUnitsQuantity"];
            this.note = _data["note"];
            this.reasonDescription = _data["reasonDescription"];
            this.fromPatientId = _data["fromPatientId"];
            this.fromPatientName = _data["fromPatientName"];
            this.toPatientId = _data["toPatientId"];
            this.toPatientName = _data["toPatientName"];
            this.operationalUnitId = _data["operationalUnitId"];
            this.operationalUnitName = _data["operationalUnitName"];
            this.fromOperationalUnitId = _data["fromOperationalUnitId"];
            this.fromOperationalUnitName = _data["fromOperationalUnitName"];
            this.confirmedByUserId = _data["confirmedByUserId"];
            this.confirmedByName = _data["confirmedByName"];
        }
    }

    static fromJS(data: any): StockHistoryEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockHistoryEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["movementId"] = this.movementId;
        data["movementTypeStaticCode"] = this.movementTypeStaticCode;
        data["movementTypeDescription"] = this.movementTypeDescription;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["operatorName"] = this.operatorName;
        data["unitsQuantity"] = this.unitsQuantity;
        data["subUnitsQuantity"] = this.subUnitsQuantity;
        data["note"] = this.note;
        data["reasonDescription"] = this.reasonDescription;
        data["fromPatientId"] = this.fromPatientId;
        data["fromPatientName"] = this.fromPatientName;
        data["toPatientId"] = this.toPatientId;
        data["toPatientName"] = this.toPatientName;
        data["operationalUnitId"] = this.operationalUnitId;
        data["operationalUnitName"] = this.operationalUnitName;
        data["fromOperationalUnitId"] = this.fromOperationalUnitId;
        data["fromOperationalUnitName"] = this.fromOperationalUnitName;
        data["confirmedByUserId"] = this.confirmedByUserId;
        data["confirmedByName"] = this.confirmedByName;
        return data;
    }

    clone(): StockHistoryEntryDto {
        const json = this.toJSON();
        let result = new StockHistoryEntryDto();
        result.init(json);
        return result;
    }
}

export interface IStockHistoryEntryDto {
    movementId: number;
    movementTypeStaticCode: string | undefined;
    movementTypeDescription: string | undefined;
    creationTime: Date;
    creatorUserId: number | undefined;
    operatorName: string | undefined;
    unitsQuantity: number | undefined;
    subUnitsQuantity: number | undefined;
    note: string | undefined;
    reasonDescription: string | undefined;
    fromPatientId: number | undefined;
    fromPatientName: string | undefined;
    toPatientId: number | undefined;
    toPatientName: string | undefined;
    operationalUnitId: number | undefined;
    operationalUnitName: string | undefined;
    fromOperationalUnitId: number | undefined;
    fromOperationalUnitName: string | undefined;
    confirmedByUserId: number | undefined;
    confirmedByName: string | undefined;
}

export class StockHistoryEntryDtoPagedResultDto implements IStockHistoryEntryDtoPagedResultDto {
    items!: StockHistoryEntryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IStockHistoryEntryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StockHistoryEntryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StockHistoryEntryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockHistoryEntryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StockHistoryEntryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StockHistoryEntryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStockHistoryEntryDtoPagedResultDto {
    items: StockHistoryEntryDto[] | undefined;
    totalCount: number;
}

export class StockImpactDto implements IStockImpactDto {
    patientId!: number;
    medicationId!: number;
    medicationName!: string | undefined;

    constructor(data?: IStockImpactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.medicationId = _data["medicationId"];
            this.medicationName = _data["medicationName"];
        }
    }

    static fromJS(data: any): StockImpactDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockImpactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["medicationId"] = this.medicationId;
        data["medicationName"] = this.medicationName;
        return data;
    }

    clone(): StockImpactDto {
        const json = this.toJSON();
        let result = new StockImpactDto();
        result.init(json);
        return result;
    }
}

export interface IStockImpactDto {
    patientId: number;
    medicationId: number;
    medicationName: string | undefined;
}

export class StockLinkCandidateDto implements IStockLinkCandidateDto {
    patientMedicationAssignmentDetailId!: number;
    medicationStockId!: number;
    code!: string | undefined;
    expiryDate!: Date;
    medication!: SimpleMedicationDto;

    constructor(data?: IStockLinkCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientMedicationAssignmentDetailId = _data["patientMedicationAssignmentDetailId"];
            this.medicationStockId = _data["medicationStockId"];
            this.code = _data["code"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.medication = _data["medication"] ? SimpleMedicationDto.fromJS(_data["medication"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StockLinkCandidateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockLinkCandidateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientMedicationAssignmentDetailId"] = this.patientMedicationAssignmentDetailId;
        data["medicationStockId"] = this.medicationStockId;
        data["code"] = this.code;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        return data;
    }

    clone(): StockLinkCandidateDto {
        const json = this.toJSON();
        let result = new StockLinkCandidateDto();
        result.init(json);
        return result;
    }
}

export interface IStockLinkCandidateDto {
    patientMedicationAssignmentDetailId: number;
    medicationStockId: number;
    code: string | undefined;
    expiryDate: Date;
    medication: SimpleMedicationDto;
}

export class StructLayoutAttribute implements IStructLayoutAttribute {
    readonly typeId!: any | undefined;
    value!: LayoutKind;

    constructor(data?: IStructLayoutAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).typeId = _data["typeId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StructLayoutAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new StructLayoutAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["value"] = this.value;
        return data;
    }

    clone(): StructLayoutAttribute {
        const json = this.toJSON();
        let result = new StructLayoutAttribute();
        result.init(json);
        return result;
    }
}

export interface IStructLayoutAttribute {
    typeId: any | undefined;
    value: LayoutKind;
}

export class TemperatureDto implements ITemperatureDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    operationalUnit!: OperationalUnitDto;
    temperatureEnvironmentType!: TemperatureEnvironmentTypeDto;
    calendarShift!: CalendarShiftDto;
    dateTime!: Date;
    note!: string | undefined;
    temperatureRecurrence!: TemperatureRecurrenceDto;
    temperatureReading!: TemperatureReadingDto;

    constructor(data?: ITemperatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.operationalUnit = _data["operationalUnit"] ? OperationalUnitDto.fromJS(_data["operationalUnit"]) : <any>undefined;
            this.temperatureEnvironmentType = _data["temperatureEnvironmentType"] ? TemperatureEnvironmentTypeDto.fromJS(_data["temperatureEnvironmentType"]) : <any>undefined;
            this.calendarShift = _data["calendarShift"] ? CalendarShiftDto.fromJS(_data["calendarShift"]) : <any>undefined;
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.temperatureRecurrence = _data["temperatureRecurrence"] ? TemperatureRecurrenceDto.fromJS(_data["temperatureRecurrence"]) : <any>undefined;
            this.temperatureReading = _data["temperatureReading"] ? TemperatureReadingDto.fromJS(_data["temperatureReading"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TemperatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["operationalUnit"] = this.operationalUnit ? this.operationalUnit.toJSON() : <any>undefined;
        data["temperatureEnvironmentType"] = this.temperatureEnvironmentType ? this.temperatureEnvironmentType.toJSON() : <any>undefined;
        data["calendarShift"] = this.calendarShift ? this.calendarShift.toJSON() : <any>undefined;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["temperatureRecurrence"] = this.temperatureRecurrence ? this.temperatureRecurrence.toJSON() : <any>undefined;
        data["temperatureReading"] = this.temperatureReading ? this.temperatureReading.toJSON() : <any>undefined;
        return data;
    }

    clone(): TemperatureDto {
        const json = this.toJSON();
        let result = new TemperatureDto();
        result.init(json);
        return result;
    }
}

export interface ITemperatureDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    operationalUnit: OperationalUnitDto;
    temperatureEnvironmentType: TemperatureEnvironmentTypeDto;
    calendarShift: CalendarShiftDto;
    dateTime: Date;
    note: string | undefined;
    temperatureRecurrence: TemperatureRecurrenceDto;
    temperatureReading: TemperatureReadingDto;
}

export class TemperatureDtoPagedResultDto implements ITemperatureDtoPagedResultDto {
    items!: TemperatureDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITemperatureDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TemperatureDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TemperatureDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TemperatureDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TemperatureDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITemperatureDtoPagedResultDto {
    items: TemperatureDto[] | undefined;
    totalCount: number;
}

export class TemperatureEnvironmentTypeDto implements ITemperatureEnvironmentTypeDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;
    isStatic!: boolean;
    minValue!: number;
    maxValue!: number;

    constructor(data?: ITemperatureEnvironmentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
            this.isStatic = _data["isStatic"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
        }
    }

    static fromJS(data: any): TemperatureEnvironmentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureEnvironmentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        data["isStatic"] = this.isStatic;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        return data;
    }

    clone(): TemperatureEnvironmentTypeDto {
        const json = this.toJSON();
        let result = new TemperatureEnvironmentTypeDto();
        result.init(json);
        return result;
    }
}

export interface ITemperatureEnvironmentTypeDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
    isStatic: boolean;
    minValue: number;
    maxValue: number;
}

export class TemperatureEnvironmentTypeDtoPagedResultDto implements ITemperatureEnvironmentTypeDtoPagedResultDto {
    items!: TemperatureEnvironmentTypeDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITemperatureEnvironmentTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TemperatureEnvironmentTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TemperatureEnvironmentTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureEnvironmentTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TemperatureEnvironmentTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TemperatureEnvironmentTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITemperatureEnvironmentTypeDtoPagedResultDto {
    items: TemperatureEnvironmentTypeDto[] | undefined;
    totalCount: number;
}

export class TemperatureReadingDto implements ITemperatureReadingDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    value!: number;
    measuredAt!: Date;
    detectionNote!: string | undefined;

    constructor(data?: ITemperatureReadingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.value = _data["value"];
            this.measuredAt = _data["measuredAt"] ? new Date(_data["measuredAt"].toString()) : <any>undefined;
            this.detectionNote = _data["detectionNote"];
        }
    }

    static fromJS(data: any): TemperatureReadingDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureReadingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["value"] = this.value;
        data["measuredAt"] = this.measuredAt ? this.measuredAt.toISOString() : <any>undefined;
        data["detectionNote"] = this.detectionNote;
        return data;
    }

    clone(): TemperatureReadingDto {
        const json = this.toJSON();
        let result = new TemperatureReadingDto();
        result.init(json);
        return result;
    }
}

export interface ITemperatureReadingDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    value: number;
    measuredAt: Date;
    detectionNote: string | undefined;
}

export class TemperatureReadingDtoPagedResultDto implements ITemperatureReadingDtoPagedResultDto {
    items!: TemperatureReadingDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITemperatureReadingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TemperatureReadingDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TemperatureReadingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureReadingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TemperatureReadingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TemperatureReadingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITemperatureReadingDtoPagedResultDto {
    items: TemperatureReadingDto[] | undefined;
    totalCount: number;
}

export class TemperatureRecurrenceDto implements ITemperatureRecurrenceDto {
    id!: number;
    recurrenceType!: DictionaryDto;
    interval!: number;
    weekDays!: DictionaryDto[] | undefined;
    recurrenceEndType!: DictionaryDto;
    endDate!: Date | undefined;
    occurrenceCount!: number | undefined;
    monthlyRecurrenceType!: DictionaryDto;
    weekPosition!: DictionaryDto;

    constructor(data?: ITemperatureRecurrenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recurrenceType = _data["recurrenceType"] ? DictionaryDto.fromJS(_data["recurrenceType"]) : <any>undefined;
            this.interval = _data["interval"];
            if (Array.isArray(_data["weekDays"])) {
                this.weekDays = [] as any;
                for (let item of _data["weekDays"])
                    this.weekDays!.push(DictionaryDto.fromJS(item));
            }
            this.recurrenceEndType = _data["recurrenceEndType"] ? DictionaryDto.fromJS(_data["recurrenceEndType"]) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.occurrenceCount = _data["occurrenceCount"];
            this.monthlyRecurrenceType = _data["monthlyRecurrenceType"] ? DictionaryDto.fromJS(_data["monthlyRecurrenceType"]) : <any>undefined;
            this.weekPosition = _data["weekPosition"] ? DictionaryDto.fromJS(_data["weekPosition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TemperatureRecurrenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureRecurrenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recurrenceType"] = this.recurrenceType ? this.recurrenceType.toJSON() : <any>undefined;
        data["interval"] = this.interval;
        if (Array.isArray(this.weekDays)) {
            data["weekDays"] = [];
            for (let item of this.weekDays)
                data["weekDays"].push(item.toJSON());
        }
        data["recurrenceEndType"] = this.recurrenceEndType ? this.recurrenceEndType.toJSON() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["occurrenceCount"] = this.occurrenceCount;
        data["monthlyRecurrenceType"] = this.monthlyRecurrenceType ? this.monthlyRecurrenceType.toJSON() : <any>undefined;
        data["weekPosition"] = this.weekPosition ? this.weekPosition.toJSON() : <any>undefined;
        return data;
    }

    clone(): TemperatureRecurrenceDto {
        const json = this.toJSON();
        let result = new TemperatureRecurrenceDto();
        result.init(json);
        return result;
    }
}

export interface ITemperatureRecurrenceDto {
    id: number;
    recurrenceType: DictionaryDto;
    interval: number;
    weekDays: DictionaryDto[] | undefined;
    recurrenceEndType: DictionaryDto;
    endDate: Date | undefined;
    occurrenceCount: number | undefined;
    monthlyRecurrenceType: DictionaryDto;
    weekPosition: DictionaryDto;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class TenantDto implements ITenantDto {
    id!: number;
    tenancyName!: string;
    name!: string;
    isActive!: boolean;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items!: TenantDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
}

export class TenantNotification implements ITenantNotification {
    id!: string;
    tenantId!: number | undefined;
    notificationName!: string | undefined;
    data!: NotificationData;
    entityType!: Type;
    entityTypeName!: string | undefined;
    entityId!: any | undefined;
    severity!: NotificationSeverity;
    creationTime!: Date;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.notificationName = _data["notificationName"];
            this.data = _data["data"] ? NotificationData.fromJS(_data["data"]) : <any>undefined;
            this.entityType = _data["entityType"] ? Type.fromJS(_data["entityType"]) : <any>undefined;
            this.entityTypeName = _data["entityTypeName"];
            this.entityId = _data["entityId"];
            this.severity = _data["severity"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantNotification {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : <any>undefined;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): TenantNotification {
        const json = this.toJSON();
        let result = new TenantNotification();
        result.init(json);
        return result;
    }
}

export interface ITenantNotification {
    id: string;
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityType: Type;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: Date;
}

export class TenantUrlDto implements ITenantUrlDto {
    id!: number;
    applicationUrl!: string | undefined;

    constructor(data?: ITenantUrlDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationUrl = _data["applicationUrl"];
        }
    }

    static fromJS(data: any): TenantUrlDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUrlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationUrl"] = this.applicationUrl;
        return data;
    }

    clone(): TenantUrlDto {
        const json = this.toJSON();
        let result = new TenantUrlDto();
        result.init(json);
        return result;
    }
}

export interface ITenantUrlDto {
    id: number;
    applicationUrl: string | undefined;
}

export class TherapeuticGoalDto implements ITherapeuticGoalDto {
    id!: number;
    therapeuticAreaType!: DictionaryDto;
    goalDefinition!: string | undefined;
    actions!: string | undefined;
    goalEvaluation!: string | undefined;
    actionsEvaluation!: string | undefined;

    constructor(data?: ITherapeuticGoalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.therapeuticAreaType = _data["therapeuticAreaType"] ? DictionaryDto.fromJS(_data["therapeuticAreaType"]) : <any>undefined;
            this.goalDefinition = _data["goalDefinition"];
            this.actions = _data["actions"];
            this.goalEvaluation = _data["goalEvaluation"];
            this.actionsEvaluation = _data["actionsEvaluation"];
        }
    }

    static fromJS(data: any): TherapeuticGoalDto {
        data = typeof data === 'object' ? data : {};
        let result = new TherapeuticGoalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["therapeuticAreaType"] = this.therapeuticAreaType ? this.therapeuticAreaType.toJSON() : <any>undefined;
        data["goalDefinition"] = this.goalDefinition;
        data["actions"] = this.actions;
        data["goalEvaluation"] = this.goalEvaluation;
        data["actionsEvaluation"] = this.actionsEvaluation;
        return data;
    }

    clone(): TherapeuticGoalDto {
        const json = this.toJSON();
        let result = new TherapeuticGoalDto();
        result.init(json);
        return result;
    }
}

export interface ITherapeuticGoalDto {
    id: number;
    therapeuticAreaType: DictionaryDto;
    goalDefinition: string | undefined;
    actions: string | undefined;
    goalEvaluation: string | undefined;
    actionsEvaluation: string | undefined;
}

export class TherapeuticProgramDto implements ITherapeuticProgramDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    name!: string | undefined;
    date!: Date;
    finalExamination!: string | undefined;
    therapeuticGoals!: TherapeuticGoalDto[] | undefined;

    constructor(data?: ITherapeuticProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.finalExamination = _data["finalExamination"];
            if (Array.isArray(_data["therapeuticGoals"])) {
                this.therapeuticGoals = [] as any;
                for (let item of _data["therapeuticGoals"])
                    this.therapeuticGoals!.push(TherapeuticGoalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TherapeuticProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new TherapeuticProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["finalExamination"] = this.finalExamination;
        if (Array.isArray(this.therapeuticGoals)) {
            data["therapeuticGoals"] = [];
            for (let item of this.therapeuticGoals)
                data["therapeuticGoals"].push(item.toJSON());
        }
        return data;
    }

    clone(): TherapeuticProgramDto {
        const json = this.toJSON();
        let result = new TherapeuticProgramDto();
        result.init(json);
        return result;
    }
}

export interface ITherapeuticProgramDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    name: string | undefined;
    date: Date;
    finalExamination: string | undefined;
    therapeuticGoals: TherapeuticGoalDto[] | undefined;
}

export class TherapeuticProgramDtoPagedResultDto implements ITherapeuticProgramDtoPagedResultDto {
    items!: TherapeuticProgramDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITherapeuticProgramDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TherapeuticProgramDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TherapeuticProgramDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TherapeuticProgramDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TherapeuticProgramDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TherapeuticProgramDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITherapeuticProgramDtoPagedResultDto {
    items: TherapeuticProgramDto[] | undefined;
    totalCount: number;
}

export class TherapyLinkCandidateDto implements ITherapyLinkCandidateDto {
    patientMedicationTherapyId!: number;
    medication!: SimpleMedicationDto;
    startDate!: Date;
    endDate!: Date | undefined;

    constructor(data?: ITherapyLinkCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientMedicationTherapyId = _data["patientMedicationTherapyId"];
            this.medication = _data["medication"] ? SimpleMedicationDto.fromJS(_data["medication"]) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TherapyLinkCandidateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TherapyLinkCandidateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientMedicationTherapyId"] = this.patientMedicationTherapyId;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): TherapyLinkCandidateDto {
        const json = this.toJSON();
        let result = new TherapyLinkCandidateDto();
        result.init(json);
        return result;
    }
}

export interface ITherapyLinkCandidateDto {
    patientMedicationTherapyId: number;
    medication: SimpleMedicationDto;
    startDate: Date;
    endDate: Date | undefined;
}

export class TransferPatientMedicationQuantityDto implements ITransferPatientMedicationQuantityDto {
    id!: number;
    fromPatientId!: number;
    toPatientId!: number;
    quantity!: number;

    constructor(data?: ITransferPatientMedicationQuantityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fromPatientId = _data["fromPatientId"];
            this.toPatientId = _data["toPatientId"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): TransferPatientMedicationQuantityDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferPatientMedicationQuantityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromPatientId"] = this.fromPatientId;
        data["toPatientId"] = this.toPatientId;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): TransferPatientMedicationQuantityDto {
        const json = this.toJSON();
        let result = new TransferPatientMedicationQuantityDto();
        result.init(json);
        return result;
    }
}

export interface ITransferPatientMedicationQuantityDto {
    id: number;
    fromPatientId: number;
    toPatientId: number;
    quantity: number;
}

export class TransferPatientMedicationStockDto implements ITransferPatientMedicationStockDto {
    id!: number;
    fromPatientId!: number;
    toPatientId!: number;
    stockId!: number;

    constructor(data?: ITransferPatientMedicationStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fromPatientId = _data["fromPatientId"];
            this.toPatientId = _data["toPatientId"];
            this.stockId = _data["stockId"];
        }
    }

    static fromJS(data: any): TransferPatientMedicationStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferPatientMedicationStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromPatientId"] = this.fromPatientId;
        data["toPatientId"] = this.toPatientId;
        data["stockId"] = this.stockId;
        return data;
    }

    clone(): TransferPatientMedicationStockDto {
        const json = this.toJSON();
        let result = new TransferPatientMedicationStockDto();
        result.init(json);
        return result;
    }
}

export interface ITransferPatientMedicationStockDto {
    id: number;
    fromPatientId: number;
    toPatientId: number;
    stockId: number;
}

export class TransferStockInput implements ITransferStockInput {
    medicationStockCode!: string;
    fromPatientId!: number | undefined;
    toPatientId!: number;
    destinationOperationalUnitId!: number;
    note!: string | undefined;
    acknowledgeWarnings!: boolean;

    constructor(data?: ITransferStockInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicationStockCode = _data["medicationStockCode"];
            this.fromPatientId = _data["fromPatientId"];
            this.toPatientId = _data["toPatientId"];
            this.destinationOperationalUnitId = _data["destinationOperationalUnitId"];
            this.note = _data["note"];
            this.acknowledgeWarnings = _data["acknowledgeWarnings"];
        }
    }

    static fromJS(data: any): TransferStockInput {
        data = typeof data === 'object' ? data : {};
        let result = new TransferStockInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicationStockCode"] = this.medicationStockCode;
        data["fromPatientId"] = this.fromPatientId;
        data["toPatientId"] = this.toPatientId;
        data["destinationOperationalUnitId"] = this.destinationOperationalUnitId;
        data["note"] = this.note;
        data["acknowledgeWarnings"] = this.acknowledgeWarnings;
        return data;
    }

    clone(): TransferStockInput {
        const json = this.toJSON();
        let result = new TransferStockInput();
        result.init(json);
        return result;
    }
}

export interface ITransferStockInput {
    medicationStockCode: string;
    fromPatientId: number | undefined;
    toPatientId: number;
    destinationOperationalUnitId: number;
    note: string | undefined;
    acknowledgeWarnings: boolean;
}

export class TransferStockResultDto implements ITransferStockResultDto {
    movementCount!: number;

    constructor(data?: ITransferStockResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.movementCount = _data["movementCount"];
        }
    }

    static fromJS(data: any): TransferStockResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferStockResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["movementCount"] = this.movementCount;
        return data;
    }

    clone(): TransferStockResultDto {
        const json = this.toJSON();
        let result = new TransferStockResultDto();
        result.init(json);
        return result;
    }
}

export interface ITransferStockResultDto {
    movementCount: number;
}

export class TransferWarningDto implements ITransferWarningDto {
    key!: string | undefined;
    message!: string | undefined;

    constructor(data?: ITransferWarningDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): TransferWarningDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferWarningDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["message"] = this.message;
        return data;
    }

    clone(): TransferWarningDto {
        const json = this.toJSON();
        let result = new TransferWarningDto();
        result.init(json);
        return result;
    }
}

export interface ITransferWarningDto {
    key: string | undefined;
    message: string | undefined;
}

export class Type implements IType {
    readonly name!: string | undefined;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    readonly isInterface!: boolean;
    memberType!: MemberTypes;
    readonly namespace!: string | undefined;
    readonly assemblyQualifiedName!: string | undefined;
    readonly fullName!: string | undefined;
    assembly!: Assembly;
    module!: Module;
    readonly isNested!: boolean;
    declaringType!: Type;
    declaringMethod!: MethodBase;
    reflectedType!: Type;
    underlyingSystemType!: Type;
    readonly isTypeDefinition!: boolean;
    readonly isArray!: boolean;
    readonly isByRef!: boolean;
    readonly isPointer!: boolean;
    readonly isConstructedGenericType!: boolean;
    readonly isGenericParameter!: boolean;
    readonly isGenericTypeParameter!: boolean;
    readonly isGenericMethodParameter!: boolean;
    readonly isGenericType!: boolean;
    readonly isGenericTypeDefinition!: boolean;
    readonly isSZArray!: boolean;
    readonly isVariableBoundArray!: boolean;
    readonly isByRefLike!: boolean;
    readonly hasElementType!: boolean;
    readonly genericTypeArguments!: Type[] | undefined;
    readonly genericParameterPosition!: number;
    genericParameterAttributes!: GenericParameterAttributes;
    attributes!: TypeAttributes;
    readonly isAbstract!: boolean;
    readonly isImport!: boolean;
    readonly isSealed!: boolean;
    readonly isSpecialName!: boolean;
    readonly isClass!: boolean;
    readonly isNestedAssembly!: boolean;
    readonly isNestedFamANDAssem!: boolean;
    readonly isNestedFamily!: boolean;
    readonly isNestedFamORAssem!: boolean;
    readonly isNestedPrivate!: boolean;
    readonly isNestedPublic!: boolean;
    readonly isNotPublic!: boolean;
    readonly isPublic!: boolean;
    readonly isAutoLayout!: boolean;
    readonly isExplicitLayout!: boolean;
    readonly isLayoutSequential!: boolean;
    readonly isAnsiClass!: boolean;
    readonly isAutoClass!: boolean;
    readonly isUnicodeClass!: boolean;
    readonly isCOMObject!: boolean;
    readonly isContextful!: boolean;
    readonly isEnum!: boolean;
    readonly isMarshalByRef!: boolean;
    readonly isPrimitive!: boolean;
    readonly isValueType!: boolean;
    readonly isSignatureType!: boolean;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    structLayoutAttribute!: StructLayoutAttribute;
    typeInitializer!: ConstructorInfo;
    typeHandle!: RuntimeTypeHandle;
    readonly guid!: string;
    baseType!: Type;
    readonly isSerializable!: boolean;
    readonly containsGenericParameters!: boolean;
    readonly isVisible!: boolean;

    constructor(data?: IType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            (<any>this).isInterface = _data["isInterface"];
            this.memberType = _data["memberType"];
            (<any>this).namespace = _data["namespace"];
            (<any>this).assemblyQualifiedName = _data["assemblyQualifiedName"];
            (<any>this).fullName = _data["fullName"];
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            (<any>this).isNested = _data["isNested"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.declaringMethod = _data["declaringMethod"] ? MethodBase.fromJS(_data["declaringMethod"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.underlyingSystemType = _data["underlyingSystemType"] ? Type.fromJS(_data["underlyingSystemType"]) : <any>undefined;
            (<any>this).isTypeDefinition = _data["isTypeDefinition"];
            (<any>this).isArray = _data["isArray"];
            (<any>this).isByRef = _data["isByRef"];
            (<any>this).isPointer = _data["isPointer"];
            (<any>this).isConstructedGenericType = _data["isConstructedGenericType"];
            (<any>this).isGenericParameter = _data["isGenericParameter"];
            (<any>this).isGenericTypeParameter = _data["isGenericTypeParameter"];
            (<any>this).isGenericMethodParameter = _data["isGenericMethodParameter"];
            (<any>this).isGenericType = _data["isGenericType"];
            (<any>this).isGenericTypeDefinition = _data["isGenericTypeDefinition"];
            (<any>this).isSZArray = _data["isSZArray"];
            (<any>this).isVariableBoundArray = _data["isVariableBoundArray"];
            (<any>this).isByRefLike = _data["isByRefLike"];
            (<any>this).hasElementType = _data["hasElementType"];
            if (Array.isArray(_data["genericTypeArguments"])) {
                (<any>this).genericTypeArguments = [] as any;
                for (let item of _data["genericTypeArguments"])
                    (<any>this).genericTypeArguments!.push(Type.fromJS(item));
            }
            (<any>this).genericParameterPosition = _data["genericParameterPosition"];
            this.genericParameterAttributes = _data["genericParameterAttributes"];
            this.attributes = _data["attributes"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isImport = _data["isImport"];
            (<any>this).isSealed = _data["isSealed"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isClass = _data["isClass"];
            (<any>this).isNestedAssembly = _data["isNestedAssembly"];
            (<any>this).isNestedFamANDAssem = _data["isNestedFamANDAssem"];
            (<any>this).isNestedFamily = _data["isNestedFamily"];
            (<any>this).isNestedFamORAssem = _data["isNestedFamORAssem"];
            (<any>this).isNestedPrivate = _data["isNestedPrivate"];
            (<any>this).isNestedPublic = _data["isNestedPublic"];
            (<any>this).isNotPublic = _data["isNotPublic"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isAutoLayout = _data["isAutoLayout"];
            (<any>this).isExplicitLayout = _data["isExplicitLayout"];
            (<any>this).isLayoutSequential = _data["isLayoutSequential"];
            (<any>this).isAnsiClass = _data["isAnsiClass"];
            (<any>this).isAutoClass = _data["isAutoClass"];
            (<any>this).isUnicodeClass = _data["isUnicodeClass"];
            (<any>this).isCOMObject = _data["isCOMObject"];
            (<any>this).isContextful = _data["isContextful"];
            (<any>this).isEnum = _data["isEnum"];
            (<any>this).isMarshalByRef = _data["isMarshalByRef"];
            (<any>this).isPrimitive = _data["isPrimitive"];
            (<any>this).isValueType = _data["isValueType"];
            (<any>this).isSignatureType = _data["isSignatureType"];
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.structLayoutAttribute = _data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(_data["structLayoutAttribute"]) : <any>undefined;
            this.typeInitializer = _data["typeInitializer"] ? ConstructorInfo.fromJS(_data["typeInitializer"]) : <any>undefined;
            this.typeHandle = _data["typeHandle"] ? RuntimeTypeHandle.fromJS(_data["typeHandle"]) : <any>undefined;
            (<any>this).guid = _data["guid"];
            this.baseType = _data["baseType"] ? Type.fromJS(_data["baseType"]) : <any>undefined;
            (<any>this).isSerializable = _data["isSerializable"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            (<any>this).isVisible = _data["isVisible"];
        }
    }

    static fromJS(data: any): Type {
        data = typeof data === 'object' ? data : {};
        let result = new Type();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["isInterface"] = this.isInterface;
        data["memberType"] = this.memberType;
        data["namespace"] = this.namespace;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName;
        data["fullName"] = this.fullName;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        data["isNested"] = this.isNested;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : <any>undefined;
        data["isTypeDefinition"] = this.isTypeDefinition;
        data["isArray"] = this.isArray;
        data["isByRef"] = this.isByRef;
        data["isPointer"] = this.isPointer;
        data["isConstructedGenericType"] = this.isConstructedGenericType;
        data["isGenericParameter"] = this.isGenericParameter;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter;
        data["isGenericType"] = this.isGenericType;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition;
        data["isSZArray"] = this.isSZArray;
        data["isVariableBoundArray"] = this.isVariableBoundArray;
        data["isByRefLike"] = this.isByRefLike;
        data["hasElementType"] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (let item of this.genericTypeArguments)
                data["genericTypeArguments"].push(item.toJSON());
        }
        data["genericParameterPosition"] = this.genericParameterPosition;
        data["genericParameterAttributes"] = this.genericParameterAttributes;
        data["attributes"] = this.attributes;
        data["isAbstract"] = this.isAbstract;
        data["isImport"] = this.isImport;
        data["isSealed"] = this.isSealed;
        data["isSpecialName"] = this.isSpecialName;
        data["isClass"] = this.isClass;
        data["isNestedAssembly"] = this.isNestedAssembly;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem;
        data["isNestedFamily"] = this.isNestedFamily;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem;
        data["isNestedPrivate"] = this.isNestedPrivate;
        data["isNestedPublic"] = this.isNestedPublic;
        data["isNotPublic"] = this.isNotPublic;
        data["isPublic"] = this.isPublic;
        data["isAutoLayout"] = this.isAutoLayout;
        data["isExplicitLayout"] = this.isExplicitLayout;
        data["isLayoutSequential"] = this.isLayoutSequential;
        data["isAnsiClass"] = this.isAnsiClass;
        data["isAutoClass"] = this.isAutoClass;
        data["isUnicodeClass"] = this.isUnicodeClass;
        data["isCOMObject"] = this.isCOMObject;
        data["isContextful"] = this.isContextful;
        data["isEnum"] = this.isEnum;
        data["isMarshalByRef"] = this.isMarshalByRef;
        data["isPrimitive"] = this.isPrimitive;
        data["isValueType"] = this.isValueType;
        data["isSignatureType"] = this.isSignatureType;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : <any>undefined;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : <any>undefined;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : <any>undefined;
        data["guid"] = this.guid;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : <any>undefined;
        data["isSerializable"] = this.isSerializable;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isVisible"] = this.isVisible;
        return data;
    }

    clone(): Type {
        const json = this.toJSON();
        let result = new Type();
        result.init(json);
        return result;
    }
}

export interface IType {
    name: string | undefined;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    isInterface: boolean;
    memberType: MemberTypes;
    namespace: string | undefined;
    assemblyQualifiedName: string | undefined;
    fullName: string | undefined;
    assembly: Assembly;
    module: Module;
    isNested: boolean;
    declaringType: Type;
    declaringMethod: MethodBase;
    reflectedType: Type;
    underlyingSystemType: Type;
    isTypeDefinition: boolean;
    isArray: boolean;
    isByRef: boolean;
    isPointer: boolean;
    isConstructedGenericType: boolean;
    isGenericParameter: boolean;
    isGenericTypeParameter: boolean;
    isGenericMethodParameter: boolean;
    isGenericType: boolean;
    isGenericTypeDefinition: boolean;
    isSZArray: boolean;
    isVariableBoundArray: boolean;
    isByRefLike: boolean;
    hasElementType: boolean;
    genericTypeArguments: Type[] | undefined;
    genericParameterPosition: number;
    genericParameterAttributes: GenericParameterAttributes;
    attributes: TypeAttributes;
    isAbstract: boolean;
    isImport: boolean;
    isSealed: boolean;
    isSpecialName: boolean;
    isClass: boolean;
    isNestedAssembly: boolean;
    isNestedFamANDAssem: boolean;
    isNestedFamily: boolean;
    isNestedFamORAssem: boolean;
    isNestedPrivate: boolean;
    isNestedPublic: boolean;
    isNotPublic: boolean;
    isPublic: boolean;
    isAutoLayout: boolean;
    isExplicitLayout: boolean;
    isLayoutSequential: boolean;
    isAnsiClass: boolean;
    isAutoClass: boolean;
    isUnicodeClass: boolean;
    isCOMObject: boolean;
    isContextful: boolean;
    isEnum: boolean;
    isMarshalByRef: boolean;
    isPrimitive: boolean;
    isValueType: boolean;
    isSignatureType: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    structLayoutAttribute: StructLayoutAttribute;
    typeInitializer: ConstructorInfo;
    typeHandle: RuntimeTypeHandle;
    guid: string;
    baseType: Type;
    isSerializable: boolean;
    containsGenericParameters: boolean;
    isVisible: boolean;
}

export enum TypeAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _16 = 16,
    _24 = 24,
    _32 = 32,
    _128 = 128,
    _256 = 256,
    _1024 = 1024,
    _2048 = 2048,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _65536 = 65536,
    _131072 = 131072,
    _196608 = 196608,
    _262144 = 262144,
    _264192 = 264192,
    _1048576 = 1048576,
    _12582912 = 12582912,
}

export class TypeInfo implements ITypeInfo {
    readonly name!: string | undefined;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    readonly isInterface!: boolean;
    memberType!: MemberTypes;
    readonly namespace!: string | undefined;
    readonly assemblyQualifiedName!: string | undefined;
    readonly fullName!: string | undefined;
    assembly!: Assembly;
    module!: Module;
    readonly isNested!: boolean;
    declaringType!: Type;
    declaringMethod!: MethodBase;
    reflectedType!: Type;
    underlyingSystemType!: Type;
    readonly isTypeDefinition!: boolean;
    readonly isArray!: boolean;
    readonly isByRef!: boolean;
    readonly isPointer!: boolean;
    readonly isConstructedGenericType!: boolean;
    readonly isGenericParameter!: boolean;
    readonly isGenericTypeParameter!: boolean;
    readonly isGenericMethodParameter!: boolean;
    readonly isGenericType!: boolean;
    readonly isGenericTypeDefinition!: boolean;
    readonly isSZArray!: boolean;
    readonly isVariableBoundArray!: boolean;
    readonly isByRefLike!: boolean;
    readonly hasElementType!: boolean;
    readonly genericTypeArguments!: Type[] | undefined;
    readonly genericParameterPosition!: number;
    genericParameterAttributes!: GenericParameterAttributes;
    attributes!: TypeAttributes;
    readonly isAbstract!: boolean;
    readonly isImport!: boolean;
    readonly isSealed!: boolean;
    readonly isSpecialName!: boolean;
    readonly isClass!: boolean;
    readonly isNestedAssembly!: boolean;
    readonly isNestedFamANDAssem!: boolean;
    readonly isNestedFamily!: boolean;
    readonly isNestedFamORAssem!: boolean;
    readonly isNestedPrivate!: boolean;
    readonly isNestedPublic!: boolean;
    readonly isNotPublic!: boolean;
    readonly isPublic!: boolean;
    readonly isAutoLayout!: boolean;
    readonly isExplicitLayout!: boolean;
    readonly isLayoutSequential!: boolean;
    readonly isAnsiClass!: boolean;
    readonly isAutoClass!: boolean;
    readonly isUnicodeClass!: boolean;
    readonly isCOMObject!: boolean;
    readonly isContextful!: boolean;
    readonly isEnum!: boolean;
    readonly isMarshalByRef!: boolean;
    readonly isPrimitive!: boolean;
    readonly isValueType!: boolean;
    readonly isSignatureType!: boolean;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    structLayoutAttribute!: StructLayoutAttribute;
    typeInitializer!: ConstructorInfo;
    typeHandle!: RuntimeTypeHandle;
    readonly guid!: string;
    baseType!: Type;
    readonly isSerializable!: boolean;
    readonly containsGenericParameters!: boolean;
    readonly isVisible!: boolean;
    readonly genericTypeParameters!: Type[] | undefined;
    readonly declaredConstructors!: ConstructorInfo[] | undefined;
    readonly declaredEvents!: EventInfo[] | undefined;
    readonly declaredFields!: FieldInfo[] | undefined;
    readonly declaredMembers!: MemberInfo[] | undefined;
    readonly declaredMethods!: MethodInfo[] | undefined;
    readonly declaredNestedTypes!: TypeInfo[] | undefined;
    readonly declaredProperties!: PropertyInfo[] | undefined;
    readonly implementedInterfaces!: Type[] | undefined;

    constructor(data?: ITypeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            (<any>this).isInterface = _data["isInterface"];
            this.memberType = _data["memberType"];
            (<any>this).namespace = _data["namespace"];
            (<any>this).assemblyQualifiedName = _data["assemblyQualifiedName"];
            (<any>this).fullName = _data["fullName"];
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            (<any>this).isNested = _data["isNested"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.declaringMethod = _data["declaringMethod"] ? MethodBase.fromJS(_data["declaringMethod"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.underlyingSystemType = _data["underlyingSystemType"] ? Type.fromJS(_data["underlyingSystemType"]) : <any>undefined;
            (<any>this).isTypeDefinition = _data["isTypeDefinition"];
            (<any>this).isArray = _data["isArray"];
            (<any>this).isByRef = _data["isByRef"];
            (<any>this).isPointer = _data["isPointer"];
            (<any>this).isConstructedGenericType = _data["isConstructedGenericType"];
            (<any>this).isGenericParameter = _data["isGenericParameter"];
            (<any>this).isGenericTypeParameter = _data["isGenericTypeParameter"];
            (<any>this).isGenericMethodParameter = _data["isGenericMethodParameter"];
            (<any>this).isGenericType = _data["isGenericType"];
            (<any>this).isGenericTypeDefinition = _data["isGenericTypeDefinition"];
            (<any>this).isSZArray = _data["isSZArray"];
            (<any>this).isVariableBoundArray = _data["isVariableBoundArray"];
            (<any>this).isByRefLike = _data["isByRefLike"];
            (<any>this).hasElementType = _data["hasElementType"];
            if (Array.isArray(_data["genericTypeArguments"])) {
                (<any>this).genericTypeArguments = [] as any;
                for (let item of _data["genericTypeArguments"])
                    (<any>this).genericTypeArguments!.push(Type.fromJS(item));
            }
            (<any>this).genericParameterPosition = _data["genericParameterPosition"];
            this.genericParameterAttributes = _data["genericParameterAttributes"];
            this.attributes = _data["attributes"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isImport = _data["isImport"];
            (<any>this).isSealed = _data["isSealed"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isClass = _data["isClass"];
            (<any>this).isNestedAssembly = _data["isNestedAssembly"];
            (<any>this).isNestedFamANDAssem = _data["isNestedFamANDAssem"];
            (<any>this).isNestedFamily = _data["isNestedFamily"];
            (<any>this).isNestedFamORAssem = _data["isNestedFamORAssem"];
            (<any>this).isNestedPrivate = _data["isNestedPrivate"];
            (<any>this).isNestedPublic = _data["isNestedPublic"];
            (<any>this).isNotPublic = _data["isNotPublic"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isAutoLayout = _data["isAutoLayout"];
            (<any>this).isExplicitLayout = _data["isExplicitLayout"];
            (<any>this).isLayoutSequential = _data["isLayoutSequential"];
            (<any>this).isAnsiClass = _data["isAnsiClass"];
            (<any>this).isAutoClass = _data["isAutoClass"];
            (<any>this).isUnicodeClass = _data["isUnicodeClass"];
            (<any>this).isCOMObject = _data["isCOMObject"];
            (<any>this).isContextful = _data["isContextful"];
            (<any>this).isEnum = _data["isEnum"];
            (<any>this).isMarshalByRef = _data["isMarshalByRef"];
            (<any>this).isPrimitive = _data["isPrimitive"];
            (<any>this).isValueType = _data["isValueType"];
            (<any>this).isSignatureType = _data["isSignatureType"];
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.structLayoutAttribute = _data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(_data["structLayoutAttribute"]) : <any>undefined;
            this.typeInitializer = _data["typeInitializer"] ? ConstructorInfo.fromJS(_data["typeInitializer"]) : <any>undefined;
            this.typeHandle = _data["typeHandle"] ? RuntimeTypeHandle.fromJS(_data["typeHandle"]) : <any>undefined;
            (<any>this).guid = _data["guid"];
            this.baseType = _data["baseType"] ? Type.fromJS(_data["baseType"]) : <any>undefined;
            (<any>this).isSerializable = _data["isSerializable"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            (<any>this).isVisible = _data["isVisible"];
            if (Array.isArray(_data["genericTypeParameters"])) {
                (<any>this).genericTypeParameters = [] as any;
                for (let item of _data["genericTypeParameters"])
                    (<any>this).genericTypeParameters!.push(Type.fromJS(item));
            }
            if (Array.isArray(_data["declaredConstructors"])) {
                (<any>this).declaredConstructors = [] as any;
                for (let item of _data["declaredConstructors"])
                    (<any>this).declaredConstructors!.push(ConstructorInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredEvents"])) {
                (<any>this).declaredEvents = [] as any;
                for (let item of _data["declaredEvents"])
                    (<any>this).declaredEvents!.push(EventInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredFields"])) {
                (<any>this).declaredFields = [] as any;
                for (let item of _data["declaredFields"])
                    (<any>this).declaredFields!.push(FieldInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredMembers"])) {
                (<any>this).declaredMembers = [] as any;
                for (let item of _data["declaredMembers"])
                    (<any>this).declaredMembers!.push(MemberInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredMethods"])) {
                (<any>this).declaredMethods = [] as any;
                for (let item of _data["declaredMethods"])
                    (<any>this).declaredMethods!.push(MethodInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredNestedTypes"])) {
                (<any>this).declaredNestedTypes = [] as any;
                for (let item of _data["declaredNestedTypes"])
                    (<any>this).declaredNestedTypes!.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredProperties"])) {
                (<any>this).declaredProperties = [] as any;
                for (let item of _data["declaredProperties"])
                    (<any>this).declaredProperties!.push(PropertyInfo.fromJS(item));
            }
            if (Array.isArray(_data["implementedInterfaces"])) {
                (<any>this).implementedInterfaces = [] as any;
                for (let item of _data["implementedInterfaces"])
                    (<any>this).implementedInterfaces!.push(Type.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TypeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TypeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["isInterface"] = this.isInterface;
        data["memberType"] = this.memberType;
        data["namespace"] = this.namespace;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName;
        data["fullName"] = this.fullName;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        data["isNested"] = this.isNested;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : <any>undefined;
        data["isTypeDefinition"] = this.isTypeDefinition;
        data["isArray"] = this.isArray;
        data["isByRef"] = this.isByRef;
        data["isPointer"] = this.isPointer;
        data["isConstructedGenericType"] = this.isConstructedGenericType;
        data["isGenericParameter"] = this.isGenericParameter;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter;
        data["isGenericType"] = this.isGenericType;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition;
        data["isSZArray"] = this.isSZArray;
        data["isVariableBoundArray"] = this.isVariableBoundArray;
        data["isByRefLike"] = this.isByRefLike;
        data["hasElementType"] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (let item of this.genericTypeArguments)
                data["genericTypeArguments"].push(item.toJSON());
        }
        data["genericParameterPosition"] = this.genericParameterPosition;
        data["genericParameterAttributes"] = this.genericParameterAttributes;
        data["attributes"] = this.attributes;
        data["isAbstract"] = this.isAbstract;
        data["isImport"] = this.isImport;
        data["isSealed"] = this.isSealed;
        data["isSpecialName"] = this.isSpecialName;
        data["isClass"] = this.isClass;
        data["isNestedAssembly"] = this.isNestedAssembly;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem;
        data["isNestedFamily"] = this.isNestedFamily;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem;
        data["isNestedPrivate"] = this.isNestedPrivate;
        data["isNestedPublic"] = this.isNestedPublic;
        data["isNotPublic"] = this.isNotPublic;
        data["isPublic"] = this.isPublic;
        data["isAutoLayout"] = this.isAutoLayout;
        data["isExplicitLayout"] = this.isExplicitLayout;
        data["isLayoutSequential"] = this.isLayoutSequential;
        data["isAnsiClass"] = this.isAnsiClass;
        data["isAutoClass"] = this.isAutoClass;
        data["isUnicodeClass"] = this.isUnicodeClass;
        data["isCOMObject"] = this.isCOMObject;
        data["isContextful"] = this.isContextful;
        data["isEnum"] = this.isEnum;
        data["isMarshalByRef"] = this.isMarshalByRef;
        data["isPrimitive"] = this.isPrimitive;
        data["isValueType"] = this.isValueType;
        data["isSignatureType"] = this.isSignatureType;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : <any>undefined;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : <any>undefined;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : <any>undefined;
        data["guid"] = this.guid;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : <any>undefined;
        data["isSerializable"] = this.isSerializable;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.genericTypeParameters)) {
            data["genericTypeParameters"] = [];
            for (let item of this.genericTypeParameters)
                data["genericTypeParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredConstructors)) {
            data["declaredConstructors"] = [];
            for (let item of this.declaredConstructors)
                data["declaredConstructors"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredEvents)) {
            data["declaredEvents"] = [];
            for (let item of this.declaredEvents)
                data["declaredEvents"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredFields)) {
            data["declaredFields"] = [];
            for (let item of this.declaredFields)
                data["declaredFields"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredMembers)) {
            data["declaredMembers"] = [];
            for (let item of this.declaredMembers)
                data["declaredMembers"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredMethods)) {
            data["declaredMethods"] = [];
            for (let item of this.declaredMethods)
                data["declaredMethods"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredNestedTypes)) {
            data["declaredNestedTypes"] = [];
            for (let item of this.declaredNestedTypes)
                data["declaredNestedTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredProperties)) {
            data["declaredProperties"] = [];
            for (let item of this.declaredProperties)
                data["declaredProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.implementedInterfaces)) {
            data["implementedInterfaces"] = [];
            for (let item of this.implementedInterfaces)
                data["implementedInterfaces"].push(item.toJSON());
        }
        return data;
    }

    clone(): TypeInfo {
        const json = this.toJSON();
        let result = new TypeInfo();
        result.init(json);
        return result;
    }
}

export interface ITypeInfo {
    name: string | undefined;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    isInterface: boolean;
    memberType: MemberTypes;
    namespace: string | undefined;
    assemblyQualifiedName: string | undefined;
    fullName: string | undefined;
    assembly: Assembly;
    module: Module;
    isNested: boolean;
    declaringType: Type;
    declaringMethod: MethodBase;
    reflectedType: Type;
    underlyingSystemType: Type;
    isTypeDefinition: boolean;
    isArray: boolean;
    isByRef: boolean;
    isPointer: boolean;
    isConstructedGenericType: boolean;
    isGenericParameter: boolean;
    isGenericTypeParameter: boolean;
    isGenericMethodParameter: boolean;
    isGenericType: boolean;
    isGenericTypeDefinition: boolean;
    isSZArray: boolean;
    isVariableBoundArray: boolean;
    isByRefLike: boolean;
    hasElementType: boolean;
    genericTypeArguments: Type[] | undefined;
    genericParameterPosition: number;
    genericParameterAttributes: GenericParameterAttributes;
    attributes: TypeAttributes;
    isAbstract: boolean;
    isImport: boolean;
    isSealed: boolean;
    isSpecialName: boolean;
    isClass: boolean;
    isNestedAssembly: boolean;
    isNestedFamANDAssem: boolean;
    isNestedFamily: boolean;
    isNestedFamORAssem: boolean;
    isNestedPrivate: boolean;
    isNestedPublic: boolean;
    isNotPublic: boolean;
    isPublic: boolean;
    isAutoLayout: boolean;
    isExplicitLayout: boolean;
    isLayoutSequential: boolean;
    isAnsiClass: boolean;
    isAutoClass: boolean;
    isUnicodeClass: boolean;
    isCOMObject: boolean;
    isContextful: boolean;
    isEnum: boolean;
    isMarshalByRef: boolean;
    isPrimitive: boolean;
    isValueType: boolean;
    isSignatureType: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    structLayoutAttribute: StructLayoutAttribute;
    typeInitializer: ConstructorInfo;
    typeHandle: RuntimeTypeHandle;
    guid: string;
    baseType: Type;
    isSerializable: boolean;
    containsGenericParameters: boolean;
    isVisible: boolean;
    genericTypeParameters: Type[] | undefined;
    declaredConstructors: ConstructorInfo[] | undefined;
    declaredEvents: EventInfo[] | undefined;
    declaredFields: FieldInfo[] | undefined;
    declaredMembers: MemberInfo[] | undefined;
    declaredMethods: MethodInfo[] | undefined;
    declaredNestedTypes: TypeInfo[] | undefined;
    declaredProperties: PropertyInfo[] | undefined;
    implementedInterfaces: Type[] | undefined;
}

export class UpdateAllergyDto implements IUpdateAllergyDto {
    id!: number;
    diagnosisDate!: Date;
    allergen!: string;
    note!: string | undefined;
    prescribedTherapyMedication!: string | undefined;
    isLifeSaving!: boolean;
    medicationId!: number | undefined;

    constructor(data?: IUpdateAllergyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.diagnosisDate = _data["diagnosisDate"] ? new Date(_data["diagnosisDate"].toString()) : <any>undefined;
            this.allergen = _data["allergen"];
            this.note = _data["note"];
            this.prescribedTherapyMedication = _data["prescribedTherapyMedication"];
            this.isLifeSaving = _data["isLifeSaving"];
            this.medicationId = _data["medicationId"];
        }
    }

    static fromJS(data: any): UpdateAllergyDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAllergyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["diagnosisDate"] = this.diagnosisDate ? this.diagnosisDate.toISOString() : <any>undefined;
        data["allergen"] = this.allergen;
        data["note"] = this.note;
        data["prescribedTherapyMedication"] = this.prescribedTherapyMedication;
        data["isLifeSaving"] = this.isLifeSaving;
        data["medicationId"] = this.medicationId;
        return data;
    }

    clone(): UpdateAllergyDto {
        const json = this.toJSON();
        let result = new UpdateAllergyDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAllergyDto {
    id: number;
    diagnosisDate: Date;
    allergen: string;
    note: string | undefined;
    prescribedTherapyMedication: string | undefined;
    isLifeSaving: boolean;
    medicationId: number | undefined;
}

export class UpdateAslContactDto implements IUpdateAslContactDto {
    id!: number;
    doctorName!: string | undefined;
    doctorPhoneNumber!: string | undefined;
    socialWorkerName!: string | undefined;
    socialWorkerPhoneNumber!: string | undefined;
    caseManager!: string | undefined;
    referenceFamilyMemberName!: string | undefined;
    referenceFamilyMemberPhoneNumber!: string | undefined;
    municipalityId!: number | undefined;
    disabilityService!: string | undefined;

    constructor(data?: IUpdateAslContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.doctorName = _data["doctorName"];
            this.doctorPhoneNumber = _data["doctorPhoneNumber"];
            this.socialWorkerName = _data["socialWorkerName"];
            this.socialWorkerPhoneNumber = _data["socialWorkerPhoneNumber"];
            this.caseManager = _data["caseManager"];
            this.referenceFamilyMemberName = _data["referenceFamilyMemberName"];
            this.referenceFamilyMemberPhoneNumber = _data["referenceFamilyMemberPhoneNumber"];
            this.municipalityId = _data["municipalityId"];
            this.disabilityService = _data["disabilityService"];
        }
    }

    static fromJS(data: any): UpdateAslContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAslContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["doctorName"] = this.doctorName;
        data["doctorPhoneNumber"] = this.doctorPhoneNumber;
        data["socialWorkerName"] = this.socialWorkerName;
        data["socialWorkerPhoneNumber"] = this.socialWorkerPhoneNumber;
        data["caseManager"] = this.caseManager;
        data["referenceFamilyMemberName"] = this.referenceFamilyMemberName;
        data["referenceFamilyMemberPhoneNumber"] = this.referenceFamilyMemberPhoneNumber;
        data["municipalityId"] = this.municipalityId;
        data["disabilityService"] = this.disabilityService;
        return data;
    }

    clone(): UpdateAslContactDto {
        const json = this.toJSON();
        let result = new UpdateAslContactDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAslContactDto {
    id: number;
    doctorName: string | undefined;
    doctorPhoneNumber: string | undefined;
    socialWorkerName: string | undefined;
    socialWorkerPhoneNumber: string | undefined;
    caseManager: string | undefined;
    referenceFamilyMemberName: string | undefined;
    referenceFamilyMemberPhoneNumber: string | undefined;
    municipalityId: number | undefined;
    disabilityService: string | undefined;
}

export class UpdateCalendarEventDto implements IUpdateCalendarEventDto {
    id!: number;
    taskId!: number;
    startDate!: Date;
    note!: string | undefined;
    userIds!: number[] | undefined;
    patientIds!: number[] | undefined;
    recurrence!: UpdateCalendarEventRecurrenceDto;

    constructor(data?: IUpdateCalendarEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskId = _data["taskId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.note = _data["note"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            if (Array.isArray(_data["patientIds"])) {
                this.patientIds = [] as any;
                for (let item of _data["patientIds"])
                    this.patientIds!.push(item);
            }
            this.recurrence = _data["recurrence"] ? UpdateCalendarEventRecurrenceDto.fromJS(_data["recurrence"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCalendarEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCalendarEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskId"] = this.taskId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        if (Array.isArray(this.patientIds)) {
            data["patientIds"] = [];
            for (let item of this.patientIds)
                data["patientIds"].push(item);
        }
        data["recurrence"] = this.recurrence ? this.recurrence.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateCalendarEventDto {
        const json = this.toJSON();
        let result = new UpdateCalendarEventDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCalendarEventDto {
    id: number;
    taskId: number;
    startDate: Date;
    note: string | undefined;
    userIds: number[] | undefined;
    patientIds: number[] | undefined;
    recurrence: UpdateCalendarEventRecurrenceDto;
}

export class UpdateCalendarEventRecurrenceDto implements IUpdateCalendarEventRecurrenceDto {
    id!: number;
    recurrenceTypeId!: number | undefined;
    interval!: number;
    weekDayIds!: number[] | undefined;
    recurrenceEndTypeId!: number | undefined;
    endDate!: Date | undefined;
    occurrenceCount!: number | undefined;
    monthlyRecurrenceTypeId!: number | undefined;
    weekPositionId!: number | undefined;

    constructor(data?: IUpdateCalendarEventRecurrenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recurrenceTypeId = _data["recurrenceTypeId"];
            this.interval = _data["interval"];
            if (Array.isArray(_data["weekDayIds"])) {
                this.weekDayIds = [] as any;
                for (let item of _data["weekDayIds"])
                    this.weekDayIds!.push(item);
            }
            this.recurrenceEndTypeId = _data["recurrenceEndTypeId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.occurrenceCount = _data["occurrenceCount"];
            this.monthlyRecurrenceTypeId = _data["monthlyRecurrenceTypeId"];
            this.weekPositionId = _data["weekPositionId"];
        }
    }

    static fromJS(data: any): UpdateCalendarEventRecurrenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCalendarEventRecurrenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recurrenceTypeId"] = this.recurrenceTypeId;
        data["interval"] = this.interval;
        if (Array.isArray(this.weekDayIds)) {
            data["weekDayIds"] = [];
            for (let item of this.weekDayIds)
                data["weekDayIds"].push(item);
        }
        data["recurrenceEndTypeId"] = this.recurrenceEndTypeId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["occurrenceCount"] = this.occurrenceCount;
        data["monthlyRecurrenceTypeId"] = this.monthlyRecurrenceTypeId;
        data["weekPositionId"] = this.weekPositionId;
        return data;
    }

    clone(): UpdateCalendarEventRecurrenceDto {
        const json = this.toJSON();
        let result = new UpdateCalendarEventRecurrenceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCalendarEventRecurrenceDto {
    id: number;
    recurrenceTypeId: number | undefined;
    interval: number;
    weekDayIds: number[] | undefined;
    recurrenceEndTypeId: number | undefined;
    endDate: Date | undefined;
    occurrenceCount: number | undefined;
    monthlyRecurrenceTypeId: number | undefined;
    weekPositionId: number | undefined;
}

export class UpdateCalendarShiftDto implements IUpdateCalendarShiftDto {
    id!: number;
    description!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;

    constructor(data?: IUpdateCalendarShiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateCalendarShiftDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCalendarShiftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): UpdateCalendarShiftDto {
        const json = this.toJSON();
        let result = new UpdateCalendarShiftDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCalendarShiftDto {
    id: number;
    description: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
}

export class UpdateCalendarStatusDto implements IUpdateCalendarStatusDto {
    id!: number;
    statusId!: number;
    dateTime!: Date;
    userId!: number;

    constructor(data?: IUpdateCalendarStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusId = _data["statusId"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UpdateCalendarStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCalendarStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusId"] = this.statusId;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        return data;
    }

    clone(): UpdateCalendarStatusDto {
        const json = this.toJSON();
        let result = new UpdateCalendarStatusDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCalendarStatusDto {
    id: number;
    statusId: number;
    dateTime: Date;
    userId: number;
}

export class UpdateCalendarTaskDto implements IUpdateCalendarTaskDto {
    id!: number;
    description!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;

    constructor(data?: IUpdateCalendarTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateCalendarTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCalendarTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): UpdateCalendarTaskDto {
        const json = this.toJSON();
        let result = new UpdateCalendarTaskDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCalendarTaskDto {
    id: number;
    description: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
}

export class UpdateCashBoxUserDto implements IUpdateCashBoxUserDto {
    id!: number;

    constructor(data?: IUpdateCashBoxUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCashBoxUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCashBoxUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateCashBoxUserDto {
        const json = this.toJSON();
        let result = new UpdateCashBoxUserDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCashBoxUserDto {
    id: number;
}

export class UpdateCashMovementDto implements IUpdateCashMovementDto {
    id!: number;
    cashMovementReasonId!: number;
    cashMovementTypeId!: number;
    date!: Date;
    amount!: number;
    note!: string | undefined;

    constructor(data?: IUpdateCashMovementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cashMovementReasonId = _data["cashMovementReasonId"];
            this.cashMovementTypeId = _data["cashMovementTypeId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateCashMovementDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCashMovementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cashMovementReasonId"] = this.cashMovementReasonId;
        data["cashMovementTypeId"] = this.cashMovementTypeId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateCashMovementDto {
        const json = this.toJSON();
        let result = new UpdateCashMovementDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCashMovementDto {
    id: number;
    cashMovementReasonId: number;
    cashMovementTypeId: number;
    date: Date;
    amount: number;
    note: string | undefined;
}

export class UpdateCashMovementReasonDto implements IUpdateCashMovementReasonDto {
    id!: number;
    description!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;
    reason!: string | undefined;
    cashMovementTypeId!: number;

    constructor(data?: IUpdateCashMovementReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
            this.reason = _data["reason"];
            this.cashMovementTypeId = _data["cashMovementTypeId"];
        }
    }

    static fromJS(data: any): UpdateCashMovementReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCashMovementReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        data["reason"] = this.reason;
        data["cashMovementTypeId"] = this.cashMovementTypeId;
        return data;
    }

    clone(): UpdateCashMovementReasonDto {
        const json = this.toJSON();
        let result = new UpdateCashMovementReasonDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCashMovementReasonDto {
    id: number;
    description: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
    reason: string | undefined;
    cashMovementTypeId: number;
}

export class UpdateCleaningEventDto implements IUpdateCleaningEventDto {
    id!: number;
    shiftId!: number;
    environmentTypeId!: number;
    interval!: number;
    startDate!: Date;
    note!: string | undefined;
    recurrence!: UpdateCleaningEventRecurrenceDto;

    constructor(data?: IUpdateCleaningEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shiftId = _data["shiftId"];
            this.environmentTypeId = _data["environmentTypeId"];
            this.interval = _data["interval"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.recurrence = _data["recurrence"] ? UpdateCleaningEventRecurrenceDto.fromJS(_data["recurrence"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCleaningEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCleaningEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shiftId"] = this.shiftId;
        data["environmentTypeId"] = this.environmentTypeId;
        data["interval"] = this.interval;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["recurrence"] = this.recurrence ? this.recurrence.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateCleaningEventDto {
        const json = this.toJSON();
        let result = new UpdateCleaningEventDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCleaningEventDto {
    id: number;
    shiftId: number;
    environmentTypeId: number;
    interval: number;
    startDate: Date;
    note: string | undefined;
    recurrence: UpdateCleaningEventRecurrenceDto;
}

export class UpdateCleaningEventRecurrenceDto implements IUpdateCleaningEventRecurrenceDto {
    id!: number;
    recurrenceTypeId!: number | undefined;
    interval!: number;
    weekDayIds!: number[] | undefined;
    recurrenceEndTypeId!: number | undefined;
    endDate!: Date | undefined;
    occurrenceCount!: number | undefined;
    monthlyRecurrenceTypeId!: number | undefined;
    weekPositionId!: number | undefined;

    constructor(data?: IUpdateCleaningEventRecurrenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recurrenceTypeId = _data["recurrenceTypeId"];
            this.interval = _data["interval"];
            if (Array.isArray(_data["weekDayIds"])) {
                this.weekDayIds = [] as any;
                for (let item of _data["weekDayIds"])
                    this.weekDayIds!.push(item);
            }
            this.recurrenceEndTypeId = _data["recurrenceEndTypeId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.occurrenceCount = _data["occurrenceCount"];
            this.monthlyRecurrenceTypeId = _data["monthlyRecurrenceTypeId"];
            this.weekPositionId = _data["weekPositionId"];
        }
    }

    static fromJS(data: any): UpdateCleaningEventRecurrenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCleaningEventRecurrenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recurrenceTypeId"] = this.recurrenceTypeId;
        data["interval"] = this.interval;
        if (Array.isArray(this.weekDayIds)) {
            data["weekDayIds"] = [];
            for (let item of this.weekDayIds)
                data["weekDayIds"].push(item);
        }
        data["recurrenceEndTypeId"] = this.recurrenceEndTypeId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["occurrenceCount"] = this.occurrenceCount;
        data["monthlyRecurrenceTypeId"] = this.monthlyRecurrenceTypeId;
        data["weekPositionId"] = this.weekPositionId;
        return data;
    }

    clone(): UpdateCleaningEventRecurrenceDto {
        const json = this.toJSON();
        let result = new UpdateCleaningEventRecurrenceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCleaningEventRecurrenceDto {
    id: number;
    recurrenceTypeId: number | undefined;
    interval: number;
    weekDayIds: number[] | undefined;
    recurrenceEndTypeId: number | undefined;
    endDate: Date | undefined;
    occurrenceCount: number | undefined;
    monthlyRecurrenceTypeId: number | undefined;
    weekPositionId: number | undefined;
}

export class UpdateCleaningStatusDto implements IUpdateCleaningStatusDto {
    id!: number;
    cleaningStatusTypeId!: number;
    dateTime!: Date;
    note!: string | undefined;

    constructor(data?: IUpdateCleaningStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cleaningStatusTypeId = _data["cleaningStatusTypeId"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateCleaningStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCleaningStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cleaningStatusTypeId"] = this.cleaningStatusTypeId;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateCleaningStatusDto {
        const json = this.toJSON();
        let result = new UpdateCleaningStatusDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCleaningStatusDto {
    id: number;
    cleaningStatusTypeId: number;
    dateTime: Date;
    note: string | undefined;
}

export class UpdateClinicalSummaryDto implements IUpdateClinicalSummaryDto {
    id!: number;
    note!: string | undefined;

    constructor(data?: IUpdateClinicalSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateClinicalSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClinicalSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateClinicalSummaryDto {
        const json = this.toJSON();
        let result = new UpdateClinicalSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateClinicalSummaryDto {
    id: number;
    note: string | undefined;
}

export class UpdateDependencyDto implements IUpdateDependencyDto {
    id!: number;
    dependencyType!: string | undefined;
    isActive!: boolean;
    firstContactDate!: Date | undefined;
    lastContactDate!: Date | undefined;
    note!: string | undefined;

    constructor(data?: IUpdateDependencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dependencyType = _data["dependencyType"];
            this.isActive = _data["isActive"];
            this.firstContactDate = _data["firstContactDate"] ? new Date(_data["firstContactDate"].toString()) : <any>undefined;
            this.lastContactDate = _data["lastContactDate"] ? new Date(_data["lastContactDate"].toString()) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateDependencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDependencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dependencyType"] = this.dependencyType;
        data["isActive"] = this.isActive;
        data["firstContactDate"] = this.firstContactDate ? this.firstContactDate.toISOString() : <any>undefined;
        data["lastContactDate"] = this.lastContactDate ? this.lastContactDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateDependencyDto {
        const json = this.toJSON();
        let result = new UpdateDependencyDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDependencyDto {
    id: number;
    dependencyType: string | undefined;
    isActive: boolean;
    firstContactDate: Date | undefined;
    lastContactDate: Date | undefined;
    note: string | undefined;
}

export class UpdateDiaryDto implements IUpdateDiaryDto {
    id!: number;
    observations!: string;
    interventions!: string | undefined;
    diaryTypeId!: number;

    constructor(data?: IUpdateDiaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.observations = _data["observations"];
            this.interventions = _data["interventions"];
            this.diaryTypeId = _data["diaryTypeId"];
        }
    }

    static fromJS(data: any): UpdateDiaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDiaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["observations"] = this.observations;
        data["interventions"] = this.interventions;
        data["diaryTypeId"] = this.diaryTypeId;
        return data;
    }

    clone(): UpdateDiaryDto {
        const json = this.toJSON();
        let result = new UpdateDiaryDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDiaryDto {
    id: number;
    observations: string;
    interventions: string | undefined;
    diaryTypeId: number;
}

export class UpdateDocumentDto implements IUpdateDocumentDto {
    id!: number;
    documentDate!: Date;
    expirationDate!: Date | undefined;
    sender!: string;
    recipient!: string;
    description!: string | undefined;
    documentTypeId!: number;
    fileId!: number;
    protocolTypeId!: number | undefined;

    constructor(data?: IUpdateDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.sender = _data["sender"];
            this.recipient = _data["recipient"];
            this.description = _data["description"];
            this.documentTypeId = _data["documentTypeId"];
            this.fileId = _data["fileId"];
            this.protocolTypeId = _data["protocolTypeId"];
        }
    }

    static fromJS(data: any): UpdateDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["sender"] = this.sender;
        data["recipient"] = this.recipient;
        data["description"] = this.description;
        data["documentTypeId"] = this.documentTypeId;
        data["fileId"] = this.fileId;
        data["protocolTypeId"] = this.protocolTypeId;
        return data;
    }

    clone(): UpdateDocumentDto {
        const json = this.toJSON();
        let result = new UpdateDocumentDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDocumentDto {
    id: number;
    documentDate: Date;
    expirationDate: Date | undefined;
    sender: string;
    recipient: string;
    description: string | undefined;
    documentTypeId: number;
    fileId: number;
    protocolTypeId: number | undefined;
}

export class UpdateDocumentTypeDto implements IUpdateDocumentTypeDto {
    id!: number;
    description!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;

    constructor(data?: IUpdateDocumentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateDocumentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): UpdateDocumentTypeDto {
        const json = this.toJSON();
        let result = new UpdateDocumentTypeDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDocumentTypeDto {
    id: number;
    description: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
}

export class UpdateEnvironmentTypeDto implements IUpdateEnvironmentTypeDto {
    id!: number;
    description!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;

    constructor(data?: IUpdateEnvironmentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateEnvironmentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEnvironmentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): UpdateEnvironmentTypeDto {
        const json = this.toJSON();
        let result = new UpdateEnvironmentTypeDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateEnvironmentTypeDto {
    id: number;
    description: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
}

export class UpdateFamilyHistoryDto implements IUpdateFamilyHistoryDto {
    id!: number;
    familialPathologies!: string | undefined;
    acquiredFamilyPathologies!: string | undefined;

    constructor(data?: IUpdateFamilyHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.familialPathologies = _data["familialPathologies"];
            this.acquiredFamilyPathologies = _data["acquiredFamilyPathologies"];
        }
    }

    static fromJS(data: any): UpdateFamilyHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFamilyHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["familialPathologies"] = this.familialPathologies;
        data["acquiredFamilyPathologies"] = this.acquiredFamilyPathologies;
        return data;
    }

    clone(): UpdateFamilyHistoryDto {
        const json = this.toJSON();
        let result = new UpdateFamilyHistoryDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateFamilyHistoryDto {
    id: number;
    familialPathologies: string | undefined;
    acquiredFamilyPathologies: string | undefined;
}

export class UpdateFamilyMemberDto implements IUpdateFamilyMemberDto {
    id!: number;
    familyMemberTypeId!: number;
    name!: string | undefined;
    age!: number | undefined;
    isDeceased!: boolean;
    disease!: string | undefined;
    profession!: string | undefined;
    residence!: string | undefined;
    note!: string | undefined;

    constructor(data?: IUpdateFamilyMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.familyMemberTypeId = _data["familyMemberTypeId"];
            this.name = _data["name"];
            this.age = _data["age"];
            this.isDeceased = _data["isDeceased"];
            this.disease = _data["disease"];
            this.profession = _data["profession"];
            this.residence = _data["residence"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateFamilyMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFamilyMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["familyMemberTypeId"] = this.familyMemberTypeId;
        data["name"] = this.name;
        data["age"] = this.age;
        data["isDeceased"] = this.isDeceased;
        data["disease"] = this.disease;
        data["profession"] = this.profession;
        data["residence"] = this.residence;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateFamilyMemberDto {
        const json = this.toJSON();
        let result = new UpdateFamilyMemberDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateFamilyMemberDto {
    id: number;
    familyMemberTypeId: number;
    name: string | undefined;
    age: number | undefined;
    isDeceased: boolean;
    disease: string | undefined;
    profession: string | undefined;
    residence: string | undefined;
    note: string | undefined;
}

export class UpdateForensicProfileDto implements IUpdateForensicProfileDto {
    id!: number;
    currentConviction!: string | undefined;
    expertJudgment!: string | undefined;
    firstOPGAdmissionAge!: number | undefined;
    opgStayYears!: number | undefined;
    opgAdmissionDiagnosis!: string | undefined;
    securityMeasureExpirationDate!: Date | undefined;
    selfHarmSuicidalHistory!: string | undefined;

    constructor(data?: IUpdateForensicProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.currentConviction = _data["currentConviction"];
            this.expertJudgment = _data["expertJudgment"];
            this.firstOPGAdmissionAge = _data["firstOPGAdmissionAge"];
            this.opgStayYears = _data["opgStayYears"];
            this.opgAdmissionDiagnosis = _data["opgAdmissionDiagnosis"];
            this.securityMeasureExpirationDate = _data["securityMeasureExpirationDate"] ? new Date(_data["securityMeasureExpirationDate"].toString()) : <any>undefined;
            this.selfHarmSuicidalHistory = _data["selfHarmSuicidalHistory"];
        }
    }

    static fromJS(data: any): UpdateForensicProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateForensicProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["currentConviction"] = this.currentConviction;
        data["expertJudgment"] = this.expertJudgment;
        data["firstOPGAdmissionAge"] = this.firstOPGAdmissionAge;
        data["opgStayYears"] = this.opgStayYears;
        data["opgAdmissionDiagnosis"] = this.opgAdmissionDiagnosis;
        data["securityMeasureExpirationDate"] = this.securityMeasureExpirationDate ? this.securityMeasureExpirationDate.toISOString() : <any>undefined;
        data["selfHarmSuicidalHistory"] = this.selfHarmSuicidalHistory;
        return data;
    }

    clone(): UpdateForensicProfileDto {
        const json = this.toJSON();
        let result = new UpdateForensicProfileDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateForensicProfileDto {
    id: number;
    currentConviction: string | undefined;
    expertJudgment: string | undefined;
    firstOPGAdmissionAge: number | undefined;
    opgStayYears: number | undefined;
    opgAdmissionDiagnosis: string | undefined;
    securityMeasureExpirationDate: Date | undefined;
    selfHarmSuicidalHistory: string | undefined;
}

export class UpdateHandoverNoteDto implements IUpdateHandoverNoteDto {
    id!: number;
    handoverNoteTypeId!: number;
    shiftTypeId!: number;
    note!: string | undefined;

    constructor(data?: IUpdateHandoverNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.handoverNoteTypeId = _data["handoverNoteTypeId"];
            this.shiftTypeId = _data["shiftTypeId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateHandoverNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHandoverNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["handoverNoteTypeId"] = this.handoverNoteTypeId;
        data["shiftTypeId"] = this.shiftTypeId;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateHandoverNoteDto {
        const json = this.toJSON();
        let result = new UpdateHandoverNoteDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateHandoverNoteDto {
    id: number;
    handoverNoteTypeId: number;
    shiftTypeId: number;
    note: string | undefined;
}

export class UpdateHistoryNoteDto implements IUpdateHistoryNoteDto {
    id!: number;
    note!: string | undefined;

    constructor(data?: IUpdateHistoryNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateHistoryNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHistoryNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateHistoryNoteDto {
        const json = this.toJSON();
        let result = new UpdateHistoryNoteDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateHistoryNoteDto {
    id: number;
    note: string | undefined;
}

export class UpdateIntoleranceDto implements IUpdateIntoleranceDto {
    id!: number;
    diagnosisDate!: Date;
    substance!: string;
    note!: string | undefined;

    constructor(data?: IUpdateIntoleranceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.diagnosisDate = _data["diagnosisDate"] ? new Date(_data["diagnosisDate"].toString()) : <any>undefined;
            this.substance = _data["substance"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateIntoleranceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIntoleranceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["diagnosisDate"] = this.diagnosisDate ? this.diagnosisDate.toISOString() : <any>undefined;
        data["substance"] = this.substance;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateIntoleranceDto {
        const json = this.toJSON();
        let result = new UpdateIntoleranceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateIntoleranceDto {
    id: number;
    diagnosisDate: Date;
    substance: string;
    note: string | undefined;
}

export class UpdateMedicalHistoryDto implements IUpdateMedicalHistoryDto {
    id!: number;
    identifier!: string;
    physiologicalHistory!: UpdatePhysiologicalHistoryDto;
    aslContact!: UpdateAslContactDto;
    historyNotes!: UpdateHistoryNoteDto[] | undefined;

    constructor(data?: IUpdateMedicalHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.physiologicalHistory = _data["physiologicalHistory"] ? UpdatePhysiologicalHistoryDto.fromJS(_data["physiologicalHistory"]) : <any>undefined;
            this.aslContact = _data["aslContact"] ? UpdateAslContactDto.fromJS(_data["aslContact"]) : <any>undefined;
            if (Array.isArray(_data["historyNotes"])) {
                this.historyNotes = [] as any;
                for (let item of _data["historyNotes"])
                    this.historyNotes!.push(UpdateHistoryNoteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateMedicalHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMedicalHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["physiologicalHistory"] = this.physiologicalHistory ? this.physiologicalHistory.toJSON() : <any>undefined;
        data["aslContact"] = this.aslContact ? this.aslContact.toJSON() : <any>undefined;
        if (Array.isArray(this.historyNotes)) {
            data["historyNotes"] = [];
            for (let item of this.historyNotes)
                data["historyNotes"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateMedicalHistoryDto {
        const json = this.toJSON();
        let result = new UpdateMedicalHistoryDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMedicalHistoryDto {
    id: number;
    identifier: string;
    physiologicalHistory: UpdatePhysiologicalHistoryDto;
    aslContact: UpdateAslContactDto;
    historyNotes: UpdateHistoryNoteDto[] | undefined;
}

export class UpdateMedicationDto implements IUpdateMedicationDto {
    id!: number;
    isActive!: boolean;
    requiresDoubleCheck!: boolean | undefined;
    name!: string | undefined;
    officialName!: string | undefined;
    manufacturer!: string | undefined;
    productCode!: string | undefined;
    eanCode!: string | undefined;
    atcCode!: string | undefined;
    cufNoteNumber!: string | undefined;
    identificationCode!: string | undefined;
    medicationPharmaceuticalFormTypeId!: number;
    medicationPackagingTypeId!: number;
    medicationStrengthUnitTypeId!: number | undefined;
    packageQuantity!: number;
    strengthValue!: number | undefined;
    drugClass!: string | undefined;
    productType!: string | undefined;
    prescriptionCategory!: string | undefined;
    prescribability!: string | undefined;
    pharmacotherapeuticCategory!: string | undefined;
    pharmaceuticalForm!: string | undefined;
    pharmaceuticalFormDetail!: string | undefined;
    storageTemperature!: string | undefined;
    activeIngredientDescription!: string | undefined;
    activeIngredients!: string | undefined;
    excipients!: string | undefined;
    indications!: string | undefined;
    contraindicationsAndSideEffects!: string | undefined;
    posology!: string | undefined;
    precautions!: string | undefined;
    warnings!: string | undefined;
    interactions!: string | undefined;
    undesirableEffects!: string | undefined;
    pregnancyAndLactation!: string | undefined;

    constructor(data?: IUpdateMedicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.requiresDoubleCheck = _data["requiresDoubleCheck"];
            this.name = _data["name"];
            this.officialName = _data["officialName"];
            this.manufacturer = _data["manufacturer"];
            this.productCode = _data["productCode"];
            this.eanCode = _data["eanCode"];
            this.atcCode = _data["atcCode"];
            this.cufNoteNumber = _data["cufNoteNumber"];
            this.identificationCode = _data["identificationCode"];
            this.medicationPharmaceuticalFormTypeId = _data["medicationPharmaceuticalFormTypeId"];
            this.medicationPackagingTypeId = _data["medicationPackagingTypeId"];
            this.medicationStrengthUnitTypeId = _data["medicationStrengthUnitTypeId"];
            this.packageQuantity = _data["packageQuantity"];
            this.strengthValue = _data["strengthValue"];
            this.drugClass = _data["drugClass"];
            this.productType = _data["productType"];
            this.prescriptionCategory = _data["prescriptionCategory"];
            this.prescribability = _data["prescribability"];
            this.pharmacotherapeuticCategory = _data["pharmacotherapeuticCategory"];
            this.pharmaceuticalForm = _data["pharmaceuticalForm"];
            this.pharmaceuticalFormDetail = _data["pharmaceuticalFormDetail"];
            this.storageTemperature = _data["storageTemperature"];
            this.activeIngredientDescription = _data["activeIngredientDescription"];
            this.activeIngredients = _data["activeIngredients"];
            this.excipients = _data["excipients"];
            this.indications = _data["indications"];
            this.contraindicationsAndSideEffects = _data["contraindicationsAndSideEffects"];
            this.posology = _data["posology"];
            this.precautions = _data["precautions"];
            this.warnings = _data["warnings"];
            this.interactions = _data["interactions"];
            this.undesirableEffects = _data["undesirableEffects"];
            this.pregnancyAndLactation = _data["pregnancyAndLactation"];
        }
    }

    static fromJS(data: any): UpdateMedicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMedicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["requiresDoubleCheck"] = this.requiresDoubleCheck;
        data["name"] = this.name;
        data["officialName"] = this.officialName;
        data["manufacturer"] = this.manufacturer;
        data["productCode"] = this.productCode;
        data["eanCode"] = this.eanCode;
        data["atcCode"] = this.atcCode;
        data["cufNoteNumber"] = this.cufNoteNumber;
        data["identificationCode"] = this.identificationCode;
        data["medicationPharmaceuticalFormTypeId"] = this.medicationPharmaceuticalFormTypeId;
        data["medicationPackagingTypeId"] = this.medicationPackagingTypeId;
        data["medicationStrengthUnitTypeId"] = this.medicationStrengthUnitTypeId;
        data["packageQuantity"] = this.packageQuantity;
        data["strengthValue"] = this.strengthValue;
        data["drugClass"] = this.drugClass;
        data["productType"] = this.productType;
        data["prescriptionCategory"] = this.prescriptionCategory;
        data["prescribability"] = this.prescribability;
        data["pharmacotherapeuticCategory"] = this.pharmacotherapeuticCategory;
        data["pharmaceuticalForm"] = this.pharmaceuticalForm;
        data["pharmaceuticalFormDetail"] = this.pharmaceuticalFormDetail;
        data["storageTemperature"] = this.storageTemperature;
        data["activeIngredientDescription"] = this.activeIngredientDescription;
        data["activeIngredients"] = this.activeIngredients;
        data["excipients"] = this.excipients;
        data["indications"] = this.indications;
        data["contraindicationsAndSideEffects"] = this.contraindicationsAndSideEffects;
        data["posology"] = this.posology;
        data["precautions"] = this.precautions;
        data["warnings"] = this.warnings;
        data["interactions"] = this.interactions;
        data["undesirableEffects"] = this.undesirableEffects;
        data["pregnancyAndLactation"] = this.pregnancyAndLactation;
        return data;
    }

    clone(): UpdateMedicationDto {
        const json = this.toJSON();
        let result = new UpdateMedicationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMedicationDto {
    id: number;
    isActive: boolean;
    requiresDoubleCheck: boolean | undefined;
    name: string | undefined;
    officialName: string | undefined;
    manufacturer: string | undefined;
    productCode: string | undefined;
    eanCode: string | undefined;
    atcCode: string | undefined;
    cufNoteNumber: string | undefined;
    identificationCode: string | undefined;
    medicationPharmaceuticalFormTypeId: number;
    medicationPackagingTypeId: number;
    medicationStrengthUnitTypeId: number | undefined;
    packageQuantity: number;
    strengthValue: number | undefined;
    drugClass: string | undefined;
    productType: string | undefined;
    prescriptionCategory: string | undefined;
    prescribability: string | undefined;
    pharmacotherapeuticCategory: string | undefined;
    pharmaceuticalForm: string | undefined;
    pharmaceuticalFormDetail: string | undefined;
    storageTemperature: string | undefined;
    activeIngredientDescription: string | undefined;
    activeIngredients: string | undefined;
    excipients: string | undefined;
    indications: string | undefined;
    contraindicationsAndSideEffects: string | undefined;
    posology: string | undefined;
    precautions: string | undefined;
    warnings: string | undefined;
    interactions: string | undefined;
    undesirableEffects: string | undefined;
    pregnancyAndLactation: string | undefined;
}

export class UpdateMedicationOrderDetailDto implements IUpdateMedicationOrderDetailDto {
    id!: number;
    quantity!: number;
    note!: string | undefined;

    constructor(data?: IUpdateMedicationOrderDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quantity = _data["quantity"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateMedicationOrderDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMedicationOrderDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quantity"] = this.quantity;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateMedicationOrderDetailDto {
        const json = this.toJSON();
        let result = new UpdateMedicationOrderDetailDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMedicationOrderDetailDto {
    id: number;
    quantity: number;
    note: string | undefined;
}

export class UpdateMedicationOrderDto implements IUpdateMedicationOrderDto {
    id!: number;
    medicationOrderStatusId!: number;
    orderDate!: Date;
    note!: string | undefined;

    constructor(data?: IUpdateMedicationOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.medicationOrderStatusId = _data["medicationOrderStatusId"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateMedicationOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMedicationOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["medicationOrderStatusId"] = this.medicationOrderStatusId;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateMedicationOrderDto {
        const json = this.toJSON();
        let result = new UpdateMedicationOrderDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMedicationOrderDto {
    id: number;
    medicationOrderStatusId: number;
    orderDate: Date;
    note: string | undefined;
}

export class UpdateMedicationStockDto implements IUpdateMedicationStockDto {
    id!: number;
    label!: string | undefined;
    boxCode!: string | undefined;
    totalQuantity!: number;
    expiryDate!: Date;
    note!: string | undefined;
    totalSubUnits!: number | undefined;
    batchNumber!: string | undefined;
    markingCode!: string | undefined;

    constructor(data?: IUpdateMedicationStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.boxCode = _data["boxCode"];
            this.totalQuantity = _data["totalQuantity"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.totalSubUnits = _data["totalSubUnits"];
            this.batchNumber = _data["batchNumber"];
            this.markingCode = _data["markingCode"];
        }
    }

    static fromJS(data: any): UpdateMedicationStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMedicationStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["boxCode"] = this.boxCode;
        data["totalQuantity"] = this.totalQuantity;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["totalSubUnits"] = this.totalSubUnits;
        data["batchNumber"] = this.batchNumber;
        data["markingCode"] = this.markingCode;
        return data;
    }

    clone(): UpdateMedicationStockDto {
        const json = this.toJSON();
        let result = new UpdateMedicationStockDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMedicationStockDto {
    id: number;
    label: string | undefined;
    boxCode: string | undefined;
    totalQuantity: number;
    expiryDate: Date;
    note: string | undefined;
    totalSubUnits: number | undefined;
    batchNumber: string | undefined;
    markingCode: string | undefined;
}

export class UpdateMedicationStockReasonDto implements IUpdateMedicationStockReasonDto {
    id!: number;
    description!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;
    applicableToUnitIncrease!: boolean;
    applicableToUnitDecrease!: boolean;
    applicableToPackageDischarge!: boolean;

    constructor(data?: IUpdateMedicationStockReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
            this.applicableToUnitIncrease = _data["applicableToUnitIncrease"];
            this.applicableToUnitDecrease = _data["applicableToUnitDecrease"];
            this.applicableToPackageDischarge = _data["applicableToPackageDischarge"];
        }
    }

    static fromJS(data: any): UpdateMedicationStockReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMedicationStockReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        data["applicableToUnitIncrease"] = this.applicableToUnitIncrease;
        data["applicableToUnitDecrease"] = this.applicableToUnitDecrease;
        data["applicableToPackageDischarge"] = this.applicableToPackageDischarge;
        return data;
    }

    clone(): UpdateMedicationStockReasonDto {
        const json = this.toJSON();
        let result = new UpdateMedicationStockReasonDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMedicationStockReasonDto {
    id: number;
    description: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
    applicableToUnitIncrease: boolean;
    applicableToUnitDecrease: boolean;
    applicableToPackageDischarge: boolean;
}

export class UpdateMeetingMinuteDto implements IUpdateMeetingMinuteDto {
    id!: number;
    meetingTypeId!: number;
    topic!: string | undefined;
    meetingDate!: Date | undefined;
    duration!: number;
    minuteNote!: string | undefined;
    patientIds!: number[] | undefined;
    userChairId!: number;
    userIds!: number[] | undefined;
    othersIds!: number[] | undefined;

    constructor(data?: IUpdateMeetingMinuteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.meetingTypeId = _data["meetingTypeId"];
            this.topic = _data["topic"];
            this.meetingDate = _data["meetingDate"] ? new Date(_data["meetingDate"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.minuteNote = _data["minuteNote"];
            if (Array.isArray(_data["patientIds"])) {
                this.patientIds = [] as any;
                for (let item of _data["patientIds"])
                    this.patientIds!.push(item);
            }
            this.userChairId = _data["userChairId"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            if (Array.isArray(_data["othersIds"])) {
                this.othersIds = [] as any;
                for (let item of _data["othersIds"])
                    this.othersIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateMeetingMinuteDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeetingMinuteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["meetingTypeId"] = this.meetingTypeId;
        data["topic"] = this.topic;
        data["meetingDate"] = this.meetingDate ? this.meetingDate.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["minuteNote"] = this.minuteNote;
        if (Array.isArray(this.patientIds)) {
            data["patientIds"] = [];
            for (let item of this.patientIds)
                data["patientIds"].push(item);
        }
        data["userChairId"] = this.userChairId;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        if (Array.isArray(this.othersIds)) {
            data["othersIds"] = [];
            for (let item of this.othersIds)
                data["othersIds"].push(item);
        }
        return data;
    }

    clone(): UpdateMeetingMinuteDto {
        const json = this.toJSON();
        let result = new UpdateMeetingMinuteDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMeetingMinuteDto {
    id: number;
    meetingTypeId: number;
    topic: string | undefined;
    meetingDate: Date | undefined;
    duration: number;
    minuteNote: string | undefined;
    patientIds: number[] | undefined;
    userChairId: number;
    userIds: number[] | undefined;
    othersIds: number[] | undefined;
}

export class UpdateMeetingTypeDto implements IUpdateMeetingTypeDto {
    id!: number;
    description!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;

    constructor(data?: IUpdateMeetingTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateMeetingTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeetingTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): UpdateMeetingTypeDto {
        const json = this.toJSON();
        let result = new UpdateMeetingTypeDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMeetingTypeDto {
    id: number;
    description: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
}

export class UpdateMyProfileDto implements IUpdateMyProfileDto {
    name!: string;
    surname!: string;
    username!: string;
    emailAddress!: string;
    birthDate!: Date | undefined;
    birthPlace!: string | undefined;
    fiscalCode!: string | undefined;
    genderId!: number | undefined;

    constructor(data?: IUpdateMyProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.username = _data["username"];
            this.emailAddress = _data["emailAddress"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.birthPlace = _data["birthPlace"];
            this.fiscalCode = _data["fiscalCode"];
            this.genderId = _data["genderId"];
        }
    }

    static fromJS(data: any): UpdateMyProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMyProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["username"] = this.username;
        data["emailAddress"] = this.emailAddress;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["birthPlace"] = this.birthPlace;
        data["fiscalCode"] = this.fiscalCode;
        data["genderId"] = this.genderId;
        return data;
    }

    clone(): UpdateMyProfileDto {
        const json = this.toJSON();
        let result = new UpdateMyProfileDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMyProfileDto {
    name: string;
    surname: string;
    username: string;
    emailAddress: string;
    birthDate: Date | undefined;
    birthPlace: string | undefined;
    fiscalCode: string | undefined;
    genderId: number | undefined;
}

export class UpdateOnCallActivationDto implements IUpdateOnCallActivationDto {
    id!: number;
    startDateTime!: Date;
    endDateTime!: Date;

    constructor(data?: IUpdateOnCallActivationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateOnCallActivationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOnCallActivationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): UpdateOnCallActivationDto {
        const json = this.toJSON();
        let result = new UpdateOnCallActivationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateOnCallActivationDto {
    id: number;
    startDateTime: Date;
    endDateTime: Date;
}

export class UpdateOperationalUnitDto implements IUpdateOperationalUnitDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    code!: string | undefined;
    unitManagerId!: number;
    userIds!: number[] | undefined;

    constructor(data?: IUpdateOperationalUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.code = _data["code"];
            this.unitManagerId = _data["unitManagerId"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateOperationalUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOperationalUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["code"] = this.code;
        data["unitManagerId"] = this.unitManagerId;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        return data;
    }

    clone(): UpdateOperationalUnitDto {
        const json = this.toJSON();
        let result = new UpdateOperationalUnitDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateOperationalUnitDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    code: string | undefined;
    unitManagerId: number;
    userIds: number[] | undefined;
}

export class UpdateOperationalUnitExpirationAlertDto implements IUpdateOperationalUnitExpirationAlertDto {
    id!: number;
    expirationWarningDays!: number;

    constructor(data?: IUpdateOperationalUnitExpirationAlertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.expirationWarningDays = _data["expirationWarningDays"];
        }
    }

    static fromJS(data: any): UpdateOperationalUnitExpirationAlertDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOperationalUnitExpirationAlertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expirationWarningDays"] = this.expirationWarningDays;
        return data;
    }

    clone(): UpdateOperationalUnitExpirationAlertDto {
        const json = this.toJSON();
        let result = new UpdateOperationalUnitExpirationAlertDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateOperationalUnitExpirationAlertDto {
    id: number;
    expirationWarningDays: number;
}

export class UpdateOperationalUnitFileDto implements IUpdateOperationalUnitFileDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IUpdateOperationalUnitFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateOperationalUnitFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOperationalUnitFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): UpdateOperationalUnitFileDto {
        const json = this.toJSON();
        let result = new UpdateOperationalUnitFileDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateOperationalUnitFileDto {
    id: number;
    name: string | undefined;
}

export class UpdateOperationalUnitShiftSlotDto implements IUpdateOperationalUnitShiftSlotDto {
    id!: number;
    startTime!: Date;
    endTime!: Date;
    validFrom!: Date;
    validTo!: Date | undefined;
    requiredCount!: number | undefined;

    constructor(data?: IUpdateOperationalUnitShiftSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.requiredCount = _data["requiredCount"];
        }
    }

    static fromJS(data: any): UpdateOperationalUnitShiftSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOperationalUnitShiftSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["validFrom"] = this.validFrom ? formatDate(this.validFrom) : <any>undefined;
        data["validTo"] = this.validTo ? formatDate(this.validTo) : <any>undefined;
        data["requiredCount"] = this.requiredCount;
        return data;
    }

    clone(): UpdateOperationalUnitShiftSlotDto {
        const json = this.toJSON();
        let result = new UpdateOperationalUnitShiftSlotDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateOperationalUnitShiftSlotDto {
    id: number;
    startTime: Date;
    endTime: Date;
    validFrom: Date;
    validTo: Date | undefined;
    requiredCount: number | undefined;
}

export class UpdatePatientAttendanceDto implements IUpdatePatientAttendanceDto {
    id!: number;
    attendanceMarkId!: number | undefined;
    note!: string | undefined;

    constructor(data?: IUpdatePatientAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attendanceMarkId = _data["attendanceMarkId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdatePatientAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attendanceMarkId"] = this.attendanceMarkId;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdatePatientAttendanceDto {
        const json = this.toJSON();
        let result = new UpdatePatientAttendanceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePatientAttendanceDto {
    id: number;
    attendanceMarkId: number | undefined;
    note: string | undefined;
}

export class UpdatePatientDischargeDto implements IUpdatePatientDischargeDto {
    id!: number;
    exitDate!: Date;
    reason!: string | undefined;

    constructor(data?: IUpdatePatientDischargeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.exitDate = _data["exitDate"] ? new Date(_data["exitDate"].toString()) : <any>undefined;
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): UpdatePatientDischargeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientDischargeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["exitDate"] = this.exitDate ? this.exitDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        return data;
    }

    clone(): UpdatePatientDischargeDto {
        const json = this.toJSON();
        let result = new UpdatePatientDischargeDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePatientDischargeDto {
    id: number;
    exitDate: Date;
    reason: string | undefined;
}

export class UpdatePatientDto implements IUpdatePatientDto {
    id!: number;
    name!: string;
    surname!: string;
    email!: string | undefined;
    phoneNumber!: string | undefined;
    fiscalCode!: string;
    healthCard!: string | undefined;
    isMale!: boolean;
    birthDate!: Date;
    birthPlace!: string;
    occupation!: string | undefined;
    note!: string | undefined;
    doctorId!: number | undefined;
    nationalityId!: number | undefined;
    address!: CreateAddressDto;

    constructor(data?: IUpdatePatientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.address = new CreateAddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.fiscalCode = _data["fiscalCode"];
            this.healthCard = _data["healthCard"];
            this.isMale = _data["isMale"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.birthPlace = _data["birthPlace"];
            this.occupation = _data["occupation"];
            this.note = _data["note"];
            this.doctorId = _data["doctorId"];
            this.nationalityId = _data["nationalityId"];
            this.address = _data["address"] ? CreateAddressDto.fromJS(_data["address"]) : new CreateAddressDto();
        }
    }

    static fromJS(data: any): UpdatePatientDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["fiscalCode"] = this.fiscalCode;
        data["healthCard"] = this.healthCard;
        data["isMale"] = this.isMale;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["birthPlace"] = this.birthPlace;
        data["occupation"] = this.occupation;
        data["note"] = this.note;
        data["doctorId"] = this.doctorId;
        data["nationalityId"] = this.nationalityId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdatePatientDto {
        const json = this.toJSON();
        let result = new UpdatePatientDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePatientDto {
    id: number;
    name: string;
    surname: string;
    email: string | undefined;
    phoneNumber: string | undefined;
    fiscalCode: string;
    healthCard: string | undefined;
    isMale: boolean;
    birthDate: Date;
    birthPlace: string;
    occupation: string | undefined;
    note: string | undefined;
    doctorId: number | undefined;
    nationalityId: number | undefined;
    address: CreateAddressDto;
}

export class UpdatePatientFileDto implements IUpdatePatientFileDto {
    id!: number;
    name!: string | undefined;
    patientId!: number | undefined;

    constructor(data?: IUpdatePatientFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): UpdatePatientFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["patientId"] = this.patientId;
        return data;
    }

    clone(): UpdatePatientFileDto {
        const json = this.toJSON();
        let result = new UpdatePatientFileDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePatientFileDto {
    id: number;
    name: string | undefined;
    patientId: number | undefined;
}

export class UpdatePatientMealDto implements IUpdatePatientMealDto {
    id!: number;
    mealMarkId!: number | undefined;
    note!: string | undefined;

    constructor(data?: IUpdatePatientMealDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mealMarkId = _data["mealMarkId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdatePatientMealDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientMealDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mealMarkId"] = this.mealMarkId;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdatePatientMealDto {
        const json = this.toJSON();
        let result = new UpdatePatientMealDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePatientMealDto {
    id: number;
    mealMarkId: number | undefined;
    note: string | undefined;
}

export class UpdatePatientMedicationAdministrationDto implements IUpdatePatientMedicationAdministrationDto {
    id!: number;
    note!: string | undefined;

    constructor(data?: IUpdatePatientMedicationAdministrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdatePatientMedicationAdministrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientMedicationAdministrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdatePatientMedicationAdministrationDto {
        const json = this.toJSON();
        let result = new UpdatePatientMedicationAdministrationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePatientMedicationAdministrationDto {
    id: number;
    note: string | undefined;
}

export class UpdatePatientMedicationAssignmentDto implements IUpdatePatientMedicationAssignmentDto {
    id!: number;
    note!: string | undefined;

    constructor(data?: IUpdatePatientMedicationAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdatePatientMedicationAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientMedicationAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdatePatientMedicationAssignmentDto {
        const json = this.toJSON();
        let result = new UpdatePatientMedicationAssignmentDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePatientMedicationAssignmentDto {
    id: number;
    note: string | undefined;
}

export class UpdatePatientMedicationScheduleDto implements IUpdatePatientMedicationScheduleDto {
    id!: number;
    plannedQuantity!: number;
    time!: Date;
    note!: string | undefined;

    constructor(data?: IUpdatePatientMedicationScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plannedQuantity = _data["plannedQuantity"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdatePatientMedicationScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientMedicationScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plannedQuantity"] = this.plannedQuantity;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdatePatientMedicationScheduleDto {
        const json = this.toJSON();
        let result = new UpdatePatientMedicationScheduleDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePatientMedicationScheduleDto {
    id: number;
    plannedQuantity: number;
    time: Date;
    note: string | undefined;
}

export class UpdatePatientMedicationTherapyDto implements IUpdatePatientMedicationTherapyDto {
    id!: number;
    medicationTherapyTypeId!: number;
    medicationAdministrationRouteId!: number;
    patientMedicationTherapyStatusId!: number | undefined;
    dose!: number;
    maxDailyDose!: number | undefined;
    note!: string | undefined;
    startDate!: Date;
    endDate!: Date | undefined;
    patientMedicationTherapyRecurrences!: UpdatePatientMedicationTherapyRecurrenceDto[] | undefined;
    patientMedicationTherapyTaperings!: UpdatePatientMedicationTherapyTaperingDto[] | undefined;

    constructor(data?: IUpdatePatientMedicationTherapyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.medicationTherapyTypeId = _data["medicationTherapyTypeId"];
            this.medicationAdministrationRouteId = _data["medicationAdministrationRouteId"];
            this.patientMedicationTherapyStatusId = _data["patientMedicationTherapyStatusId"];
            this.dose = _data["dose"];
            this.maxDailyDose = _data["maxDailyDose"];
            this.note = _data["note"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["patientMedicationTherapyRecurrences"])) {
                this.patientMedicationTherapyRecurrences = [] as any;
                for (let item of _data["patientMedicationTherapyRecurrences"])
                    this.patientMedicationTherapyRecurrences!.push(UpdatePatientMedicationTherapyRecurrenceDto.fromJS(item));
            }
            if (Array.isArray(_data["patientMedicationTherapyTaperings"])) {
                this.patientMedicationTherapyTaperings = [] as any;
                for (let item of _data["patientMedicationTherapyTaperings"])
                    this.patientMedicationTherapyTaperings!.push(UpdatePatientMedicationTherapyTaperingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePatientMedicationTherapyDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientMedicationTherapyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["medicationTherapyTypeId"] = this.medicationTherapyTypeId;
        data["medicationAdministrationRouteId"] = this.medicationAdministrationRouteId;
        data["patientMedicationTherapyStatusId"] = this.patientMedicationTherapyStatusId;
        data["dose"] = this.dose;
        data["maxDailyDose"] = this.maxDailyDose;
        data["note"] = this.note;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.patientMedicationTherapyRecurrences)) {
            data["patientMedicationTherapyRecurrences"] = [];
            for (let item of this.patientMedicationTherapyRecurrences)
                data["patientMedicationTherapyRecurrences"].push(item.toJSON());
        }
        if (Array.isArray(this.patientMedicationTherapyTaperings)) {
            data["patientMedicationTherapyTaperings"] = [];
            for (let item of this.patientMedicationTherapyTaperings)
                data["patientMedicationTherapyTaperings"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdatePatientMedicationTherapyDto {
        const json = this.toJSON();
        let result = new UpdatePatientMedicationTherapyDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePatientMedicationTherapyDto {
    id: number;
    medicationTherapyTypeId: number;
    medicationAdministrationRouteId: number;
    patientMedicationTherapyStatusId: number | undefined;
    dose: number;
    maxDailyDose: number | undefined;
    note: string | undefined;
    startDate: Date;
    endDate: Date | undefined;
    patientMedicationTherapyRecurrences: UpdatePatientMedicationTherapyRecurrenceDto[] | undefined;
    patientMedicationTherapyTaperings: UpdatePatientMedicationTherapyTaperingDto[] | undefined;
}

export class UpdatePatientMedicationTherapyRecurrenceDto implements IUpdatePatientMedicationTherapyRecurrenceDto {
    id!: number;
    timeOfDay!: Date;
    dose!: number | undefined;

    constructor(data?: IUpdatePatientMedicationTherapyRecurrenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.timeOfDay = _data["timeOfDay"] ? new Date(_data["timeOfDay"].toString()) : <any>undefined;
            this.dose = _data["dose"];
        }
    }

    static fromJS(data: any): UpdatePatientMedicationTherapyRecurrenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientMedicationTherapyRecurrenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timeOfDay"] = this.timeOfDay ? this.timeOfDay.toISOString() : <any>undefined;
        data["dose"] = this.dose;
        return data;
    }

    clone(): UpdatePatientMedicationTherapyRecurrenceDto {
        const json = this.toJSON();
        let result = new UpdatePatientMedicationTherapyRecurrenceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePatientMedicationTherapyRecurrenceDto {
    id: number;
    timeOfDay: Date;
    dose: number | undefined;
}

export class UpdatePatientMedicationTherapyTaperingDto implements IUpdatePatientMedicationTherapyTaperingDto {
    id!: number;
    dayOffset!: number;
    timeOfDay!: Date | undefined;
    dose!: number;

    constructor(data?: IUpdatePatientMedicationTherapyTaperingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dayOffset = _data["dayOffset"];
            this.timeOfDay = _data["timeOfDay"] ? new Date(_data["timeOfDay"].toString()) : <any>undefined;
            this.dose = _data["dose"];
        }
    }

    static fromJS(data: any): UpdatePatientMedicationTherapyTaperingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientMedicationTherapyTaperingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dayOffset"] = this.dayOffset;
        data["timeOfDay"] = this.timeOfDay ? this.timeOfDay.toISOString() : <any>undefined;
        data["dose"] = this.dose;
        return data;
    }

    clone(): UpdatePatientMedicationTherapyTaperingDto {
        const json = this.toJSON();
        let result = new UpdatePatientMedicationTherapyTaperingDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePatientMedicationTherapyTaperingDto {
    id: number;
    dayOffset: number;
    timeOfDay: Date | undefined;
    dose: number;
}

export class UpdatePatientNoteDto implements IUpdatePatientNoteDto {
    id!: number;
    text!: string | undefined;

    constructor(data?: IUpdatePatientNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): UpdatePatientNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }

    clone(): UpdatePatientNoteDto {
        const json = this.toJSON();
        let result = new UpdatePatientNoteDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePatientNoteDto {
    id: number;
    text: string | undefined;
}

export class UpdatePatientOperationDto implements IUpdatePatientOperationDto {
    id!: number;
    description!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;

    constructor(data?: IUpdatePatientOperationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdatePatientOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientOperationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): UpdatePatientOperationDto {
        const json = this.toJSON();
        let result = new UpdatePatientOperationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePatientOperationDto {
    id: number;
    description: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
}

export class UpdatePatientTransferRequestDto implements IUpdatePatientTransferRequestDto {
    id!: number;
    toOperationalUnitId!: number;

    constructor(data?: IUpdatePatientTransferRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.toOperationalUnitId = _data["toOperationalUnitId"];
        }
    }

    static fromJS(data: any): UpdatePatientTransferRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientTransferRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["toOperationalUnitId"] = this.toOperationalUnitId;
        return data;
    }

    clone(): UpdatePatientTransferRequestDto {
        const json = this.toJSON();
        let result = new UpdatePatientTransferRequestDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePatientTransferRequestDto {
    id: number;
    toOperationalUnitId: number;
}

export class UpdatePhysiologicalHistoryDto implements IUpdatePhysiologicalHistoryDto {
    id!: number;
    weightKg!: number | undefined;
    heightCm!: number | undefined;
    bloodGroupId!: number | undefined;
    note!: string | undefined;

    constructor(data?: IUpdatePhysiologicalHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.weightKg = _data["weightKg"];
            this.heightCm = _data["heightCm"];
            this.bloodGroupId = _data["bloodGroupId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdatePhysiologicalHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePhysiologicalHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["weightKg"] = this.weightKg;
        data["heightCm"] = this.heightCm;
        data["bloodGroupId"] = this.bloodGroupId;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdatePhysiologicalHistoryDto {
        const json = this.toJSON();
        let result = new UpdatePhysiologicalHistoryDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePhysiologicalHistoryDto {
    id: number;
    weightKg: number | undefined;
    heightCm: number | undefined;
    bloodGroupId: number | undefined;
    note: string | undefined;
}

export class UpdatePlannedAssignmentDto implements IUpdatePlannedAssignmentDto {
    id!: number;
    assignmentTypeId!: number;
    onCallTypeId!: number | undefined;
    startDateTime!: Date;
    endDateTime!: Date;

    constructor(data?: IUpdatePlannedAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assignmentTypeId = _data["assignmentTypeId"];
            this.onCallTypeId = _data["onCallTypeId"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePlannedAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlannedAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assignmentTypeId"] = this.assignmentTypeId;
        data["onCallTypeId"] = this.onCallTypeId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): UpdatePlannedAssignmentDto {
        const json = this.toJSON();
        let result = new UpdatePlannedAssignmentDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePlannedAssignmentDto {
    id: number;
    assignmentTypeId: number;
    onCallTypeId: number | undefined;
    startDateTime: Date;
    endDateTime: Date;
}

export class UpdatePlannedSlotDto implements IUpdatePlannedSlotDto {
    id!: number;
    requiredCount!: number | undefined;
    minMinutesToCount!: number | undefined;

    constructor(data?: IUpdatePlannedSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requiredCount = _data["requiredCount"];
            this.minMinutesToCount = _data["minMinutesToCount"];
        }
    }

    static fromJS(data: any): UpdatePlannedSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlannedSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requiredCount"] = this.requiredCount;
        data["minMinutesToCount"] = this.minMinutesToCount;
        return data;
    }

    clone(): UpdatePlannedSlotDto {
        const json = this.toJSON();
        let result = new UpdatePlannedSlotDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePlannedSlotDto {
    id: number;
    requiredCount: number | undefined;
    minMinutesToCount: number | undefined;
}

export class UpdateProtocolTypeDto implements IUpdateProtocolTypeDto {
    id!: number;
    description!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;

    constructor(data?: IUpdateProtocolTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateProtocolTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProtocolTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): UpdateProtocolTypeDto {
        const json = this.toJSON();
        let result = new UpdateProtocolTypeDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateProtocolTypeDto {
    id: number;
    description: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
}

export class UpdatePsychiatricAdmissionExamDto implements IUpdatePsychiatricAdmissionExamDto {
    id!: number;
    note!: string | undefined;

    constructor(data?: IUpdatePsychiatricAdmissionExamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdatePsychiatricAdmissionExamDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePsychiatricAdmissionExamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdatePsychiatricAdmissionExamDto {
        const json = this.toJSON();
        let result = new UpdatePsychiatricAdmissionExamDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePsychiatricAdmissionExamDto {
    id: number;
    note: string | undefined;
}

export class UpdatePsychiatricProfileDto implements IUpdatePsychiatricProfileDto {
    id!: number;
    note!: string | undefined;

    constructor(data?: IUpdatePsychiatricProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdatePsychiatricProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePsychiatricProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdatePsychiatricProfileDto {
        const json = this.toJSON();
        let result = new UpdatePsychiatricProfileDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePsychiatricProfileDto {
    id: number;
    note: string | undefined;
}

export class UpdateTemperatureDto implements IUpdateTemperatureDto {
    id!: number;
    temperatureEnvironmentTypeId!: number;
    temperatureShiftId!: number | undefined;
    note!: string | undefined;
    dateTime!: Date;
    temperatureRecurrence!: UpdateTemperatureRecurrenceDto;

    constructor(data?: IUpdateTemperatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.temperatureEnvironmentTypeId = _data["temperatureEnvironmentTypeId"];
            this.temperatureShiftId = _data["temperatureShiftId"];
            this.note = _data["note"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.temperatureRecurrence = _data["temperatureRecurrence"] ? UpdateTemperatureRecurrenceDto.fromJS(_data["temperatureRecurrence"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateTemperatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemperatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["temperatureEnvironmentTypeId"] = this.temperatureEnvironmentTypeId;
        data["temperatureShiftId"] = this.temperatureShiftId;
        data["note"] = this.note;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["temperatureRecurrence"] = this.temperatureRecurrence ? this.temperatureRecurrence.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateTemperatureDto {
        const json = this.toJSON();
        let result = new UpdateTemperatureDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTemperatureDto {
    id: number;
    temperatureEnvironmentTypeId: number;
    temperatureShiftId: number | undefined;
    note: string | undefined;
    dateTime: Date;
    temperatureRecurrence: UpdateTemperatureRecurrenceDto;
}

export class UpdateTemperatureEnvironmentTypeDto implements IUpdateTemperatureEnvironmentTypeDto {
    id!: number;
    description!: string | undefined;
    displayOrder!: number | undefined;
    isActive!: boolean;
    minValue!: number;
    maxValue!: number;

    constructor(data?: IUpdateTemperatureEnvironmentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
        }
    }

    static fromJS(data: any): UpdateTemperatureEnvironmentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemperatureEnvironmentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        return data;
    }

    clone(): UpdateTemperatureEnvironmentTypeDto {
        const json = this.toJSON();
        let result = new UpdateTemperatureEnvironmentTypeDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTemperatureEnvironmentTypeDto {
    id: number;
    description: string | undefined;
    displayOrder: number | undefined;
    isActive: boolean;
    minValue: number;
    maxValue: number;
}

export class UpdateTemperatureReadingDto implements IUpdateTemperatureReadingDto {
    id!: number;
    value!: number;
    measuredAt!: Date;
    detectionNote!: string | undefined;

    constructor(data?: IUpdateTemperatureReadingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.measuredAt = _data["measuredAt"] ? new Date(_data["measuredAt"].toString()) : <any>undefined;
            this.detectionNote = _data["detectionNote"];
        }
    }

    static fromJS(data: any): UpdateTemperatureReadingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemperatureReadingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["measuredAt"] = this.measuredAt ? this.measuredAt.toISOString() : <any>undefined;
        data["detectionNote"] = this.detectionNote;
        return data;
    }

    clone(): UpdateTemperatureReadingDto {
        const json = this.toJSON();
        let result = new UpdateTemperatureReadingDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTemperatureReadingDto {
    id: number;
    value: number;
    measuredAt: Date;
    detectionNote: string | undefined;
}

export class UpdateTemperatureRecurrenceDto implements IUpdateTemperatureRecurrenceDto {
    id!: number;
    recurrenceTypeId!: number | undefined;
    interval!: number;
    weekDayIds!: number[] | undefined;
    recurreEndTypeId!: number | undefined;
    endDate!: Date | undefined;
    occurrenceCount!: number | undefined;
    monthlyRecurrenceTypeId!: number | undefined;
    weekPositionId!: number | undefined;

    constructor(data?: IUpdateTemperatureRecurrenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recurrenceTypeId = _data["recurrenceTypeId"];
            this.interval = _data["interval"];
            if (Array.isArray(_data["weekDayIds"])) {
                this.weekDayIds = [] as any;
                for (let item of _data["weekDayIds"])
                    this.weekDayIds!.push(item);
            }
            this.recurreEndTypeId = _data["recurreEndTypeId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.occurrenceCount = _data["occurrenceCount"];
            this.monthlyRecurrenceTypeId = _data["monthlyRecurrenceTypeId"];
            this.weekPositionId = _data["weekPositionId"];
        }
    }

    static fromJS(data: any): UpdateTemperatureRecurrenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemperatureRecurrenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recurrenceTypeId"] = this.recurrenceTypeId;
        data["interval"] = this.interval;
        if (Array.isArray(this.weekDayIds)) {
            data["weekDayIds"] = [];
            for (let item of this.weekDayIds)
                data["weekDayIds"].push(item);
        }
        data["recurreEndTypeId"] = this.recurreEndTypeId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["occurrenceCount"] = this.occurrenceCount;
        data["monthlyRecurrenceTypeId"] = this.monthlyRecurrenceTypeId;
        data["weekPositionId"] = this.weekPositionId;
        return data;
    }

    clone(): UpdateTemperatureRecurrenceDto {
        const json = this.toJSON();
        let result = new UpdateTemperatureRecurrenceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTemperatureRecurrenceDto {
    id: number;
    recurrenceTypeId: number | undefined;
    interval: number;
    weekDayIds: number[] | undefined;
    recurreEndTypeId: number | undefined;
    endDate: Date | undefined;
    occurrenceCount: number | undefined;
    monthlyRecurrenceTypeId: number | undefined;
    weekPositionId: number | undefined;
}

export class UpdateTherapeuticGoalDto implements IUpdateTherapeuticGoalDto {
    id!: number;
    therapeuticAreaTypeId!: number;
    goalDefinition!: string | undefined;
    actions!: string | undefined;
    goalEvaluation!: string | undefined;
    actionsEvaluation!: string | undefined;

    constructor(data?: IUpdateTherapeuticGoalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.therapeuticAreaTypeId = _data["therapeuticAreaTypeId"];
            this.goalDefinition = _data["goalDefinition"];
            this.actions = _data["actions"];
            this.goalEvaluation = _data["goalEvaluation"];
            this.actionsEvaluation = _data["actionsEvaluation"];
        }
    }

    static fromJS(data: any): UpdateTherapeuticGoalDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTherapeuticGoalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["therapeuticAreaTypeId"] = this.therapeuticAreaTypeId;
        data["goalDefinition"] = this.goalDefinition;
        data["actions"] = this.actions;
        data["goalEvaluation"] = this.goalEvaluation;
        data["actionsEvaluation"] = this.actionsEvaluation;
        return data;
    }

    clone(): UpdateTherapeuticGoalDto {
        const json = this.toJSON();
        let result = new UpdateTherapeuticGoalDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTherapeuticGoalDto {
    id: number;
    therapeuticAreaTypeId: number;
    goalDefinition: string | undefined;
    actions: string | undefined;
    goalEvaluation: string | undefined;
    actionsEvaluation: string | undefined;
}

export class UpdateTherapeuticProgramDto implements IUpdateTherapeuticProgramDto {
    id!: number;
    name!: string | undefined;
    date!: Date;
    finalExamination!: string | undefined;
    therapeuticGoals!: UpdateTherapeuticGoalDto[] | undefined;

    constructor(data?: IUpdateTherapeuticProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.finalExamination = _data["finalExamination"];
            if (Array.isArray(_data["therapeuticGoals"])) {
                this.therapeuticGoals = [] as any;
                for (let item of _data["therapeuticGoals"])
                    this.therapeuticGoals!.push(UpdateTherapeuticGoalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTherapeuticProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTherapeuticProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["finalExamination"] = this.finalExamination;
        if (Array.isArray(this.therapeuticGoals)) {
            data["therapeuticGoals"] = [];
            for (let item of this.therapeuticGoals)
                data["therapeuticGoals"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateTherapeuticProgramDto {
        const json = this.toJSON();
        let result = new UpdateTherapeuticProgramDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTherapeuticProgramDto {
    id: number;
    name: string | undefined;
    date: Date;
    finalExamination: string | undefined;
    therapeuticGoals: UpdateTherapeuticGoalDto[] | undefined;
}

export class UpdateUserDto implements IUpdateUserDto {
    id!: number;
    name!: string;
    surname!: string;
    username!: string;
    emailAddress!: string;
    birthDate!: Date | undefined;
    birthPlace!: string | undefined;
    fiscalCode!: string | undefined;
    genderId!: number | undefined;
    isActive!: boolean;
    operationalUnitIds!: number[] | undefined;
    note!: string | undefined;
    roleNames!: string[];

    constructor(data?: IUpdateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roleNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.username = _data["username"];
            this.emailAddress = _data["emailAddress"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.birthPlace = _data["birthPlace"];
            this.fiscalCode = _data["fiscalCode"];
            this.genderId = _data["genderId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["operationalUnitIds"])) {
                this.operationalUnitIds = [] as any;
                for (let item of _data["operationalUnitIds"])
                    this.operationalUnitIds!.push(item);
            }
            this.note = _data["note"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["username"] = this.username;
        data["emailAddress"] = this.emailAddress;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["birthPlace"] = this.birthPlace;
        data["fiscalCode"] = this.fiscalCode;
        data["genderId"] = this.genderId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.operationalUnitIds)) {
            data["operationalUnitIds"] = [];
            for (let item of this.operationalUnitIds)
                data["operationalUnitIds"].push(item);
        }
        data["note"] = this.note;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        return data;
    }

    clone(): UpdateUserDto {
        const json = this.toJSON();
        let result = new UpdateUserDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserDto {
    id: number;
    name: string;
    surname: string;
    username: string;
    emailAddress: string;
    birthDate: Date | undefined;
    birthPlace: string | undefined;
    fiscalCode: string | undefined;
    genderId: number | undefined;
    isActive: boolean;
    operationalUnitIds: number[] | undefined;
    note: string | undefined;
    roleNames: string[];
}

export class UpdateUserFileDto implements IUpdateUserFileDto {
    id!: number;
    userFileTypeId!: number;
    expirationDate!: Date | undefined;

    constructor(data?: IUpdateUserFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userFileTypeId = _data["userFileTypeId"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateUserFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userFileTypeId"] = this.userFileTypeId;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): UpdateUserFileDto {
        const json = this.toJSON();
        let result = new UpdateUserFileDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserFileDto {
    id: number;
    userFileTypeId: number;
    expirationDate: Date | undefined;
}

export class UpdateVaccinationDto implements IUpdateVaccinationDto {
    id!: number;
    vaccinationDictionaryId!: number;
    vaccinationTypeId!: number;
    date!: Date;
    organizationOrDoctor!: string | undefined;
    description!: string | undefined;
    vaccinationResultId!: number | undefined;

    constructor(data?: IUpdateVaccinationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vaccinationDictionaryId = _data["vaccinationDictionaryId"];
            this.vaccinationTypeId = _data["vaccinationTypeId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.organizationOrDoctor = _data["organizationOrDoctor"];
            this.description = _data["description"];
            this.vaccinationResultId = _data["vaccinationResultId"];
        }
    }

    static fromJS(data: any): UpdateVaccinationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVaccinationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vaccinationDictionaryId"] = this.vaccinationDictionaryId;
        data["vaccinationTypeId"] = this.vaccinationTypeId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["organizationOrDoctor"] = this.organizationOrDoctor;
        data["description"] = this.description;
        data["vaccinationResultId"] = this.vaccinationResultId;
        return data;
    }

    clone(): UpdateVaccinationDto {
        const json = this.toJSON();
        let result = new UpdateVaccinationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateVaccinationDto {
    id: number;
    vaccinationDictionaryId: number;
    vaccinationTypeId: number;
    date: Date;
    organizationOrDoctor: string | undefined;
    description: string | undefined;
    vaccinationResultId: number | undefined;
}

export class UpdateVitalParameterDto implements IUpdateVitalParameterDto {
    id!: number;
    normal!: number | undefined;
    therapy!: number | undefined;

    constructor(data?: IUpdateVitalParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.normal = _data["normal"];
            this.therapy = _data["therapy"];
        }
    }

    static fromJS(data: any): UpdateVitalParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVitalParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["normal"] = this.normal;
        data["therapy"] = this.therapy;
        return data;
    }

    clone(): UpdateVitalParameterDto {
        const json = this.toJSON();
        let result = new UpdateVitalParameterDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateVitalParameterDto {
    id: number;
    normal: number | undefined;
    therapy: number | undefined;
}

export class UpdateVitalSignsRecordDto implements IUpdateVitalSignsRecordDto {
    id!: number;
    recordedAt!: Date;
    vitalParameters!: UpdateVitalParameterDto[] | undefined;

    constructor(data?: IUpdateVitalSignsRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recordedAt = _data["recordedAt"] ? new Date(_data["recordedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["vitalParameters"])) {
                this.vitalParameters = [] as any;
                for (let item of _data["vitalParameters"])
                    this.vitalParameters!.push(UpdateVitalParameterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateVitalSignsRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVitalSignsRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recordedAt"] = this.recordedAt ? this.recordedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.vitalParameters)) {
            data["vitalParameters"] = [];
            for (let item of this.vitalParameters)
                data["vitalParameters"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateVitalSignsRecordDto {
        const json = this.toJSON();
        let result = new UpdateVitalSignsRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateVitalSignsRecordDto {
    id: number;
    recordedAt: Date;
    vitalParameters: UpdateVitalParameterDto[] | undefined;
}

export class UserDto implements IUserDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    username!: string | undefined;
    phoneNumber!: string | undefined;
    birthDate!: Date | undefined;
    birthPlace!: string | undefined;
    fiscalCode!: string | undefined;
    gender!: DictionaryDto;
    isManager!: boolean;
    operationalUnit!: OperationalUnitDto;
    operationalUnits!: OperationalUnitDto[] | undefined;
    note!: string | undefined;
    emailAddress!: string | undefined;
    roleNames!: string[] | undefined;
    roleDisplayNames!: string[] | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    lastLoginTime!: Date | undefined;
    isEmailConfirmed!: boolean;
    fullName!: string | undefined;
    accessFailedCount!: number;
    lockoutEndDateUtc!: Date | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.username = _data["username"];
            this.phoneNumber = _data["phoneNumber"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.birthPlace = _data["birthPlace"];
            this.fiscalCode = _data["fiscalCode"];
            this.gender = _data["gender"] ? DictionaryDto.fromJS(_data["gender"]) : <any>undefined;
            this.isManager = _data["isManager"];
            this.operationalUnit = _data["operationalUnit"] ? OperationalUnitDto.fromJS(_data["operationalUnit"]) : <any>undefined;
            if (Array.isArray(_data["operationalUnits"])) {
                this.operationalUnits = [] as any;
                for (let item of _data["operationalUnits"])
                    this.operationalUnits!.push(OperationalUnitDto.fromJS(item));
            }
            this.note = _data["note"];
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            if (Array.isArray(_data["roleDisplayNames"])) {
                this.roleDisplayNames = [] as any;
                for (let item of _data["roleDisplayNames"])
                    this.roleDisplayNames!.push(item);
            }
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.lastLoginTime = _data["lastLoginTime"] ? new Date(_data["lastLoginTime"].toString()) : <any>undefined;
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.fullName = _data["fullName"];
            this.accessFailedCount = _data["accessFailedCount"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? new Date(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["username"] = this.username;
        data["phoneNumber"] = this.phoneNumber;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["birthPlace"] = this.birthPlace;
        data["fiscalCode"] = this.fiscalCode;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["isManager"] = this.isManager;
        data["operationalUnit"] = this.operationalUnit ? this.operationalUnit.toJSON() : <any>undefined;
        if (Array.isArray(this.operationalUnits)) {
            data["operationalUnits"] = [];
            for (let item of this.operationalUnits)
                data["operationalUnits"].push(item.toJSON());
        }
        data["note"] = this.note;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        if (Array.isArray(this.roleDisplayNames)) {
            data["roleDisplayNames"] = [];
            for (let item of this.roleDisplayNames)
                data["roleDisplayNames"].push(item);
        }
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["fullName"] = this.fullName;
        data["accessFailedCount"] = this.accessFailedCount;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    username: string | undefined;
    phoneNumber: string | undefined;
    birthDate: Date | undefined;
    birthPlace: string | undefined;
    fiscalCode: string | undefined;
    gender: DictionaryDto;
    isManager: boolean;
    operationalUnit: OperationalUnitDto;
    operationalUnits: OperationalUnitDto[] | undefined;
    note: string | undefined;
    emailAddress: string | undefined;
    roleNames: string[] | undefined;
    roleDisplayNames: string[] | undefined;
    isActive: boolean;
    isDeleted: boolean;
    lastLoginTime: Date | undefined;
    isEmailConfirmed: boolean;
    fullName: string | undefined;
    accessFailedCount: number;
    lockoutEndDateUtc: Date | undefined;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items!: UserDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;
}

export class UserFileDto implements IUserFileDto {
    id!: number;
    file!: FileDto;
    user!: UserDto;
    userFileType!: DictionaryDto;
    expirationDate!: Date | undefined;

    constructor(data?: IUserFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : <any>undefined;
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.userFileType = _data["userFileType"] ? DictionaryDto.fromJS(_data["userFileType"]) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userFileType"] = this.userFileType ? this.userFileType.toJSON() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserFileDto {
        const json = this.toJSON();
        let result = new UserFileDto();
        result.init(json);
        return result;
    }
}

export interface IUserFileDto {
    id: number;
    file: FileDto;
    user: UserDto;
    userFileType: DictionaryDto;
    expirationDate: Date | undefined;
}

export class UserFileDtoPagedResultDto implements IUserFileDtoPagedResultDto {
    items!: UserFileDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserFileDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserFileDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserFileDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserFileDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserFileDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserFileDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserFileDtoPagedResultDto {
    items: UserFileDto[] | undefined;
    totalCount: number;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    fullName!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
}

export class UserNotification implements IUserNotification {
    id!: string;
    tenantId!: number | undefined;
    userId!: number;
    state!: UserNotificationState;
    notification!: TenantNotification;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.state = _data["state"];
            this.notification = _data["notification"] ? TenantNotification.fromJS(_data["notification"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        return data;
    }

    clone(): UserNotification {
        const json = this.toJSON();
        let result = new UserNotification();
        result.init(json);
        return result;
    }
}

export interface IUserNotification {
    id: string;
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
}

export class UserNotificationPagedResultDto implements IUserNotificationPagedResultDto {
    items!: UserNotification[] | undefined;
    totalCount!: number;

    constructor(data?: IUserNotificationPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserNotification.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserNotificationPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserNotificationPagedResultDto {
        const json = this.toJSON();
        let result = new UserNotificationPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserNotificationPagedResultDto {
    items: UserNotification[] | undefined;
    totalCount: number;
}

export enum UserNotificationState {
    _0 = 0,
    _1 = 1,
}

export class VaccinationDto implements IVaccinationDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    vaccinationDictionary!: DictionaryDto;
    vaccinationType!: DictionaryDto;
    date!: Date;
    organizationOrDoctor!: string | undefined;
    description!: string | undefined;
    vaccinationResult!: DictionaryDto;

    constructor(data?: IVaccinationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.vaccinationDictionary = _data["vaccinationDictionary"] ? DictionaryDto.fromJS(_data["vaccinationDictionary"]) : <any>undefined;
            this.vaccinationType = _data["vaccinationType"] ? DictionaryDto.fromJS(_data["vaccinationType"]) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.organizationOrDoctor = _data["organizationOrDoctor"];
            this.description = _data["description"];
            this.vaccinationResult = _data["vaccinationResult"] ? DictionaryDto.fromJS(_data["vaccinationResult"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VaccinationDto {
        data = typeof data === 'object' ? data : {};
        let result = new VaccinationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["vaccinationDictionary"] = this.vaccinationDictionary ? this.vaccinationDictionary.toJSON() : <any>undefined;
        data["vaccinationType"] = this.vaccinationType ? this.vaccinationType.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["organizationOrDoctor"] = this.organizationOrDoctor;
        data["description"] = this.description;
        data["vaccinationResult"] = this.vaccinationResult ? this.vaccinationResult.toJSON() : <any>undefined;
        return data;
    }

    clone(): VaccinationDto {
        const json = this.toJSON();
        let result = new VaccinationDto();
        result.init(json);
        return result;
    }
}

export interface IVaccinationDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    vaccinationDictionary: DictionaryDto;
    vaccinationType: DictionaryDto;
    date: Date;
    organizationOrDoctor: string | undefined;
    description: string | undefined;
    vaccinationResult: DictionaryDto;
}

export class VaccinationDtoPagedResultDto implements IVaccinationDtoPagedResultDto {
    items!: VaccinationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IVaccinationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VaccinationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): VaccinationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VaccinationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): VaccinationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VaccinationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVaccinationDtoPagedResultDto {
    items: VaccinationDto[] | undefined;
    totalCount: number;
}

export class VitalParameterDto implements IVitalParameterDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    vitalParameterType!: DictionaryDto;
    normal!: number | undefined;
    therapy!: number | undefined;

    constructor(data?: IVitalParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.vitalParameterType = _data["vitalParameterType"] ? DictionaryDto.fromJS(_data["vitalParameterType"]) : <any>undefined;
            this.normal = _data["normal"];
            this.therapy = _data["therapy"];
        }
    }

    static fromJS(data: any): VitalParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new VitalParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["vitalParameterType"] = this.vitalParameterType ? this.vitalParameterType.toJSON() : <any>undefined;
        data["normal"] = this.normal;
        data["therapy"] = this.therapy;
        return data;
    }

    clone(): VitalParameterDto {
        const json = this.toJSON();
        let result = new VitalParameterDto();
        result.init(json);
        return result;
    }
}

export interface IVitalParameterDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    vitalParameterType: DictionaryDto;
    normal: number | undefined;
    therapy: number | undefined;
}

export class VitalSignsRecordDto implements IVitalSignsRecordDto {
    id!: number;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: Date | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: Date | undefined;
    recordedAt!: Date;
    parameters!: VitalParameterDto[] | undefined;

    constructor(data?: IVitalSignsRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.recordedAt = _data["recordedAt"] ? new Date(_data["recordedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(VitalParameterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VitalSignsRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new VitalSignsRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["recordedAt"] = this.recordedAt ? this.recordedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        return data;
    }

    clone(): VitalSignsRecordDto {
        const json = this.toJSON();
        let result = new VitalSignsRecordDto();
        result.init(json);
        return result;
    }
}

export interface IVitalSignsRecordDto {
    id: number;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: Date | undefined;
    recordedAt: Date;
    parameters: VitalParameterDto[] | undefined;
}

export class VitalSignsRecordDtoPagedResultDto implements IVitalSignsRecordDtoPagedResultDto {
    items!: VitalSignsRecordDto[] | undefined;
    totalCount!: number;

    constructor(data?: IVitalSignsRecordDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VitalSignsRecordDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): VitalSignsRecordDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VitalSignsRecordDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): VitalSignsRecordDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VitalSignsRecordDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVitalSignsRecordDtoPagedResultDto {
    items: VitalSignsRecordDto[] | undefined;
    totalCount: number;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}